///////////////////////////////////////////////////////////////////////////////////
// This file is generated by SuperOffice ResourceExporter.
// Don't edit this file. Your changes WILL be lost!
///////////////////////////////////////////////////////////////////////////////////

export type ResourceLanguageName = "CS" | "DA" | "DE" | "EN_US" | "ES" | "FI" | "FR" | "IT" | "KO" | "NL" | "NO" | "PL" | "SV" | "VI";
export const resourceLanguages: ResourceLanguageName[] = ["CS", "DA", "DE", "EN_US", "ES", "FI", "FR", "IT", "KO", "NL", "NO", "PL", "SV", "VI"];
export const defaultLanguage: ResourceLanguageName = "EN_US";

export interface SingleLanguageResources {
  /**
   * Returns text like: Add
   */
  ACTION_ADD: string;
  /**
   * Returns text like: Back
   */
  ACTION_BACK: string;
  /**
   * Returns text like: Activities
   */
  ACTIVITIES: string;
  /**
   * Returns text like: Invite contact from SuperOffice.
   */
  ADD_ATTENDEES: string;
  /**
   * Returns text like: Add e-mail address to existing contact
   */
  ADD_EMAIL_ADDRESS_TO_EXISTING: string;
  /**
   * Returns text like: AI text features are not enabled for your organization. Contact your SuperOffice administrator.
   */
  AI_SUMMARY_AI_NOT_ENABLED: string;
  /**
   * Returns text like: Append
   */
  AI_SUMMARY_APPEND: string;
  /**
   * Returns text like: This feature has been turned off for your organization.
   */
  AI_SUMMARY_FEATURE_DISABLED: string;
  /**
   * Returns text like: Generate
   */
  AI_SUMMARY_GENERATE: string;
  /**
   * Returns text like: Couldn't generate a summary right now. Please try again.
   */
  AI_SUMMARY_GENERATE_ERROR: string;
  /**
   * Returns text like: Generate AI summary
   */
  AI_SUMMARY_GENERATE_TOOLTIP: string;
  /**
   * Returns text like: Participants:
   */
  AI_SUMMARY_HEADER_PARTICIPANTS: string;
  /**
   * Returns text like: Subject:
   */
  AI_SUMMARY_HEADER_SUBJECT: string;
  /**
   * Returns text like: Generating summary…
   */
  AI_SUMMARY_LOADING: string;
  /**
   * Returns text like: You do not have a license to use AI features
   */
  AI_SUMMARY_NO_LICENSE_TOOLTIP: string;
  /**
   * Returns text like: You don't have permission to read this e-mail.
   */
  AI_SUMMARY_NO_PERMISSION: string;
  /**
   * Returns text like: There's nothing to summarize in this e-mail.
   */
  AI_SUMMARY_NOTHING_TO_SUMMARIZE: string;
  /**
   * Returns text like: Replace
   */
  AI_SUMMARY_REPLACE_CONFIRM: string;
  /**
   * Returns text like: The attachment is already archived by <%- archivedBy %> on <%- archivedAt %>.
   */
  ALREADY_ARCHIVED_ATTACHMENT: string;
  /**
   * Returns text like: This e-mail is already archived by <%- archivedBy %> on <%- archivedAt %>.
   */
  ALREADY_ARCHIVED_EMAIL: string;
  /**
   * Returns text like: A sale has already been created for this e-mail by <%- archivedBy %> on <%- archivedAt %>.
   */
  ALREADY_ARCHIVED_SALE: string;
  /**
   * Returns text like: The activity has already been created for this e-mail by <%- archivedBy %> on <%- archivedAt %>.
   */
  ALREADY_ARCHIVED_TASK: string;
  /**
   * Returns text like: Already done
   */
  ALREADY_DONE: string;
  /**
   * Returns text like: This appointment exists in CRM and was created by <%- createdBy %> on <%- creationDate %>.
 
   */
  APPOINTMENT_EXISTS_IN_CRM: string;
  /**
   * Returns text like: Create activity
   */
  ARCHIVE_ACTIVITY: string;
  /**
   * Returns text like: Always show the archive dialog
   */
  ARCHIVE_ALWAYS_SHOW: string;
  /**
   * Returns text like: Create appointment in SuperOffice
   */
  ARCHIVE_AS_ACTIVITY: string;
  /**
   * Returns text like: Save attachment in SuperOffice
   */
  ARCHIVE_AS_ATTACHMENT: string;
  /**
   * Returns text like: Create request in SuperOffice
   */
  ARCHIVE_AS_REQUEST: string;
  /**
   * Returns text like: Create sale in SuperOffice
   */
  ARCHIVE_AS_SALE: string;
  /**
   * Returns text like: Create task in SuperOffice
   */
  ARCHIVE_AS_TASK: string;
  /**
   * Returns text like: Remove e-mail from inbox after archiving as default
   */
  ARCHIVE_REMOVE_FROM_INBOX: string;
  /**
   * Returns text like: Include non e-mail templates in template list
   */
  ARCHIVE_SHOW_ALL_TEMPLATES: string;
  /**
   * Returns text like: Attachments are too large and cannot be archived. Only the e-mail without attachments can be archived.
   */
  ATTACHMENT_SIZE_INFO: string;
  /**
   * Returns text like: Need more details?
   */
  AUTH__BOTTOM_TEXT_1: string;
  /**
   * Returns text like: Learn how to authorize the add-in
   */
  AUTH__BOTTOM_TEXT_2: string;
  /**
   * Returns text like: Copy admin link
   */
  AUTH__BUTTON: string;
  /**
   * Returns text like: Copied to clipboard
   */
  AUTH__COPIED: string;
  /**
   * Returns text like: SuperOffice for Outlook update
   */
  AUTH__HEADER: string;
  /**
   * Returns text like: To enable {feature}, additional permissions are required.
   */
  AUTH__INCREMENTAL_TEXT_1: string;
  /**
   * Returns text like: To meet Microsoft’s latest security requirements, the Outlook add-in has been updated.
   */
  AUTH__MID_TEXT_1: string;
  /**
   * Returns text like: To continue using it, <b>a Microsoft 365 Global Administrator must grant permissions</b> (consent) on behalf of all users.
   */
  AUTH__MID_TEXT_2: string;
  /**
   * Returns text like: <b>Share this link</b> with your Microsoft 365 administrator:
   */
  AUTH__MID_TEXT_3: string;
  /**
   * Returns text like: The SuperOffice for Outlook add-in requires additional permissions to access Microsoft 365 data.
   */
  AUTH__NEW_USER_TEXT_1: string;
  /**
   * Returns text like: Authorisation in progress
   */
  AUTH_IN_PROGRESS__HEADER: string;
  /**
   * Returns text like: Please continue the interactive authentication that is currently in progress and retry.
   */
  AUTH_IN_PROGRESS__MID_TEXT: string;
  /**
   * Returns text like: Not saved.
   */
  AUTOSAVE_FAIL: string;
  /**
   * Returns text like: Saving...
   */
  AUTOSAVE_IN_PROGRESS: string;
  /**
   * Returns text like: Retry
   */
  AUTOSAVE_RETRY: string;
  /**
   * Returns text like: Saved
   */
  AUTOSAVE_SUCCESS: string;
  /**
   * Returns text like: Message created.
   */
  BANNER_ADD_MESSAGE: string;
  /**
   * Returns text like: Appointment created.
   */
  BANNER_CREATE_APPOINTMENT: string;
  /**
   * Returns text like: Request created.
   */
  BANNER_CREATE_REQUEST: string;
  /**
   * Returns text like: Sale created.
   */
  BANNER_CREATE_SALE: string;
  /**
   * Returns text like: Task created.
   */
  BANNER_CREATE_TASK: string;
  /**
   * Returns text like: Attachment saved.
   */
  BANNER_SAVE_ATTACHMENT: string;
  /**
   * Returns text like: E-mail saved.
   */
  BANNER_SAVE_TO_SUPEROFFICE: string;
  /**
   * Returns text like: View in CRM
   */
  BANNER_VIEW_IN_CRM: string;
  /**
   * Returns text like: Add message to request
   */
  BTN_ADD_TO_EXISTING_REQUEST: string;
  /**
   * Returns text like: Add to SuperOffice
   */
  BTN_ADD_TO_SUPEROFFICE: string;
  /**
   * Returns text like: Archive
   */
  BTN_ARCHIVE: string;
  /**
   * Returns text like: Cancel
   */
  BTN_CANCEL: string;
  /**
   * Returns text like: Click to add new contact
   */
  BTN_CLICK_TO_ADD_NEW_CONTACT: string;
  /**
   * Returns text like: Connect
   */
  BTN_CONNECT: string;
  /**
   * Returns text like: We run SuperOffice Online
   */
  BTN_CONNECT_TO_SUPEROFFICE: string;
  /**
   * Returns text like: We run SuperOffice Onsite
   */
  BTN_CONNECT_TO_SUPEROFFICE_ONSITE: string;
  /**
   * Returns text like: Create
   */
  BTN_CREATE: string;
  /**
   * Returns text like: Create new company and contact
   */
  BTN_CREATE_NEW_COMPANY_AND_PERSON: string;
  /**
   * Returns text like: Go to SuperOffice
   */
  BTN_GO_TO_SUPEROFFICE: string;
  /**
   * Returns text like: Keep
   */
  BTN_KEEP_CONTACT: string;
  /**
   * Returns text like: Login
   */
  BTN_LOGIN: string;
  /**
   * Returns text like: Search for sender
   */
  BTN_LOOKUP_SENDER: string;
  /**
   * Returns text like: OK
   */
  BTN_OK: string;
  /**
   * Returns text like: Change SuperOffice user
   */
  BTN_RECONNECT: string;
  /**
   * Returns text like: Save
   */
  BTN_SAVE: string;
  /**
   * Returns text like: Send and archive
   */
  BTN_SAVE_AND_ARCHIVE: string;
  /**
   * Returns text like: Sign up for a free trial
   */
  BTN_SIGN_UP_FOR_FREE_TRIAL: string;
  /**
   * Returns text like: Update
   */
  BTN_UPDATE_CONTACT: string;
  /**
   * Returns text like: Business
   */
  BUSINESS: string;
  /**
   * Returns text like: Let's get started
   */
  BUTTON_LETS_GO: string;
  /**
   * Returns text like: Reload
   */
  BUTTON_RELOAD: string;
  /**
   * Returns text like: Can't grant permission?
   */
  CAN_NOT_GRANT_PERMISSION: string;
  /**
   * Returns text like: Cannot add message to request because attachment may be unsafe
   */
  CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: string;
  /**
   * Returns text like: Attachments cannot be archived because some may be unsafe. Only e-mails without attachments can be archived.
   */
  CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: string;
  /**
   * Returns text like: Cannot save digitally signed attachment
   */
  CANNOT_ARCHIVE_SIGNED_ATTACHMENT: string;
  /**
   * Returns text like: This e-mail is digitally signed. Attachments in the signature cannot be saved individually.
   */
  CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: string;
  /**
   * Returns text like: Cannot archive because attachment may be unsafe
   */
  CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: string;
  /**
   * Returns text like: Cannot create request because attachment may be unsafe
   */
  CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: string;
  /**
   * Returns text like: Cannot save contact
   */
  CANNOT_SAVE_CONTACT: string;
  /**
   * Returns text like: Category
   */
  CATEGORY: string;
  /**
   * Returns text like: Your changes are being saved automatically
   */
  CHANGES_SAVED_AUTOMATICALLY: string;
  /**
   * Returns text like: Please choose one or continue.
   */
  CHOOSE_ONE_OR_CONTINUE: string;
  /**
   * Returns text like: Click here to view it.
   */
  CLICK_HERE_TO_SEE_IT: string;
  /**
   * Returns text like: Select contact
   */
  CLICK_HERE_TO_SELECT_CONTACT: string;
  /**
   * Returns text like: Click here to select the right contact to archive on.
   */
  CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: string;
  /**
   * Returns text like: +{0} more. Click here to show all.
   */
  CLICK_HERE_TO_SHOW_MORE: string;
  /**
   * Returns text like: Click here to open your SuperOffice installation in a new tab.
   */
  CLICK_LOGIN_ONSITE: string;
  /**
   * Returns text like: Add a comment…
   */
  COMMENT_PLACEHOLDER: string;
  /**
   * Returns text like: Company name
   */
  COMPANY_NAME: string;
  /**
   * Returns text like: Connect to SuperOffice CRM Onsite installation
   */
  CONNECT_ONSITE: string;
  /**
   * Returns text like: Connect to your SuperOffice CRM Online account
   */
  CONNECT_TO_SUPEROFFICE: string;
  /**
   * Returns text like: Contact your SuperOffice administrator to review your CRM configuration.
   */
  CONTACT_ADMINISTRATOR: string;
  /**
   * Returns text like: Continue
   */
  CONTINUE: string;
  /**
   * Returns text like: Could it be one of these?
   */
  COULD_IT_BE_ONE_OF_THESE: string;
  /**
   * Returns text like: Country
   */
  COUNTRY: string;
  /**
   * Returns text like: Create new company
   */
  CREATE_NEW_COMPANY: string;
  /**
   * Returns text like: Create new contact
   */
  CREATE_NEW_CONTACT: string;
  /**
   * Returns text like: Create request
   */
  CREATE_REQUEST: string;
  /**
   * Returns text like: Request has been created
   */
  CREATED_REQUEST: string;
  /**
   * Returns text like: Department
   */
  DEPARTMENT: string;
  /**
   * Returns text like: Do not archive attachments
   */
  DO_NOT_ARCHIVE_ATTACHMENTS: string;
  /**
   * Returns text like: Attachments are archived by default
   */
  DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: string;
  /**
   * Returns text like: E-mail archived in SuperOffice.
   */
  DOCUMENT_ARCHIVED_IN_SUPEROFFICE: string;
  /**
   * Returns text like: E-mail
   */
  EMAIL_ADDRESS: string;
  /**
   * Returns text like: This e-mail address does not exist in SuperOffice.
   */
  EMAIL_ADDRESS_NOT_REGISTERED: string;
  /**
   * Returns text like: <span class='so-email'>{0}</span> is attached to several contacts in SuperOffice.
   */
  EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: string;
  /**
   * Returns text like: E-mail registered in SuperOffice.
   */
  EMAIL_REGISTERED_IN_SUPEROFFICE: string;
  /**
   * Returns text like: This e-mail address is registered on several contacts in SuperOffice.
   */
  EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: string;
  /**
   * Returns text like: Enable archiving to edit these settings
   */
  ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: string;
  /**
   * Returns text like: Error
   */
  ERROR: string;
  /**
   * Returns text like: Unable to add e-mail address to SuperOffice.
   */
  ERROR_ADDING_EMAIL_TO_SUPEROFFICE: string;
  /**
   * Returns text like: Unable to archive attachment.
   */
  ERROR_ARCHIVING_ATTACHMENT: string;
  /**
   * Returns text like: Unable to archive e-mail.
   */
  ERROR_ARCHIVING_EMAIL: string;
  /**
   * Returns text like: Unable to archive request.
   */
  ERROR_ARCHIVING_REQUEST: string;
  /**
   * Returns text like: Unable to create activity.
   */
  ERROR_ARCHIVING_TASK: string;
  /**
   * Returns text like: Unable to communicate with SuperOffice.
   */
  ERROR_COMMUNICATING_WITH_SUPEROFFICE: string;
  /**
   * Returns text like: You do not have permission to create companies or contacts in SuperOffice.
   */
  ERROR_PERMISSIONS_CREATE_CONTACTS: string;
  /**
   * Returns text like: Find a company or contact...
   */
  FIND_COMPANY_OR_PERSON: string;
  /**
   * Returns text like: The meeting contact has changed. 
   */
  FIRST_ATTENDEE_CHANGED: string;
  /**
   * Returns text like: Choose which contact the appointment should be linked to.
   */
  FIRST_ATTENDEE_MISMATCH_DESC: string;
  /**
   * Returns text like: Contact and meeting attendee do not match
   */
  FIRST_ATTENDEE_MISMATCH_LABEL: string;
  /**
   * Returns text like: First name
   */
  FIRSTNAME: string;
  /**
   * Returns text like: Follow-ups
   */
  FOLLOWUPS: string;
  /**
   * Returns text like: SuperOffice for Outlook could not reach Microsoft services. Please try again shortly.
   */
  GRAPH_API_ERROR_MESSAGE_SOFO: string;
  /**
   * Returns text like: Microsoft services temporarily unavailable
   */
  GRAPH_API_ERROR_TITLE_SOFO: string;
  /**
   * Returns text like: Add e-mail/contact: {0}
   */
  HEADER_ADD_EMAIL: string;
  /**
   * Returns text like: Add e-mail address to SuperOffice
   */
  HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: string;
  /**
   * Returns text like: Add recipients from SuperOffice
   */
  HEADER_ADD_RECPIENTS: string;
  /**
   * Returns text like: Add to existing contact
   */
  HEADER_ADD_TO_EXISTING_PERSON: string;
  /**
   * Returns text like: Create activity
   */
  HEADER_ARCHIVE_APPOINTMENT: string;
  /**
   * Returns text like: Archive attachment as a SuperOffice document
   */
  HEADER_ARCHIVE_ATTACHMENT: string;
  /**
   * Returns text like: Archive e-mail in SuperOffice
   */
  HEADER_ARCHIVE_EMAIL: string;
  /**
   * Returns text like: Connect to another SuperOffice installation
   */
  HEADER_CONNECT_TO_NEW_INSTALLATION: string;
  /**
   * Returns text like: Create activity in SuperOffice based on e-mail
   */
  HEADER_CREATE_EMAIL_AS_ACTIVITY: string;
  /**
   * Returns text like: Save attachments from this e-mail in SuperOffice
   */
  HEADER_CREATE_EMAIL_AS_ATTACHMENT: string;
  /**
   * Returns text like: Archive this e-mail in SuperOffice
   */
  HEADER_CREATE_EMAIL_AS_EMAIL: string;
  /**
   * Returns text like: Create request in SuperOffice based on e-mail
   */
  HEADER_CREATE_EMAIL_AS_REQUEST: string;
  /**
   * Returns text like: Create sale in SuperOffice based on this e-mail
   */
  HEADER_CREATE_EMAIL_AS_SALE: string;
  /**
   * Returns text like: Create a task in your checklist based on e-mail
   */
  HEADER_CREATE_EMAIL_AS_TASK: string;
  /**
   * Returns text like: Create new company and contact
   */
  HEADER_CREATE_NEW_COMPANY_AND_PERSON: string;
  /**
   * Returns text like: Create new contact
   */
  HEADER_CREATE_NEW_PERSON: string;
  /**
   * Returns text like: Welcome
   */
  HEADER_WELCOME: string;
  /**
   * Returns text like: Achieve more with integration
   */
  LABEL_ACHIEVE_MORE: string;
  /**
   * Returns text like: Add the e-mail as a message in an existing request in SuperOffice
   */
  LABEL_ADD_TO_EXISTING_REQUEST: string;
  /**
   * Returns text like: Archive file:
   */
  LABEL_ARCHIVE_FILE: string;
  /**
   * Returns text like: Attachment already saved
   */
  LABEL_ATTACHMENT_ALREADY_SAVED: string;
  /**
   * Returns text like: Attachment not saved
   */
  LABEL_ATTACHMENT_NOT_SAVED: string;
  /**
   * Returns text like: Comment:
   */
  LABEL_COMMENT: string;
  /**
   * Returns text like: Company phone:
   */
  LABEL_COMPANYPHONE: string;
  /**
   * Returns text like: Company:
   */
  LABEL_CONTACT: string;
  /**
   * Returns text like: Contact or Company:
   */
  LABEL_CONTACT_OR_COMPANY: string;
  /**
   * Returns text like: Create and visualize like a pro
   */
  LABEL_CREATE_AND_VISUALIZE: string;
  /**
   * Returns text like: Currency:
   */
  LABEL_CURRENCY: string;
  /**
   * Returns text like: Date:
   */
  LABEL_DATE: string;
  /**
   * Returns text like: Description:
   */
  LABEL_DESCRIPTION: string;
  /**
   * Returns text like: Direct phone:
   */
  LABEL_DIRECTPHONE: string;
  /**
   * Returns text like: Discover what this add-in can do for you today!
   */
  LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: string;
  /**
   * Returns text like: Home address:
   */
  LABEL_HOME_ADDRESS: string;
  /**
   * Returns text like: Mobile phone:
   */
  LABEL_MOBILEPHONE: string;
  /**
   * Returns text like: Notes:
   */
  LABEL_NOTES: string;
  /**
   * Returns text like: Number:
   */
  LABEL_NUMBER: string;
  /**
   * Returns text like: Optional
   */
  LABEL_OPTIONAL_ATTENDEE: string;
  /**
   * Returns text like: Contact:
   */
  LABEL_PERSON: string;
  /**
   * Returns text like: Position:
   */
  LABEL_POSITION: string;
  /**
   * Returns text like: Project:
   */
  LABEL_PROJECT: string;
  /**
   * Returns text like: Required
   */
  LABEL_REQUIRED_ATTENDEE: string;
  /**
   * Returns text like: Sale:
   */
  LABEL_SALE: string;
  /**
   * Returns text like: Sale amount:
   */
  LABEL_SALE_AMOUNT: string;
  /**
   * Returns text like: Sale date:
   */
  LABEL_SALE_DATE: string;
  /**
   * Returns text like: Sale name:
   */
  LABEL_SALE_NAME: string;
  /**
   * Returns text like: Sale type:
   */
  LABEL_SALE_TYPE: string;
  /**
   * Returns text like: Your changes have been saved.
   */
  LABEL_SAVED_CHANGES: string;
  /**
   * Returns text like: Add request to this queue:
   */
  LABEL_SELECT_CS_QUEUE: string;
  /**
   * Returns text like: Select queue
   */
  LABEL_SELECT_CS_QUEUE_SHORT: string;
  /**
   * Returns text like: Server version:
   */
  LABEL_SERVER_VERSION: string;
  /**
   * Returns text like: Subject:
   */
  LABEL_SUBJECT: string;
  /**
   * Returns text like: SuperOffice site:
   */
  LABEL_SUPEROFFICE_SITE: string;
  /**
   * Returns text like: Phone:
   */
  LABEL_TELEPHONE: string;
  /**
   * Returns text like: Time:
   */
  LABEL_TIME: string;
  /**
   * Returns text like: Type:
   */
  LABEL_TYPE: string;
  /**
   * Returns text like: Unlock features and functionality
   */
  LABEL_UNLOCK_FEATURES: string;
  /**
   * Returns text like: URL:
   */
  LABEL_URL: string;
  /**
   * Returns text like: User:
   */
  LABEL_USER: string;
  /**
   * Returns text like: Visible for:
   */
  LABEL_VISIBLE_FOR: string;
  /**
   * Returns text like: Web page:
   */
  LABEL_WEB_PAGE: string;
  /**
   * Returns text like: Last name
   */
  LASTNAME: string;
  /**
   * Returns text like: Learn more
   */
  LEARN_MORE: string;
  /**
   * Returns text like: To complete the setup of SuperOffice Gmail Link, you need to log in to SuperOffice.
   */
  LOGIN_COMPLETE_SETUP: string;
  /**
   * Returns text like: Please log in to your SuperOffice CRM Onsite installation.
   */
  LOGIN_ONSITE: string;
  /**
   * Returns text like: Log out of SuperOffice and close the open SuperOffice tab(s) if any.
   */
  LOGOUT_FROM_SUPEROFFICE_1: string;
  /**
   * Returns text like: The next time you log in to SuperOffice CRM Online, the new connection will be set up automatically.
   */
  LOGOUT_FROM_SUPEROFFICE_2: string;
  /**
   * Returns text like: Make this the primary e-mail address
   */
  MAKE_PRIMARY_EMAIL_ADDRESS: string;
  /**
   * Returns text like: Mark as completed
   */
  MARK_COMPLETED: string;
  /**
   * Returns text like: Remove from Inbox
   */
  MARK_REMOVE_FROM_INBOX: string;
  /**
   * Returns text like: Archive E-mail
   */
  MENU_ARCHIVE_EMAIL: string;
  /**
   * Returns text like: Create activity
   */
  MENU_CREATE_APPOINTMENT: string;
  /**
   * Returns text like: Create new sale
   */
  MENU_CREATE_NEW_SALE: string;
  /**
   * Returns text like: Save to SuperOffice
   */
  MENU_SAVE_TO_SUPEROFFICE: string;
  /**
   * Returns text like: Contact has no e-mail address
   */
  MESSAGE_NO_EMAIL_ADDRESS: string;
  /**
   * Returns text like: Middle name
   */
  MIDDLENAME: string;
  /**
   * Returns text like: Some required fields are not available for your user account:
   */
  MISSING_REQUIRED_VALUES_INTRO: string;
  /**
   * Returns text like: Add company
   */
  ML_ADD_COMPANY: string;
  /**
   * Returns text like: Add e-mail to contact
   */
  ML_ADD_EMAIL_TO_CONTACT_PERSON: string;
  /**
   * Returns text like: Add new company and contact
   */
  ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: string;
  /**
   * Returns text like: Add new contact
   */
  ML_ADD_NEW_CONTACT_PERSON: string;
  /**
   * Returns text like: Archive this e-mail as an appointment in your calendar
   */
  ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: string;
  /**
   * Returns text like: Archive e-mail in SuperOffice on the sender's company card
   */
  ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: string;
  /**
   * Returns text like: Click to add to SuperOffice
   */
  ML_CLICK_TO_ADD_TO_SUPEROFFICE: string;
  /**
   * Returns text like: Company details
   */
  ML_COMPANY_DETAILS: string;
  /**
   * Returns text like: Contact details
   */
  ML_CONTACT_DETAILS: string;
  /**
   * Returns text like: Create a new sale for this customer
   */
  ML_CREATE_A_NEW_SALE: string;
  /**
   * Returns text like: Disconnect Outlook from SuperOffice
   */
  ML_DISCONNECT_FROM_SUPEROFFICE: string;
  /**
   * Returns text like: Invitations
   */
  ML_INVITATION_OPTIONS: string;
  /**
   * Returns text like: Add this e-mail to Customer Service as a new request
   */
  ML_MOVE_INTO_CS_AS_REQUEST: string;
  /**
   * Returns text like: OR ADD CONTACT TO COMPANY?
   */
  ML_OR_ADD_CONTACT_TO_COMPANY: string;
  /**
   * Returns text like: People mentioned in this message
   */
  ML_PEOPLE_METIONED_IN_MESSAGE: string;
  /**
   * Returns text like: This contact could be
   */
  ML_PERSON_COULD_BE: string;
  /**
   * Returns text like: Search for contact or company...
   */
  ML_SEARCH_FOR_PERSON_OR_COMPANY: string;
  /**
   * Returns text like: Invitations for SuperOffice
   */
  ML_SETTINGS_INVITATIONS_HEADER: string;
  /**
   * Returns text like: Add / update appointment in SuperOffice when responding to invitations in Outlook.
   */
  ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: string;
  /**
   * Returns text like: Mobile
   */
  MOBILE: string;
  /**
   * Returns text like: More
   */
  MORE: string;
  /**
   * Returns text like: Mr/Ms
   */
  MRMS: string;
  /**
   * Returns text like: This e-mail address is registered on several contacts in SuperOffice. Click here to select the right contact to archive on.
   */
  MULTIPLE_EMAILADDRESSES_FOUND: string;
  /**
   * Returns text like: My Profile
   */
  MYPROFILE: string;
  /**
   * Returns text like: No results
   */
  NO_RESULTS: string;
  /**
   * Returns text like: Based on the content of this e-mail, we have suggested details for this sender. Please verify before creating this contact.
   */
  NOTE_CONTACT_DATA_PREDICTED: string;
  /**
   * Returns text like: Check that the username and password you have entered are correct.
   */
  ONSITE_AUTHENTICATION_ERROR_LINE_2: string;
  /**
   * Returns text like: Congratulations. SuperOffice Gmail Link has successfully connected with your SuperOffice CRM Onsite installation.
   */
  ONSITE_CONNECTION_SUCCESSFUL: string;
  /**
   * Returns text like: Please check that you are logged in to your onsite installation before continuing.
   */
  ONSITE_CONTINUE_WHEN_LOGGED_IN: string;
  /**
   * Returns text like: There were some issues during the login process.
   */
  ONSITE_ERROR_LINE_1: string;
  /**
   * Returns text like: Make sure you have entered a correct Server URL. Click on the information button to find out how to obtain it.
   */
  ONSITE_ERROR_LINE_2: string;
  /**
   * Returns text like: Password:
   */
  ONSITE_PASSWORD: string;
  /**
   * Returns text like: Server URL:
   */
  ONSITE_SERVER_URL: string;
  /**
   * Returns text like: In SuperOffice CRM, select Copy shortcut from the main menu
   */
  ONSITE_SERVER_URL_LINE_1: string;
  /**
   * Returns text like: Then paste into the Server URL here
   */
  ONSITE_SERVER_URL_LINE_2: string;
  /**
   * Returns text like: URL to your SuperOffice CRM Onsite installation:
   */
  ONSITE_URL: string;
  /**
   * Returns text like: Username:
   */
  ONSITE_USER_NAME: string;
  /**
   * Returns text like: Open in CRM
   */
  OPEN_IN_CRM: string;
  /**
   * Returns text like: OR
   */
  OR_UPPER: string;
  /**
   * Returns text like: Our contact
   */
  OUR_CONTACT: string;
  /**
   * Returns text like: Outlook + SuperOffice CRM
   */
  OUTLOOK_AND_SUPEROFFICE: string;
  /**
   * Returns text like: If you change your mind later on, please open the SuperOffice for Outlook addin in the calendar screen again
   */
  PERMISSION_CHANGE_OF_MIND: string;
  /**
   * Returns text like: Click "Continue" to open a new window and grant required permissions
   */
  PERMISSION_CONTINUE: string;
  /**
   * Returns text like: SuperOffice for Outlook needs your permission to access your calendar items.
   */
  PERMISSION_FOR_CALENDAR: string;
  /**
   * Returns text like: Bcc
   */
  PICKER_BCC: string;
  /**
   * Returns text like: Cc
   */
  PICKER_CC: string;
  /**
   * Returns text like: Cc
   */
  PICKER_CC_COPY: string;
  /**
   * Returns text like: To
   */
  PICKER_TO: string;
  /**
   * Returns text like: Place request in this queue:
   */
  PLACE_REQUEST_IN_QUEUE: string;
  /**
   * Returns text like: Please allow pop-ups for this page and retry.
   */
  POPUP__BOTTOM_TEXT: string;
  /**
   * Returns text like: Pop-up blocker detected
   */
  POPUP__HEADER: string;
  /**
   * Returns text like: SuperOffice for Outlook needs to authenticate, but your browser's pop-up blocker is preventing it.
   */
  POPUP__MID_TEXT: string;
  /**
   * Returns text like: SuperOffice Gmail Link
   */
  PRODUCT_NAME: string;
  /**
   * Returns text like: Remove from inbox
   */
  REMOVE_FROM_INBOX: string;
  /**
   * Returns text like: Moves e-mail to deleted items after archiving
   */
  REMOVE_FROM_INBOX_DESC: string;
  /**
   * Returns text like: Request
   */
  REQUEST: string;
  /**
   * Returns text like: This e-mail is too large to add to a request.
   */
  REQUEST_EMAIL_TOO_LARGE_MESSAGE: string;
  /**
   * Returns text like: E-mail too large
   */
  REQUEST_EMAIL_TOO_LARGE_TITLE: string;
  /**
   * Returns text like: Priority
   */
  REQUEST_PRIORITY: string;
  /**
   * Returns text like: Request queue
   */
  REQUEST_QUEUE: string;
  /**
   * Returns text like: Reset all
   */
  RESET_ALL: string;
  /**
   * Returns text like: Would you like to reset the information in SuperOffice for Outlook? This will remove the current data.
   */
  RESET_INFO_SOFO: string;
  /**
   * Returns text like: Revision:
   */
  REVISION_LABEL: string;
  /**
   * Returns text like: Search failed. Please try again.
   */
  SEARCH_FAILED: string;
  /**
   * Returns text like: Settings
   */
  SETTINGS: string;
  /**
   * Returns text like: Apply archive category
   */
  SETTINGS_ApplyArchiveStatus: string;
  /**
   * Returns text like: External recipients only
   */
  SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: string;
  /**
   * Returns text like: External recipients are people outside your organization.
   */
  SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: string;
  /**
   * Returns text like: Forwards
   */
  SETTINGS_ARCHIVE_REMINDER_FORWARDS: string;
  /**
   * Returns text like: Archive reminder
   */
  SETTINGS_ARCHIVE_REMINDER_HEADER: string;
  /**
   * Returns text like: Archive reminder helps ensure e-mails and meetings are saved to SuperOffice before they are sent.
   */
  SETTINGS_ARCHIVE_REMINDER_INFO: string;
  /**
   * Returns text like: You will be reminded to archive meetings in SuperOffice.
   */
  SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: string;
  /**
   * Returns text like: Remind me before sending meetings
   */
  SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: string;
  /**
   * Returns text like: New e-mails
   */
  SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: string;
  /**
   * Returns text like: Replies
   */
  SETTINGS_ARCHIVE_REMINDER_REPLIES: string;
  /**
   * Returns text like: You will be reminded to archive e-mails in SuperOffice.
   */
  SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: string;
  /**
   * Returns text like: Remind me before sending e-mails
   */
  SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: string;
  /**
   * Returns text like: Category color
   */
  SETTINGS_CategoryColor: string;
  /**
   * Returns text like: Category name
   */
  SETTINGS_CategoryName: string;
  /**
   * Returns text like: The category name is fixed and cannot be changed.
   */
  SETTINGS_CategoryNameFixedInfo: string;
  /**
   * Returns text like: Use an Outlook category to identify e-mails that have already been archived to SuperOffice.
   */
  SETTINGS_CategoryTaggingDescription: string;
  /**
   * Returns text like: E-mail archive status helps you see which e-mails have already been saved to SuperOffice, directly in your Outlook mailbox.
   */
  SETTINGS_CategoryTaggingInfo: string;
  /**
   * Returns text like: E-mail archive status
   */
  SETTINGS_CategoryTaggingSection: string;
  /**
   * Returns text like: Default activity type
   */
  SETTINGS_DEFAULT_APPOINTMENT_TYPE: string;
  /**
   * Returns text like: Default e-mail type
   */
  SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: string;
  /**
   * Returns text like: Incoming e-mail
   */
  SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: string;
  /**
   * Returns text like: Outgoing e-mail
   */
  SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: string;
  /**
   * Returns text like: Default incoming e-mail template
   */
  SETTINGS_DEFAULT_INCOMING_TEMPLATE: string;
  /**
   * Returns text like: Default outgoing e-mail template
   */
  SETTINGS_DEFAULT_OUTGOING_TEMPLATE: string;
  /**
   * Returns text like: In shared mailboxes
   */
  SETTINGS_EnableCategoryForSharedMailbox: string;
  /**
   * Returns text like: When opening archived e-mails
   */
  SETTINGS_EnableCategoryOnOpen: string;
  /**
   * Returns text like: When using Send & Archive
   */
  SETTINGS_EnableCategoryOnSendAndArchive: string;
  /**
   * Returns text like: Show archive category in Outlook
   */
  SETTINGS_EnableCategoryTagging: string;
  /**
   * Returns text like: Show contextual projects and sales
   */
  SETTINGS_EnableContextualProjectsAndSalesForContact: string;
  /**
   * Returns text like: General
   */
  SETTINGS_GENERAL_HEADER: string;
  /**
   * Returns text like: To display archive status, the archive category must be created in the shared mailbox.
   */
  SETTINGS_SharedMailboxCategoryInfo: string;
  /**
   * Returns text like: For shared mailboxes:
   */
  SETTINGS_SharedMailboxCategoryInfoBold: string;
  /**
   * Returns text like: Learn more about shared mailbox setup
   */
  SETTINGS_SharedMailboxCategoryLearnMore: string;
  /**
   * Returns text like: Company name:
   */
  SETTINGS_YOURCOMPANY: string;
  /**
   * Returns text like: Archive and send
   */
  SMART_ALERT_ARCHIVE_AND_SEND_LABEL: string;
  /**
   * Returns text like: Select a contact or company to archive.
   */
  SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: string;
  /**
   * Returns text like: This e-mail is ready to send, but it cannot be archived in SuperOffice.
   */
  SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: string;
  /**
   * Returns text like: Archive
   */
  SMART_ALERT_BUTTON_ARCHIVE_LABEL: string;
  /**
   * Returns text like: This e-mail is ready to send, but it is not set to be archived in SuperOffice. Archive it now so the communication is saved with the right company or contact, or send it without archiving.
   */
  SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: string;
  /**
   * Returns text like: Something went wrong when loading settings.
   */
  SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: string;
  /**
   * Returns text like: Please log in to SuperOffice before opening settings.
   */
  SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: string;
  /**
   * Returns text like: My Apps
   */
  SR_ADMIN_MYAPPS: string;
  /**
   * Returns text like: All
   */
  SR_ALL_ITEM: string;
  /**
   * Returns text like: Are you sure you want to turn off biometric login? You will need to manually sign in again next time.
   */
  SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: string;
  /**
   * Returns text like: Failed to copy to clipboard
   */
  SR_FAILED_TO_COPY_TO_CLIPBOARD: string;
  /**
   * Returns text like: (No Selection)
   */
  SR_NO_SELECTION: string;
  /**
   * Returns text like: The microphone is in use. Try again when it is free.
   */
  SR_VOICEMEMO_MICROPHONE_BUSY: string;
  /**
   * Returns text like: Get started in a few clicks
   */
  SYNCHRONIZER_GET_STARTED: string;
  /**
   * Returns text like: Reactivate in a few clicks
   */
  SYNCHRONIZER_REACTIVATE: string;
  /**
   * Returns text like: Sync your Outlook calendar and tasks with SuperOffice CRM to keep meetings, contacts, projects, and sales up-to-date.
   */
  SYNCRONIZER_MSG_CONTENT: string;
  /**
   * Returns text like: SuperOffice Calendar Synchronization with Outlook is almost set up. Continue to activate it and keep you calendars in sync.
   */
  SYNCRONIZER_NEED_AUTHENTICATION: string;
  /**
   * Returns text like: Your SuperOffice Calendar Synchronization with Outlook is currently interrupted. Continue to reactivate and keep your calendars in sync.
   */
  SYNCRONIZER_NEED_REAUTHENTICATION: string;
  /**
   * Returns text like: Action
   */
  TAB_ACTION: string;
  /**
   * Returns text like: People
   */
  TAB_PEOPLE: string;
  /**
   * Returns text like: Activity created in SuperOffice.
   */
  TASK_ARCHIVED_IN_SUPEROFFICE: string;
  /**
   * Returns text like: Activity created in SuperOffice.
   */
  TASK_ARCHIVED_IN_SUPEROFFICE_COPY: string;
  /**
   * Returns text like: The server took too long to respond. Please try again.
   */
  TIMEOUT_ERROR_MESSAGE: string;
  /**
   * Returns text like: Request timed out
   */
  TIMEOUT_ERROR_TITLE: string;
  /**
   * Returns text like: Title
   */
  TITLE: string;
  /**
   * Returns text like: Undo
   */
  UNDO: string;
  /**
   * Returns text like: Unknown e-mail address.
   */
  UNKNOWN_EMAIL_ADDRESS: string;
  /**
   * Returns text like: This sender's e-mail address is not recognized. Click here to add this e-mail address to SuperOffice.
   */
  UNKNOWN_EMAILADDRESS: string;
  /**
   * Returns text like: This recipient's e-mail address is not recognised. Click here to update SuperOffice with this e-mail address.
   */
  UNKNOWN_EMAILADDRESS_OUTGOING: string;
  /**
   * Returns text like: Unknown e-mail address. Add {0} to SuperOffice.
   */
  UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: string;
  /**
   * Returns text like: Unlock these features with synchronizer
   */
  UNLOCK_THESE_FEATURES: string;
  /**
   * Returns text like: https://www.superoffice.com/crm/demo/
   */
  URL_SIGN_UP_FREE_TRIAL: string;
  /**
   * Returns text like: ver.
   */
  VERSION_SHORT: string;
  /**
   * Returns text like: Visit App Store
   */
  VISIT_APP_STORE: string;
  /**
   * Returns text like: To determine if you are running Online, do the following:
   */
  WE_RUN_ONLINE_LINE_1: string;
  /**
   * Returns text like: 1. In SuperOffice CRM, select Help and then About
   */
  WE_RUN_ONLINE_LINE_2: string;
  /**
   * Returns text like: 2. Look at the entry for NetServer:
   */
  WE_RUN_ONLINE_LINE_3: string;
  /**
   * Returns text like: If it states "SuperOffice CRM Online ...", you are running Online
   */
  WE_RUN_ONLINE_LINE_4: string;
  /**
   * Returns text like: To determine if you are running Onsite, do the following:
   */
  WE_RUN_ONSITE_LINE_1: string;
  /**
   * Returns text like: If it states "SuperOffice CRM OnSite ...", you are running Onsite
   */
  WE_RUN_ONSITE_LINE_4: string;
  /**
   * Returns text like: You can still use SuperOffice for Outlook for e-mails!
   */
  YOU_CAN_STILL_USE: string;
}

export type ResourcesType = {
  [key in ResourceLanguageName]: SingleLanguageResources;
}

const resources: ResourcesType = {
  CS: {
    ACTION_ADD: "Přidat",
    ACTION_BACK: "Zpět",
    ACTIVITIES: "Činnosti",
    ADD_ATTENDEES: "Pozvat kontakty ze SuperOffice",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Přidat e-mailovou adresu ke stávajícímu kontaktu",
    AI_SUMMARY_AI_NOT_ENABLED: "Funkce pro práci s textem pomocí AI nejsou ve vaší organizaci povoleny. Obraťte se na správce systému SuperOffice.",
    AI_SUMMARY_APPEND: "Připojit",
    AI_SUMMARY_FEATURE_DISABLED: "Tato funkce byla ve vaší organizaci vypnuta.",
    AI_SUMMARY_GENERATE: "Generovat",
    AI_SUMMARY_GENERATE_ERROR: "Shrnutí se nyní nepodařilo vygenerovat. Zkuste to znovu.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Vygenerovat shrnutí pomocí AI",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Účastníci:",
    AI_SUMMARY_HEADER_SUBJECT: "Předmět:",
    AI_SUMMARY_LOADING: "Generování shrnutí…",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Nemáte licenci k používání funkcí AI",
    AI_SUMMARY_NO_PERMISSION: "Nemáte oprávnění číst tento e-mail.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "V tomto e-mailu není nic, co by bylo možné shrnout.",
    AI_SUMMARY_REPLACE_CONFIRM: "Nahradit",
    ALREADY_ARCHIVED_ATTACHMENT: "Tato příloha je již archivována uživatelem <%- archivedBy %> dne <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "Tento e-mail je již archivován uživatelem <%- archivedBy %> dne <%- archivedAt %>.",
    ALREADY_ARCHIVED_SALE: "Pro tento e-mail již byl vytvořen prodej uživatelem <%- archivedBy %> dne <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "Pro tento e-mail již byla vytvořena činnost uživatelem <%- archivedBy %> dne <%- archivedAt %>.",
    ALREADY_DONE: "Již hotovo",
    APPOINTMENT_EXISTS_IN_CRM: "Tato schůzka v CRM existuje a byla vytvořena <%- createdBy %> dne <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Vytvořit činnost",
    ARCHIVE_ALWAYS_SHOW: "Vždy zobrazit dialogové okno archivu",
    ARCHIVE_AS_ACTIVITY: "Vytvořit schůzku v SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Uložit přílohu v SuperOffice",
    ARCHIVE_AS_REQUEST: "Vytvořit požadavek v SuperOffice",
    ARCHIVE_AS_SALE: "Vytvořit prodej v SuperOffice",
    ARCHIVE_AS_TASK: "Vytvořit úkol v SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Odebrat e-mail ze schránky po archivaci jako výchozí",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Zahrnout nee-mailové šablonny do seznamu šablon",
    ATTACHMENT_SIZE_INFO: "Přílohy jsou příliš velké a není možné je archivovat. Archivovat lze pouze e-maily bez příloh.",
    AUTH__BOTTOM_TEXT_1: "\u2028Potřebujete další podrobnosti?",
    AUTH__BOTTOM_TEXT_2: "Zjistěte, jak autorizovat doplněk",
    AUTH__BUTTON: "Kopírovat odkaz správce",
    AUTH__COPIED: "Zkopírováno do schránky",
    AUTH__HEADER: "SuperOffice pro aktualizaci aplikace Outlook",
    AUTH__INCREMENTAL_TEXT_1: "K povolení {feature}jsou vyžadována další oprávnění.",
    AUTH__MID_TEXT_1: "Aby byly splněny nejnovější požadavky společnosti Microsoft na zabezpečení, byl doplněk aplikace Outlook aktualizován.",
    AUTH__MID_TEXT_2: "Chcete-li jej nadále používat, musí globální <b>administrátor Microsoft 365 udělit oprávnění</b> (souhlas) jménem všech uživatelů.",
    AUTH__MID_TEXT_3: "<b>Sdílejte tento odkaz</b> s administrátorem Microsoft 365:",
    AUTH__NEW_USER_TEXT_1: "Doplněk SuperOffice pro Outlook vyžaduje pro přístup k datům Microsoft 365 další oprávnění.",
    AUTH_IN_PROGRESS__HEADER: "Probíhá ověřování",
    AUTH_IN_PROGRESS__MID_TEXT: "Pokračujte v právě probíhajícím interaktivním ověřování a zkuste to znovu.",
    AUTOSAVE_FAIL: "Neuloženo.",
    AUTOSAVE_IN_PROGRESS: "Ukládání…",
    AUTOSAVE_RETRY: "Zkusit znovu",
    AUTOSAVE_SUCCESS: "Uloženo",
    BANNER_ADD_MESSAGE: "Zpráva vytvořena.",
    BANNER_CREATE_APPOINTMENT: "Schůzka vytvořena.",
    BANNER_CREATE_REQUEST: "Požadavek vytvořen.",
    BANNER_CREATE_SALE: "Prodej vytvořen.",
    BANNER_CREATE_TASK: "Úkol vytvořen.",
    BANNER_SAVE_ATTACHMENT: "Příloha uložena.",
    BANNER_SAVE_TO_SUPEROFFICE: "E-mail uložen.",
    BANNER_VIEW_IN_CRM: "Zobrazit v aplikaci CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Přidat zprávu k požadavku",
    BTN_ADD_TO_SUPEROFFICE: "Přidat do SuperOffice",
    BTN_ARCHIVE: "Archiv",
    BTN_CANCEL: "Zrušit",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Klepnutím přidejte nový kontakt",
    BTN_CONNECT: "Připojit",
    BTN_CONNECT_TO_SUPEROFFICE: "Provozujeme SuperOffice v režimu online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Provozujeme SuperOffice v místním režimu",
    BTN_CREATE: "Vytvořit",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Přidat novou společnost a kontakt",
    BTN_GO_TO_SUPEROFFICE: "Jít na SuperOffice",
    BTN_KEEP_CONTACT: "Ponechat",
    BTN_LOGIN: "Přihlásit",
    BTN_LOOKUP_SENDER: "Hledat odesilatele",
    BTN_OK: "OK",
    BTN_RECONNECT: "Změnit uživatele SuperOffice",
    BTN_SAVE: "Uložit",
    BTN_SAVE_AND_ARCHIVE: "Odeslat a archivovat",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Zaregistrujte se k bezplatné zkušební verzi",
    BTN_UPDATE_CONTACT: "Aktualizovat",
    BUSINESS: "Podnik",
    BUTTON_LETS_GO: "Začněme",
    BUTTON_RELOAD: "Načíst znovu",
    CAN_NOT_GRANT_PERMISSION: "Nelze udělit oprávnění?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Nelze přidat zprávu k požadavku",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Přílohy není možné archivovat, protože některé z nich mohou být nebezpečné. Archivovat lze pouze e-maily bez příloh.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Nelze uložit digitálně podepsanou přílohu",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Tento e-mail je opatřen digitálním podpisem. Přílohy v podpisu nelze ukládat jednotlivě.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Nelze archivovat, protože příloha může být nebezpečná",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Nelze vytvořit požadavek",
    CANNOT_SAVE_CONTACT: "Kontakt nelze uložit",
    CATEGORY: "Kategorie",
    CHANGES_SAVED_AUTOMATICALLY: "Vaše změny se ukládají automaticky.",
    CHOOSE_ONE_OR_CONTINUE: "Vyberte možnost nebo pokračujte.",
    CLICK_HERE_TO_SEE_IT: "Pro zobrazení klepněte zde.",
    CLICK_HERE_TO_SELECT_CONTACT: "Vyberte kontakt",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Klepněte zde, abyste vybrali správný kontakt pro archivaci.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} další. Klepnutím sem zobrazte všechny.",
    CLICK_LOGIN_ONSITE: "Klepněte sem, abyste otevřeli instalaci SuperOffice v nové liště.",
    COMMENT_PLACEHOLDER: "Přidat poznánku…",
    COMPANY_NAME: "Název společnosti",
    CONNECT_ONSITE: "Připojte se k instalaci SuperOffice CRM Onsite",
    CONNECT_TO_SUPEROFFICE: "Připojit k vašemu online účtu SuperOffice CRM Online",
    CONTACT_ADMINISTRATOR: "Požádejte správce SuperOffice o kontrolu konfigurace CRM.",
    CONTINUE: "Pokračovat",
    COULD_IT_BE_ONE_OF_THESE: "Můžete to být jeden z těchto?",
    COUNTRY: "Země",
    CREATE_NEW_COMPANY: "Vytvořit novou společnost",
    CREATE_NEW_CONTACT: "Vytvořit nový kontakt",
    CREATE_REQUEST: "Vytvořit požadavek",
    CREATED_REQUEST: "Požadavek byl vytvořen",
    DEPARTMENT: "Oddělení",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Přílohy nearchivujte",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Přílohy jsou ve výchozím nastavení archivovány.",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-mail archivován v SuperOffice.",
    EMAIL_ADDRESS: "E-mail",
    EMAIL_ADDRESS_NOT_REGISTERED: "Tato e-mailová adresa v SuperOffice neexistuje.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> je přiložen k více kontaktům v SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-mail registrován v SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Tato e-mailová adresa je registrována u více kontaktů v SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Pokud chcete tato nastavení upravit, povolte archivaci",
    ERROR: "Chyba",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "E-mailovou adresu nelze přidat do SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Přílohu nelze archivovat.",
    ERROR_ARCHIVING_EMAIL: "E-mail nelze archivovat.",
    ERROR_ARCHIVING_REQUEST: "Požadavek nelze archivovat.",
    ERROR_ARCHIVING_TASK: "Činnost nelze vytvořit.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Nelze komunikovat se SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Nemáte oprávnění pro vytvoření společností nebo kontaktů v SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Hledat společnost nebo kontakt…",
    FIRST_ATTENDEE_CHANGED: "Kontakt schůzky se změnil.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Zvolte, ke kterému kontaktu má být schůzka přiřazena.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Kontakt a účastník schůzky se neshodují",
    FIRSTNAME: "Křestní jméno",
    FOLLOWUPS: "Činnosti",
    GRAPH_API_ERROR_MESSAGE_SOFO: "Aplikace SuperOffice pro Outlook se nemohla připojit ke službám společnosti Microsoft. Zkuste to za chvíli znovu.",
    GRAPH_API_ERROR_TITLE_SOFO: "Služby společnosti Microsoft jsou dočasně nedostupné",
    HEADER_ADD_EMAIL: "Přidat e-mail/kontakt: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Přidat e-mailovou adresu do SuperOffice",
    HEADER_ADD_RECPIENTS: "Přidat příjemce ze SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Přidat ke stávajícímu kontaktu",
    HEADER_ARCHIVE_APPOINTMENT: "Vytvořit činnost",
    HEADER_ARCHIVE_ATTACHMENT: "Archivovat přílohu jako dokument SuperOffice",
    HEADER_ARCHIVE_EMAIL: "Archivovat e-mail v SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Připojit k jiné instalaci SuperOffice",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Vytvořit činnost v SuperOffice podle e-mailu",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Uložit přílohy z tohoto e-mailu v SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Archivovat tento e-mail v SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Vytvořit požadavek v SuperOffice podle e-mailu",
    HEADER_CREATE_EMAIL_AS_SALE: "Vytvořit prodej v SuperOffice podle tohoto e-mailu",
    HEADER_CREATE_EMAIL_AS_TASK: "Vytvoření úkolu v kontrolním seznamu na základě e-mailu",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Vytvořit novou společnost a kontakt",
    HEADER_CREATE_NEW_PERSON: "Vytvořit nový kontakt",
    HEADER_WELCOME: "Vítejte",
    LABEL_ACHIEVE_MORE: "Dosáhněte více s integrací",
    LABEL_ADD_TO_EXISTING_REQUEST: "Přidat e-mail jako zprávu do existujícího požadavku v SuperOffice",
    LABEL_ARCHIVE_FILE: "Archivovat soubor:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Příloha již byla uložena",
    LABEL_ATTACHMENT_NOT_SAVED: "Příloha neuložena",
    LABEL_COMMENT: "Poznámka:",
    LABEL_COMPANYPHONE: "Telefon společnosti:",
    LABEL_CONTACT: "Společnost",
    LABEL_CONTACT_OR_COMPANY: "Kontakt nebo společnost:",
    LABEL_CREATE_AND_VISUALIZE: "Tvořte a vizualizujte jako profesionál",
    LABEL_CURRENCY: "Měna:",
    LABEL_DATE: "Datum:",
    LABEL_DESCRIPTION: "Popis:",
    LABEL_DIRECTPHONE: "Přímý tel.:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Ještě dnes zjistěte, co vám tento doplněk může přinést!",
    LABEL_HOME_ADDRESS: "Soukromá adresa:",
    LABEL_MOBILEPHONE: "Mobil:",
    LABEL_NOTES: "Poznámky:",
    LABEL_NUMBER: "Číslo:",
    LABEL_OPTIONAL_ATTENDEE: "Volitelné",
    LABEL_PERSON: "Kontakt:",
    LABEL_POSITION: "Zařazení:",
    LABEL_PROJECT: "Projekt:",
    LABEL_REQUIRED_ATTENDEE: "Povinné",
    LABEL_SALE: "Prodej:",
    LABEL_SALE_AMOUNT: "Částka prodeje:",
    LABEL_SALE_DATE: "Datum prodeje:",
    LABEL_SALE_NAME: "Název prodeje:",
    LABEL_SALE_TYPE: "Typ prodeje:",
    LABEL_SAVED_CHANGES: "Vaše změny byly uloženy.",
    LABEL_SELECT_CS_QUEUE: "Přidat požadavek do této fronty:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Vybrat frontu",
    LABEL_SERVER_VERSION: "Verze na serveru:",
    LABEL_SUBJECT: "Předmět:",
    LABEL_SUPEROFFICE_SITE: "Stránka SuperOffice:",
    LABEL_TELEPHONE: "Telefon:",
    LABEL_TIME: "Čas:",
    LABEL_TYPE: "Typ:",
    LABEL_UNLOCK_FEATURES: "Odblokovat vlastnosti a funkce",
    LABEL_URL: "URL:",
    LABEL_USER: "Uživatel:",
    LABEL_VISIBLE_FOR: "Viditelné pro:",
    LABEL_WEB_PAGE: "Webová stránka:",
    LASTNAME: "Příjmení",
    LEARN_MORE: "Zjistit více",
    LOGIN_COMPLETE_SETUP: "Abyste dokončili nastavení SuperOffice Gmail Link, musíte se přihlásit do SuperOffice.",
    LOGIN_ONSITE: "Přihlaste se do instalace SuperOffice CRM Onsite.",
    LOGOUT_FROM_SUPEROFFICE_1: "Odhlaste se ze SuperOffice a zavřete všechny otevřené karty SuperOffice, jsou-li nějaké.",
    LOGOUT_FROM_SUPEROFFICE_2: "Při příštím přihlášení do SuperOffice CRM Online bude nové připojení nastaveno automaticky.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Použít jako primární e-mailovou adresu",
    MARK_COMPLETED: "Označit jako splněno",
    MARK_REMOVE_FROM_INBOX: "Odebrat ze schránky",
    MENU_ARCHIVE_EMAIL: "Archivovat e-mail",
    MENU_CREATE_APPOINTMENT: "Vytvořit činnost",
    MENU_CREATE_NEW_SALE: "Vytvořit nový prodej",
    MENU_SAVE_TO_SUPEROFFICE: "Uložit do aplikace SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Kontakt nemá žádnou e-mailovou adresu",
    MIDDLENAME: "Prostřední jméno",
    MISSING_REQUIRED_VALUES_INTRO: "Některá povinná pole nejsou pro váš uživatelský účet k dispozici:",
    ML_ADD_COMPANY: "Přidat společnost",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Přidat e-mail ke kontaktu",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Přidat novou společnost a kontakt",
    ML_ADD_NEW_CONTACT_PERSON: "Přidat nový kontakt",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Archivovat tento e-mail v\u00A0kalendáři jako schůzku",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Archivovat e-mail v\u00A0programu SuperOffice na kartu společnosti odesílatele",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Klepnutím přidejte do SuperOffice",
    ML_COMPANY_DETAILS: "Podrobné údaje o společnosti",
    ML_CONTACT_DETAILS: "Podrobné údaje kontaktu",
    ML_CREATE_A_NEW_SALE: "Vytvořit nový prodej pro tohoto zákazníka",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Odpojit Outlook od SuperOffice",
    ML_INVITATION_OPTIONS: "Pozvání",
    ML_MOVE_INTO_CS_AS_REQUEST: "Přidat tento e-mail do Customer Service jako nový požadavek",
    ML_OR_ADD_CONTACT_TO_COMPANY: "NEBO PŘIDAT KONTAKTNÍ OSOBU KE SPOLEČNOSTI?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Osoby uvedené v této zprávě",
    ML_PERSON_COULD_BE: "Tento kontakt může být",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Hledat kontakt nebo společnost…",
    ML_SETTINGS_INVITATIONS_HEADER: "Pozvání pro SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Přidání/aktivace schůzky v SuperOffice při odpovídání na pozvání v aplikaci Outlook.",
    MOBILE: "Mobil",
    MORE: "Další",
    MRMS: "Pan/Paní",
    MULTIPLE_EMAILADDRESSES_FOUND: "Tato e-mailová adresa je registrována u více kontaktů v SuperOffice. Klepněte zde, abyste vybrali správný kontakt pro archivaci.",
    MYPROFILE: "Můj profil",
    NO_RESULTS: "Žádné výsledky",
    NOTE_CONTACT_DATA_PREDICTED: "Na základě obsahu tohoto e-mailu jsme navrhli podrobnosti pro tohoto odesílatele. Před vytvořením tohoto kontaktu si to ověřte.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Zkontrolujte správnost uživatelského jména a hesla, které jste zadali.",
    ONSITE_CONNECTION_SUCCESSFUL: "Gratulujeme. SuperOffice Gmail Link se úspěšně spojil s vaší instalací SuperOffice CRM Onsite.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Zkontrolujte, zda jste přihlášení do instalace onsite, než budete pokračovat.",
    ONSITE_ERROR_LINE_1: "Vyskytly se určité problémy během přihlašování.",
    ONSITE_ERROR_LINE_2: "Ujistěte se, že jste zadali správnou adresu URL serveru. Chcete-li zjistit, jak ji získat, klikněte na tlačítko Informace.",
    ONSITE_PASSWORD: "Heslo:",
    ONSITE_SERVER_URL: "Adresa URL serveru:",
    ONSITE_SERVER_URL_LINE_1: "V hlavní nabídce aplikace SuperOffice CRM vyberte zástupce Kopírovat",
    ONSITE_SERVER_URL_LINE_2: "Potom sem vložte adresu URL serveru",
    ONSITE_URL: "URL k instalaci SuperOffice CRM Onsite:",
    ONSITE_USER_NAME: "Uživatelské jméno:",
    OPEN_IN_CRM: "Otevřít v aplikaci CRM",
    OR_UPPER: "NEBO",
    OUR_CONTACT: "Náš kontakt",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Pokud si to později rozmyslíte, otevřete znovu v kalendáři doplněk SuperOffice pro Outlook.",
    PERMISSION_CONTINUE: "Kliknutím na tlačítko „Pokračovat“ otevřete nové okno a udělte požadovaná oprávnění.",
    PERMISSION_FOR_CALENDAR: "SuperOffice pro Outlook potřebuje vaše povolení pro přístup k vašim položkám kalendáře.",
    PICKER_BCC: "Skrytá kopie",
    PICKER_CC: "Kopie",
    PICKER_CC_COPY: "Kopie",
    PICKER_TO: "Komu",
    PLACE_REQUEST_IN_QUEUE: "Zařadit požadavek do fronty:",
    POPUP__BOTTOM_TEXT: "Povolte prosím vyskakovací okna pro tuto stránku a zkuste to znovu.",
    POPUP__HEADER: "Zjištěn blokátor vyskakovacích oken",
    POPUP__MID_TEXT: "Aplikace SuperOffice for Outlook se potřebuje ověřit, ale blokátor vyskakovacích oken vašeho prohlížeče tomu brání.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Odstranit ze schránky",
    REMOVE_FROM_INBOX_DESC: "Po archivaci přesune e-mail do odstraněných položek",
    REQUEST: "Požadavek",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Tento e-mail je příliš velký na to, aby jej bylo možné přidat k požadavku.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "E-mail je příliš velký",
    REQUEST_PRIORITY: "Priorita",
    REQUEST_QUEUE: "Fronta požadavků",
    RESET_ALL: "Resetovat vše",
    RESET_INFO_SOFO: "Chcete resetovat informace v SuperOffice pro Outlook? Tím se odstraní aktuální data.",
    REVISION_LABEL: "Revize:",
    SEARCH_FAILED: "Vyhledávání se nezdařilo. Zkuste to znovu.",
    SETTINGS: "Nastavení",
    SETTINGS_ApplyArchiveStatus: "Použít kategorii archivace",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Pouze externí příjemci",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Externí příjemci jsou osoby mimo vaši organizaci.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Přeposlané zprávy",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Připomenutí archivace",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Připomenutí archivace pomáhá zajistit, aby byly e-maily a schůzky před odesláním uloženy do aplikace SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Zobrazí se vám připomenutí k archivaci schůzek v aplikaci SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Připomenout před odesláním schůzek",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Nové e-maily",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Odpovědi",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "V systému SuperOffice se vám bude zobrazovat připomenutí k archivaci e-mailů.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Připomenout před odesláním e-mailů",
    SETTINGS_CategoryColor: "Barva kategorie",
    SETTINGS_CategoryName: "Název kategorie",
    SETTINGS_CategoryNameFixedInfo: "Název kategorie je pevně daný a nelze jej změnit.",
    SETTINGS_CategoryTaggingDescription: "Pomocí kategorie aplikace Outlook označte e-maily, které již byly archivovány do aplikace SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "Stav archivace e-mailů vám pomáhá přímo v poštovní schránce aplikace Outlook zjistit, které e-maily již byly uloženy do aplikace SuperOffice.",
    SETTINGS_CategoryTaggingSection: "Stav archivace e-mailů",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Výchozí typ činnosti",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Výchozí typ e-mailu",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Příchozí e-mail",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Odchozí e-mail",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Výchozí šablona příchozího e-mailu",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Výchozí šablona odchozího e-mailu",
    SETTINGS_EnableCategoryForSharedMailbox: "Ve sdílených schránkách pošty",
    SETTINGS_EnableCategoryOnOpen: "Při otevírání archivovaných e-mailů",
    SETTINGS_EnableCategoryOnSendAndArchive: "Při použití funkce Odeslat a archivovat",
    SETTINGS_EnableCategoryTagging: "Zobrazit kategorii archivace v aplikaci Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Zobrazit kontextové projekty a prodeje",
    SETTINGS_GENERAL_HEADER: "Obecné",
    SETTINGS_SharedMailboxCategoryInfo: "Aby bylo možné zobrazit stav archivace, musí být kategorie archivace vytvořena ve sdílené schránce pošty.",
    SETTINGS_SharedMailboxCategoryInfoBold: "V případě sdílených schránek pošty:",
    SETTINGS_SharedMailboxCategoryLearnMore: "Další informace o nastavení sdílené schránky pošty",
    SETTINGS_YOURCOMPANY: "Název společnosti:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Archivovat a odeslat",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Vyberte kontakt nebo společnost, kterou chcete archivovat.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Tento e-mail je připraven k odeslání, ale nelze jej archivovat v aplikaci SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Archiv",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Tento e-mail je připraven k odeslání, ale v systému SuperOffice není nastaveno jeho archivování. Uložte jej nyní do archivu, aby byla komunikace přiřazena ke správné společnosti nebo kontaktní osobě, nebo jej odešlete bez uložení do archivu.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Při načítání nastavení došlo k chybě.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Přihlaste se do SuperOffice před otevřením nastavení.",
    SR_ADMIN_MYAPPS: "Moje aplikace",
    SR_ALL_ITEM: "Vše",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Opravdu chcete vypnout biometrické přihlášení? Příště se budete muset znovu manuálně přihlásit.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Kopírování do schránky se nezdařilo.",
    SR_NO_SELECTION: "(Žádný výběr)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Začněte několika kliknutími",
    SYNCHRONIZER_REACTIVATE: "Opětovná aktivace několika kliknutími",
    SYNCRONIZER_MSG_CONTENT: "Synchronizujte svůj kalendář aplikace Outlook a úkoly s aplikací SuperOffice CRM, abyste zachovali schůzky, kontakty, projekty a prodeje aktuální.",
    SYNCRONIZER_NEED_AUTHENTICATION: "Synchronizace kalendáře SuperOffice s aplikací Outlook je téměř nastavena. Pokračujte v aktivaci a udržujte své kalendáře synchronizované.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "Synchronizace kalendáře SuperOffice s aplikací Outlook je momentálně přerušena. Pokračujte v opětovné aktivaci a udržujte své kalendáře synchronizované.",
    TAB_ACTION: "Akce",
    TAB_PEOPLE: "Lidé",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Činnost vytvořena v SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Činnost vytvořena v SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "Server reagoval příliš pomalu. Zkuste to znovu.",
    TIMEOUT_ERROR_TITLE: "Vypršela časová lhůta pro odeslání požadavku",
    TITLE: "Titul",
    UNDO: "Zpět",
    UNKNOWN_EMAIL_ADDRESS: "Neznámá e-mailová adresa.",
    UNKNOWN_EMAILADDRESS: "Tato e-mailová adresa odesilatele nebyla rozpoznána. Klepněte zde, abyste tuto e-mailovou adresu přidali do SuperOffice.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Adresa tohoto příjemce nebyla rozpoznána. Pro přidání této e-mailové adresy do programu SuperOffice klikněte sem.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Neznámá e-mailová adresa. Přidat {0} do SuperOffice.",
    UNLOCK_THESE_FEATURES: "Odemkněte tyto funkce pomocí synchronizace",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.com/crm/demo/",
    VERSION_SHORT: "ver.",
    VISIT_APP_STORE: "Navštivte App Store",
    WE_RUN_ONLINE_LINE_1: "Chcete-li zjistit, zda jste v režimu online, postupujte takto:",
    WE_RUN_ONLINE_LINE_2: "1. V aplikaci SuperOffice CRM vyberte možnost Nápověda a potom možnost O programu",
    WE_RUN_ONLINE_LINE_3: "2. Podívejte se na položku NetServer:",
    WE_RUN_ONLINE_LINE_4: "Pokud uvádí „SuperOffice CRM Online ...“, jste v režimu online",
    WE_RUN_ONSITE_LINE_1: "Chcete-li zjistit, zda jste v místním režimu, postupujte takto:",
    WE_RUN_ONSITE_LINE_4: "Pokud uvádí „SuperOffice CRM OnSite ...“, jste v místním režimu",
    YOU_CAN_STILL_USE: "Pro e-maily můžete stále používat SuperOffice pro Outlook!",
  },
  DA: {
    ACTION_ADD: "Tilføj",
    ACTION_BACK: "Tilbage",
    ACTIVITIES: "Aktiviteter",
    ADD_ATTENDEES: "Inviter person fra SuperOffice.",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Tilføj e-mailadresse på eksisterende person",
    AI_SUMMARY_AI_NOT_ENABLED: "AI-tekstfunktioner er ikke aktiveret for din organisation. Kontakt din SuperOffice-administrator.",
    AI_SUMMARY_APPEND: "Tilføj",
    AI_SUMMARY_FEATURE_DISABLED: "Denne funktion er blevet deaktiveret for din organisation.",
    AI_SUMMARY_GENERATE: "Generer",
    AI_SUMMARY_GENERATE_ERROR: "Det er ikke muligt at generere en oversigt lige nu. Prøv igen.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Generer en AI-oversigt",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Deltagere:",
    AI_SUMMARY_HEADER_SUBJECT: "Emne:",
    AI_SUMMARY_LOADING: "Genererer oversigt …",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Du har ikke en licens til at bruge AI-funktioner",
    AI_SUMMARY_NO_PERMISSION: "Du har ikke tilladelse til at læse denne e-mail.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "Der er ikke noget at opsummere i denne e-mail.",
    AI_SUMMARY_REPLACE_CONFIRM: "Erstat",
    ALREADY_ARCHIVED_ATTACHMENT: "Den vedhæftede fil er allerede arkiveret af <%- archivedBy %> den <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "E-mailen er allerede arkiveret af <%- archivedBy %> den <%- archivedAt %>.\n",
    ALREADY_ARCHIVED_SALE: "Der er allerede oprettet et salg for denne e-mail af <%- archivedBy %> den <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "Aktiviteten er allerede blevet oprettet for denne e-mail af <%- archivedBy %> den <%- archivedAt %>.",
    ALREADY_DONE: "Allerede udført",
    APPOINTMENT_EXISTS_IN_CRM: "Denne aftale findes i CRM og blev oprettet af <%- createdBy %> den <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Opret aktivitet",
    ARCHIVE_ALWAYS_SHOW: "Vis altid dialogboks for arkivering",
    ARCHIVE_AS_ACTIVITY: "Opret aftale i SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Gem vedhæftet fil i SuperOffice",
    ARCHIVE_AS_REQUEST: "Opret sag i SuperOffice",
    ARCHIVE_AS_SALE: "Opret salg i SuperOffice",
    ARCHIVE_AS_TASK: "Opret opgave i SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Fjern e-mail fra indbakke efter arkivering som standard",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Medtag skabelontyper som er ikke e-mail i skabelonlisten",
    ATTACHMENT_SIZE_INFO: "De vedhæftede filer er for store og kan ikke arkiveres. Kun selve e-mailen uden vedhæftede filer kan arkiveres.",
    AUTH__BOTTOM_TEXT_1: "\u2028Har du brug for flere detaljer?",
    AUTH__BOTTOM_TEXT_2: "Få mere at vide om, hvordan du godkender tilføjelsesprogrammet",
    AUTH__BUTTON: "Kopiér admin-link",
    AUTH__COPIED: "Kopieret til Udklipsholder",
    AUTH__HEADER: "Opdatering af SuperOffice til Outlook",
    AUTH__INCREMENTAL_TEXT_1: "Aktivering af {feature} kræver yderligere tilladelser.",
    AUTH__MID_TEXT_1: "For at opfylde Microsofts nyeste sikkerhedskrav er Outlook-tilføjelsesprogrammet blevet opdateret.",
    AUTH__MID_TEXT_2: "Hvis du vil fortsætte med at bruge det, <b>skal en global Microsoft 365-administrator give tilladelser</b> (samtykke) på vegne af alle brugere.",
    AUTH__MID_TEXT_3: "<b>Del dette link</b> med din globale Microsoft 365-administrator:",
    AUTH__NEW_USER_TEXT_1: "Tilføjelsesprogrammet SuperOffice for Outlook kræver yderligere tilladelser for at få adgang til Microsoft 365-data.",
    AUTH_IN_PROGRESS__HEADER: "Autorisation i gang",
    AUTH_IN_PROGRESS__MID_TEXT: "Fortsæt den aktuelle interaktive godkendelse, og prøv igen.",
    AUTOSAVE_FAIL: "Ikke gemt.",
    AUTOSAVE_IN_PROGRESS: "Gemmer ...",
    AUTOSAVE_RETRY: "Prøv igen",
    AUTOSAVE_SUCCESS: "Gemt",
    BANNER_ADD_MESSAGE: "Meddelelse oprettet..",
    BANNER_CREATE_APPOINTMENT: "Aftale oprettet.",
    BANNER_CREATE_REQUEST: "Sag oprettet.",
    BANNER_CREATE_SALE: "Salg oprettet.",
    BANNER_CREATE_TASK: "Opgave oprettet.",
    BANNER_SAVE_ATTACHMENT: "Vedhæftet fil gemt.",
    BANNER_SAVE_TO_SUPEROFFICE: "E-mail gemt.",
    BANNER_VIEW_IN_CRM: "Vis i CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Føj meddelelse til sag",
    BTN_ADD_TO_SUPEROFFICE: "Registrer i SuperOffice",
    BTN_ARCHIVE: "Arkivér",
    BTN_CANCEL: "Afbryd",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Klik for at tilføje en ny person",
    BTN_CONNECT: "Tilslut",
    BTN_CONNECT_TO_SUPEROFFICE: "Vi kører SuperOffice online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Vi kører SuperOffice onsite",
    BTN_CREATE: "Opret",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Opret nyt firma og ny person",
    BTN_GO_TO_SUPEROFFICE: "Vis i SuperOffice",
    BTN_KEEP_CONTACT: "Behold",
    BTN_LOGIN: "Logon",
    BTN_LOOKUP_SENDER: "Søg på afsender",
    BTN_OK: "OK",
    BTN_RECONNECT: "Skift SuperOffice-bruger",
    BTN_SAVE: "Gem",
    BTN_SAVE_AND_ARCHIVE: "Send og arkiver",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Tilmeld dig en gratis prøveperiode",
    BTN_UPDATE_CONTACT: "Opdater",
    BUSINESS: "Branche",
    BUTTON_LETS_GO: "Lad os komme igang:",
    BUTTON_RELOAD: "Genindlæs",
    CAN_NOT_GRANT_PERMISSION: "Kan du ikke give tilladelse?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Meddelelsen kan ikke føjes til sagen",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "De vedhæftede filer kan ikke arkiveres, da nogle af dem kan være usikre. Kun e-mails uden vedhæftede filer kan arkiveres.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Det er ikke muligt at gemme en digitalt signeret vedhæftet fil",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Denne e-mail er digitalt signeret. Vedhæftede filer i signaturen kan ikke gemmes hver for sig.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Der kan ikke arkiveres, fordi de vedhæftede filer kan være usikre",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Sagen kan ikke oprettes",
    CANNOT_SAVE_CONTACT: "Det er ikke muligt at gemme personen",
    CATEGORY: "Kategori",
    CHANGES_SAVED_AUTOMATICALLY: "Dine ændringer gemmes automatisk",
    CHOOSE_ONE_OR_CONTINUE: "Vælg en, eller fortsæt.",
    CLICK_HERE_TO_SEE_IT: "Klik her for at vise den.",
    CLICK_HERE_TO_SELECT_CONTACT: "Vælg person",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Klik her for at vælge den rigtige person til arkivering.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} mere. Klik her for at vise alle.",
    CLICK_LOGIN_ONSITE: "Klik her for at åbne din SuperOffice-installation i en ny fane.",
    COMMENT_PLACEHOLDER: "Tilføj en kommentar …",
    COMPANY_NAME: "Firmanavn",
    CONNECT_ONSITE: "Opret forbindelse til SuperOffice CRM onsite-installation",
    CONNECT_TO_SUPEROFFICE: "Link til din SuperOffice CRM Online-konto",
    CONTACT_ADMINISTRATOR: "Kontakt din SuperOffice-administrator for at gennemgå din CRM-konfiguration.",
    CONTINUE: "Fortsæt",
    COULD_IT_BE_ONE_OF_THESE: "Er det en af disse?",
    COUNTRY: "Land",
    CREATE_NEW_COMPANY: "Opret nyt firma",
    CREATE_NEW_CONTACT: "Opret ny person",
    CREATE_REQUEST: "Opret sag",
    CREATED_REQUEST: "Sagen er oprettet",
    DEPARTMENT: "Afdeling",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Arkiver ikke vedhæftede filer",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Vedhæftede filer arkiveres som standard",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-mail er arkiveret i SuperOffice.",
    EMAIL_ADDRESS: "E-mail",
    EMAIL_ADDRESS_NOT_REGISTERED: "Denne e-mailadresse findes ikke i SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> er registreret på flere personer i SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-mail registreret i SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Denne e-mailadresse er registreret på flere personer i SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Aktivér arkivering for at redigere disse indstillinger",
    ERROR: "Fejl",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Kan ikke tilføje e-mailadresse til SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Kan ikke arkivere vedhæftet fil.",
    ERROR_ARCHIVING_EMAIL: "Kan ikke arkivere e-mail.",
    ERROR_ARCHIVING_REQUEST: "Kan ikke arkivere sag.",
    ERROR_ARCHIVING_TASK: "Kan ikke oprette aktiviteten.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Kan ikke kommunikere med SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Du har ikke tilladelse til at oprette firmaer eller personer i SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Find firma eller person ...",
    FIRST_ATTENDEE_CHANGED: "Mødepersonen er ændret.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Vælg, hvilken person aftalen skal knyttes til.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Person og mødedeltager stemmer ikke overens",
    FIRSTNAME: "Fornavn",
    FOLLOWUPS: "Opfølgninger",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice til Outlook kan ikke oprette forbindelse til Microsofts tjenester. Prøv igen om lidt.",
    GRAPH_API_ERROR_TITLE_SOFO: "Microsofts tjenester er midlertidigt utilgængelige",
    HEADER_ADD_EMAIL: "Tilføj e-mail/person: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Tilføj e-mailadresse i SuperOffice",
    HEADER_ADD_RECPIENTS: "Tilføje modtagere fra SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Tilføj på eksisterende person",
    HEADER_ARCHIVE_APPOINTMENT: "Opret aktivitet",
    HEADER_ARCHIVE_ATTACHMENT: "Gem vedhæftede filer som et SuperOffice-dokument",
    HEADER_ARCHIVE_EMAIL: "Arkiver e-mail i SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Link til en anden SuperOffice-installation",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Opret aktivitet i SuperOffice baseret på e-mail",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Gem vedhæftede filer fra denne e-mail i SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Arkiver denne e-mail i SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Opret sag i SuperOffice baseret på e-mail",
    HEADER_CREATE_EMAIL_AS_SALE: "Opret salg i SuperOffice baseret på denne e-mail",
    HEADER_CREATE_EMAIL_AS_TASK: "Opret en opgave i din tjekliste baseret på e-mail",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Opret nyt firma og ny person",
    HEADER_CREATE_NEW_PERSON: "Opret ny person",
    HEADER_WELCOME: "Velkommen",
    LABEL_ACHIEVE_MORE: "Opnå mere med integration",
    LABEL_ADD_TO_EXISTING_REQUEST: "Tilføje e-mailen som en meddelelse i en eksisterende sag i SuperOffice",
    LABEL_ARCHIVE_FILE: "Arkiver fil:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Vedhæftet fil er allerede gemt",
    LABEL_ATTACHMENT_NOT_SAVED: "Vedhæftet fil er ikke gemt",
    LABEL_COMMENT: "Kommentar:",
    LABEL_COMPANYPHONE: "Telefon (firma):",
    LABEL_CONTACT: "Firma:",
    LABEL_CONTACT_OR_COMPANY: "Person eller firma:",
    LABEL_CREATE_AND_VISUALIZE: "Opret og visualiser som en professionel",
    LABEL_CURRENCY: "Valuta:",
    LABEL_DATE: "Dato:",
    LABEL_DESCRIPTION: "Beskrivelse:",
    LABEL_DIRECTPHONE: "Direkte nr.:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Find ud af, hvad dette tilføjelsesprogram kan gøre for dig i dag!",
    LABEL_HOME_ADDRESS: "Privatadresse",
    LABEL_MOBILEPHONE: "Mobilnr.:",
    LABEL_NOTES: "Noter:",
    LABEL_NUMBER: "Nummer:",
    LABEL_OPTIONAL_ATTENDEE: "Valgfri",
    LABEL_PERSON: "Person:",
    LABEL_POSITION: "Stilling:",
    LABEL_PROJECT: "Projekt:",
    LABEL_REQUIRED_ATTENDEE: "Påkrævet",
    LABEL_SALE: "Salg:",
    LABEL_SALE_AMOUNT: "Salgsbeløb:",
    LABEL_SALE_DATE: "Salgsdato:",
    LABEL_SALE_NAME: "Salgsnavn:",
    LABEL_SALE_TYPE: "Salgstype:",
    LABEL_SAVED_CHANGES: "Dine ændringer er blevet gemt.",
    LABEL_SELECT_CS_QUEUE: "Føj sag til denne kø:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Vælg kø",
    LABEL_SERVER_VERSION: "Serverversion:",
    LABEL_SUBJECT: "Overskrift:",
    LABEL_SUPEROFFICE_SITE: "SuperOffice-adresse:",
    LABEL_TELEPHONE: "Telefon:",
    LABEL_TIME: "Klokkeslæt:",
    LABEL_TYPE: "Type:",
    LABEL_UNLOCK_FEATURES: "Lås op for funktioner og funktionalitet",
    LABEL_URL: "URL:",
    LABEL_USER: "Bruger:",
    LABEL_VISIBLE_FOR: "Synlig for:",
    LABEL_WEB_PAGE: "Webside:",
    LASTNAME: "Efternavn",
    LEARN_MORE: "Få mere at vide",
    LOGIN_COMPLETE_SETUP: "Du skal logge på SuperOffice for at fuldføre opsætningen af SuperOffice Gmail Link.",
    LOGIN_ONSITE: "Log på din SuperOffice CRM onsite-installation.",
    LOGOUT_FROM_SUPEROFFICE_1: "Log af SuperOffice og luk eventuelle åbne SuperOffice-faner.",
    LOGOUT_FROM_SUPEROFFICE_2: "Næste gang du logger på SuperOffice CRM Online, bliver det nye link konfigureret automatisk.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Angiv som primær e-mailadresse.",
    MARK_COMPLETED: "Marker som udført",
    MARK_REMOVE_FROM_INBOX: "Fjern fra indbakke",
    MENU_ARCHIVE_EMAIL: "Arkiver e-mail",
    MENU_CREATE_APPOINTMENT: "Opret aktivitet",
    MENU_CREATE_NEW_SALE: "Opret nyt salg",
    MENU_SAVE_TO_SUPEROFFICE: "Gem i SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Personen har ingen e-mailadresse",
    MIDDLENAME: "Mellemnavn",
    MISSING_REQUIRED_VALUES_INTRO: "Nogle påkrævede felter er ikke tilgængelige for din brugerkonto:",
    ML_ADD_COMPANY: "Tilføj firma",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Tilføj e-mailadresse på person",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Tilføj nyt firma og ny person",
    ML_ADD_NEW_CONTACT_PERSON: "Tilføj ny person",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Arkiver e-mail som aftale i din kalender",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Arkiver e-mailmeddelelse i SuperOffice på afsenderens personkort",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Klik for at føje til SuperOffice",
    ML_COMPANY_DETAILS: "Firmaoplysninger",
    ML_CONTACT_DETAILS: "Personoplysninger",
    ML_CREATE_A_NEW_SALE: "Opret et nyt salg til denne kunde",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Afbryd forbindelsen mellem Outlook og SuperOffice",
    ML_INVITATION_OPTIONS: "Invitationer",
    ML_MOVE_INTO_CS_AS_REQUEST: "Føj denne e-mail til kundeservice som en ny sag",
    ML_OR_ADD_CONTACT_TO_COMPANY: "ELLER TILFØJ PERSON TIL FIRMA?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Personer nævnt i denne meddelelse",
    ML_PERSON_COULD_BE: "Denne kontakt kunne være",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Søg efter person eller firma ...",
    ML_SETTINGS_INVITATIONS_HEADER: "Invitationer til SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Tilføj/opdater aftale i SuperOffice, når du svarer på invitationer i Outlook.",
    MOBILE: "Mobil",
    MORE: "Mere",
    MRMS: "Hr./Fr.",
    MULTIPLE_EMAILADDRESSES_FOUND: "Denne e-mailadresse er registreret på flere personer i SuperOffice. Klik her for at vælge den rigtige person til arkivering.",
    MYPROFILE: "Min profil",
    NO_RESULTS: "Ingen resultater",
    NOTE_CONTACT_DATA_PREDICTED: "Baseret på indholdet af denne e-mail har vi foreslået detaljer for denne afsender. Kontrollér dem, før du opretter denne person.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Kontroller, at det brugernavn og den adgangskode, du har indtastet, er korrekt.",
    ONSITE_CONNECTION_SUCCESSFUL: "Tillykke. SuperOffice Gmail Link har oprettet forbindelse til din SuperOffice CRM onsite-installation.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Kontroller, at du er logget på din onsite-installation, før du fortsætter.",
    ONSITE_ERROR_LINE_1: "Der var problemer under loginprocessen.",
    ONSITE_ERROR_LINE_2: "Sørg for, at du har indtastet en korrekt server-URL-adresse. Klik på informationsknappen for at finde ud af, hvordan du får den.",
    ONSITE_PASSWORD: "Adgangskode:",
    ONSITE_SERVER_URL: "Server-URL:",
    ONSITE_SERVER_URL_LINE_1: "I SuperOffice CRM skal du vælge Kopiér genvej i hovedmenuen",
    ONSITE_SERVER_URL_LINE_2: "Indsæt derefter genvejen i server-URL'en her",
    ONSITE_URL: "URL til din SuperOffice CRM onsite-installation:",
    ONSITE_USER_NAME: "Brugernavn:",
    OPEN_IN_CRM: "Åbn i CRM",
    OR_UPPER: "ELLER",
    OUR_CONTACT: "Vores kontakt",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Hvis du skifter mening senere, skal du åbne tilføjelsesprogrammet SuperOffice til Outlook på kalenderskærmen igen",
    PERMISSION_CONTINUE: "Klik på \"Fortsæt\" for at åbne et nyt vindue og give de nødvendige tilladelser",
    PERMISSION_FOR_CALENDAR: "SuperOffice til Outlook skal bruge din tilladelse til at få adgang til dine kalenderelementer.",
    PICKER_BCC: "Bcc",
    PICKER_CC: "Cc",
    PICKER_CC_COPY: "Cc",
    PICKER_TO: "Til",
    PLACE_REQUEST_IN_QUEUE: "Anbring sagen i denne kø:",
    POPUP__BOTTOM_TEXT: "Tillad pop op-vinduer for denne side, og prøv igen.",
    POPUP__HEADER: "Blokering af pop op-vinduer fundet",
    POPUP__MID_TEXT: "SuperOffice til Outlook skal godkendes, men din browsers pop op-blokering forhindrer det.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Fjern fra indbakke",
    REMOVE_FROM_INBOX_DESC: "Flytter e-mailen til mappen Slettede e-mails efter arkivering",
    REQUEST: "Sag",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Denne e-mail er for stor til at blive føjet til en sag.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "E-mailen er for stor",
    REQUEST_PRIORITY: "Prioritet",
    REQUEST_QUEUE: "Sagskø:",
    RESET_ALL: "Nulstil alle",
    RESET_INFO_SOFO: "Vil du nulstille oplysningerne i SuperOffice til Outlook? Det indebærer, at de nuværende data fjernes.",
    REVISION_LABEL: "Version:",
    SEARCH_FAILED: "Søgningen mislykkedes. Prøv igen.",
    SETTINGS: "Indstillinger",
    SETTINGS_ApplyArchiveStatus: "Anvend arkivkategori",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Kun eksterne e-mailmodtagere",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Eksterne e-mailmodtagere er personer uden for din organisation.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Videresendelser",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Arkiveringspåmindelse",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Arkiveringspåmindelsen hjælper med at sikre, at e-mails og møder gemmes i SuperOffice, inden de sendes.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Du bliver mindet om at arkivere møder i SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Påmind mig, før jeg sender møder",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Nye e-mails",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Svar",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Du bliver mindet om at arkivere e-mails i SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Påmind mig, før jeg sender e-mails",
    SETTINGS_CategoryColor: "Kategorifarve",
    SETTINGS_CategoryName: "Kategorinavn",
    SETTINGS_CategoryNameFixedInfo: "Kategorinavnet er fast og kan ikke ændres.",
    SETTINGS_CategoryTaggingDescription: "Brug en Outlook-kategori til at identificere e-mails, der allerede er arkiveret i SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "E-mailens arkiveringsstatus hjælper dig med at se, hvilke e-mails der allerede er gemt i SuperOffice, direkte i din Outlook-postkasse.",
    SETTINGS_CategoryTaggingSection: "E-mailens arkiveringsstatus",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Standard aktivitetstype",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Standard-e-mailtype",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Indgående e-mail",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Udgående e-mail",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Standardskabelon til indgående e-mails",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Standardskabelon til udgående e-mails",
    SETTINGS_EnableCategoryForSharedMailbox: "I delte postkasser",
    SETTINGS_EnableCategoryOnOpen: "Ved åbning af arkiverede e-mails",
    SETTINGS_EnableCategoryOnSendAndArchive: "Ved brug af Send og arkivér",
    SETTINGS_EnableCategoryTagging: "Vis arkivkategori i Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Vis kontekstafhængige projekter og salg",
    SETTINGS_GENERAL_HEADER: "Generelt",
    SETTINGS_SharedMailboxCategoryInfo: "Arkivkategorien skal være oprettet i den delte postkasse, for at arkiveringsstatus kan vises.",
    SETTINGS_SharedMailboxCategoryInfoBold: "For delte postkasser",
    SETTINGS_SharedMailboxCategoryLearnMore: "Læs mere om opsætning af delte postkasser",
    SETTINGS_YOURCOMPANY: "Firmanavn:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Arkivér og send",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Vælg en person eller et firma, der skal arkiveres.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Denne e-mail er klar til afsendelse, men den kan ikke arkiveres i SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Arkiv",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Denne e-mail er klar til afsendelse, men den er ikke indstillet til at blive arkiveret i SuperOffice. Arkivér den nu, så meddelelsen gemmes under det rigtige firma eller den rigtige person, eller send den uden at arkivere den.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Der opstod en fejl under indlæsning af indstillinger.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Log på SuperOffice før du åbner indstillinger.",
    SR_ADMIN_MYAPPS: "Mine apps",
    SR_ALL_ITEM: "Alle",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Er du sikker på, at du vil deaktivere biometrisk login? Du skal logge ind manuelt igen næste gang.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Der kunne ikke kopieres til udklipsholder",
    SR_NO_SELECTION: "(Ingen valgt)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Kom i gang med nogle få klik",
    SYNCHRONIZER_REACTIVATE: "Genaktiver med nogle få klik",
    SYNCRONIZER_MSG_CONTENT: "Synkroniser din Outlook-kalender og dine opgaver med SuperOffice CRM for at holde møder, personer, projekter og salg opdateret.",
    SYNCRONIZER_NEED_AUTHENTICATION: "SuperOffice Kalendersynkronisering med Outlook er næsten konfigureret. Fortsæt med at aktivere det og holde dine kalendere synkroniserede.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "Din SuperOffice Kalendersynkronisering med Outlook er afbrudt. Fortsæt med at genaktivere og holde dine kalendere synkroniserede.",
    TAB_ACTION: "Handling",
    TAB_PEOPLE: "Mennesker",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Aktiviteten er oprettet i SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Aktiviteten er oprettet i SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "Serveren var for lang tid om at svare. Prøv igen.",
    TIMEOUT_ERROR_TITLE: "Anmodningen er udløbet",
    TITLE: "Titel",
    UNDO: "Fortryd",
    UNKNOWN_EMAIL_ADDRESS: "Ukendt e-mailadresse.",
    UNKNOWN_EMAILADDRESS: "Senders e-mailadresse er ikke registreret. Klik her for at tilføje den i SuperOffice. ",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Modtagerens e-mailadresse er ikke registreret. Klik her for at opdatere SuperOffice med denne adresse. ",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Ukendt e-mailadresse. Tilføj {0} i SuperOffice.",
    UNLOCK_THESE_FEATURES: "Lås op for disse funktioner med synkroniseringsprogrammet",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.dk/crm/demo/",
    VERSION_SHORT: "ver.",
    VISIT_APP_STORE: "Besøg App Store",
    WE_RUN_ONLINE_LINE_1: "Gør følgende for at finde ud af, om du kører online:",
    WE_RUN_ONLINE_LINE_2: "1. I SuperOffice CRM skal du vælge Hjælp og derefter Om",
    WE_RUN_ONLINE_LINE_3: "2. Se på posten for NetServer:",
    WE_RUN_ONLINE_LINE_4: "Hvis der står \"SuperOffice CRM Online ... \", kører du online",
    WE_RUN_ONSITE_LINE_1: "Gør følgende for at finde ud af, om du kører onsite:",
    WE_RUN_ONSITE_LINE_4: "Hvis der står \"SuperOffice CRM Onsite ... \", kører du onsite",
    YOU_CAN_STILL_USE: "Du kan stadig bruge SuperOffice til Outlook til e-mails!",
  },
  DE: {
    ACTION_ADD: "Hinzufügen",
    ACTION_BACK: "Zurück",
    ACTIVITIES: "Aktivitäten",
    ADD_ATTENDEES: "Kontakt von SuperOffice einladen.",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "E-Mail-Adresse zu vorhandener Person hinzufügen",
    AI_SUMMARY_AI_NOT_ENABLED: "KI-Textfunktionen sind für Ihre Organisation nicht aktiviert. Wenden Sie sich an Ihren SuperOffice-Administrator.",
    AI_SUMMARY_APPEND: "Anhängen",
    AI_SUMMARY_FEATURE_DISABLED: "Diese Funktion wurde für Ihre Organisation deaktiviert.",
    AI_SUMMARY_GENERATE: "Generieren",
    AI_SUMMARY_GENERATE_ERROR: "Im Moment konnte keine Zusammenfassung erstellt werden. Bitte erneut versuchen.",
    AI_SUMMARY_GENERATE_TOOLTIP: "KI-Zusammenfassung erstellen",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Teilnehmer:",
    AI_SUMMARY_HEADER_SUBJECT: "Betreff:",
    AI_SUMMARY_LOADING: "Zusammenfassung wird erstellt\u00A0…",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Sie haben keine Lizenz zur Nutzung von KI-Funktionen",
    AI_SUMMARY_NO_PERMISSION: "Sie haben keine Berechtigung, diese E-Mail zu lesen.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "In dieser E-Mail gibt es nichts zusammenzufassen.",
    AI_SUMMARY_REPLACE_CONFIRM: "Ersetzen",
    ALREADY_ARCHIVED_ATTACHMENT: "Der Anhang wurde bereits von <%- archivedBy %> am <%- archivedAt %> archiviert.",
    ALREADY_ARCHIVED_EMAIL: "Diese E-Mail wurde bereits von <%- archivedBy %> am <%- archivedAt %> archiviert.",
    ALREADY_ARCHIVED_SALE: "Ein Verkauf zu dieser E-Mail wurde bereits von <%- archivedBy %> am <%- archivedAt %>erstellt.",
    ALREADY_ARCHIVED_TASK: "Die Aktivität zu dieser E-Mail wurde bereits von <%- archivedBy %> am <%- archivedAt %>erstellt.",
    ALREADY_DONE: "Bereits erledigt",
    APPOINTMENT_EXISTS_IN_CRM: "Dieser Termin existiert in CRM und wurde von <%- createdBy %> am <%- creationDate %> erstellt.",
    ARCHIVE_ACTIVITY: "Aktivität erstellen",
    ARCHIVE_ALWAYS_SHOW: "Dialogfeld für Archivierung immer anzeigen",
    ARCHIVE_AS_ACTIVITY: "Termin in SuperOffice erstellen",
    ARCHIVE_AS_ATTACHMENT: "Anhang in SuperOffice speichern",
    ARCHIVE_AS_REQUEST: "Anfrage in SuperOffice erstellen",
    ARCHIVE_AS_SALE: "Verkauf in SuperOffice erstellen",
    ARCHIVE_AS_TASK: "Aufgabe in SuperOffice erstellen",
    ARCHIVE_REMOVE_FROM_INBOX: "E-Mail nach Archivieren standardmäßig aus Posteingang entfernen ",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Andere als E-Mail-Vorlagen in Vorlagenliste hinzufügen",
    ATTACHMENT_SIZE_INFO: "Die Anhänge sind zu groß und können nicht archiviert werden. Es können nur E-Mails ohne Anhänge archiviert werden.",
    AUTH__BOTTOM_TEXT_1: "\u2028Benötigen Sie weitere Details?",
    AUTH__BOTTOM_TEXT_2: "Erfahren Sie, wie Sie das Add-in genehmigen",
    AUTH__BUTTON: "Admin-Link kopieren",
    AUTH__COPIED: "In die Zwischenablage kopiert",
    AUTH__HEADER: "Aktualisierung von SuperOffice für Outlook",
    AUTH__INCREMENTAL_TEXT_1: "Zur Aktivierung von {feature} sind zusätzliche Berechtigungen erforderlich.",
    AUTH__MID_TEXT_1: "Zur Erfüllung der neuesten Sicherheitsanforderungen von Microsoft wurde das Outlook-Add-in aktualisiert.",
    AUTH__MID_TEXT_2: "Zur weiteren Nutzung muss <b>ein Microsoft 365 Global Administrator im Namen aller Benutzer Berechtigungen</b> (Genehmigung) erteilen.",
    AUTH__MID_TEXT_3: "<b>Teilen Sie diesen Link</b> mit Ihrem Microsoft 365-Administrator.",
    AUTH__NEW_USER_TEXT_1: "Das SuperOffice for Outlook-Add-in erfordert zusätzliche Berechtigungen, um auf Microsoft 365-Daten zugreifen zu können.",
    AUTH_IN_PROGRESS__HEADER: "Autorisierung läuft",
    AUTH_IN_PROGRESS__MID_TEXT: "Bitte setzen Sie die laufende interaktive Authentifizierung fort und versuchen Sie es erneut.",
    AUTOSAVE_FAIL: "Nicht gespeichert.",
    AUTOSAVE_IN_PROGRESS: "Wird gespeichert\u00A0…",
    AUTOSAVE_RETRY: "Erneut versuchen",
    AUTOSAVE_SUCCESS: "Gespeichert",
    BANNER_ADD_MESSAGE: "Nachricht erstellt.",
    BANNER_CREATE_APPOINTMENT: "Termin erstellt.",
    BANNER_CREATE_REQUEST: "Anfrage erstellt.",
    BANNER_CREATE_SALE: "Verkauf erstellt.",
    BANNER_CREATE_TASK: "Aufgabe erstellt.",
    BANNER_SAVE_ATTACHMENT: "Anhang gespeichert.",
    BANNER_SAVE_TO_SUPEROFFICE: "E-Mail gespeichert.",
    BANNER_VIEW_IN_CRM: "Im CRM anzeigen",
    BTN_ADD_TO_EXISTING_REQUEST: "Nachricht zur Anfrage hinzufügen",
    BTN_ADD_TO_SUPEROFFICE: "Zu SuperOffice hinzufügen",
    BTN_ARCHIVE: "Archiv",
    BTN_CANCEL: "Abbrechen",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Klicken Sie hier, um eine neue Person hinzuzufügen",
    BTN_CONNECT: "Verbinden",
    BTN_CONNECT_TO_SUPEROFFICE: "Wir verwenden SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Wir verwenden SuperOffice Onsite",
    BTN_CREATE: "Erstellen",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Neue Firma und Person erstellen",
    BTN_GO_TO_SUPEROFFICE: "Zu SuperOffice wechseln",
    BTN_KEEP_CONTACT: "Beibehalten",
    BTN_LOGIN: "Login",
    BTN_LOOKUP_SENDER: "Nach Absender suchen",
    BTN_OK: "OK",
    BTN_RECONNECT: "SuperOffice Benutzer ändern",
    BTN_SAVE: "Speichern",
    BTN_SAVE_AND_ARCHIVE: "Senden und archivieren",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Für Free Trial anmelden",
    BTN_UPDATE_CONTACT: "Aktualisieren",
    BUSINESS: "Branche",
    BUTTON_LETS_GO: "Loslegen",
    BUTTON_RELOAD: "Neu laden",
    CAN_NOT_GRANT_PERMISSION: "Kann keine Erlaubnis erteilt werden?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Die Nachricht kann der Anfrage nicht hinzugefügt werden",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Die Anhänge können nicht archiviert werden, da einige davon möglicherweise unsicher sind. Es können nur E-Mails ohne Anhänge archiviert werden.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Ein digital signierter Anhang kann nicht gespeichert werden",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Diese E-Mail ist digital signiert. Anhänge in der Unterschrift können nicht einzeln gespeichert werden.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Archivierung nicht möglich, da Anlage möglicherweise unsicher",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Die Anfrage kann nicht erstellt werden",
    CANNOT_SAVE_CONTACT: "Person kann nicht gespeichert werden",
    CATEGORY: "Kategorie",
    CHANGES_SAVED_AUTOMATICALLY: "Ihre Änderungen werden automatisch gespeichert",
    CHOOSE_ONE_OR_CONTINUE: "Bitte eine auswählen, um fortzufahren.",
    CLICK_HERE_TO_SEE_IT: "Zum Anzeigen hier klicken.",
    CLICK_HERE_TO_SELECT_CONTACT: "Ausgewählte Person",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Klicken Sie hier, um für die Archivierung die richtige Person auszuwählen.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} mehr. Klicken Sie hier, um alle anzuzeigen.",
    CLICK_LOGIN_ONSITE: "Klicken Sie hier, um Ihre SuperOffice-Installation in einer neuen Registerkarte zu öffnen.",
    COMMENT_PLACEHOLDER: "Einen Kommentar hinzufügen\u00A0…",
    COMPANY_NAME: "Firmenname",
    CONNECT_ONSITE: "Mit SuperOffice CRM Onsite-Installation verbinden",
    CONNECT_TO_SUPEROFFICE: "Mit Ihrem SuperOffice CRM Online-Konto verbinden",
    CONTACT_ADMINISTRATOR: "Wenden Sie sich an Ihren SuperOffice-Administrator, um Ihre CRM-Konfiguration zu überprüfen.",
    CONTINUE: "Fortfahren",
    COULD_IT_BE_ONE_OF_THESE: "Ist es eventuell eine dieser Personen?",
    COUNTRY: "Land",
    CREATE_NEW_COMPANY: "Neue Firma erstellen",
    CREATE_NEW_CONTACT: "Neue Person erstellen",
    CREATE_REQUEST: "Anfrage erstellen",
    CREATED_REQUEST: "Anfrage wurde erstellt",
    DEPARTMENT: "Abteilung",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Anhänge nicht archivieren",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Anhänge werden standardmäßig archiviert",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-Mail in SuperOffice archiviert.",
    EMAIL_ADDRESS: "E-Mail",
    EMAIL_ADDRESS_NOT_REGISTERED: "Diese E-Mail-Adresse ist in SuperOffice nicht vorhanden.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> ist mehreren Personen in SuperOffice zugewiesen.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-Mail in SuperOffice registriert.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Die E-Mail-Adresse ist für mehrere Personen in SuperOffice registriert.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Aktivieren Sie die Archivierung, um diese Einstellungen zu bearbeiten",
    ERROR: "Fehler",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "E-Mail-Adresse kann nicht zu SuperOffice hinzugefügt werden.",
    ERROR_ARCHIVING_ATTACHMENT: "Anhang kann nicht archiviert werden.",
    ERROR_ARCHIVING_EMAIL: "E-Mail kann nicht archiviert werden.",
    ERROR_ARCHIVING_REQUEST: "Anfrage kann nicht archiviert werden.",
    ERROR_ARCHIVING_TASK: "Aktivität kann nicht erstellt werden.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Kommunikation mit SuperOffice nicht möglich.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Sie sind nicht berechtigt, in SuperOffice Firmen oder Personen zu erstellen.",
    FIND_COMPANY_OR_PERSON: "Firma oder Person suchen ...",
    FIRST_ATTENDEE_CHANGED: "Der Kontakt für die Besprechung hat sich geändert.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Wählen Sie die Person aus, mit der der Termin verknüpft werden soll.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Person und Besprechungsteilnehmer stimmen nicht überein",
    FIRSTNAME: "Vorname",
    FOLLOWUPS: "Folgeaufgaben",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice für Outlook konnte keine Verbindung zu den Microsoft-Diensten herstellen. Bitte versuchen Sie es in Kürze erneut.",
    GRAPH_API_ERROR_TITLE_SOFO: "Microsoft-Dienste sind vorübergehend nicht verfügbar",
    HEADER_ADD_EMAIL: "E-Mail/Person hinzufügen: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "E-Mail-Adresse zu SuperOffice hinzufügen",
    HEADER_ADD_RECPIENTS: "Empfänger aus SuperOffice hinzufügen",
    HEADER_ADD_TO_EXISTING_PERSON: "Zu vorhandener Person hinzufügen",
    HEADER_ARCHIVE_APPOINTMENT: "Aktivität erstellen",
    HEADER_ARCHIVE_ATTACHMENT: "Anhang als SuperOffice Dokument archivieren",
    HEADER_ARCHIVE_EMAIL: "E-Mail in SuperOffice archivieren",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Mit anderer SuperOffice Installation verbinden",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Aktivität in SuperOffice auf Grundlage von E-Mail erstellen",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Anhänge dieser E-Mail in SuperOffice speichern",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Diese E-Mail in SuperOffice archivieren",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Anfrage in SuperOffice auf Grundlage von E-Mail erstellen",
    HEADER_CREATE_EMAIL_AS_SALE: "Verkauf in SuperOffice auf Grundlage dieser E-Mail erstellen",
    HEADER_CREATE_EMAIL_AS_TASK: "Basierend auf E-Mail Aufgabe in Ihrer Checkliste erstellen",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Neue Firma und Person erstellen",
    HEADER_CREATE_NEW_PERSON: "Neue Person erstellen",
    HEADER_WELCOME: "Willkommen",
    LABEL_ACHIEVE_MORE: "Mit Integration mehr erreichen",
    LABEL_ADD_TO_EXISTING_REQUEST: "E-Mail als Nachricht in vorhandener Anfrage in SuperOffice hinzufügen",
    LABEL_ARCHIVE_FILE: "Datei archivieren:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Anhang bereits gespeichert",
    LABEL_ATTACHMENT_NOT_SAVED: "Anhang nicht gespeichert",
    LABEL_COMMENT: "Kommentar:",
    LABEL_COMPANYPHONE: "Firmen-Telefonnummer:",
    LABEL_CONTACT: "Firma:",
    LABEL_CONTACT_OR_COMPANY: "Kontaktperson oder Firma:",
    LABEL_CREATE_AND_VISUALIZE: "Wie ein Profi erstellen und visualisieren",
    LABEL_CURRENCY: "Währung:",
    LABEL_DATE: "Datum:",
    LABEL_DESCRIPTION: "Beschreibung:",
    LABEL_DIRECTPHONE: "Telefon-Direkt:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Entdecken Sie noch heute, welche Vorteile dieses Add-In Ihnen bietet!",
    LABEL_HOME_ADDRESS: "Privatadresse:",
    LABEL_MOBILEPHONE: "Mobiltelefon:",
    LABEL_NOTES: "Notizen:",
    LABEL_NUMBER: "Nummer:",
    LABEL_OPTIONAL_ATTENDEE: "Optional",
    LABEL_PERSON: "Person:",
    LABEL_POSITION: "Position:",
    LABEL_PROJECT: "Projekt:",
    LABEL_REQUIRED_ATTENDEE: "Erforderlich",
    LABEL_SALE: "Verkauf:",
    LABEL_SALE_AMOUNT: "Verkaufsbetrag:",
    LABEL_SALE_DATE: "Verkaufsdatum:",
    LABEL_SALE_NAME: "Verkaufsname:",
    LABEL_SALE_TYPE: "Verkaufstyp:",
    LABEL_SAVED_CHANGES: "Ihre Änderungen wurden gespeichert.",
    LABEL_SELECT_CS_QUEUE: "Anfrage zu dieser Warteschlange hinzufügen:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Warteschlange auswählen",
    LABEL_SERVER_VERSION: "Serverversion:",
    LABEL_SUBJECT: "Betreff:",
    LABEL_SUPEROFFICE_SITE: "SuperOffice Website:",
    LABEL_TELEPHONE: "Telefon:",
    LABEL_TIME: "Uhrzeit:",
    LABEL_TYPE: "Typ:",
    LABEL_UNLOCK_FEATURES: "Funktionen freischalten",
    LABEL_URL: "URL:",
    LABEL_USER: "Benutzer:",
    LABEL_VISIBLE_FOR: "Sichtbar für:",
    LABEL_WEB_PAGE: "Webseite:",
    LASTNAME: "Nachname",
    LEARN_MORE: "Mehr erfahren",
    LOGIN_COMPLETE_SETUP: "Zum Abschließen der Konfiguration von SuperOffice Gmail Link müssen Sie sich bei SuperOffice anmelden.",
    LOGIN_ONSITE: "Bitte loggen Sie sich bei Ihrer SuperOffice CRM Onsite-Installation ein.",
    LOGOUT_FROM_SUPEROFFICE_1: "Melden Sie sich von SuperOffice ab und schließen Sie alle offenen SuperOffice Registerkarten.",
    LOGOUT_FROM_SUPEROFFICE_2: "Wenn Sie sich das nächste Mal bei SuperOffice CRM Online anmelden, wird die neue Verbindung automatisch hergestellt.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Diese als primäre E-Mail-Adresse festlegen",
    MARK_COMPLETED: "Als \"Erledigt\" markieren",
    MARK_REMOVE_FROM_INBOX: "Aus Posteingang entfernen",
    MENU_ARCHIVE_EMAIL: "E-Mail archivieren",
    MENU_CREATE_APPOINTMENT: "Aktivität erstellen",
    MENU_CREATE_NEW_SALE: "Neuen Verkauf erstellen",
    MENU_SAVE_TO_SUPEROFFICE: "In SuperOffice speichern",
    MESSAGE_NO_EMAIL_ADDRESS: "Person hat keine E-Mail-Adresse",
    MIDDLENAME: "Zweiter Vorname",
    MISSING_REQUIRED_VALUES_INTRO: "Einige Pflichtfelder stehen für Ihr Benutzerkonto nicht zur Verfügung:",
    ML_ADD_COMPANY: "Firma hinzufügen",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "E-Mail-Adresse zu Person hinzufügen",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Neue Firma und Person hinzuzufügen",
    ML_ADD_NEW_CONTACT_PERSON: "Neue Person hinzufügen",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Diese E-Mail als Termin im Kalender archivieren",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "E-Mail in SuperOffice auf Firmenkarte des Absenders archivieren",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Klicken, um zu SuperOffice hinzuzufügen",
    ML_COMPANY_DETAILS: "Firmendetails",
    ML_CONTACT_DETAILS: "Personendetails",
    ML_CREATE_A_NEW_SALE: "Neuen Verkauf für diesen Kunden erstellen",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Outlook von SuperOffice trennen",
    ML_INVITATION_OPTIONS: "Einladungen",
    ML_MOVE_INTO_CS_AS_REQUEST: "Diese E-Mail dem Customer Service als neue Anfrage hinzufügen",
    ML_OR_ADD_CONTACT_TO_COMPANY: "ODER PERSON ZU FIRMA HINZUFÜGEN?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "In dieser Nachricht erwähnte Personen",
    ML_PERSON_COULD_BE: "Bei dieser Person könnte sich um folgende handeln",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Nach Person oder Firma suchen...",
    ML_SETTINGS_INVITATIONS_HEADER: "Einladungen für SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Hinzufügen/Aktualisieren von Terminen in SuperOffice beim Antworten auf Einladungen in Outlook.",
    MOBILE: "Mobiltelefon",
    MORE: "Mehr",
    MRMS: "Hr./Fr.",
    MULTIPLE_EMAILADDRESSES_FOUND: "Die E-Mail-Adresse ist für mehrere Personen in SuperOffice registriert. Klicken Sie hier, um für die Archivierung die richtige Person auszuwählen.",
    MYPROFILE: "Mein Profil\r\n",
    NO_RESULTS: "Keine Ergebnisse",
    NOTE_CONTACT_DATA_PREDICTED: "Ausgehend vom Inhalt dieser E-Mail haben wir Details für diesen Absender vorgeschlagen. Bitte überprüfen, bevor Sie diese Person erstellen.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Überprüfen Sie, ob der von Ihnen eingegebene Benutzername und das Passwort korrekt sind.",
    ONSITE_CONNECTION_SUCCESSFUL: "Herzlichen Glückwunsch. SuperOffice Gmail Link wurde erfolgreich mit Ihrer SuperOffice CRM Onsite-Installation verbunden.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Bitte prüfen Sie, ob Sie bei Ihrer Onsite-Installation eingeloggt sind, bevor Sie fortfahren.",
    ONSITE_ERROR_LINE_1: "Während des Anmeldevorgangs gab es einige Probleme.",
    ONSITE_ERROR_LINE_2: "Stellen Sie sicher, dass Sie eine korrekte Server-URL eingegeben haben. Klicken Sie auf die Informationsschaltfläche, um herauszufinden, wo Sie sie finden.",
    ONSITE_PASSWORD: "Passwort:",
    ONSITE_SERVER_URL: "Server-URL:",
    ONSITE_SERVER_URL_LINE_1: "Wählen Sie in SuperOffice CRM \"Shortcut kopieren\" aus dem Hauptmenü",
    ONSITE_SERVER_URL_LINE_2: "Fügen Sie ihn dann hier in die Server-URL ein",
    ONSITE_URL: "URL zu Ihrer SuperOffice CRM Onsite-Installation:",
    ONSITE_USER_NAME: "Benutzername:",
    OPEN_IN_CRM: "Im CRM öffnen",
    OR_UPPER: "ODER",
    OUR_CONTACT: "Verantwortlich",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Sollten Sie Ihre Meinung später ändern, öffnen Sie bitte das SuperOffice for Outlook-Add-in erneut im Kalenderbildschirm",
    PERMISSION_CONTINUE: "Klicken Sie auf „Weiter“, um ein neues Fenster zu öffnen und die erforderlichen Berechtigungen zu erteilen.",
    PERMISSION_FOR_CALENDAR: "SuperOffice for Outlook benötigt Ihre Erlaubnis, um auf Ihre Kalenderelemente zuzugreifen.",
    PICKER_BCC: "BCC",
    PICKER_CC: "CC",
    PICKER_CC_COPY: "CC",
    PICKER_TO: "An",
    PLACE_REQUEST_IN_QUEUE: "Anfrage in diese Warteschlange stellen:",
    POPUP__BOTTOM_TEXT: "Bitte erlauben Sie Pop-ups für diese Seite und versuchen Sie es erneut.",
    POPUP__HEADER: "Pop-up-Blocker erkannt",
    POPUP__MID_TEXT: "SuperOffice für Outlook erfordert eine Authentifizierung. Der Vorgang wird jedoch durch den Pop-up-Blocker Ihres Browsers verhindert.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Aus Eingangsbox entfernen",
    REMOVE_FROM_INBOX_DESC: "Verschiebt E-Mails nach der Archivierung in den Ordner „Gelöschte Objekte“",
    REQUEST: "Anfrage",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Diese E-Mail ist zu groß, um sie einer Anfrage hinzuzufügen.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "E-Mail zu groß",
    REQUEST_PRIORITY: "Priorität",
    REQUEST_QUEUE: "Anfragewarteschlange",
    RESET_ALL: "Alles zurücksetzen",
    RESET_INFO_SOFO: "Möchten Sie die Informationen für Outlook in SuperOffice zurücksetzen? Hierdurch werden die aktuellen Daten entfernt.",
    REVISION_LABEL: "Version:",
    SEARCH_FAILED: "Die Suche ist fehlgeschlagen. Bitte erneut versuchen.",
    SETTINGS: "Einstellungen",
    SETTINGS_ApplyArchiveStatus: "Archivkategorie anwenden",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Nur externe Empfänger",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Externe Empfänger sind Personen außerhalb Ihrer Organisation.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Weiterleiten",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Erinnerung ans Archivieren",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Die Archivierungserinnerung trägt dazu bei, dass E-Mails und Besprechungen vor dem Versenden in SuperOffice gespeichert werden.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Sie werden daran erinnert, Besprechungen in SuperOffice zu archivieren.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Vor dem Senden von Besprechungen erinnern",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Neue E-Mails",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Antworten",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Sie werden daran erinnert, E-Mails in SuperOffice zu archivieren.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Vor dem Senden von E-Mails erinnern",
    SETTINGS_CategoryColor: "Kategoriefarbe",
    SETTINGS_CategoryName: "Kategoriebezeichnung",
    SETTINGS_CategoryNameFixedInfo: "Die Kategoriebezeichnung ist fest vorgegeben und kann nicht geändert werden.",
    SETTINGS_CategoryTaggingDescription: "Verwenden Sie eine Outlook-Kategorie, um E-Mails zu kennzeichnen, die bereits in SuperOffice archiviert wurden.",
    SETTINGS_CategoryTaggingInfo: "Mit dem Archivstatus der E-Mail sehen Sie direkt in Ihrem Outlook-Postfach, welche E-Mails bereits in SuperOffice gespeichert wurden.",
    SETTINGS_CategoryTaggingSection: "Archivstatus der E-Mail",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Standardaktivitätstyp",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Standard-E-Mail-Typ",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Eingehende E-Mail",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Ausgehende E-Mail",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Standardvorlage für eingehende E-Mail",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Standardvorlage für ausgehende E-Mail",
    SETTINGS_EnableCategoryForSharedMailbox: "In gemeinsamen Postfächern",
    SETTINGS_EnableCategoryOnOpen: "Beim Öffnen archivierter E-Mails",
    SETTINGS_EnableCategoryOnSendAndArchive: "Bei Verwendung von „Senden und archivieren“",
    SETTINGS_EnableCategoryTagging: "Archivkategorie in Outlook anzeigen",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Kontextbezogene Projekte und Verkäufe anzeigen",
    SETTINGS_GENERAL_HEADER: "Allgemein",
    SETTINGS_SharedMailboxCategoryInfo: "Um den Archivstatus anzuzeigen, muss die Archivkategorie im gemeinsamen Postfach angelegt werden.",
    SETTINGS_SharedMailboxCategoryInfoBold: "Für gemeinsam genutzte Postfächer:",
    SETTINGS_SharedMailboxCategoryLearnMore: "Mehr erfahren über die Einrichtung gemeinsamer Postfächer",
    SETTINGS_YOURCOMPANY: "Firmenname:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Archivieren und senden",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Wählen Sie eine Person oder ein Unternehmen zur Archivierung aus.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Diese E-Mail ist versandfertig, kann jedoch nicht in SuperOffice archiviert werden.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Archiv",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Diese E-Mail ist versandfertig, Archivieren in SuperOffice ist jedoch nicht aktiviert. Archivieren Sie die Nachricht jetzt, damit die Kommunikation unter dem richtigen Unternehmen oder der richtigen Person gespeichert wird, oder senden Sie sie ohne Archivierung.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Beim Laden von Einstellungen ist ein Fehler aufgetreten.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Melden Sie sich bitte vor dem Öffnen von Einstellungen bei SuperOffice an.",
    SR_ADMIN_MYAPPS: "Meine Apps",
    SR_ALL_ITEM: "Alle",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Möchten Sie die biometrische Anmeldung wirklich deaktivieren? Sie müssen sich beim nächsten Mal erneut manuell anmelden.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Kopieren in die Zwischenablage fehlgeschlagen",
    SR_NO_SELECTION: "(Keine Selektion)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Startklar in wenigen Klicks",
    SYNCHRONIZER_REACTIVATE: "Reaktivierung in wenigen Klicks",
    SYNCRONIZER_MSG_CONTENT: "Synchronisieren Sie Ihren Outlook-Kalender und Ihre Aufgaben mit SuperOffice CRM, um Besprechungen, Kontakte, Projekte und Verkäufe immer aktuell zu halten.",
    SYNCRONIZER_NEED_AUTHENTICATION: "Die Einrichtung der SuperOffice-Kalendersynchronisierung mit Outlook ist fast abgeschlossen. Setzen Sie die Aktivierung fort und halten Sie Ihre Kalender synchronisiert.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "Ihre SuperOffice-Kalender-Synchronisierung mit Outlook ist derzeit unterbrochen. Fahren Sie mit der Reaktivierung fort und halten Sie Ihre Kalender synchronisiert.",
    TAB_ACTION: "Aktion",
    TAB_PEOPLE: "Personen",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Aktivität in SuperOffice erstellt.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Aktivität in SuperOffice erstellt.",
    TIMEOUT_ERROR_MESSAGE: "Der Server hat zu lange gebraucht, um zu antworten. Bitte erneut versuchen.",
    TIMEOUT_ERROR_TITLE: "Zeitüberschreitung bei der Anfrage",
    TITLE: "Titel",
    UNDO: "Annullieren",
    UNKNOWN_EMAIL_ADDRESS: "Unbekannte E-Mail-Adresse.",
    UNKNOWN_EMAILADDRESS: "Die E-Mail-Adresse des Absenders wird nicht erkannt. Klicken Sie hier, um diese E-Mail-Adresse zu SuperOffice hinzuzufügen.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Die E-Mail-Adresse dieses Empfängers ist nicht bekannt. Klicken Sie hier, um SuperOffice mit dieser E-Mail-Adresse zu aktualisieren.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Unbekannte E-Mail-Adresse. {0} zu SuperOffice hinzufügen.",
    UNLOCK_THESE_FEATURES: "Erschließen Sie sich diese Funktionen mit dem Synchronizer",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.de/crm/demo/",
    VERSION_SHORT: "Ver.",
    VISIT_APP_STORE: "App Store besuchen",
    WE_RUN_ONLINE_LINE_1: "Gehen Sie wie folgt vor, um festzustellen, ob Sie Online ausführen:",
    WE_RUN_ONLINE_LINE_2: "1. Wählen Sie in SuperOffice CRM \"Hilfe\" und dann \"Info\".",
    WE_RUN_ONLINE_LINE_3: "2. Schauen Sie sich den Eintrag für NetServer an:",
    WE_RUN_ONLINE_LINE_4: "Wenn \"SuperOffice CRM Online ... \" angegeben ist, wird Online ausgeführt",
    WE_RUN_ONSITE_LINE_1: "Gehen Sie wie folgt vor, um festzustellen, ob Sie Onsite ausführen:",
    WE_RUN_ONSITE_LINE_4: "Wenn \"SuperOffice CRM OnSite ... \" angegeben ist, wird Onsite ausgeführt",
    YOU_CAN_STILL_USE: "Sie können SuperOffice für Outlook aber weiterhin für E-Mails nutzen!",
  },
  EN_US: {
    ACTION_ADD: "Add",
    ACTION_BACK: "Back",
    ACTIVITIES: "Activities",
    ADD_ATTENDEES: "Invite contact from SuperOffice.",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Add e-mail address to existing contact",
    AI_SUMMARY_AI_NOT_ENABLED: "AI text features are not enabled for your organization. Contact your SuperOffice administrator.",
    AI_SUMMARY_APPEND: "Append",
    AI_SUMMARY_FEATURE_DISABLED: "This feature has been turned off for your organization.",
    AI_SUMMARY_GENERATE: "Generate",
    AI_SUMMARY_GENERATE_ERROR: "Couldn't generate a summary right now. Please try again.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Generate AI summary",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Participants:",
    AI_SUMMARY_HEADER_SUBJECT: "Subject:",
    AI_SUMMARY_LOADING: "Generating summary…",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "You do not have a license to use AI features",
    AI_SUMMARY_NO_PERMISSION: "You don't have permission to read this e-mail.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "There's nothing to summarize in this e-mail.",
    AI_SUMMARY_REPLACE_CONFIRM: "Replace",
    ALREADY_ARCHIVED_ATTACHMENT: "The attachment is already archived by <%- archivedBy %> on <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "This e-mail is already archived by <%- archivedBy %> on <%- archivedAt %>.",
    ALREADY_ARCHIVED_SALE: "A sale has already been created for this e-mail by <%- archivedBy %> on <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "The activity has already been created for this e-mail by <%- archivedBy %> on <%- archivedAt %>.",
    ALREADY_DONE: "Already done",
    APPOINTMENT_EXISTS_IN_CRM: "This appointment exists in CRM and was created by <%- createdBy %> on <%- creationDate %>.\n ",
    ARCHIVE_ACTIVITY: "Create activity",
    ARCHIVE_ALWAYS_SHOW: "Always show the archive dialog",
    ARCHIVE_AS_ACTIVITY: "Create appointment in SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Save attachment in SuperOffice",
    ARCHIVE_AS_REQUEST: "Create request in SuperOffice",
    ARCHIVE_AS_SALE: "Create sale in SuperOffice",
    ARCHIVE_AS_TASK: "Create task in SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Remove e-mail from inbox after archiving as default",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Include non e-mail templates in template list",
    ATTACHMENT_SIZE_INFO: "Attachments are too large and cannot be archived. Only the e-mail without attachments can be archived.",
    AUTH__BOTTOM_TEXT_1: "Need more details?",
    AUTH__BOTTOM_TEXT_2: "Learn how to authorize the add-in",
    AUTH__BUTTON: "Copy admin link",
    AUTH__COPIED: "Copied to clipboard",
    AUTH__HEADER: "SuperOffice for Outlook update",
    AUTH__INCREMENTAL_TEXT_1: "To enable {feature}, additional permissions are required.",
    AUTH__MID_TEXT_1: "To meet Microsoft’s latest security requirements, the Outlook add-in has been updated.",
    AUTH__MID_TEXT_2: "To continue using it, <b>a Microsoft 365 Global Administrator must grant permissions</b> (consent) on behalf of all users.",
    AUTH__MID_TEXT_3: "<b>Share this link</b> with your Microsoft 365 administrator:",
    AUTH__NEW_USER_TEXT_1: "The SuperOffice for Outlook add-in requires additional permissions to access Microsoft 365 data.",
    AUTH_IN_PROGRESS__HEADER: "Authorisation in progress",
    AUTH_IN_PROGRESS__MID_TEXT: "Please continue the interactive authentication that is currently in progress and retry.",
    AUTOSAVE_FAIL: "Not saved.",
    AUTOSAVE_IN_PROGRESS: "Saving...",
    AUTOSAVE_RETRY: "Retry",
    AUTOSAVE_SUCCESS: "Saved",
    BANNER_ADD_MESSAGE: "Message created.",
    BANNER_CREATE_APPOINTMENT: "Appointment created.",
    BANNER_CREATE_REQUEST: "Request created.",
    BANNER_CREATE_SALE: "Sale created.",
    BANNER_CREATE_TASK: "Task created.",
    BANNER_SAVE_ATTACHMENT: "Attachment saved.",
    BANNER_SAVE_TO_SUPEROFFICE: "E-mail saved.",
    BANNER_VIEW_IN_CRM: "View in CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Add message to request",
    BTN_ADD_TO_SUPEROFFICE: "Add to SuperOffice",
    BTN_ARCHIVE: "Archive",
    BTN_CANCEL: "Cancel",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Click to add new contact",
    BTN_CONNECT: "Connect",
    BTN_CONNECT_TO_SUPEROFFICE: "We run SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "We run SuperOffice Onsite",
    BTN_CREATE: "Create",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Create new company and contact",
    BTN_GO_TO_SUPEROFFICE: "Go to SuperOffice",
    BTN_KEEP_CONTACT: "Keep",
    BTN_LOGIN: "Login",
    BTN_LOOKUP_SENDER: "Search for sender",
    BTN_OK: "OK",
    BTN_RECONNECT: "Change SuperOffice user",
    BTN_SAVE: "Save",
    BTN_SAVE_AND_ARCHIVE: "Send and archive",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Sign up for a free trial",
    BTN_UPDATE_CONTACT: "Update",
    BUSINESS: "Business",
    BUTTON_LETS_GO: "Let's get started",
    BUTTON_RELOAD: "Reload",
    CAN_NOT_GRANT_PERMISSION: "Can't grant permission?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Cannot add message to request because attachment may be unsafe",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Attachments cannot be archived because some may be unsafe. Only e-mails without attachments can be archived.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Cannot save digitally signed attachment",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "This e-mail is digitally signed. Attachments in the signature cannot be saved individually.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Cannot archive because attachment may be unsafe",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Cannot create request because attachment may be unsafe",
    CANNOT_SAVE_CONTACT: "Cannot save contact",
    CATEGORY: "Category",
    CHANGES_SAVED_AUTOMATICALLY: "Your changes are being saved automatically",
    CHOOSE_ONE_OR_CONTINUE: "Please choose one or continue.",
    CLICK_HERE_TO_SEE_IT: "Click here to view it.",
    CLICK_HERE_TO_SELECT_CONTACT: "Select contact",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Click here to select the right contact to archive on.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} more. Click here to show all.",
    CLICK_LOGIN_ONSITE: "Click here to open your SuperOffice installation in a new tab.",
    COMMENT_PLACEHOLDER: "Add a comment…",
    COMPANY_NAME: "Company name",
    CONNECT_ONSITE: "Connect to SuperOffice CRM Onsite installation",
    CONNECT_TO_SUPEROFFICE: "Connect to your SuperOffice CRM Online account",
    CONTACT_ADMINISTRATOR: "Contact your SuperOffice administrator to review your CRM configuration.",
    CONTINUE: "Continue",
    COULD_IT_BE_ONE_OF_THESE: "Could it be one of these?",
    COUNTRY: "Country",
    CREATE_NEW_COMPANY: "Create new company",
    CREATE_NEW_CONTACT: "Create new contact",
    CREATE_REQUEST: "Create request",
    CREATED_REQUEST: "Request has been created",
    DEPARTMENT: "Department",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Do not archive attachments",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Attachments are archived by default",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-mail archived in SuperOffice.",
    EMAIL_ADDRESS: "E-mail",
    EMAIL_ADDRESS_NOT_REGISTERED: "This e-mail address does not exist in SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> is attached to several contacts in SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-mail registered in SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "This e-mail address is registered on several contacts in SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Enable archiving to edit these settings",
    ERROR: "Error",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Unable to add e-mail address to SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Unable to archive attachment.",
    ERROR_ARCHIVING_EMAIL: "Unable to archive e-mail.",
    ERROR_ARCHIVING_REQUEST: "Unable to archive request.",
    ERROR_ARCHIVING_TASK: "Unable to create activity.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Unable to communicate with SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "You do not have permission to create companies or contacts in SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Find a company or contact...",
    FIRST_ATTENDEE_CHANGED: "The meeting contact has changed. ",
    FIRST_ATTENDEE_MISMATCH_DESC: "Choose which contact the appointment should be linked to.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Contact and meeting attendee do not match",
    FIRSTNAME: "First name",
    FOLLOWUPS: "Follow-ups",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice for Outlook could not reach Microsoft services. Please try again shortly.",
    GRAPH_API_ERROR_TITLE_SOFO: "Microsoft services temporarily unavailable",
    HEADER_ADD_EMAIL: "Add e-mail/contact: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Add e-mail address to SuperOffice",
    HEADER_ADD_RECPIENTS: "Add recipients from SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Add to existing contact",
    HEADER_ARCHIVE_APPOINTMENT: "Create activity",
    HEADER_ARCHIVE_ATTACHMENT: "Archive attachment as a SuperOffice document",
    HEADER_ARCHIVE_EMAIL: "Archive e-mail in SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Connect to another SuperOffice installation",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Create activity in SuperOffice based on e-mail",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Save attachments from this e-mail in SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Archive this e-mail in SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Create request in SuperOffice based on e-mail",
    HEADER_CREATE_EMAIL_AS_SALE: "Create sale in SuperOffice based on this e-mail",
    HEADER_CREATE_EMAIL_AS_TASK: "Create a task in your checklist based on e-mail",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Create new company and contact",
    HEADER_CREATE_NEW_PERSON: "Create new contact",
    HEADER_WELCOME: "Welcome",
    LABEL_ACHIEVE_MORE: "Achieve more with integration",
    LABEL_ADD_TO_EXISTING_REQUEST: "Add the e-mail as a message in an existing request in SuperOffice",
    LABEL_ARCHIVE_FILE: "Archive file:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Attachment already saved",
    LABEL_ATTACHMENT_NOT_SAVED: "Attachment not saved",
    LABEL_COMMENT: "Comment:",
    LABEL_COMPANYPHONE: "Company phone:",
    LABEL_CONTACT: "Company:",
    LABEL_CONTACT_OR_COMPANY: "Contact or Company:",
    LABEL_CREATE_AND_VISUALIZE: "Create and visualize like a pro",
    LABEL_CURRENCY: "Currency:",
    LABEL_DATE: "Date:",
    LABEL_DESCRIPTION: "Description:",
    LABEL_DIRECTPHONE: "Direct phone:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Discover what this add-in can do for you today!",
    LABEL_HOME_ADDRESS: "Home address:",
    LABEL_MOBILEPHONE: "Mobile phone:",
    LABEL_NOTES: "Notes:",
    LABEL_NUMBER: "Number:",
    LABEL_OPTIONAL_ATTENDEE: "Optional",
    LABEL_PERSON: "Contact:",
    LABEL_POSITION: "Position:",
    LABEL_PROJECT: "Project:",
    LABEL_REQUIRED_ATTENDEE: "Required",
    LABEL_SALE: "Sale:",
    LABEL_SALE_AMOUNT: "Sale amount:",
    LABEL_SALE_DATE: "Sale date:",
    LABEL_SALE_NAME: "Sale name:",
    LABEL_SALE_TYPE: "Sale type:",
    LABEL_SAVED_CHANGES: "Your changes have been saved.",
    LABEL_SELECT_CS_QUEUE: "Add request to this queue:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Select queue",
    LABEL_SERVER_VERSION: "Server version:",
    LABEL_SUBJECT: "Subject:",
    LABEL_SUPEROFFICE_SITE: "SuperOffice site:",
    LABEL_TELEPHONE: "Phone:",
    LABEL_TIME: "Time:",
    LABEL_TYPE: "Type:",
    LABEL_UNLOCK_FEATURES: "Unlock features and functionality",
    LABEL_URL: "URL:",
    LABEL_USER: "User:",
    LABEL_VISIBLE_FOR: "Visible for:",
    LABEL_WEB_PAGE: "Web page:",
    LASTNAME: "Last name",
    LEARN_MORE: "Learn more",
    LOGIN_COMPLETE_SETUP: "To complete the setup of SuperOffice Gmail Link, you need to log in to SuperOffice.",
    LOGIN_ONSITE: "Please log in to your SuperOffice CRM Onsite installation.",
    LOGOUT_FROM_SUPEROFFICE_1: "Log out of SuperOffice and close the open SuperOffice tab(s) if any.",
    LOGOUT_FROM_SUPEROFFICE_2: "The next time you log in to SuperOffice CRM Online, the new connection will be set up automatically.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Make this the primary e-mail address",
    MARK_COMPLETED: "Mark as completed",
    MARK_REMOVE_FROM_INBOX: "Remove from Inbox",
    MENU_ARCHIVE_EMAIL: "Archive E-mail",
    MENU_CREATE_APPOINTMENT: "Create activity",
    MENU_CREATE_NEW_SALE: "Create new sale",
    MENU_SAVE_TO_SUPEROFFICE: "Save to SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Contact has no e-mail address",
    MIDDLENAME: "Middle name",
    MISSING_REQUIRED_VALUES_INTRO: "Some required fields are not available for your user account:",
    ML_ADD_COMPANY: "Add company",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Add e-mail to contact",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Add new company and contact",
    ML_ADD_NEW_CONTACT_PERSON: "Add new contact",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Archive this e-mail as an appointment in your calendar",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Archive e-mail in SuperOffice on the sender's company card",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Click to add to SuperOffice",
    ML_COMPANY_DETAILS: "Company details",
    ML_CONTACT_DETAILS: "Contact details",
    ML_CREATE_A_NEW_SALE: "Create a new sale for this customer",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Disconnect Outlook from SuperOffice",
    ML_INVITATION_OPTIONS: "Invitations",
    ML_MOVE_INTO_CS_AS_REQUEST: "Add this e-mail to Customer Service as a new request",
    ML_OR_ADD_CONTACT_TO_COMPANY: "OR ADD CONTACT TO COMPANY?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "People mentioned in this message",
    ML_PERSON_COULD_BE: "This contact could be",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Search for contact or company...",
    ML_SETTINGS_INVITATIONS_HEADER: "Invitations for SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Add / update appointment in SuperOffice when responding to invitations in Outlook.",
    MOBILE: "Mobile",
    MORE: "More",
    MRMS: "Mr/Ms",
    MULTIPLE_EMAILADDRESSES_FOUND: "This e-mail address is registered on several contacts in SuperOffice. Click here to select the right contact to archive on.",
    MYPROFILE: "My Profile",
    NO_RESULTS: "No results",
    NOTE_CONTACT_DATA_PREDICTED: "Based on the content of this e-mail, we have suggested details for this sender. Please verify before creating this contact.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Check that the username and password you have entered are correct.",
    ONSITE_CONNECTION_SUCCESSFUL: "Congratulations. SuperOffice Gmail Link has successfully connected with your SuperOffice CRM Onsite installation.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Please check that you are logged in to your onsite installation before continuing.",
    ONSITE_ERROR_LINE_1: "There were some issues during the login process.",
    ONSITE_ERROR_LINE_2: "Make sure you have entered a correct Server URL. Click on the information button to find out how to obtain it.",
    ONSITE_PASSWORD: "Password:",
    ONSITE_SERVER_URL: "Server URL:",
    ONSITE_SERVER_URL_LINE_1: "In SuperOffice CRM, select Copy shortcut from the main menu",
    ONSITE_SERVER_URL_LINE_2: "Then paste into the Server URL here",
    ONSITE_URL: "URL to your SuperOffice CRM Onsite installation:",
    ONSITE_USER_NAME: "Username:",
    OPEN_IN_CRM: "Open in CRM",
    OR_UPPER: "OR",
    OUR_CONTACT: "Our contact",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "If you change your mind later on, please open the SuperOffice for Outlook addin in the calendar screen again",
    PERMISSION_CONTINUE: "Click \"Continue\" to open a new window and grant required permissions",
    PERMISSION_FOR_CALENDAR: "SuperOffice for Outlook needs your permission to access your calendar items.",
    PICKER_BCC: "Bcc",
    PICKER_CC: "Cc",
    PICKER_CC_COPY: "Cc",
    PICKER_TO: "To",
    PLACE_REQUEST_IN_QUEUE: "Place request in this queue:",
    POPUP__BOTTOM_TEXT: "Please allow pop-ups for this page and retry.",
    POPUP__HEADER: "Pop-up blocker detected",
    POPUP__MID_TEXT: "SuperOffice for Outlook needs to authenticate, but your browser's pop-up blocker is preventing it.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Remove from inbox",
    REMOVE_FROM_INBOX_DESC: "Moves e-mail to deleted items after archiving",
    REQUEST: "Request",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "This e-mail is too large to add to a request.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "E-mail too large",
    REQUEST_PRIORITY: "Priority",
    REQUEST_QUEUE: "Request queue",
    RESET_ALL: "Reset all",
    RESET_INFO_SOFO: "Would you like to reset the information in SuperOffice for Outlook? This will remove the current data.",
    REVISION_LABEL: "Revision:",
    SEARCH_FAILED: "Search failed. Please try again.",
    SETTINGS: "Settings",
    SETTINGS_ApplyArchiveStatus: "Apply archive category",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "External recipients only",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "External recipients are people outside your organization.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Forwards",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Archive reminder",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Archive reminder helps ensure e-mails and meetings are saved to SuperOffice before they are sent.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "You will be reminded to archive meetings in SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Remind me before sending meetings",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "New e-mails",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Replies",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "You will be reminded to archive e-mails in SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Remind me before sending e-mails",
    SETTINGS_CategoryColor: "Category color",
    SETTINGS_CategoryName: "Category name",
    SETTINGS_CategoryNameFixedInfo: "The category name is fixed and cannot be changed.",
    SETTINGS_CategoryTaggingDescription: "Use an Outlook category to identify e-mails that have already been archived to SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "E-mail archive status helps you see which e-mails have already been saved to SuperOffice, directly in your Outlook mailbox.",
    SETTINGS_CategoryTaggingSection: "E-mail archive status",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Default activity type",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Default e-mail type",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Incoming e-mail",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Outgoing e-mail",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Default incoming e-mail template",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Default outgoing e-mail template",
    SETTINGS_EnableCategoryForSharedMailbox: "In shared mailboxes",
    SETTINGS_EnableCategoryOnOpen: "When opening archived e-mails",
    SETTINGS_EnableCategoryOnSendAndArchive: "When using Send & Archive",
    SETTINGS_EnableCategoryTagging: "Show archive category in Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Show contextual projects and sales",
    SETTINGS_GENERAL_HEADER: "General",
    SETTINGS_SharedMailboxCategoryInfo: "To display archive status, the archive category must be created in the shared mailbox.",
    SETTINGS_SharedMailboxCategoryInfoBold: "For shared mailboxes:",
    SETTINGS_SharedMailboxCategoryLearnMore: "Learn more about shared mailbox setup",
    SETTINGS_YOURCOMPANY: "Company name:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Archive and send",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Select a contact or company to archive.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "This e-mail is ready to send, but it cannot be archived in SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Archive",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "This e-mail is ready to send, but it is not set to be archived in SuperOffice. Archive it now so the communication is saved with the right company or contact, or send it without archiving.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Something went wrong when loading settings.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Please log in to SuperOffice before opening settings.",
    SR_ADMIN_MYAPPS: "My Apps",
    SR_ALL_ITEM: "All",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Are you sure you want to turn off biometric login? You will need to manually sign in again next time.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Failed to copy to clipboard",
    SR_NO_SELECTION: "(No Selection)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Get started in a few clicks",
    SYNCHRONIZER_REACTIVATE: "Reactivate in a few clicks",
    SYNCRONIZER_MSG_CONTENT: "Sync your Outlook calendar and tasks with SuperOffice CRM to keep meetings, contacts, projects, and sales up-to-date.",
    SYNCRONIZER_NEED_AUTHENTICATION: "SuperOffice Calendar Synchronization with Outlook is almost set up. Continue to activate it and keep you calendars in sync.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "Your SuperOffice Calendar Synchronization with Outlook is currently interrupted. Continue to reactivate and keep your calendars in sync.",
    TAB_ACTION: "Action",
    TAB_PEOPLE: "People",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Activity created in SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Activity created in SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "The server took too long to respond. Please try again.",
    TIMEOUT_ERROR_TITLE: "Request timed out",
    TITLE: "Title",
    UNDO: "Undo",
    UNKNOWN_EMAIL_ADDRESS: "Unknown e-mail address.",
    UNKNOWN_EMAILADDRESS: "This sender's e-mail address is not recognized. Click here to add this e-mail address to SuperOffice.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "This recipient's e-mail address is not recognised. Click here to update SuperOffice with this e-mail address.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Unknown e-mail address. Add {0} to SuperOffice.",
    UNLOCK_THESE_FEATURES: "Unlock these features with synchronizer",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.com/crm/demo/",
    VERSION_SHORT: "ver.",
    VISIT_APP_STORE: "Visit App Store",
    WE_RUN_ONLINE_LINE_1: "To determine if you are running Online, do the following:",
    WE_RUN_ONLINE_LINE_2: "1. In SuperOffice CRM, select Help and then About",
    WE_RUN_ONLINE_LINE_3: "2. Look at the entry for NetServer:",
    WE_RUN_ONLINE_LINE_4: "If it states \"SuperOffice CRM Online ...\", you are running Online",
    WE_RUN_ONSITE_LINE_1: "To determine if you are running Onsite, do the following:",
    WE_RUN_ONSITE_LINE_4: "If it states \"SuperOffice CRM OnSite ...\", you are running Onsite",
    YOU_CAN_STILL_USE: "You can still use SuperOffice for Outlook for e-mails!",
  },
  ES: {
    ACTION_ADD: "Agregar",
    ACTION_BACK: "Atrás",
    ACTIVITIES: "Actividades",
    ADD_ATTENDEES: "Invitar a contactos desde SuperOffice",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Agregar dirección de correo electrónico a contacto existente",
    AI_SUMMARY_AI_NOT_ENABLED: "Las funciones de texto con IA no están habilitadas para su organización. Póngase en contacto con su administrador de SuperOffice.",
    AI_SUMMARY_APPEND: "Adjuntar",
    AI_SUMMARY_FEATURE_DISABLED: "Esta función se ha desactivado para su organización.",
    AI_SUMMARY_GENERATE: "Generar",
    AI_SUMMARY_GENERATE_ERROR: "No se ha podido generar un resumen en este momento. Inténtelo de nuevo.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Generar resumen con IA",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Participantes:",
    AI_SUMMARY_HEADER_SUBJECT: "Asunto:",
    AI_SUMMARY_LOADING: "Generando resumen…",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "No dispone de una licencia para utilizar las funciones de IA",
    AI_SUMMARY_NO_PERMISSION: "No tiene permiso para leer este correo electrónico.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "No hay nada que resumir en este correo electrónico.",
    AI_SUMMARY_REPLACE_CONFIRM: "Sustituir",
    ALREADY_ARCHIVED_ATTACHMENT: "El archivo adjunto ya ha sido archivado por <%- archivedBy %> en <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "Este correo electrónico ya ha sido archivado por <%- archivedBy %> en <%- archivedAt %>.",
    ALREADY_ARCHIVED_SALE: "Ya se ha creado una venta para este correo electrónico por parte de <%- archivedBy %> el <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "Ya se ha creado la actividad para este correo electrónico por parte de <%- archivedBy %> el <%- archivedAt %>.",
    ALREADY_DONE: "Ya hecho",
    APPOINTMENT_EXISTS_IN_CRM: "Esta cita existe en CRM y la creó <%- createdBy %> el <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Crear actividad",
    ARCHIVE_ALWAYS_SHOW: "Mostrar siempre el cuadro de diálogo de archivo",
    ARCHIVE_AS_ACTIVITY: "Crear cita en SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Guardar adjunto en SuperOffice",
    ARCHIVE_AS_REQUEST: "Crear petición en SuperOffice",
    ARCHIVE_AS_SALE: "Crear venta en SuperOffice",
    ARCHIVE_AS_TASK: "Crear tarea en SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Eliminar correo electrónico de la bandeja de entrada después de archivarlo de la forma predeterminada",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Incluir plantillas que no son de correo electrónico en la lista de plantillas",
    ATTACHMENT_SIZE_INFO: "Los adjuntos son demasiado grandes y no se pueden archivar. Solo se pueden archivar los correos electrónicos sin adjuntos.",
    AUTH__BOTTOM_TEXT_1: "\u2028¿Necesita más detalles?",
    AUTH__BOTTOM_TEXT_2: "Aprender a autorizar el complemento",
    AUTH__BUTTON: "Copiar enlace de administrador",
    AUTH__COPIED: "Copiado en el portapapeles",
    AUTH__HEADER: "Actualización de SuperOffice para Outlook",
    AUTH__INCREMENTAL_TEXT_1: "Para habilitar {feature}, se requieren permisos adicionales.",
    AUTH__MID_TEXT_1: "Para cumplir con los requisitos de seguridad más recientes de Microsoft, se ha actualizado el complemento de Outlook.",
    AUTH__MID_TEXT_2: "Para continuar usándolo, <b>un administrador global de Microsoft 365 debe conceder permisos</b> (consentimiento) en nombre de todos los usuarios.",
    AUTH__MID_TEXT_3: "<b>Comparta este enlace</b> con el administrador de Microsoft\u00A0365:",
    AUTH__NEW_USER_TEXT_1: "El complemento SuperOffice para Outlook requiere permisos adicionales para acceder a los datos de Microsoft 365.",
    AUTH_IN_PROGRESS__HEADER: "Autorización en curso",
    AUTH_IN_PROGRESS__MID_TEXT: "Siga con la autenticación interactiva que está en curso y vuelva a intentarlo.",
    AUTOSAVE_FAIL: "Sin guardar.",
    AUTOSAVE_IN_PROGRESS: "Guardando…",
    AUTOSAVE_RETRY: "Intentar de nuevo",
    AUTOSAVE_SUCCESS: "Guardado",
    BANNER_ADD_MESSAGE: "Mensaje creado.",
    BANNER_CREATE_APPOINTMENT: "Cita creada.",
    BANNER_CREATE_REQUEST: "Solicitud creada.",
    BANNER_CREATE_SALE: "Venta creada.",
    BANNER_CREATE_TASK: "Tarea creada.",
    BANNER_SAVE_ATTACHMENT: "Adjunto guardado.",
    BANNER_SAVE_TO_SUPEROFFICE: "Correo electrónico guardado.",
    BANNER_VIEW_IN_CRM: "Ver en CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Agregar mensaje a la petición",
    BTN_ADD_TO_SUPEROFFICE: "Agregar a SuperOffice",
    BTN_ARCHIVE: "Guardar",
    BTN_CANCEL: "Cancelar",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Haga clic para agregar un nuevo contacto",
    BTN_CONNECT: "Conectar",
    BTN_CONNECT_TO_SUPEROFFICE: "Ejecutamos SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Ejecutamos SuperOffice Onsite",
    BTN_CREATE: "Crear",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Crear empresa y contacto nuevos",
    BTN_GO_TO_SUPEROFFICE: "Ir a SuperOffice",
    BTN_KEEP_CONTACT: "Conservar",
    BTN_LOGIN: "Conectar",
    BTN_LOOKUP_SENDER: "Buscar remitente",
    BTN_OK: "Correcto",
    BTN_RECONNECT: "Cambiar usuario de SuperOffice",
    BTN_SAVE: "Guardar",
    BTN_SAVE_AND_ARCHIVE: "Enviar y archivar",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Regístrese para obtener una prueba gratuita",
    BTN_UPDATE_CONTACT: "Actualizar",
    BUSINESS: "Negocio",
    BUTTON_LETS_GO: "Empecemos",
    BUTTON_RELOAD: "Volver a cargar",
    CAN_NOT_GRANT_PERMISSION: "¿No puede otorgar permiso?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "No se puede agregar un mensaje a la solicitud porque el archivo adjunto puede no ser seguro",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Los adjuntos no se pueden archivar porque algunos puede que no sean seguros. Solo se pueden archivar los correos electrónicos sin adjuntos.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "No se puede guardar el adjunto firmado digitalmente",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Este correo electrónico cuenta con una firma digital. Los adjuntos de la firma no se pueden guardar por separado.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "No se puede archivar porque puede que el adjunto no sea seguro",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "No se puede crear una solicitud porque el adjunto puede no ser seguro",
    CANNOT_SAVE_CONTACT: "No se puede guardar el contacto",
    CATEGORY: "Categoría",
    CHANGES_SAVED_AUTOMATICALLY: "Los cambios se guardan automáticamente",
    CHOOSE_ONE_OR_CONTINUE: "Elija uno o continúe.",
    CLICK_HERE_TO_SEE_IT: "Haga clic aquí para verlo.",
    CLICK_HERE_TO_SELECT_CONTACT: "Seleccionar contacto",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Haga clic aquí para seleccionar el contacto adecuado en el que se debe archivar.",
    CLICK_HERE_TO_SHOW_MORE: "{0} más. Haga clic aquí para mostrarlos todos.",
    CLICK_LOGIN_ONSITE: "Haz clic aquí para abrir la instalación de SuperOffice en una nueva pestaña.",
    COMMENT_PLACEHOLDER: "Agregar comentario…",
    COMPANY_NAME: "Nombre de empresa",
    CONNECT_ONSITE: "Conectarse con la instalación de SuperOffice CRM Onsite",
    CONNECT_TO_SUPEROFFICE: "Conectar con su cuenta de SuperOffice CRM Online",
    CONTACT_ADMINISTRATOR: "Póngase en contacto con su administrador de SuperOffice para revisar la configuración de su CRM.",
    CONTINUE: "Continuar",
    COULD_IT_BE_ONE_OF_THESE: "¿Podría ser una de estas?",
    COUNTRY: "País",
    CREATE_NEW_COMPANY: "Crear nueva empresa",
    CREATE_NEW_CONTACT: "Crear nuevo contacto",
    CREATE_REQUEST: "Crear petición",
    CREATED_REQUEST: "La petición ha sido creada",
    DEPARTMENT: "Departamento",
    DO_NOT_ARCHIVE_ATTACHMENTS: "No archivar adjuntos",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Los adjuntos se archivan por defecto",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "Correo electrónico archivado en SuperOffice.",
    EMAIL_ADDRESS: "Correo electrónico",
    EMAIL_ADDRESS_NOT_REGISTERED: "Esta dirección de correo electrónico no existe en SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "Se adjunta <span class='so-email'>{0}</span> a varios contactos en SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "Correo electrónico registrado en SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Esta dirección de correo electrónico está registrada en varios contactos de SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Habilite el archivado para editar esta configuración",
    ERROR: "Error",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "No se ha podido añadir un correo electrónico a SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "No se ha podido archivar el adjunto.",
    ERROR_ARCHIVING_EMAIL: "No se ha podido archivar el correo electrónico.",
    ERROR_ARCHIVING_REQUEST: "No se ha podido archivar la solicitud.",
    ERROR_ARCHIVING_TASK: "No se ha podido crear la actividad.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "No se ha podido comunicar con SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "No tiene permiso para crear empresas o contactos en SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Buscar una empresa o un contacto...",
    FIRST_ATTENDEE_CHANGED: "El contacto de la reunión ha cambiado.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Elija a qué contacto debe vincularse la cita.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "El contacto y el asistente a la reunión no coinciden",
    FIRSTNAME: "Nombre",
    FOLLOWUPS: "Seguimientos",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice para Outlook no ha podido conectarse a los servicios de Microsoft. Inténtelo de nuevo dentro de unos minutos.",
    GRAPH_API_ERROR_TITLE_SOFO: "Los servicios de Microsoft no están disponibles temporalmente",
    HEADER_ADD_EMAIL: "Agregar correo electrónico/contacto: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Agregar dirección de correo electrónico a SuperOffice",
    HEADER_ADD_RECPIENTS: "Agregar destinatarios de SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Agregar a contacto existente",
    HEADER_ARCHIVE_APPOINTMENT: "Crear actividad",
    HEADER_ARCHIVE_ATTACHMENT: "Guardar el archivo adjunto como documento SuperOffice",
    HEADER_ARCHIVE_EMAIL: "Guardar el correo electrónico en SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Conectar con otra instalación de SuperOffice",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Crear actividad en SuperOffice en función del correo electrónico",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Guardar adjuntos de este correo electrónico en SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Archivar este correo electrónico en SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Crear petición en SuperOffice en función del correo electrónico",
    HEADER_CREATE_EMAIL_AS_SALE: "Crear venta en SuperOffice en función de este correo electrónico",
    HEADER_CREATE_EMAIL_AS_TASK: "Crear una tarea en su lista de tareas basada en el correo electrónico",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Crear empresa y contacto nuevos",
    HEADER_CREATE_NEW_PERSON: "Crear nuevo contacto",
    HEADER_WELCOME: "Bienvenido",
    LABEL_ACHIEVE_MORE: "Logre más con la integración",
    LABEL_ADD_TO_EXISTING_REQUEST: "Agregar el correo electrónico como un mensaje en una petición existente en SuperOffice",
    LABEL_ARCHIVE_FILE: "Guardar archivo:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Adjunto ya guardado",
    LABEL_ATTACHMENT_NOT_SAVED: "Adjunto no guardado",
    LABEL_COMMENT: "Comentario:",
    LABEL_COMPANYPHONE: "Teléfono de empresa:",
    LABEL_CONTACT: "Empresa:",
    LABEL_CONTACT_OR_COMPANY: "Contacto o empresa:",
    LABEL_CREATE_AND_VISUALIZE: "Cree y visualice como un profesional",
    LABEL_CURRENCY: "Moneda:",
    LABEL_DATE: "Fecha:",
    LABEL_DESCRIPTION: "Descripción:",
    LABEL_DIRECTPHONE: "Teléfono directo:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "¡Descubra lo que este complemento puede hacer por usted hoy mismo!",
    LABEL_HOME_ADDRESS: "Dirección particular:",
    LABEL_MOBILEPHONE: "Teléfono móvil:",
    LABEL_NOTES: "Notas:",
    LABEL_NUMBER: "Número:",
    LABEL_OPTIONAL_ATTENDEE: "Opcional",
    LABEL_PERSON: "Contacto:",
    LABEL_POSITION: "Puesto:",
    LABEL_PROJECT: "Proyecto:",
    LABEL_REQUIRED_ATTENDEE: "Obligatorio",
    LABEL_SALE: "Venta:",
    LABEL_SALE_AMOUNT: "Cantidad de la venta:",
    LABEL_SALE_DATE: "Fecha de venta:",
    LABEL_SALE_NAME: "Nombre de la venta:",
    LABEL_SALE_TYPE: "Tipo de venta:",
    LABEL_SAVED_CHANGES: "Los cambios se han guardado.",
    LABEL_SELECT_CS_QUEUE: "Agregar la petición a esta cola:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Seleccionar cola",
    LABEL_SERVER_VERSION: "Versión del servidor:",
    LABEL_SUBJECT: "Asunto:",
    LABEL_SUPEROFFICE_SITE: "Sitio de SuperOffice:",
    LABEL_TELEPHONE: "Teléfono:",
    LABEL_TIME: "Hora:",
    LABEL_TYPE: "Tipo:",
    LABEL_UNLOCK_FEATURES: "Desbloquear características y funciones",
    LABEL_URL: "URL:",
    LABEL_USER: "Usuario:",
    LABEL_VISIBLE_FOR: "Visible para:",
    LABEL_WEB_PAGE: "Página Web:",
    LASTNAME: "Apellidos",
    LEARN_MORE: "Más información",
    LOGIN_COMPLETE_SETUP: "Para completar la configuración de SuperOffice Gmail Link, es necesario iniciar sesión en SuperOffice.",
    LOGIN_ONSITE: "Por favor, ingresa en la instalación de SuperOffice CRM Onsite.",
    LOGOUT_FROM_SUPEROFFICE_1: "Cierre las pestañas abiertas de SuperOffice, si las hubiera, y la sesión.",
    LOGOUT_FROM_SUPEROFFICE_2: "La próxima vez que inicie sesión en SuperOffice CRM Online, la nueva conexión se configurará automáticamente.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Establezca esta dirección de correo electrónico como principal",
    MARK_COMPLETED: "Marcar como completada",
    MARK_REMOVE_FROM_INBOX: "Eliminar de la Bandeja de entrada",
    MENU_ARCHIVE_EMAIL: "Archivar c. electrónico",
    MENU_CREATE_APPOINTMENT: "Crear actividad",
    MENU_CREATE_NEW_SALE: "Crear nueva venta",
    MENU_SAVE_TO_SUPEROFFICE: "Guardar en SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "El contacto no tiene dirección de correo electrónico",
    MIDDLENAME: "Segundo nombre",
    MISSING_REQUIRED_VALUES_INTRO: "Algunos campos obligatorios no están disponibles para su cuenta de usuario:",
    ML_ADD_COMPANY: "Agregar empresa",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Agregar correo electrónico a contacto",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Agregar empresa y contacto nuevos",
    ML_ADD_NEW_CONTACT_PERSON: "Agregar contacto nuevo",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Archivar este correo electrónico como una cita en el calendario",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Archivar correo electrónico en SuperOffice en la tarjeta de empresa del remitente",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Haga clic para agregar a SuperOffice",
    ML_COMPANY_DETAILS: "Detalles de la empresa",
    ML_CONTACT_DETAILS: "Detalles del contacto",
    ML_CREATE_A_NEW_SALE: "Crear una nueva venta para este cliente",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Desconectar Outlook de SuperOffice",
    ML_INVITATION_OPTIONS: "Invitaciones",
    ML_MOVE_INTO_CS_AS_REQUEST: "Agregar este correo electrónico a Customer Service como nueva petición",
    ML_OR_ADD_CONTACT_TO_COMPANY: "¿O AGREGAR CONTACTO A EMPRESA?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Personas mencionadas en este mensaje",
    ML_PERSON_COULD_BE: "Este contacto podría ser",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Buscar contacto o empresa...",
    ML_SETTINGS_INVITATIONS_HEADER: "Invitaciones para SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Agregar/actualizar cita en SuperOffice al responder a invitaciones en Outlook.",
    MOBILE: "Móvil",
    MORE: "Más",
    MRMS: "Sr./Sra.",
    MULTIPLE_EMAILADDRESSES_FOUND: "Esta dirección de correo electrónico está registrada en varios contactos de SuperOffice. Haga clic aquí para seleccionar el contacto correcto en el que se debe archivar.",
    MYPROFILE: "Mi perfil",
    NO_RESULTS: "Sin resultados",
    NOTE_CONTACT_DATA_PREDICTED: "Basándonos en el contenido de este correo electrónico, hemos sugerido detalles para este remitente. Compruébelos antes de crear este contacto.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Compruebe que el nombre de usuario y la contraseña introducidos sean correctos.",
    ONSITE_CONNECTION_SUCCESSFUL: "Felicitaciones. SuperOffice Gmail Link se ha conectado correctamente con la instalación de SuperOffice CRM Onsite.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Por favor, corrobora que hayas ingresado en la instalación de Onsite antes de continuar.",
    ONSITE_ERROR_LINE_1: "Hubo algunos problemas durante el proceso de inicio de sesión.",
    ONSITE_ERROR_LINE_2: "Asegúrese de haber introducido una URL de servidor correcta. Haga clic en el botón de información para saber cómo obtenerla.",
    ONSITE_PASSWORD: "Contraseña:",
    ONSITE_SERVER_URL: "URL del servidor:",
    ONSITE_SERVER_URL_LINE_1: "En SuperOffice CRM, seleccione Copiar acceso directo en el menú principal",
    ONSITE_SERVER_URL_LINE_2: "Luego péguelo en la URL del servidor aquí",
    ONSITE_URL: "Dirección URL a la instalación de SuperOffice CRM Onsite:",
    ONSITE_USER_NAME: "Nombre de usuario:",
    OPEN_IN_CRM: "Abrir en CRM",
    OR_UPPER: "O BIEN",
    OUR_CONTACT: "Nuestro contacto",
    OUTLOOK_AND_SUPEROFFICE: "CRM de Outlook + SuperOffice",
    PERMISSION_CHANGE_OF_MIND: "Si cambia de opinión más adelante, vuelva a abrir el complemento SuperOffice para Outlook en la pantalla del calendario",
    PERMISSION_CONTINUE: "Haga clic en \"Continuar\" para abrir una nueva ventana y conceder los permisos necesarios",
    PERMISSION_FOR_CALENDAR: "SuperOffice para Outlook necesita su permiso para acceder a los elementos de su calendario.",
    PICKER_BCC: "CCO",
    PICKER_CC: "CC",
    PICKER_CC_COPY: "CC",
    PICKER_TO: "Para",
    PLACE_REQUEST_IN_QUEUE: "Coloque la petición en esta cola:",
    POPUP__BOTTOM_TEXT: "Permita las ventanas emergentes de esta página y vuelva a intentarlo.",
    POPUP__HEADER: "Bloqueador de ventanas emergentes detectado",
    POPUP__MID_TEXT: "SuperOffice para Outlook necesita autenticarse, pero el bloqueador de ventanas emergentes de su navegador lo impide.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Eliminar de la bandeja de entrada",
    REMOVE_FROM_INBOX_DESC: "Tras archivar un correo electrónico, lo traslada a la carpeta «Elementos eliminados»",
    REQUEST: "Petición",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Este correo electrónico es demasiado grande para agregarlo a una petición.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "Correo electrónico demasiado grande",
    REQUEST_PRIORITY: "Prioridad",
    REQUEST_QUEUE: "Cola de peticiones",
    RESET_ALL: "Restablecer todo",
    RESET_INFO_SOFO: "¿Quiere restablecer la información en SuperOffice para Outlook? Hacerlo eliminará los datos actuales.",
    REVISION_LABEL: "Revisión:",
    SEARCH_FAILED: "La búsqueda no se ha podido realizar. Inténtelo de nuevo.",
    SETTINGS: "Configuración",
    SETTINGS_ApplyArchiveStatus: "Aplicar categoría de archivo",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Solo destinatarios externos",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Los destinatarios externos son personas ajenas a su organización.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Reenvíos",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Recordatorio sobre archivar",
    SETTINGS_ARCHIVE_REMINDER_INFO: "El recordatorio de archivo ayuda a garantizar que los correos electrónicos y las reuniones se guarden en SuperOffice antes de enviarlos.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Se le recordará que debe archivar las reuniones en SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Recordármelo antes de enviar reuniones",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Nuevos correos electrónicos",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Respuestas",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Se le recordará que debe archivar los correos electrónicos en SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Recordármelo antes de enviar correos electrónicos",
    SETTINGS_CategoryColor: "Color de la categoría",
    SETTINGS_CategoryName: "Nombre de la categoría",
    SETTINGS_CategoryNameFixedInfo: "El nombre de la categoría es fijo y no se puede modificar.",
    SETTINGS_CategoryTaggingDescription: "Utilice una categoría de Outlook para identificar los correos electrónicos que ya se han archivado en SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "El estado del archivo de correo electrónico le ayuda a ver qué correos electrónicos ya se han guardado en SuperOffice, directamente en su buzón de Outlook.",
    SETTINGS_CategoryTaggingSection: "Estado del archivo de correo electrónico",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Tipo de actividad predeterminado",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Tipo de correo electrónico predeterminado",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Correo electrónico entrante",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Correo electrónico saliente",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Plantilla de correo electrónico entrante predeterminada",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Plantilla de correo electrónico saliente predeterminada",
    SETTINGS_EnableCategoryForSharedMailbox: "En buzones compartidos",
    SETTINGS_EnableCategoryOnOpen: "Al abrir correos electrónicos archivados",
    SETTINGS_EnableCategoryOnSendAndArchive: "Al utilizar la función «Enviar y archivar»",
    SETTINGS_EnableCategoryTagging: "Mostrar la categoría de archivo en Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Mostrar proyectos y ventas contextuales",
    SETTINGS_GENERAL_HEADER: "General",
    SETTINGS_SharedMailboxCategoryInfo: "Para mostrar el estado del archivo, es necesario crear la categoría de archivo en el buzón compartido.",
    SETTINGS_SharedMailboxCategoryInfoBold: "Para buzones compartidos:",
    SETTINGS_SharedMailboxCategoryLearnMore: "Más información sobre la configuración de los buzones compartidos",
    SETTINGS_YOURCOMPANY: "Nombre de la empresa:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Archivar y enviar",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Seleccione un contacto o una empresa para archivarla.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Este correo electrónico está listo para enviarse, pero no puede archivarse en SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Archivar",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Este correo electrónico está listo para enviarse, pero no está configurado para archivarse en SuperOffice. Archívelo ahora para que la comunicación quede guardada con la empresa o el contacto correspondiente, o envíelo sin archivarlo.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Se produjo un error al cargar la configuración.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Inicie sesión en SuperOffice antes de abrir la configuración.",
    SR_ADMIN_MYAPPS: "Mis aplicaciones",
    SR_ALL_ITEM: "Todos",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "¿Está seguro de que desea desactivar el inicio de sesión biométrico? La próxima vez tendrá que volver a iniciar sesión manualmente.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Error al copiar en el portapapeles",
    SR_NO_SELECTION: "(Sin selección)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Empezar con unos pocos clics",
    SYNCHRONIZER_REACTIVATE: "Reactivar con unos pocos clics",
    SYNCRONIZER_MSG_CONTENT: "Sincronice su calendario y tareas de Outlook con SuperOffice CRM para mantener actualizadas las reuniones, los contactos, los proyectos y las ventas.",
    SYNCRONIZER_NEED_AUTHENTICATION: "La sincronización del calendario de SuperOffice con Outlook está casi configurada. Continúe para activarla y mantener sincronizados sus calendarios.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "La sincronización del calendario de SuperOffice con Outlook se ha interrumpido actualmente. Continúe para reactivarla y mantener sincronizados sus calendarios.",
    TAB_ACTION: "Acción",
    TAB_PEOPLE: "Gente",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Actividad creada en SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Actividad creada en SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "El servidor tardó demasiado en responder. Inténtelo de nuevo.",
    TIMEOUT_ERROR_TITLE: "Se ha agotado el tiempo de espera de la solicitud",
    TITLE: "Cargo",
    UNDO: "Deshacer",
    UNKNOWN_EMAIL_ADDRESS: "Dirección de correo electrónico desconocida.",
    UNKNOWN_EMAILADDRESS: "No se reconoce la dirección de correo electrónico de este remitente. Haga clic aquí para agregar esta dirección de correo electrónico a SuperOffice.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "No se reconoce la dirección de correo electrónico de este destinatario. Haga clic aquí para actualizar SuperOffice con esta dirección de correo electrónico.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Dirección de correo electrónico desconocida. Agregar {0} a SuperOffice.",
    UNLOCK_THESE_FEATURES: "Desbloquee estas funciones con el sincronizador",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.com/crm/demo/",
    VERSION_SHORT: "ver.",
    VISIT_APP_STORE: "Visite App Store",
    WE_RUN_ONLINE_LINE_1: "Para determinar si está ejecutando la versión Online, haga lo siguiente:",
    WE_RUN_ONLINE_LINE_2: "1. En SuperOffice CRM, seleccione Ayuda y luego Acerca de",
    WE_RUN_ONLINE_LINE_3: "2. Mire la entrada para NetServer:",
    WE_RUN_ONLINE_LINE_4: "Si dice \"SuperOffice CRM Online... \", está ejecutando la versión Online",
    WE_RUN_ONSITE_LINE_1: "Para determinar si está ejecutando la versión Onsite, haga lo siguiente:",
    WE_RUN_ONSITE_LINE_4: "Si dice \"SuperOffice CRM OnSite ... \", está ejecutando la versión Onsite",
    YOU_CAN_STILL_USE: "Aún puede utilizar SuperOffice para Outlook para el correo electrónico.",
  },
  FI: {
    ACTION_ADD: "Lisää",
    ACTION_BACK: "Takaisin",
    ACTIVITIES: "Toiminnat",
    ADD_ATTENDEES: "Kutsu yhteystiedot SuperOfficesta",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Lisää sähköpostiosoite olemassa olevaan yhteystietoon",
    AI_SUMMARY_AI_NOT_ENABLED: "Tekoälypohjaisia tekstitoimintoja ei ole otettu käyttöön organisaatiossasi. Ota yhteys SuperOffice-järjestelmävalvojaasi.",
    AI_SUMMARY_APPEND: "Lisää",
    AI_SUMMARY_FEATURE_DISABLED: "Tämä ominaisuus on poistettu käytöstä organisaatiossasi.",
    AI_SUMMARY_GENERATE: "Luo",
    AI_SUMMARY_GENERATE_ERROR: "Yhteenvetoa ei voitu luoda juuri nyt. Yritä uudelleen.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Luo tekoäly-yhteenveto",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Osallistujat:",
    AI_SUMMARY_HEADER_SUBJECT: "Aihe:",
    AI_SUMMARY_LOADING: "Luodaan yhteenvetoa...",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Sinulla ei ole lisenssiä tekoälyominaisuuksiin",
    AI_SUMMARY_NO_PERMISSION: "Sinulla ei ole oikeutta lukea tätä sähköpostiviestiä.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "Tässä sähköpostissa ei ole mitään tiivistettävää.",
    AI_SUMMARY_REPLACE_CONFIRM: "Korvaa",
    ALREADY_ARCHIVED_ATTACHMENT: "<%- archivedBy %> on jo arkistoinut liitteen kohteeseen  <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: " <%- archivedBy %> on jo arkistoinut tämän sähköpostin kohteeseen <%- archivedAt %>.",
    ALREADY_ARCHIVED_SALE: "Tälle sähköpostiviestille on jo luonut myynnin <%- archivedBy %>   <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "Tälle sähköpostiviestille on jo luonut toiminnan <%- archivedBy %>   <%- archivedAt %>.",
    ALREADY_DONE: "Jo tehty",
    APPOINTMENT_EXISTS_IN_CRM: "Tämä tapaaminen on CRM:ssä ja sen on luonut <%- createdBy %> <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Luo toiminta",
    ARCHIVE_ALWAYS_SHOW: "Näytä aina arkistointidialogi",
    ARCHIVE_AS_ACTIVITY: "Luo tapaaminen SuperOfficessa",
    ARCHIVE_AS_ATTACHMENT: "Tallenna liite SuperOfficeen",
    ARCHIVE_AS_REQUEST: "Luo pyyntö SuperOfficessa",
    ARCHIVE_AS_SALE: "Luo myynti SuperOfficessa",
    ARCHIVE_AS_TASK: "Luo tehtävä SuperOfficessa",
    ARCHIVE_REMOVE_FROM_INBOX: "Poista sähköposti oletusarvoisesti Saapuneet-kansiosta arkistoinnin jälkeen",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Sisällytä muita kuin sähköpostimalleja malliluetteloon",
    ATTACHMENT_SIZE_INFO: "Liitteet ovat liian suuria, eikä niitä voida arkistoida. Vain sähköpostit ilman liitteitä voidaan arkistoida.",
    AUTH__BOTTOM_TEXT_1: "\u2028Tarvitsetko enemmän tietoja?",
    AUTH__BOTTOM_TEXT_2: "Opettele valtuuttamaan lisäosa",
    AUTH__BUTTON: "Kopioi järjestelmänvalvojan linkki",
    AUTH__COPIED: "Kopioitu leikepöydälle",
    AUTH__HEADER: "SuperOffice for Outlook -päivitys",
    AUTH__INCREMENTAL_TEXT_1: "{feature}:n käyttöönotto edellyttää lisäkäyttöoikeuksia.",
    AUTH__MID_TEXT_1: "Microsoftin uusimpien tietoturvavaatimusten täyttämiseksi Outlook-lisäosa on päivitetty.",
    AUTH__MID_TEXT_2: "Sen käytön jatkamiseksi <b>Microsoft 365:n yleisen järjestelmänvalvojan on myönnettävä (suostumus)</b> kaikkien käyttäjien puolesta.",
    AUTH__MID_TEXT_3: "<b>Jaa tämä linkki</b> Microsoft 365 -järjestelmänvalvojallesi.",
    AUTH__NEW_USER_TEXT_1: "SuperOffice for Outlook -lisäosa vaatii lisäkäyttöoikeuksia Microsoft 365 -tietojen käyttämiseen.",
    AUTH_IN_PROGRESS__HEADER: "Todennus käynnissä",
    AUTH_IN_PROGRESS__MID_TEXT: "Jatka käynnissä olevaa interaktiivista todennusta ja yritä uudelleen.",
    AUTOSAVE_FAIL: "Ei tallennettu.",
    AUTOSAVE_IN_PROGRESS: "Tallennetaan…",
    AUTOSAVE_RETRY: "Yritä uudelleen",
    AUTOSAVE_SUCCESS: "Tallennettu",
    BANNER_ADD_MESSAGE: "Viesti luotu.",
    BANNER_CREATE_APPOINTMENT: "Tapaaminen luotu.",
    BANNER_CREATE_REQUEST: "Pyyntö luotu.",
    BANNER_CREATE_SALE: "Myynti luotu.",
    BANNER_CREATE_TASK: "Tehtävä luotu.",
    BANNER_SAVE_ATTACHMENT: "Liite tallennettu.",
    BANNER_SAVE_TO_SUPEROFFICE: "Sähköposti tallennettu.",
    BANNER_VIEW_IN_CRM: "Näytä CRM:ssä",
    BTN_ADD_TO_EXISTING_REQUEST: "Lisää viesti pyyntöön",
    BTN_ADD_TO_SUPEROFFICE: "Lisää SuperOfficeen",
    BTN_ARCHIVE: "Arkisto",
    BTN_CANCEL: "Peruuta",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Lisää uusi yhteystieto klikkaamalla",
    BTN_CONNECT: "Yhdistä",
    BTN_CONNECT_TO_SUPEROFFICE: "Meillä on SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Meillä on SuperOffice Onsite",
    BTN_CREATE: "Luo",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Luo uusi yritys ja yhteyshenkilö",
    BTN_GO_TO_SUPEROFFICE: "Siirry  SuperOfficeen",
    BTN_KEEP_CONTACT: "Pidä",
    BTN_LOGIN: "Sisäänkirjautuminen",
    BTN_LOOKUP_SENDER: "Etsi lähettäjä",
    BTN_OK: "OK",
    BTN_RECONNECT: "Vaihda  SuperOffice-käyttäjä",
    BTN_SAVE: "Tallenna",
    BTN_SAVE_AND_ARCHIVE: "Lähetä ja arkistoi",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Rekisteröidy ilmaista kokeilua varten",
    BTN_UPDATE_CONTACT: "Päivitä",
    BUSINESS: "Liikeala",
    BUTTON_LETS_GO: "Aloitetaan",
    BUTTON_RELOAD: "Lataa uudelleen",
    CAN_NOT_GRANT_PERMISSION: "Etkö voi myöntää lupaa?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Viestiä ei voi lisätä pyyntöön",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Liitteitä ei voida arkistoida, koska osa niistä saattaa olla vaarallisia. Vain sähköpostit ilman liitteitä voidaan arkistoida.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Digitaalisesti allekirjoitettua liitettä ei voida tallentaa",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Tämä sähköposti on digitaalisesti allekirjoitettu. Allekirjoituksen liitteitä ei voi tallentaa erikseen.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Ei voi arkistoida, koska liite ei ehkä ole turvallinen",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Pyyntöä ei voi luoda",
    CANNOT_SAVE_CONTACT: "Yhteystietoa ei voida tallentaa",
    CATEGORY: "Kategoria",
    CHANGES_SAVED_AUTOMATICALLY: "Muutoksesi tallennetaan automaattisesti",
    CHOOSE_ONE_OR_CONTINUE: "Valitse yksi tai jatka.",
    CLICK_HERE_TO_SEE_IT: "Napsauta tässä tarkastellaksesi sitä.",
    CLICK_HERE_TO_SELECT_CONTACT: "Valitse yhteyshenkilö",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Napsauta tässä valitaksesi oikean yhteystiedon, johon se arkistoidaan.",
    CLICK_HERE_TO_SHOW_MORE: "+ {0} lisää. Näytä kaikki napsauttamalla tästä.",
    CLICK_LOGIN_ONSITE: "Napsauta tässä avataksesi SuperOffice-asennuksen uudessa välilehdessä.",
    COMMENT_PLACEHOLDER: "Lisää kommentti…",
    COMPANY_NAME: "Yrityksen nimi",
    CONNECT_ONSITE: "Muodosta yhteys SuperOffice CRM Onsite -asennukseen",
    CONNECT_TO_SUPEROFFICE: "Muodosta yhteys  SuperOffice CRM Online -tiliisi",
    CONTACT_ADMINISTRATOR: "Ota yhteys SuperOffice-järjestelmänvalvojaan CRM-asetustesi tarkistamiseksi.",
    CONTINUE: "Jatka",
    COULD_IT_BE_ONE_OF_THESE: "Olisiko se jokin näistä?",
    COUNTRY: "Maa",
    CREATE_NEW_COMPANY: "Luo uusi yritys",
    CREATE_NEW_CONTACT: "Luo uusi yhteystieto",
    CREATE_REQUEST: "Luo pyyntö",
    CREATED_REQUEST: "Pyyntö on luotu",
    DEPARTMENT: "Osasto",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Älä arkistoi liitteitä",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Liitteet arkistoidaan oletusarvoisesti",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "Sähköposti on arkistoitu  SuperOfficeen.",
    EMAIL_ADDRESS: "Sähköposti",
    EMAIL_ADDRESS_NOT_REGISTERED: "Tätä sähköpostiosoitetta ei ole  SuperOfficessa.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> on liitetty useisiin yhteyshenkilöihin SuperOfficessa.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "Sähköposti rekisteröity SuperOfficessa.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Tämä lähettäjän sähköpostiosoite on rekisteröity useisiin yhteystietoihin SuperOfficessa.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Muokkaa näitä asetuksia ottamalla arkistointi käyttöön",
    ERROR: "Virhe",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Osoitetta ei voida lisätä SuperOfficeen.",
    ERROR_ARCHIVING_ATTACHMENT: "Liitettä ei voi arkistoida.",
    ERROR_ARCHIVING_EMAIL: "Sähköpostia ei voi arkistoida.",
    ERROR_ARCHIVING_REQUEST: "Pyyntöä ei voi arkistoida.",
    ERROR_ARCHIVING_TASK: "Tehtävää ei voi luoda.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Tiedonsiirto SuperOfficen kanssa ei onnistu.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Sinulla ei ole lupaa luoda yrityksiä tai yhteyshenkilöitä SuperOfficessa.",
    FIND_COMPANY_OR_PERSON: "Etsi yritys tai yhteyshenkilö…",
    FIRST_ATTENDEE_CHANGED: "Kokouksen yhteyshenkilö on muuttunut.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Valitse, mihin yhteystietoon tapaaminen liitetään.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Yhteystieto ja kokouksen osallistuja eivät täsmää",
    FIRSTNAME: "Etunimi",
    FOLLOWUPS: "Seurannat",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice for Outlook ei saanut yhteyttä Microsoftin palveluihin. Yritä hetken kuluttua uudelleen.",
    GRAPH_API_ERROR_TITLE_SOFO: "Microsoftin palvelut eivät ole tilapäisesti käytettävissä",
    HEADER_ADD_EMAIL: "Lisää sähköposti/yhteyshenkilö: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Lisää sähköpostiosoite  SuperOfficeen",
    HEADER_ADD_RECPIENTS: "Lisää vastaanottajat SuperOfficesta",
    HEADER_ADD_TO_EXISTING_PERSON: "Lisää olemassa olevaan yhteyshenkilöön",
    HEADER_ARCHIVE_APPOINTMENT: "Luo tehtävä",
    HEADER_ARCHIVE_ATTACHMENT: "Arkistoi liite SuperOffice-asiakirjana",
    HEADER_ARCHIVE_EMAIL: "Arkistoi sähköposti SuperOfficeen",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Muodosta yhteys toiseen  SuperOffice-asennukseen",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Luo toiminta SuperOfficessa sähköpostin perusteella",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Tallenna tämän sähköpostin liitteet SuperOfficeen",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Arkistoi tämä sähköpostiviesti SuperOfficeen",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Luo pyyntö SuperOfficeen sähköpostin perusteella",
    HEADER_CREATE_EMAIL_AS_SALE: "Luo myynti SuperOfficeen tämän sähköpostin perusteella",
    HEADER_CREATE_EMAIL_AS_TASK: "Luo tehtävä tarkistuslistaasi sähköpostin perusteella",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Luo uusi yritys tai yhteyshenkilö",
    HEADER_CREATE_NEW_PERSON: "Luo uusi yhteyshenkilö",
    HEADER_WELCOME: "Tervetuloa",
    LABEL_ACHIEVE_MORE: "Saavuta enemmän integraatiolla",
    LABEL_ADD_TO_EXISTING_REQUEST: "Lisää sähköposti viestinä nykyiseen pyyntöön SuperOfficessa",
    LABEL_ARCHIVE_FILE: "Arkistoi tiedosto:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Liite on jo tallennettu",
    LABEL_ATTACHMENT_NOT_SAVED: "Liitettä ei ole tallennettu",
    LABEL_COMMENT: "Kommentti:",
    LABEL_COMPANYPHONE: "Yrityksen puhelin:",
    LABEL_CONTACT: "Yritys:",
    LABEL_CONTACT_OR_COMPANY: "Yhteyshenkilö tai yritys:",
    LABEL_CREATE_AND_VISUALIZE: "Luo ja visualisoi kuin ammattilainen",
    LABEL_CURRENCY: "Valuutta:",
    LABEL_DATE: "Päivämäärä:",
    LABEL_DESCRIPTION: "Kuvaus",
    LABEL_DIRECTPHONE: "Suora puhelin:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Tutustu, miten voit hyötyä tästä lisäosasta tänään!",
    LABEL_HOME_ADDRESS: "Yksityinen:",
    LABEL_MOBILEPHONE: "Matkapuhelin:",
    LABEL_NOTES: "Muistiinpanot:",
    LABEL_NUMBER: "Numero:",
    LABEL_OPTIONAL_ATTENDEE: "Valinnainen",
    LABEL_PERSON: "Yhteyshenkilö:",
    LABEL_POSITION: "Asema:",
    LABEL_PROJECT: "Projekti:",
    LABEL_REQUIRED_ATTENDEE: "Pakollinen",
    LABEL_SALE: "Myynti:",
    LABEL_SALE_AMOUNT: "Myyntisumma:",
    LABEL_SALE_DATE: "Päivämäärä:",
    LABEL_SALE_NAME: "Myynnin nimi:",
    LABEL_SALE_TYPE: "Myyntityyppi:",
    LABEL_SAVED_CHANGES: "Muutoksesi on tallennettu.",
    LABEL_SELECT_CS_QUEUE: "Lisää pyyntö tähän jonoon:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Valitse jono",
    LABEL_SERVER_VERSION: "Palvelimen versio:",
    LABEL_SUBJECT: "Aihe:",
    LABEL_SUPEROFFICE_SITE: "SuperOffice-sivusto:",
    LABEL_TELEPHONE: "Puhelin:",
    LABEL_TIME: "Kellonaika:",
    LABEL_TYPE: "Tyyppi:",
    LABEL_UNLOCK_FEATURES: "Avaa ominaisuudet ja toiminnot",
    LABEL_URL: "URL:",
    LABEL_USER: "Käyttäjä:",
    LABEL_VISIBLE_FOR: "Näytetään:",
    LABEL_WEB_PAGE: "Web-sivu:",
    LASTNAME: "Sukunimi",
    LEARN_MORE: "Lue lisää",
    LOGIN_COMPLETE_SETUP: "Voidaksesi viimeistellä SuperOffice Gmail Link -määrityksen sinun on kirjauduttava sisään SuperOfficeen.",
    LOGIN_ONSITE: "Kirjaudu sisään SuperOffice CRM Onsite -asennukseesi.",
    LOGOUT_FROM_SUPEROFFICE_1: "Kirjaudu ulos  SuperOfficesta ja sulje mahdolliset avoimet SuperOffice-välilehdet.",
    LOGOUT_FROM_SUPEROFFICE_2: "Seuraavan kerran, kun kirjaudut sisään SuperOffice CRM Online -palveluun, uusi yhteys muodostetaan automaattisesti.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Tee tästä ensisijainen sähköpostiosoite",
    MARK_COMPLETED: "Merkitse tehdyksi",
    MARK_REMOVE_FROM_INBOX: "Poista saapuneista",
    MENU_ARCHIVE_EMAIL: "Arkistoi sähköposti",
    MENU_CREATE_APPOINTMENT: "Luo toiminta",
    MENU_CREATE_NEW_SALE: "Luo uusi myynti",
    MENU_SAVE_TO_SUPEROFFICE: "Tallenna SuperOffice-ohjelmaan",
    MESSAGE_NO_EMAIL_ADDRESS: "Yhteystiedolla ei ole sähköpostiosoitetta",
    MIDDLENAME: "Toinen nimi",
    MISSING_REQUIRED_VALUES_INTRO: "Jotkin pakolliset kentät eivät ole käytettävissä käyttäjätililläsi:",
    ML_ADD_COMPANY: "Lisää yritys",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Lisää sähköpostiosoite yhteystietoon",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Luo uusi yritys ja yhteystieto",
    ML_ADD_NEW_CONTACT_PERSON: "Lisää uusi yhteystieto",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Arkistoi tämä sähköposti tapaamisena kalenteriin",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Arkistoi sähköposti SuperOfficeen lähettäjän käyntikorttiin",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Lisää SuperOfficeen napsauttamalla",
    ML_COMPANY_DETAILS: "Yrityksen tiedot",
    ML_CONTACT_DETAILS: "Yhteyshenkilön tiedot",
    ML_CREATE_A_NEW_SALE: "Luo uusi myynti tälle asiakkaalle",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Katkaiset Outlookin yhteys SuperOfficeen",
    ML_INVITATION_OPTIONS: "Kutsut",
    ML_MOVE_INTO_CS_AS_REQUEST: "Lisää tämä sähköposti Customer Serviceen uutena pyyntönä",
    ML_OR_ADD_CONTACT_TO_COMPANY: "TAI LISÄTÄÄNKÖ YHTEYSHENKILÖ YRITYKSEEN?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Tässä viestissä mainitut henkilöt",
    ML_PERSON_COULD_BE: "Tämä yhteyshenkilö voi olla",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Etsi henkilöä tai yritystä...",
    ML_SETTINGS_INVITATIONS_HEADER: "Kutsut SuperOfficeen",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Lisää / päivitä tapaaminen SuperOfficessa, kun vastaat kutsuihin Outlookissa.",
    MOBILE: "Matkapuhelin",
    MORE: "Lisää",
    MRMS: "Hra/Rva",
    MULTIPLE_EMAILADDRESSES_FOUND: "Tämä lähettäjän sähköpostiosoite on rekisteröity useisiin yhteystietoihin SuperOfficessa. Napsauta tässä valitaksesi oikean yhteystiedon, johon se arkistoidaan.",
    MYPROFILE: "Oma profiili",
    NO_RESULTS: "Ei tuloksia",
    NOTE_CONTACT_DATA_PREDICTED: "Tämän sähköpostiviestin sisällön perusteella olemme ehdottaneet tietoja tälle lähettäjälle. Tarkista ennen tämän yhteyshenkilön luomista.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Tarkista, että antamasi käyttäjätunnus ja salasana ovat oikein.",
    ONSITE_CONNECTION_SUCCESSFUL: "Onnittelut. SuperOffice Gmail Link on yhdistetty SuperOffice CRM Onsite -asennukseesi.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Tarkista, että olet kirjautunut sisään paikalliseen asennukseen, ennen kuin jatkat.",
    ONSITE_ERROR_LINE_1: "Kirjautumisprosessin aikana oli joitain ongelmia.",
    ONSITE_ERROR_LINE_2: "Varmista, että olet antanut oikean palvelimen URL-osoitteen. Napsauttamalla tietopainiketta näet, miten saat osoitteen.",
    ONSITE_PASSWORD: "Salasana:",
    ONSITE_SERVER_URL: "Palvelimen URL:",
    ONSITE_SERVER_URL_LINE_1: "Valitse SuperOffice CRM:n päävalikossa Kopioi-pikakuvake",
    ONSITE_SERVER_URL_LINE_2: "Liitä sitten palvelimen URL-osoitteeseen tähän",
    ONSITE_URL: "URL SuperOffice CRM Onsite -asennukseen:",
    ONSITE_USER_NAME: "Käyttäjätunnus:",
    OPEN_IN_CRM: "Avaa CRM:ssä",
    OR_UPPER: "TAI",
    OUR_CONTACT: "Oma yhteyshenkilö",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Jos muutat mielesi myöhemmin, avaa SuperOffice for Outlook -apuohjelma uudelleen kalenterinäytössä",
    PERMISSION_CONTINUE: "Avaa uusi ikkuna ja myönnä tarvittavat luvat napsauttamalla ”Jatka”",
    PERMISSION_FOR_CALENDAR: "SuperOffice for Outlook tarvitsee luvan käyttää kalenterikohteitasi.",
    PICKER_BCC: "Piilokopio",
    PICKER_CC: "Kopio",
    PICKER_CC_COPY: "Kopio",
    PICKER_TO: "Vastaanottaja",
    PLACE_REQUEST_IN_QUEUE: "Aseta pyyntö tähän jonoon:",
    POPUP__BOTTOM_TEXT: "Salli ponnahdusikkunat tälle sivulle ja yritä uudelleen.",
    POPUP__HEADER: "Ponnahdusikkunoiden esto havaittu",
    POPUP__MID_TEXT: "SuperOffice for Outlook tarvitsee todennuksen, mutta selaimesi ponnahdusikkunoiden esto estää sen.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Poista saapuneista",
    REMOVE_FROM_INBOX_DESC: "Siirtää sähköpostin poistettuihin viesteihin arkistoinnin jälkeen",
    REQUEST: "Pyyntö",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Tämä sähköposti on liian suuri lisättäväksi pyyntöön.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "Sähköposti on liian suuri",
    REQUEST_PRIORITY: "Prioriteetti",
    REQUEST_QUEUE: "Pyyntöjono",
    RESET_ALL: "Nollaa kaikki",
    RESET_INFO_SOFO: "Haluatko nollata tiedot SuperOffice for Outlookissa? Tämä poistaa nykyiset tiedot.",
    REVISION_LABEL: "Versio:",
    SEARCH_FAILED: "Haku epäonnistui. Yritä uudelleen.",
    SETTINGS: "Asetukset",
    SETTINGS_ApplyArchiveStatus: "Käytä arkistoluokkaa",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Vain ulkoiset vastaanottajat",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Ulkoiset vastaanottajat ovat organisaatiosi ulkopuolisia henkilöitä.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Eteenpäin",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Arkistointimuistutus",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Arkistointimuistutus auttaa varmistamaan, että sähköpostit ja tapaamiset tallennetaan SuperOfficeen ennen niiden lähettämistä.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Sinua muistutetaan kokousten arkistoinnista SuperOfficessa.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Muistuta ennen kokousten lähettämistä",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Uudet sähköpostit",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Vastaukset",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Sinua muistutetaan sähköpostien arkistoinnista SuperOfficessa.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Muistuta ennen sähköpostien lähettämistä",
    SETTINGS_CategoryColor: "Luokan väri",
    SETTINGS_CategoryName: "Luokan nimi",
    SETTINGS_CategoryNameFixedInfo: "Luokan nimi on kiinteä eikä sitä voi muuttaa.",
    SETTINGS_CategoryTaggingDescription: "Käytä Outlook-luokkaa sähköpostien tunnistamiseen, jotka on jo arkistoitu SuperOfficeen.",
    SETTINGS_CategoryTaggingInfo: "Sähköpostiarkiston tila auttaa sinua näkemään suoraan Outlook-postilaatikossasi, mitkä sähköpostit on jo tallennettu SuperOfficeen.",
    SETTINGS_CategoryTaggingSection: "Sähköpostiarkiston tila",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Toiminnan oletustyyppi",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Sähköpostin oletustyyppi",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Saapuva sähköposti",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Lähtevä sähköposti",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Saapuvien s-postien oletusmalli",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Lähtevien s-postien oletusmalli",
    SETTINGS_EnableCategoryForSharedMailbox: "Jaetuissa postilaatikoissa",
    SETTINGS_EnableCategoryOnOpen: "Arkistoituja sähköposteja avattaessa",
    SETTINGS_EnableCategoryOnSendAndArchive: "Lähetä ja arkistoi -toimintoa käytettäessä",
    SETTINGS_EnableCategoryTagging: "Näytä arkistoluokka Outlookissa",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Näytä asiayhteyteen liittyvät projektit ja myynnit",
    SETTINGS_GENERAL_HEADER: "Yleinen",
    SETTINGS_SharedMailboxCategoryInfo: "Arkistotilan näyttämiseksi arkistoluokka on luotava jaettuun postilaatikkoon.",
    SETTINGS_SharedMailboxCategoryInfoBold: "Jaettujen postilaatikoiden osalta:",
    SETTINGS_SharedMailboxCategoryLearnMore: "Lue lisää jaetun postilaatikon määrittämisestä",
    SETTINGS_YOURCOMPANY: "Yrityksen nimi:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Arkistoi ja lähetä",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Valitse arkistoitava yhteystieto tai yritys.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Tämä sähköposti on valmis lähetettäväksi, mutta sitä ei voida arkistoida SuperOfficessa.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Arkistoi",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Tämä sähköposti on valmis lähetettäväksi, mutta sitä ei ole asetettu arkistoitavaksi SuperOfficessa. Arkistoi se nyt, jotta viestintä tallentuu oikealle yritykselle tai yhteyshenkilölle, tai lähetä se ilman arkistointia.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Jokin epäonnistui asetuksia ladattaessa.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Kirjaudu sisään SuperOfficeen ennen asetusten avaamista.",
    SR_ADMIN_MYAPPS: "Omat sovellukset",
    SR_ALL_ITEM: "Kaikki",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Haluatko varmasti poistaa biometrisen kirjautumisen käytöstä? Seuraavalla kerralla sinun on kirjauduttava sisään manuaalisesti uudelleen.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Kopiointi leikepöydälle epäonnistui",
    SR_NO_SELECTION: "(Ei valintaa)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Aloita muutamalla klikkauksella",
    SYNCHRONIZER_REACTIVATE: "Aktivoi uudelleen muutamalla klikkauksella",
    SYNCRONIZER_MSG_CONTENT: "Synkronoi Outlook-kalenterisi ja tehtäväsi SuperOffice CRM:n kanssa pitääksesi kokoukset, yhteystiedot, projektit ja myynnin ajan tasalla.",
    SYNCRONIZER_NEED_AUTHENTICATION: "SuperOffice-kalenterin synkronointi Outlookin kanssa on melkein määritetty. Jatka sen aktivointia ja pidä kalenterit synkronoituina.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "SuperOffice-kalenterisi synkronointi Outlookin kanssa on tällä hetkellä keskeytetty. Jatka uudelleenaktivointia ja pidä kalenterisi synkronoituina.",
    TAB_ACTION: "Toiminto",
    TAB_PEOPLE: "Ihmiset",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Tehtävä luotu SuperOfficessa.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Tehtävä luotu SuperOfficessa.",
    TIMEOUT_ERROR_MESSAGE: "Palvelimella kesti liian kauan vastata. Yritä uudelleen.",
    TIMEOUT_ERROR_TITLE: "Pyyntö aikakatkaistiin",
    TITLE: "Titteli",
    UNDO: "Kumoa",
    UNKNOWN_EMAIL_ADDRESS: "Tuntematon sähköpostiosoite.",
    UNKNOWN_EMAILADDRESS: "Tätä lähettäjän sähköpostiosoitetta ei tunnisteta. Napsauta tässä lisätäksesi tämän sähköpostiosoitteen SuperOfficeen.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Vastaanottajan s-postiosoitetta ei tunnisteta. Napsauta tähän, kun haluat päivittää tämän s-postiosoitteen SuperOfficeen.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Tuntematon sähköpostiosoite. Lisää {0} SuperOfficeen.",
    UNLOCK_THESE_FEATURES: "Avaa nämä ominaisuudet synkronointiohjelmalla",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.com/crm/demo/",
    VERSION_SHORT: "ver.",
    VISIT_APP_STORE: "Käy App Storessa",
    WE_RUN_ONLINE_LINE_1: "Selvitä seuraavasti, oletko Online-tilassa:",
    WE_RUN_ONLINE_LINE_2: "1. Valitse SuperOffice CRM:ssä Ohje ja sitten Tietoja",
    WE_RUN_ONLINE_LINE_3: "2. Katso NetServer-merkintä:",
    WE_RUN_ONLINE_LINE_4: "Jos siinä lukee ”SuperOffice CRM Online ...”, olet Online-tilassa",
    WE_RUN_ONSITE_LINE_1: "Selvitä seuraavasti, oletko Onsite-tilassa:",
    WE_RUN_ONSITE_LINE_4: "Jos siinä lukee ”SuperOffice CRM OnSite...”, olet Onsite-tilassa",
    YOU_CAN_STILL_USE: "Voit edelleen käyttää SuperOffice for Outlookia sähköposteille!",
  },
  FR: {
    ACTION_ADD: "Ajouter",
    ACTION_BACK: "Retour",
    ACTIVITIES: "Activités",
    ADD_ATTENDEES: "Inviter des contacts depuis SuperOffice",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Ajouter l’adresse e-mail à un contact existant",
    AI_SUMMARY_AI_NOT_ENABLED: "Les fonctionnalités de texte basées sur l’IA ne sont pas activées pour votre organisation. Contactez votre administrateur SuperOffice.",
    AI_SUMMARY_APPEND: "Ajouter",
    AI_SUMMARY_FEATURE_DISABLED: "Cette fonctionnalité a été désactivée pour votre organisation.",
    AI_SUMMARY_GENERATE: "Générer",
    AI_SUMMARY_GENERATE_ERROR: "Impossible de générer un résumé pour le moment. Veuillez réessayer.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Générer un résumé par l’IA",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Participants\u00A0:",
    AI_SUMMARY_HEADER_SUBJECT: "Objet\u00A0:",
    AI_SUMMARY_LOADING: "Génération du résumé…",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Vous ne disposez pas d'une licence vous permettant d'utiliser les fonctionnalités d'IA",
    AI_SUMMARY_NO_PERMISSION: "Vous ne disposez pas de l’autorisation nécessaire pour lire cet e-mail.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "Il n’y a rien à résumer dans cet e-mail.",
    AI_SUMMARY_REPLACE_CONFIRM: "Remplacer",
    ALREADY_ARCHIVED_ATTACHMENT: "Cette pièce jointe a déjà été archivée par <%- archivedBy %> le <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "Cet e-mail a déjà été archivé par <%- archivedBy %> le <%- archivedAt %>.",
    ALREADY_ARCHIVED_SALE: "Une vente a déjà été créée pour cet e-mail par <%- archivedBy %> le <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "L’activité a déjà été créée pour cet e-mail par <%- archivedBy %> le <%- archivedAt %>.",
    ALREADY_DONE: "Déjà fait",
    APPOINTMENT_EXISTS_IN_CRM: "Ce rendez-vous existe dans CRM et a été créé par <%- createdBy %> le <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Créer une activité",
    ARCHIVE_ALWAYS_SHOW: "Toujours afficher la boîte de dialogue d’archivage",
    ARCHIVE_AS_ACTIVITY: "Créer un rendez-vous dans SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Enregistrer la pièce jointe dans SuperOffice",
    ARCHIVE_AS_REQUEST: "Créer une demande dans SuperOffice",
    ARCHIVE_AS_SALE: "Créer une vente dans SuperOffice",
    ARCHIVE_AS_TASK: "Créer une tâche dans SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Par défaut, retirer l’e-mail de la boîte de réception après l’archivage",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Inclure les modèles qui ne sont pas des modèles d’e-mail dans la liste des modèles",
    ATTACHMENT_SIZE_INFO: "Les pièces jointes sont trop volumineuses et ne peuvent pas être archivées. Seuls les e-mails sans pièces jointes peuvent être archivés.",
    AUTH__BOTTOM_TEXT_1: "\u2028Afficher plus de détails\u00A0?",
    AUTH__BOTTOM_TEXT_2: "Apprendre à autoriser le module complémentaire",
    AUTH__BUTTON: "Copier le lien admin",
    AUTH__COPIED: "Copié dans le presse-papiers",
    AUTH__HEADER: "Mise à jour de SuperOffice pour Outlook",
    AUTH__INCREMENTAL_TEXT_1: "Pour activer {feature}, des autorisations supplémentaires sont requises.",
    AUTH__MID_TEXT_1: "Afin de se conformer aux dernières exigences de Microsoft en matière de sécurité, le module complémentaire Outlook a été mis à jour.",
    AUTH__MID_TEXT_2: "Pour continuer à l'utiliser, <b>un administrateur global Microsoft 365 doit accorder des autorisations</b> (consentement) au nom de tous les utilisateurs.",
    AUTH__MID_TEXT_3: "<b>Partagez ce lien</b> avec votre administrateur Microsoft 365\u00A0:",
    AUTH__NEW_USER_TEXT_1: "Le module complémentaire SuperOffice pour Outlook nécessite des autorisations supplémentaires pour accéder aux données Microsoft 365.",
    AUTH_IN_PROGRESS__HEADER: "Autorisation en cours",
    AUTH_IN_PROGRESS__MID_TEXT: "Veuillez poursuivre l’authentification interactive en cours et réessayer.",
    AUTOSAVE_FAIL: "Pas enregistré.",
    AUTOSAVE_IN_PROGRESS: "Enregistrement…",
    AUTOSAVE_RETRY: "Réessayer",
    AUTOSAVE_SUCCESS: "Enregistré",
    BANNER_ADD_MESSAGE: "Message créé.",
    BANNER_CREATE_APPOINTMENT: "Rendez-vous créé.",
    BANNER_CREATE_REQUEST: "Demande créée.",
    BANNER_CREATE_SALE: "Vente créée.",
    BANNER_CREATE_TASK: "Tâche créée.",
    BANNER_SAVE_ATTACHMENT: "Pièce jointe enregistrée.",
    BANNER_SAVE_TO_SUPEROFFICE: "E-mail enregistré.",
    BANNER_VIEW_IN_CRM: "Afficher dans CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Ajouter un message à la demande",
    BTN_ADD_TO_SUPEROFFICE: "Ajouter à SuperOffice",
    BTN_ARCHIVE: "Archiver",
    BTN_CANCEL: "Annuler",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Cliquer pour ajouter un nouveau contact",
    BTN_CONNECT: "Se connecter",
    BTN_CONNECT_TO_SUPEROFFICE: "Nous utilisons SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Nous utilisons SuperOffice Onsite",
    BTN_CREATE: "Créer",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Créer une nouvelle société et un nouveau contact",
    BTN_GO_TO_SUPEROFFICE: "Aller à SuperOffice",
    BTN_KEEP_CONTACT: "Conserver",
    BTN_LOGIN: "Connexion",
    BTN_LOOKUP_SENDER: "Rechercher l'expéditeur",
    BTN_OK: "OK",
    BTN_RECONNECT: "Modifier un utilisateur de SuperOffice",
    BTN_SAVE: "Enregistrer",
    BTN_SAVE_AND_ARCHIVE: "Envoyer et archiver",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Inscrivez-vous pour un essai gratuit",
    BTN_UPDATE_CONTACT: "Mettre à jour",
    BUSINESS: "Secteur",
    BUTTON_LETS_GO: "Commençons",
    BUTTON_RELOAD: "Recharger",
    CAN_NOT_GRANT_PERMISSION: "Autorisation impossible à donner\u00A0?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Impossible d’ajouter un message à la demande car la pièce jointe peut être dangereuse",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Les pièces jointes ne peuvent pas être archivées, car certaines pourraient présenter un risque. Seuls les e-mails sans pièces jointes peuvent être archivés.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Impossible d’enregistrer une pièce jointe signée numériquement",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Cet e-mail a été signé numériquement. Les pièces jointes dans la signature ne peuvent pas être enregistrées individuellement.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Archivage impossible car la pièce jointe peut être dangereuse",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Impossible de créer une demande car la pièce jointe peut être dangereuse",
    CANNOT_SAVE_CONTACT: "Impossible d'enregistrer le contact",
    CATEGORY: "Catégorie",
    CHANGES_SAVED_AUTOMATICALLY: "Vos modifications sont enregistrées automatiquement",
    CHOOSE_ONE_OR_CONTINUE: "Veuillez en choisir un ou continuer.",
    CLICK_HERE_TO_SEE_IT: "Cliquer ici pour l’afficher.",
    CLICK_HERE_TO_SELECT_CONTACT: "Sélectionner un contact",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Cliquez ici pour sélectionner le bon contact à archiver.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} de plus. Cliquez ici pour afficher tout.",
    CLICK_LOGIN_ONSITE: "Cliquez ici pour ouvrir l'installation de votre SuperOffice dans un nouvel onglet",
    COMMENT_PLACEHOLDER: "Ajouter un commentaire…",
    COMPANY_NAME: "Nom de société",
    CONNECT_ONSITE: "Se connecter à l'installation de SuperOffice CRM Onsite",
    CONNECT_TO_SUPEROFFICE: "Vous connecter à votre compte SuperOffice CRM en ligne",
    CONTACT_ADMINISTRATOR: "Contactez votre administrateur SuperOffice pour vérifier la configuration de votre CRM.",
    CONTINUE: "Continuer",
    COULD_IT_BE_ONE_OF_THESE: "Est-ce que ce pourrait être l’un de ceux-ci\u00A0?",
    COUNTRY: "Pays",
    CREATE_NEW_COMPANY: "Créer une nouvelle société",
    CREATE_NEW_CONTACT: "Créer un nouveau contact",
    CREATE_REQUEST: "Créer une demande",
    CREATED_REQUEST: "Une demande a été créée",
    DEPARTMENT: "Département",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Ne pas archiver les pièces jointes",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Les pièces jointes sont archivées par défaut",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-mail archivé dans SuperOffice.",
    EMAIL_ADDRESS: "Adresse électronique",
    EMAIL_ADDRESS_NOT_REGISTERED: "Cette adresse e-mail n’existe pas dans SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "L'adresse <span class='so-email'>{0}</span> est rattachée à plusieurs contacts dans SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-mail enregistré dans SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Cette adresse e-mail est enregistrée sous plusieurs contacts dans SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Activez l’archivage pour modifier ces paramètres",
    ERROR: "Erreur",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Impossible d'ajouter l'adresse e-mail à SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Impossible d'archiver la pièce jointe.",
    ERROR_ARCHIVING_EMAIL: "Impossible d'archiver l'e-mail.",
    ERROR_ARCHIVING_REQUEST: "Impossible d'archiver la demande.",
    ERROR_ARCHIVING_TASK: "Impossible de créer l'activité.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Impossible de communiquer avec SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Vous n'êtes pas autorisé à créer des sociétés ou des contacts dans SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Trouver une société ou un contact...",
    FIRST_ATTENDEE_CHANGED: "Le contact pour la réunion a changé.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Choisissez le contact auquel le rendez-vous doit être associé.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Le contact et le participant à la réunion ne correspondent pas",
    FIRSTNAME: "Prénom",
    FOLLOWUPS: "Actions",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice pour Outlook n'a pas pu se connecter aux services Microsoft. Veuillez réessayer dans quelques instants.",
    GRAPH_API_ERROR_TITLE_SOFO: "Les services Microsoft sont temporairement indisponibles",
    HEADER_ADD_EMAIL: "Ajouter l’e-mail/le contact\u00A0: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Ajouter l’adresse e-mail à SuperOffice",
    HEADER_ADD_RECPIENTS: "Ajouter des destinataires de SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Ajouter à un contact existant",
    HEADER_ARCHIVE_APPOINTMENT: "Créer activité",
    HEADER_ARCHIVE_ATTACHMENT: "Archiver la pièce jointe en tant que document SuperOffice",
    HEADER_ARCHIVE_EMAIL: "Archiver l’e-mail dans SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Se connecter à une autre installation SuperOffice",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Créer une activité dans SuperOffice basée sur les e-mails",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Enregistrer les pièces jointes de cet e-mail dans SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Archiver cet e-mail dans SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Créer une demande dans SuperOffice basée sur les e-mails",
    HEADER_CREATE_EMAIL_AS_SALE: "Créer une vente dans SuperOffice basée sur cet e-mail",
    HEADER_CREATE_EMAIL_AS_TASK: "Créer une tâche dans votre aide-mémoire sur la base de l'e-mail",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Créer une nouvelle société et un nouveau contact",
    HEADER_CREATE_NEW_PERSON: "Créer un nouveau contact",
    HEADER_WELCOME: "Bienvenue",
    LABEL_ACHIEVE_MORE: "En faire plus avec l'intégration",
    LABEL_ADD_TO_EXISTING_REQUEST: "Ajouter l'e-mail comme message dans une demande existante dans SuperOffice",
    LABEL_ARCHIVE_FILE: "Archiver le fichier\u00A0:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Pièce jointe déjà enregistrée",
    LABEL_ATTACHMENT_NOT_SAVED: "Pièce jointe non enregistrée",
    LABEL_COMMENT: "Commentaire\u00A0:",
    LABEL_COMPANYPHONE: "Numéro de téléphone de la société:",
    LABEL_CONTACT: "Société:",
    LABEL_CONTACT_OR_COMPANY: "Contact ou société\u00A0:",
    LABEL_CREATE_AND_VISUALIZE: "Créer et visualiser comme un pro",
    LABEL_CURRENCY: "Devise:",
    LABEL_DATE: "Date:",
    LABEL_DESCRIPTION: "Description:",
    LABEL_DIRECTPHONE: "Ligne directe:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Découvrez ce que ce module complémentaire peut faire pour vous dès aujourd'hui !",
    LABEL_HOME_ADDRESS: "Adresse du domicile :",
    LABEL_MOBILEPHONE: "Tél. portable:",
    LABEL_NOTES: "Remarques\u00A0:",
    LABEL_NUMBER: "Numéro:",
    LABEL_OPTIONAL_ATTENDEE: "En option",
    LABEL_PERSON: "Contact:",
    LABEL_POSITION: "Fonction:",
    LABEL_PROJECT: "Projet:",
    LABEL_REQUIRED_ATTENDEE: "Requis",
    LABEL_SALE: "Vente:",
    LABEL_SALE_AMOUNT: "Montant de la vente :",
    LABEL_SALE_DATE: "Date de vente :",
    LABEL_SALE_NAME: "Nom de la vente :",
    LABEL_SALE_TYPE: "Type de vente:",
    LABEL_SAVED_CHANGES: "Vos modifications ont été enregistrées.",
    LABEL_SELECT_CS_QUEUE: "Ajouter une demande à cette file d’attente :",
    LABEL_SELECT_CS_QUEUE_SHORT: "Sélectionner la file d'attente",
    LABEL_SERVER_VERSION: "Version du serveur :",
    LABEL_SUBJECT: "Objet:",
    LABEL_SUPEROFFICE_SITE: "Site de SuperOffice\u00A0:",
    LABEL_TELEPHONE: "Téléphone :",
    LABEL_TIME: "Heure:",
    LABEL_TYPE: "Type:",
    LABEL_UNLOCK_FEATURES: "Déverrouiller des fonctions et des fonctionnalités",
    LABEL_URL: "URL:",
    LABEL_USER: "Utilisateur:",
    LABEL_VISIBLE_FOR: "Visible par:",
    LABEL_WEB_PAGE: "Page Web:",
    LASTNAME: "Nom",
    LEARN_MORE: "En savoir plus",
    LOGIN_COMPLETE_SETUP: "Pour terminer la configuration de SuperOffice Gmail Link, vous devez vous connecter à SuperOffice.",
    LOGIN_ONSITE: "Connectez-vous à votre installation de SuperOffice CRM Onsite. ",
    LOGOUT_FROM_SUPEROFFICE_1: "Se déconnecter de SuperOffice et fermer tout onglet de SuperOffice ouvert.",
    LOGOUT_FROM_SUPEROFFICE_2: "La prochaine fois que vous vous connecterez à SuperOffice CRM Online, la nouvelle connexion sera configurée automatiquement.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Faire de cette l’adresse, l’adresse e-mail principale",
    MARK_COMPLETED: "Marquer en tant que terminé",
    MARK_REMOVE_FROM_INBOX: "Supprimer de la boîte de réception",
    MENU_ARCHIVE_EMAIL: "Archiver l'e-mail",
    MENU_CREATE_APPOINTMENT: "Créer une activité",
    MENU_CREATE_NEW_SALE: "Créer une nouvelle vente",
    MENU_SAVE_TO_SUPEROFFICE: "Enregistrer dans SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Le contact n’a pas d’adresse électronique",
    MIDDLENAME: "Deuxième prénom",
    MISSING_REQUIRED_VALUES_INTRO: "Certains champs obligatoires ne sont pas disponibles pour votre compte utilisateur\u00A0:",
    ML_ADD_COMPANY: "Ajouter société",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Ajouter un e-mail au contact",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Ajouter une nouvelle société et un nouveau contact",
    ML_ADD_NEW_CONTACT_PERSON: "Ajouter un nouveau contact",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Archiver cet e-mail comme rendez-vous dans votre calendrier",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Archiver l'e-mail dans SuperOffice sur la carte société de l'expéditeur",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Cliquez pour l’ajouter à SuperOffice",
    ML_COMPANY_DETAILS: "Coordonnées de la société",
    ML_CONTACT_DETAILS: "Coordonnées du contact",
    ML_CREATE_A_NEW_SALE: "Créer une nouvelle vente pour ce client",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Déconnecter Outlook de SuperOffice",
    ML_INVITATION_OPTIONS: "Invitations",
    ML_MOVE_INTO_CS_AS_REQUEST: "Ajouter cet e-mail au Customer Service, en tant que nouvelle demande.",
    ML_OR_ADD_CONTACT_TO_COMPANY: "OU AJOUTER UN CONTACT À LA SOCIÉTÉ\u00A0?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Personnes mentionnées dans ce message",
    ML_PERSON_COULD_BE: "Ce contact pourrait être",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Rechercher un contact ou une société...",
    ML_SETTINGS_INVITATIONS_HEADER: "Invitations pour SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Ajouter/mettre à jour le rendez-vous dans SuperOffice lors de la réponse aux invitations dans Outlook.",
    MOBILE: "Mobile",
    MORE: "Plus",
    MRMS: "M./Mme",
    MULTIPLE_EMAILADDRESSES_FOUND: "Cette adresse e-mail est enregistrée sous plusieurs contacts dans SuperOffice. Cliquez ici pour sélectionner le bon contact à utiliser pour l’archivage.",
    MYPROFILE: "Mon Profil",
    NO_RESULTS: "Aucun résultat",
    NOTE_CONTACT_DATA_PREDICTED: "En nous appuyant sur le contenu de cet e-mail, nous avons suggéré des détails pour cet expéditeur. Merci de les vérifier avant de créer ce contact.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Vérifiez que le nom d'utilisateur et le mot de passe que vous avez saisis sont corrects.",
    ONSITE_CONNECTION_SUCCESSFUL: "Félicitations. La connexion de SuperOffice Gmail Link à votre installation de SuperOffice CRM Onsite est réussie.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Assurez-vous d'être connecté à votre installation sur place avant de continuer.",
    ONSITE_ERROR_LINE_1: "Une erreur est survenue lors du processus de connexion.",
    ONSITE_ERROR_LINE_2: "Assurez-vous d'avoir saisi une URL de serveur correcte. Cliquez sur la touche d'information pour savoir comment l'obtenir.",
    ONSITE_PASSWORD: "Mot de passe :",
    ONSITE_SERVER_URL: "URL du serveur :",
    ONSITE_SERVER_URL_LINE_1: "Dans SuperOffice CRM, sélectionnez Copier le raccourci dans le menu principal",
    ONSITE_SERVER_URL_LINE_2: "Puis collez l'URL du serveur ici",
    ONSITE_URL: "URL de votre installation SuperOffice CRM Onsite :",
    ONSITE_USER_NAME: "Nom d'utilisateur :",
    OPEN_IN_CRM: "Ouvrir dans CRM",
    OR_UPPER: "OU",
    OUR_CONTACT: "Notre contact",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Si vous changez d'avis plus tard, ouvrez à nouveau le complément SuperOffice pour Outlook dans l'écran du calendrier",
    PERMISSION_CONTINUE: "Cliquez sur «\u00A0Continuer\u00A0» pour ouvrir une nouvelle fenêtre et accorder les autorisations nécessaires",
    PERMISSION_FOR_CALENDAR: "SuperOffice pour Outlook a besoin de votre autorisation pour accéder à vos éléments de calendrier.",
    PICKER_BCC: "Cci",
    PICKER_CC: "Cc",
    PICKER_CC_COPY: "Cc",
    PICKER_TO: "A",
    PLACE_REQUEST_IN_QUEUE: "Placer la demande dans cette file d’attente\u00A0:",
    POPUP__BOTTOM_TEXT: "Veuillez autoriser les fenêtres pop-up pour cette page et réessayer.",
    POPUP__HEADER: "Bloqueur de fenêtres pop-up détecté",
    POPUP__MID_TEXT: "SuperOffice pour Outlook doit s’authentifier, mais le bloqueur de fenêtres pop-up de votre navigateur l’en empêche.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Retirer de la boîte de réception",
    REMOVE_FROM_INBOX_DESC: "Déplace les e-mails vers le dossier «\u00A0Éléments supprimés\u00A0» après l’archivage",
    REQUEST: "Demande",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Cet e-mail est trop volumineux pour être ajouté à une demande.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "E-mail trop volumineux",
    REQUEST_PRIORITY: "Priorité",
    REQUEST_QUEUE: "File d'attente des demandes",
    RESET_ALL: "Réinitialiser tout",
    RESET_INFO_SOFO: "Souhaitez-vous réinitialiser les informations dans SuperOffice pour Outlook\u00A0? Les données actuelles seront supprimées.",
    REVISION_LABEL: "Révision :",
    SEARCH_FAILED: "Échec de la recherche. Veuillez réessayer.",
    SETTINGS: "Paramètres",
    SETTINGS_ApplyArchiveStatus: "Appliquer une catégorie d'archivage",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Destinataires externes uniquement",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Les destinataires externes sont des personnes extérieures à votre organisation.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Transferts",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Rappel concernant l’archivage",
    SETTINGS_ARCHIVE_REMINDER_INFO: "La fonction de rappel d'archivage permet de s'assurer que les e-mails et les réunions sont enregistrés dans SuperOffice avant leur envoi.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Un rappel vous invite à archiver vos réunions dans SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "M’envoyer un rappel avant d’envoyer des réunions",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Nouveaux e-mails",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Réponses",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Un rappel vous invite à archiver vos e-mails dans SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Envoyer un rappel avant d’envoyer des e-mails",
    SETTINGS_CategoryColor: "Couleur de la catégorie",
    SETTINGS_CategoryName: "Nom de la catégorie",
    SETTINGS_CategoryNameFixedInfo: "Le nom de la catégorie est fixe et ne peut pas être modifié.",
    SETTINGS_CategoryTaggingDescription: "Utilisez une catégorie Outlook pour identifier les e-mails qui ont déjà été archivés dans SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "Le statut d’archivage des e-mails vous permet de voir directement dans votre boîte aux lettres Outlook quels e-mails ont déjà été enregistrés dans SuperOffice.",
    SETTINGS_CategoryTaggingSection: "Statut d’archivage des e-mails",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Type d’activité par défaut",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Type d’e-mail par défaut",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "E-mail entrant",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "E-mail sortant",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Modèle d'e-mail entrant par défaut",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Modèle d'e-mail sortant par défaut",
    SETTINGS_EnableCategoryForSharedMailbox: "Dans les messageries partagées",
    SETTINGS_EnableCategoryOnOpen: "Lors de l'ouverture d'e-mails archivés",
    SETTINGS_EnableCategoryOnSendAndArchive: "Lors de l'utilisation de la fonction «\u00A0Envoyer et archiver\u00A0»",
    SETTINGS_EnableCategoryTagging: "Afficher la catégorie d'archivage dans Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Afficher les projets contextuels et les ventes",
    SETTINGS_GENERAL_HEADER: "Général",
    SETTINGS_SharedMailboxCategoryInfo: "Pour afficher le statut d'archivage, la catégorie d'archivage doit avoir été créée dans la messagerie partagée.",
    SETTINGS_SharedMailboxCategoryInfoBold: "Pour les messageries partagées\u00A0:",
    SETTINGS_SharedMailboxCategoryLearnMore: "En savoir plus sur la configuration d'une messagerie partagée",
    SETTINGS_YOURCOMPANY: "Nom de société:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Archiver et envoyer",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Sélectionnez un contact ou une société à archiver.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Cet e-mail est prêt à être envoyé, mais il ne peut pas être archivé dans SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Archiver",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Cet e-mail est prêt à être envoyé, mais il n’est pas configuré pour être archivé dans SuperOffice. Archivez-le dès maintenant afin que la communication soit enregistrée avec une société ou un contact correct, ou envoyez-le sans l’archiver.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Une erreur s’est produite lors du chargement des paramètres.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Veuillez vous connecter à SuperOffice avant d’ouvrir les paramètres.",
    SR_ADMIN_MYAPPS: "Mes applications",
    SR_ALL_ITEM: "Tous",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Êtes-vous sûr de vouloir désactiver la connexion biométrique\u00A0? Vous devrez vous reconnecter manuellement la prochaine fois.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Échec de la copie dans le presse-papiers",
    SR_NO_SELECTION: "(Aucune sélection)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Démarrer en quelques clics",
    SYNCHRONIZER_REACTIVATE: "Réactiver en quelques clics",
    SYNCRONIZER_MSG_CONTENT: "Synchronisez votre calendrier et vos tâches Outlook avec SuperOffice CRM pour tenir à jour les réunions, les contacts, les projets et les ventes.",
    SYNCRONIZER_NEED_AUTHENTICATION: "La synchronisation du calendrier SuperOffice avec Outlook est presque terminée. Continuez à l'activer et gardez vos calendriers synchronisés.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "La synchronisation de votre calendrier SuperOffice avec Outlook est actuellement interrompue. Continuez à réactiver et à synchroniser vos calendriers.",
    TAB_ACTION: "Action",
    TAB_PEOPLE: "Personnes",
    TASK_ARCHIVED_IN_SUPEROFFICE: "L’activité a été créée dans SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "L’activité a été créée dans SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "Le serveur a mis trop de temps à répondre. Veuillez réessayer.",
    TIMEOUT_ERROR_TITLE: "Expiration de la demande",
    TITLE: "Titre",
    UNDO: "Annuler",
    UNKNOWN_EMAIL_ADDRESS: "Adresse e-mail inconnue.",
    UNKNOWN_EMAILADDRESS: "L’adresse e-mail de cet expéditeur n’est pas reconnue. Cliquer ici pour ajouter cette adresse e-mail à SuperOffice.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "L'adresse e-mail de ce destinataire n'est pas reconnue. Cliquez ici pour mettre à jour SuperOffice avec cette adresse e-mail.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Adresse e-mail inconnue. Ajouter {0} à SuperOffice.",
    UNLOCK_THESE_FEATURES: "Déverrouillez ces fonctionnalités avec l’application de synchonisation",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.com/crm/demo/",
    VERSION_SHORT: "vers.",
    VISIT_APP_STORE: "Consultez l’App Store",
    WE_RUN_ONLINE_LINE_1: "Pour savoir si vous utilisez la version Online, procédez comme suit :",
    WE_RUN_ONLINE_LINE_2: "1. Dans SuperOffice CRM, sélectionnez Aide, puis À propos de",
    WE_RUN_ONLINE_LINE_3: "2. Examinez l'entrée pour NetServer :",
    WE_RUN_ONLINE_LINE_4: "Si elle indique \"SuperOffice CRM Online ...\", cela signifie que vous utilisez la version Online",
    WE_RUN_ONSITE_LINE_1: "Pour savoir si vous utilisez la version Onsite, procédez comme suit :",
    WE_RUN_ONSITE_LINE_4: "Si elle indique \"SuperOffice CRM OnSite ...\", cela signifie que vous utilisez la version Onsite",
    YOU_CAN_STILL_USE: "Vous pouvez continuer à utiliser SuperOffice pour Outlook pour les e-mails\u00A0!",
  },
  IT: {
    ACTION_ADD: "Aggiungi",
    ACTION_BACK: "Indietro",
    ACTIVITIES: "Attività",
    ADD_ATTENDEES: "Invita contatti da SuperOffice",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Aggiungi indirizzo e-mail a contatto esistente",
    AI_SUMMARY_AI_NOT_ENABLED: "Le funzionalità di testo AI non sono abilitate per la tua organizzazione. Contatta il tuo amministratore di SuperOffice.",
    AI_SUMMARY_APPEND: "Allega",
    AI_SUMMARY_FEATURE_DISABLED: "Questa funzionalità è stata disattivata per la tua organizzazione.",
    AI_SUMMARY_GENERATE: "Genera",
    AI_SUMMARY_GENERATE_ERROR: "Al momento non è stato possibile generare un riepilogo. Riprovare.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Genera riepilogo AI",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Partecipanti:",
    AI_SUMMARY_HEADER_SUBJECT: "Oggetto:",
    AI_SUMMARY_LOADING: "Generazione del riepilogo…",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Non disponi di una licenza per utilizzare le funzionalità AI",
    AI_SUMMARY_NO_PERMISSION: "Non sei autorizzato a leggere questa e-mail.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "Non c’è nulla da riassumere in questa e-mail.",
    AI_SUMMARY_REPLACE_CONFIRM: "Sostituisci",
    ALREADY_ARCHIVED_ATTACHMENT: "L'allegato è già stato archiviato da <%- archivedBy %> in data <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "Questa e-mail è già stata archiviata da <%- archivedBy %> in data <%- archivedAt %>.",
    ALREADY_ARCHIVED_SALE: "È già stata creata una vendita per questa e-mail da <%- archivedBy %> su <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "L’attività è già stata creata per questa e-mail da <%- archivedBy %> il <%- archivedAt %>.",
    ALREADY_DONE: "Già fatto",
    APPOINTMENT_EXISTS_IN_CRM: "Questo appuntamento esiste in CRM ed è stato creato da <%- createdBy %> in data <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Crea attività",
    ARCHIVE_ALWAYS_SHOW: "Mostra sempre la finestra di dialogo archiviazione",
    ARCHIVE_AS_ACTIVITY: "Crea appuntamento in SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Salva allegato in SuperOffice",
    ARCHIVE_AS_REQUEST: "Crea richiesta in SuperOffice",
    ARCHIVE_AS_SALE: "Crea vendita in SuperOffice",
    ARCHIVE_AS_TASK: "Crea compito in SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Rimuovi e-mail dalla posta in arrivo dopo l'archiviazione come operazione predefinita",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Includi modelli non e-mail nell'elenco dei modelli",
    ATTACHMENT_SIZE_INFO: "Gli allegati sono troppo grandi ed è impossibile archiviarli. È possibile archiviare soltanto le e-mail prive di allegati.",
    AUTH__BOTTOM_TEXT_1: "\u2028Servono più dettagli?",
    AUTH__BOTTOM_TEXT_2: "Scopri in che modo autorizzare il componente aggiuntivo",
    AUTH__BUTTON: "Copia link amministratore",
    AUTH__COPIED: "Copiato negli appunti",
    AUTH__HEADER: "Aggiornamento di SuperOffice per Outlook",
    AUTH__INCREMENTAL_TEXT_1: "Per abilitare {feature}, sono necessarie autorizzazioni aggiuntive.",
    AUTH__MID_TEXT_1: "Il componente aggiuntivo Outlook è stato aggiornato per soddisfare i requisiti di sicurezza più recenti di Microsoft.",
    AUTH__MID_TEXT_2: "Per continuare a utilizzarlo, <b>è necessario che un amministratore globale di Microsoft 365 conceda le autorizzazioni</b> (consenso) per conto di tutti gli utenti.",
    AUTH__MID_TEXT_3: "<b>Condividi questo link</b> con l’amministratore di Microsoft 365 di riferimento.",
    AUTH__NEW_USER_TEXT_1: "Il componente aggiuntivo SuperOffice per Outlook richiede autorizzazioni aggiuntive per accedere ai dati di Microsoft 365.",
    AUTH_IN_PROGRESS__HEADER: "Autorizzazione in corso",
    AUTH_IN_PROGRESS__MID_TEXT: "Continuare l’autenticazione interattiva attualmente in corso e riprovare.",
    AUTOSAVE_FAIL: "Non salvato.",
    AUTOSAVE_IN_PROGRESS: "Salvataggio in corso",
    AUTOSAVE_RETRY: "Riprova",
    AUTOSAVE_SUCCESS: "Salvato",
    BANNER_ADD_MESSAGE: "Messaggio creato.",
    BANNER_CREATE_APPOINTMENT: "Appuntamento creato.",
    BANNER_CREATE_REQUEST: "Richiesta creata.",
    BANNER_CREATE_SALE: "Vendita creata.",
    BANNER_CREATE_TASK: "Compito creato.",
    BANNER_SAVE_ATTACHMENT: "Allegato salvato.",
    BANNER_SAVE_TO_SUPEROFFICE: "E-mail salvata.",
    BANNER_VIEW_IN_CRM: "Visualizza in CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Aggiungi messaggio alla richiesta",
    BTN_ADD_TO_SUPEROFFICE: "Aggiungi a SuperOffice",
    BTN_ARCHIVE: "Archivio",
    BTN_CANCEL: "Annulla",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Fare clic per aggiungere un nuovo contatto",
    BTN_CONNECT: "Connetti",
    BTN_CONNECT_TO_SUPEROFFICE: "È in esecuzione SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "È in esecuzione SuperOffice Onsite",
    BTN_CREATE: "Crea",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Crea nuova società e nuovo contatto",
    BTN_GO_TO_SUPEROFFICE: "Vai s SuperOffice",
    BTN_KEEP_CONTACT: "Mantieni",
    BTN_LOGIN: "Accesso",
    BTN_LOOKUP_SENDER: "Cerca mittente",
    BTN_OK: "OK",
    BTN_RECONNECT: "Modifica utente SuperOffice",
    BTN_SAVE: "Salva",
    BTN_SAVE_AND_ARCHIVE: "Invia e archivia",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Registrati per una prova gratuita",
    BTN_UPDATE_CONTACT: "Aggiorna",
    BUSINESS: "Settore",
    BUTTON_LETS_GO: "Iniziamo",
    BUTTON_RELOAD: "Ricarica",
    CAN_NOT_GRANT_PERMISSION: "Impossibile concedere autorizzazione?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Impossibile aggiungere un messaggio alla richiesta perché l’allegato potrebbe non essere sicuro",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "È impossibile archiviare gli allegati perché alcuni potrebbero non essere sicuri. È possibile archiviare soltanto e-mail prive di allegati.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Impossibile salvare l’allegato firmato digitalmente",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Questa e-mail è firmata digitalmente. Gli allegati nella firma non possono essere salvati singolarmente.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Impossibile archiviare perché l’allegato potrebbe non essere sicuro",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Impossibile creare una richiesta perché l’allegato potrebbe non essere sicuro",
    CANNOT_SAVE_CONTACT: "Impossibile salvare il contatto",
    CATEGORY: "Categoria",
    CHANGES_SAVED_AUTOMATICALLY: "Le modifiche vengono salvate automaticamente",
    CHOOSE_ONE_OR_CONTINUE: "Scegliere una voce oppure continuare.",
    CLICK_HERE_TO_SEE_IT: "Fare clic qui per visualizzarlo.",
    CLICK_HERE_TO_SELECT_CONTACT: "Seleziona contatto",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Fare clic qui per selezionare il contatto giusto da archiviare.",
    CLICK_HERE_TO_SHOW_MORE: "+ altri {0}. Fare clic qui per visualizzare tutto.",
    CLICK_LOGIN_ONSITE: "Fare clic qui per aprire l'installazione SuperOffice in una nuova scheda.",
    COMMENT_PLACEHOLDER: "Aggiungi un commento…",
    COMPANY_NAME: "Nome società",
    CONNECT_ONSITE: "Connettersi all'installazione di SuperOffice CRM Onsite",
    CONNECT_TO_SUPEROFFICE: "Connetti al tuo account di SuperOffice CRM Online",
    CONTACT_ADMINISTRATOR: "Contattare l’amministratore di SuperOffice per riesaminare la configurazione del tuo CRM.",
    CONTINUE: "Continua",
    COULD_IT_BE_ONE_OF_THESE: "Potrebbe essere uno di questi?",
    COUNTRY: "Paese",
    CREATE_NEW_COMPANY: "Crea nuova società",
    CREATE_NEW_CONTACT: "Crea nuovo contatto",
    CREATE_REQUEST: "Crea richiesta",
    CREATED_REQUEST: "La richiesta è stata creata",
    DEPARTMENT: "Reparto",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Non archiviare allegati",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Gli allegati vengono archiviati per impostazione predefinita",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-mail archiviata in SuperOffice.",
    EMAIL_ADDRESS: "E-mail",
    EMAIL_ADDRESS_NOT_REGISTERED: "Questo indirizzo e-mail non esiste in SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> è allegato a più contatti in SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-mail registrata in SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Questo indirizzo e-mail è registrato su più contatti in SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Abilita l’archiviazione per modificare queste impostazioni",
    ERROR: "Errore",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Impossibile aggiungere indirizzo e-mail a SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Impossibile archiviare l'allegato.",
    ERROR_ARCHIVING_EMAIL: "Impossibile archiviare l'e-mail.",
    ERROR_ARCHIVING_REQUEST: "Impossibile archiviare la richiesta.",
    ERROR_ARCHIVING_TASK: "Impossibile creare attività.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Impossibile comunicare con SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Non si ha il permesso di creare società o contatti in SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Trova una società o un contatto...",
    FIRST_ATTENDEE_CHANGED: "Il contatto della riunione è cambiato.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Scegliere a quale contatto deve essere collegato l’appuntamento.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Il contatto e il partecipante alla riunione non corrispondono",
    FIRSTNAME: "Nome",
    FOLLOWUPS: "Follow-up",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice per Outlook non è riuscito a connettersi ai servizi Microsoft. Riprova tra qualche minuto.",
    GRAPH_API_ERROR_TITLE_SOFO: "Servizi Microsoft temporaneamente non disponibili",
    HEADER_ADD_EMAIL: "Aggiungi e-mail/contatto: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Aggiungi indirizzo e-mail in SuperOffice",
    HEADER_ADD_RECPIENTS: "Aggiungi destinatari da SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Aggiungi a contatto esistente",
    HEADER_ARCHIVE_APPOINTMENT: "Crea attività",
    HEADER_ARCHIVE_ATTACHMENT: "Archivia allegato come documento SuperOffice",
    HEADER_ARCHIVE_EMAIL: "Archivia e-mail in SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Connetti a un'altra installazione di SuperOffice",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Crea attività in SuperOffice basata su e-mail",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Salva allegati da questa e-mail in SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Archivia questa e-mail in SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Crea richiesta in SuperOffice basata su e-mail",
    HEADER_CREATE_EMAIL_AS_SALE: "Crea vendita in SuperOffice basata su questa e-mail",
    HEADER_CREATE_EMAIL_AS_TASK: "Crea un compito nella lista di controllo in base alla posta elettronica",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Crea nuova società e nuovo contatto",
    HEADER_CREATE_NEW_PERSON: "Crea nuovo contatto",
    HEADER_WELCOME: "Benvenuti",
    LABEL_ACHIEVE_MORE: "Ottieni di più con l’integrazione",
    LABEL_ADD_TO_EXISTING_REQUEST: "Aggiungi l’e-mail come messaggio in una richiesta esistente in SuperOffice",
    LABEL_ARCHIVE_FILE: "Archivia file:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Allegato già salvato",
    LABEL_ATTACHMENT_NOT_SAVED: "Allegato non salvato",
    LABEL_COMMENT: "Commento:",
    LABEL_COMPANYPHONE: "Telefono società:",
    LABEL_CONTACT: "Società:",
    LABEL_CONTACT_OR_COMPANY: "Contatto o Società",
    LABEL_CREATE_AND_VISUALIZE: "Crea e visualizza come un professionista",
    LABEL_CURRENCY: "Valuta:",
    LABEL_DATE: "Data:",
    LABEL_DESCRIPTION: "Descrizione:",
    LABEL_DIRECTPHONE: "Telefono diretto:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Scopri oggi stesso cosa può fare questo componente aggiuntivo per te!",
    LABEL_HOME_ADDRESS: "Indirizzo privato:",
    LABEL_MOBILEPHONE: "Cellulare:",
    LABEL_NOTES: "Note:",
    LABEL_NUMBER: "Numero:",
    LABEL_OPTIONAL_ATTENDEE: "Opzionale",
    LABEL_PERSON: "Contatto:",
    LABEL_POSITION: "Posizione:",
    LABEL_PROJECT: "Progetto:",
    LABEL_REQUIRED_ATTENDEE: "Richiesto",
    LABEL_SALE: "Vendita:",
    LABEL_SALE_AMOUNT: "Importo della vendita:",
    LABEL_SALE_DATE: "Data di vendita:",
    LABEL_SALE_NAME: "Nome della vendita:",
    LABEL_SALE_TYPE: "Tipo di vendita:",
    LABEL_SAVED_CHANGES: "Le modifiche sono state salvate.",
    LABEL_SELECT_CS_QUEUE: "Aggiungi richiesta a questa coda:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Seleziona coda",
    LABEL_SERVER_VERSION: "Versione del server:",
    LABEL_SUBJECT: "Argomento:",
    LABEL_SUPEROFFICE_SITE: "Sito SuperOffice:",
    LABEL_TELEPHONE: "Telefono:",
    LABEL_TIME: "Ora:",
    LABEL_TYPE: "Tipo:",
    LABEL_UNLOCK_FEATURES: "Sblocca caratteristiche e funzionalità",
    LABEL_URL: "URL:",
    LABEL_USER: "Utente:",
    LABEL_VISIBLE_FOR: "Visibile per:",
    LABEL_WEB_PAGE: "Pagina Web:",
    LASTNAME: "Cognome",
    LEARN_MORE: "Per saperne di più",
    LOGIN_COMPLETE_SETUP: "Per completare la configurazione di SuperOffice Gmail Link, è necessario accedere a SuperOffice.",
    LOGIN_ONSITE: "Accedere all'installazione di SuperOffice CRM Onsite.",
    LOGOUT_FROM_SUPEROFFICE_1: "Disconnetti da SuperOffice e chiudi la scheda o le schede di SuperOffice aperte, se del caso.",
    LOGOUT_FROM_SUPEROFFICE_2: "All'accesso successivo a SuperOffice CRM Online, la nuova connessione verrà configurata automaticamente.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Rendi questo come indirizzo e-mail principale",
    MARK_COMPLETED: "Contrassegna come completato",
    MARK_REMOVE_FROM_INBOX: "Rimuovi dalla posta in arrivo",
    MENU_ARCHIVE_EMAIL: "Archivia e-mail",
    MENU_CREATE_APPOINTMENT: "Crea attività",
    MENU_CREATE_NEW_SALE: "Crea nuova vendita",
    MENU_SAVE_TO_SUPEROFFICE: "Salva in SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Il contatto non ha indirizzo e-mail",
    MIDDLENAME: "Secondo nome",
    MISSING_REQUIRED_VALUES_INTRO: "Alcuni campi obbligatori non sono disponibili per il tuo account utente:",
    ML_ADD_COMPANY: "Aggiungi società",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Aggiungi e-mail a contatto",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Aggiungi nuova società e contatto",
    ML_ADD_NEW_CONTACT_PERSON: "Aggiungi nuovo contatto",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Archivia questa e-mail come appuntamento nel calendario",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Archivia e-mail in SuperOffice sulla scheda Società del mittente",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Fare clic per aggiungere a SuperOffice",
    ML_COMPANY_DETAILS: "Dettagli società",
    ML_CONTACT_DETAILS: "Dettagli contatto",
    ML_CREATE_A_NEW_SALE: "Crea una nuova vendita per questo cliente",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Disconnetti Outlook da SuperOffice",
    ML_INVITATION_OPTIONS: "Inviti",
    ML_MOVE_INTO_CS_AS_REQUEST: "Aggiungi questa e-mail a Customer Service come nuova richiesta",
    ML_OR_ADD_CONTACT_TO_COMPANY: "OPPURE AGGIUNGERE CONTATTO A SOCIETÀ?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Persone menzionate in questo messaggio",
    ML_PERSON_COULD_BE: "Questo contatto potrebbe essere",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Cerca contatto o società…",
    ML_SETTINGS_INVITATIONS_HEADER: "Inviti per SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Aggiungi / aggiorna l’appuntamento in SuperOffice quando rispondi agli inviti in Outlook.",
    MOBILE: "Cellulare",
    MORE: "Altri",
    MRMS: "Sig./Sig.ra",
    MULTIPLE_EMAILADDRESSES_FOUND: "Questo indirizzo e-mail è registrato su più contatti in SuperOffice. Fare clic qui per selezionare il contatto giusto per l'archiviazione.",
    MYPROFILE: "Il mio profilo",
    NO_RESULTS: "Nessun risultato",
    NOTE_CONTACT_DATA_PREDICTED: "Sulla base del contenuto della presente e-mail, abbiamo suggerito dettagli per questo mittente. È necessario verificare prima di creare questo contatto.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Verifica che il nome utente e la password inseriti siano corretti.",
    ONSITE_CONNECTION_SUCCESSFUL: "Congratulazioni. SuperOffice Gmail Link è stato connesso correttamente all'installazione di SuperOffice CRM Onsite.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Verificare di aver eseguito l'accesso alla propria installazione Onsite prima di continuare.",
    ONSITE_ERROR_LINE_1: "Si sono verificati alcuni problemi durante il processo di login.",
    ONSITE_ERROR_LINE_2: "È necessario assicurarsi che l’URL del server inserito sia corretto. Fai clic sul pulsante delle informazioni per scoprire come ottenerlo.",
    ONSITE_PASSWORD: "Password:",
    ONSITE_SERVER_URL: "URL del server:",
    ONSITE_SERVER_URL_LINE_1: "In SuperOffice CRM, seleziona Copia collegamento dal menu principale",
    ONSITE_SERVER_URL_LINE_2: "In seguito, incolla qui l’URL del server",
    ONSITE_URL: "URL all'installazione di SuperOffice CRM Onsite:",
    ONSITE_USER_NAME: "Nome utente:",
    OPEN_IN_CRM: "Apri in CRM",
    OR_UPPER: "OPPURE",
    OUR_CONTACT: "Contatto associato",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Qualora si cambiasse idea in un secondo momento, aprire nuovamente il componente aggiuntivo SuperOffice per Outlook nella schermata del calendario",
    PERMISSION_CONTINUE: "Fare clic su “Continua” per aprire una nuova finestra e concedere le autorizzazioni richieste",
    PERMISSION_FOR_CALENDAR: "SuperOffice per Outlook richiede l’autorizzazione per accedere agli elementi del proprio calendario.",
    PICKER_BCC: "Ccn",
    PICKER_CC: "Cc",
    PICKER_CC_COPY: "Cc",
    PICKER_TO: "A",
    PLACE_REQUEST_IN_QUEUE: "Posiziona richiesta in questa coda:",
    POPUP__BOTTOM_TEXT: "Consenti i pop-up per questa pagina e riprova.",
    POPUP__HEADER: "Blocco pop-up rilevato",
    POPUP__MID_TEXT: "SuperOffice per Outlook richiede l’autenticazione, ma il blocco dei pop-up da parte del browser la impedisce.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Rimuovi da posta in arrivo",
    REMOVE_FROM_INBOX_DESC: "Sposta l’e-mail negli elementi eliminati dopo l’archiviazione",
    REQUEST: "Richiesta",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Questa e-mail è troppo grande per essere aggiunta a una richiesta.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "E-mail troppo grande",
    REQUEST_PRIORITY: "Priorità",
    REQUEST_QUEUE: "Coda richieste",
    RESET_ALL: "Ripristina tutto",
    RESET_INFO_SOFO: "Ripristinare le informazioni in SuperOffice per Outlook? Tale operazione rimuoverà i dati correnti.",
    REVISION_LABEL: "Revisione:",
    SEARCH_FAILED: "Ricerca non riuscita. Riprovare.",
    SETTINGS: "Impostazioni",
    SETTINGS_ApplyArchiveStatus: "Applica categoria di archivio",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Solo destinatari esterni",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "I destinatari esterni sono persone all’esterno dell’organizzazione.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Inoltri",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Promemoria sull’archivio",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Il promemoria dell’archivio aiuta a garantire che le e-mail e le riunioni vengano salvate in SuperOffice prima di essere inviate.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Verrà ricordato di archiviare le riunioni in SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Ricordamelo prima di inviare le riunioni",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Nuove e-mail",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Risposte",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Verrà ricordato di archiviare le e-mail in SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Ricordamelo prima di inviare le e-mail",
    SETTINGS_CategoryColor: "Colore categoria",
    SETTINGS_CategoryName: "Nome categoria",
    SETTINGS_CategoryNameFixedInfo: "Il nome della categoria è fisso e non può essere modificato.",
    SETTINGS_CategoryTaggingDescription: "Usa una categoria di Outlook per identificare le e-mail già archiviate in SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "Lo stato dell’archivio delle e-mail ti aiuta a vedere direttamente nella tua casella di posta di Outlook quali e-mail sono già state salvate in SuperOffice.",
    SETTINGS_CategoryTaggingSection: "Stato dell’archivio delle e-mail",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Tipo di attività predefinita",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Tipo di e-mail predefinito",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "E-mail in arrivo",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "E-mail in uscita",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Modello di e-mail in arrivo predefinito",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Modello di e-mail in uscita predefinito",
    SETTINGS_EnableCategoryForSharedMailbox: "Nelle caselle di posta condivise",
    SETTINGS_EnableCategoryOnOpen: "All’apertura delle e-mail archiviate",
    SETTINGS_EnableCategoryOnSendAndArchive: "Quando si utilizza Invia & Archivia",
    SETTINGS_EnableCategoryTagging: "Mostra la categoria di archivio in Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Mostra progetti e vendite contestuali",
    SETTINGS_GENERAL_HEADER: "Generale",
    SETTINGS_SharedMailboxCategoryInfo: "Per visualizzare lo stato dell’archivio, è necessario creare la categoria di archivio nella casella di posta condivisa.",
    SETTINGS_SharedMailboxCategoryInfoBold: "Per le caselle di posta condivise:",
    SETTINGS_SharedMailboxCategoryLearnMore: "Per saperne di più sulla configurazione delle caselle di posta condivise",
    SETTINGS_YOURCOMPANY: "Nome società:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Invia e archivia",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Selezionare un contatto o una società da archiviare.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Questa e-mail è pronta per l’invio, ma non può essere archiviata in SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Archivia",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Questa e-mail è pronta per l’invio, ma non è impostata per essere archiviata in SuperOffice. È possibile archiviarla adesso, in modo che la comunicazione venga salvata con la società o il contatto corretti, oppure inviarla senza archiviarla.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Qualcosa è andato storto durante il caricamento delle impostazioni.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Accedere a SuperOffice prima di aprire le impostazioni.",
    SR_ADMIN_MYAPPS: "Le mie app",
    SR_ALL_ITEM: "Tutti",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Si è sicuri di voler disattivare il login biometrico? La prossima volta sarà necessario accedere di nuovo manualmente.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Impossibile copiare negli Appunti",
    SR_NO_SELECTION: "(Nessuna selezione)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Inizia con pochi clic",
    SYNCHRONIZER_REACTIVATE: "Riattiva con pochi clic",
    SYNCRONIZER_MSG_CONTENT: "Sincronizza il tuo calendario e i tuoi compiti di Outlook con SuperOffice CRM per mantenere aggiornati riunioni, contatti, progetti e vendite.",
    SYNCRONIZER_NEED_AUTHENTICATION: "La sincronizzazione del Calendario di SuperOffice con Outlook è quasi impostata. Continua ad attivarla e mantieni sincronizzati i calendari.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "La sincronizzazione del calendario di SuperOffice con Outlook è attualmente interrotta. Continua a riattivarla e mantieni sincronizzati i calendari.",
    TAB_ACTION: "Azione",
    TAB_PEOPLE: "Persone",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Attività creata in SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Attività creata in SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "Il server ha impiegato troppo tempo a rispondere. Riprovare.",
    TIMEOUT_ERROR_TITLE: "Richiesta scaduta",
    TITLE: "Titolo",
    UNDO: "Annulla",
    UNKNOWN_EMAIL_ADDRESS: "Indirizzo e-mail sconosciuto.",
    UNKNOWN_EMAILADDRESS: "Indirizzo e-mail del mittente non riconosciuto. Fare clic qui per aggiungerlo a SuperOffice.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Questo indirizzo e-mail del destinatario non è riconosciuto. Fare clic qui per aggiornare SuperOffice con questo indirizzo e-mail.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Indirizzo e-mail sconosciuto. Aggiungere {0} a SuperOffice.",
    UNLOCK_THESE_FEATURES: "Sblocca queste funzioni con il sincronizzatore",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.com/crm/demo/",
    VERSION_SHORT: "ver.",
    VISIT_APP_STORE: "Visita l’App Store",
    WE_RUN_ONLINE_LINE_1: "Per scoprire se l’esecuzione è Online, procedi nel modo seguente:",
    WE_RUN_ONLINE_LINE_2: "1. In SuperOffice CRM, seleziona Guida e poi Info su",
    WE_RUN_ONLINE_LINE_3: "2. Cerca la voce per NetServer:",
    WE_RUN_ONLINE_LINE_4: "Se indica “SuperOffice CRM Online...”, l’esecuzione è online",
    WE_RUN_ONSITE_LINE_1: "Per scoprire se l’esecuzione è Onsite, procedi nel modo seguente:",
    WE_RUN_ONSITE_LINE_4: "Se indica “SuperOffice CRM Onsite...”, l’esecuzione è in loco",
    YOU_CAN_STILL_USE: "Puoi ancora utilizzare SuperOffice per Outlook per le e-mail!",
  },
  KO: {
    ACTION_ADD: "추가",
    ACTION_BACK: "뒤로",
    ACTIVITIES: "활동",
    ADD_ATTENDEES: "슈퍼오피스 에서 연락처 초대",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "기존 담당자에 전자 메일 주소 추가",
    AI_SUMMARY_AI_NOT_ENABLED: "조직에 AI 텍스트 기능이 활성화되어 있지 않습니다. SuperOffice 관리자에게 문의하십시오.",
    AI_SUMMARY_APPEND: "추가",
    AI_SUMMARY_FEATURE_DISABLED: "이 기능은 조직에서 꺼져 있습니다.",
    AI_SUMMARY_GENERATE: "생성",
    AI_SUMMARY_GENERATE_ERROR: "지금 요약을 생성할 수 없습니다. 다시 시도하십시오.",
    AI_SUMMARY_GENERATE_TOOLTIP: "AI 요약 생성",
    AI_SUMMARY_HEADER_PARTICIPANTS: "참가자:",
    AI_SUMMARY_HEADER_SUBJECT: "제목:",
    AI_SUMMARY_LOADING: "요약 생성 중...",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "AI 기능을 사용할 수 있는 라이선스가 없습니다",
    AI_SUMMARY_NO_PERMISSION: "이 이메일을 읽을 권한이 없습니다.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "이 이메일에는 요약할 내용이 없습니다.",
    AI_SUMMARY_REPLACE_CONFIRM: "교체",
    ALREADY_ARCHIVED_ATTACHMENT: "첨부 파일은 이미 <%- archivedBy %> 에 의해 <%- archivedAt %>에 보관되었습니다.",
    ALREADY_ARCHIVED_EMAIL: "이 전자 메일은 <%- archivedBy %> 에 의해 <%- archivedAt %>에 보관되었습니다.",
    ALREADY_ARCHIVED_SALE: "이 전자 메일에 대한 판매는 이미 <%- archivedBy %> 에 의해 <%- archivedAt %>에 보관되었습니다.",
    ALREADY_ARCHIVED_TASK: "이 전자 메일에 대한 활동은 이미 <%- archivedBy %> 에 의해 <%- archivedAt %>에 보관되었습니다.",
    ALREADY_DONE: "이미 완료됨",
    APPOINTMENT_EXISTS_IN_CRM: "이 약속은 CRM에 존재하며, <%- creationDate %>일에 <%- createdBy %>가 생성했습니다.",
    ARCHIVE_ACTIVITY: "활동 만들기",
    ARCHIVE_ALWAYS_SHOW: "항상 아카이브 대화 상자 표시",
    ARCHIVE_AS_ACTIVITY: "SuperOffice에서 약속 만들기",
    ARCHIVE_AS_ATTACHMENT: "SuperOffice에서 첨부 파일 저장",
    ARCHIVE_AS_REQUEST: "SuperOffice에서 요청 만들기",
    ARCHIVE_AS_SALE: "SuperOffice에서 판매 만들기",
    ARCHIVE_AS_TASK: "SuperOffice에서 작업 만들기",
    ARCHIVE_REMOVE_FROM_INBOX: "기본으로 보관 후 받은 편지함에서 전자 메일 제거",
    ARCHIVE_SHOW_ALL_TEMPLATES: "템플릿 목록에 전자 메일 외 다른 템플릿 포함",
    ATTACHMENT_SIZE_INFO: "첨부 파일이 너무 커서 보관할 수 없습니다. 첨부 파일이 없는 이메일만 보관할 수 있습니다.",
    AUTH__BOTTOM_TEXT_1: "\u2028더 자세한 정보가 필요하십니까?",
    AUTH__BOTTOM_TEXT_2: "추가 기능을 승인하는 방법 알아보기",
    AUTH__BUTTON: "관리자 링크 복사",
    AUTH__COPIED: "클립보드에 복사됨",
    AUTH__HEADER: "Outlook 업데이트를 위한 SuperOffice",
    AUTH__INCREMENTAL_TEXT_1: "{feature}를 활성화하려면 추가 권한이 필요합니다.",
    AUTH__MID_TEXT_1: "Microsoft의 최신 보안 요구 사항을 충족하기 위해, Outlook 추가 기능이 업데이트되었습니다.",
    AUTH__MID_TEXT_2: "계속 사용하려면, <b>Microsoft 365 글로벌 관리자가 모든 사용자를 대신하여 사용 권한</b>(동의)을 부여해야 합니다.",
    AUTH__MID_TEXT_3: "<b>이 링크를</b> Microsoft 365 관리자와 공유하십시오:",
    AUTH__NEW_USER_TEXT_1: "Outlook용 SuperOffice 추가 기능은 Microsoft 365 데이터에 액세스하기 위한 추가 권한이 필요합니다.",
    AUTH_IN_PROGRESS__HEADER: "승인 절차 진행 중",
    AUTH_IN_PROGRESS__MID_TEXT: "현재 진행 중인 대화식 인증을 계속하시고 다시 시도해 주세요.",
    AUTOSAVE_FAIL: "저장되지 않았습니다.",
    AUTOSAVE_IN_PROGRESS: "저장 중...",
    AUTOSAVE_RETRY: "재시도",
    AUTOSAVE_SUCCESS: "저장됨",
    BANNER_ADD_MESSAGE: "메시지 생성됨.",
    BANNER_CREATE_APPOINTMENT: "약속이 생성되었습니다.",
    BANNER_CREATE_REQUEST: "요청이 생성되었습니다.",
    BANNER_CREATE_SALE: "판매가 생성되었습니다.",
    BANNER_CREATE_TASK: "작업이 생성되었습니다.",
    BANNER_SAVE_ATTACHMENT: "첨부 파일이 저장되었습니다.",
    BANNER_SAVE_TO_SUPEROFFICE: "이메일이 저장되었습니다.",
    BANNER_VIEW_IN_CRM: "CRM에서 보기",
    BTN_ADD_TO_EXISTING_REQUEST: "요청에 메시지 추가",
    BTN_ADD_TO_SUPEROFFICE: "SuperOffice에 추가",
    BTN_ARCHIVE: "보관",
    BTN_CANCEL: "취소",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "클릭하여 새 담당자를 추가합니다",
    BTN_CONNECT: "연결",
    BTN_CONNECT_TO_SUPEROFFICE: "SuperOffice Online을 운영합니다",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "SuperOffice Onsite를 운영합니다",
    BTN_CREATE: "만들기",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "새 회사 및 담당자 만들기",
    BTN_GO_TO_SUPEROFFICE: "SuperOffice로 이동",
    BTN_KEEP_CONTACT: "유지",
    BTN_LOGIN: "로그인",
    BTN_LOOKUP_SENDER: "보낸 사람 검색",
    BTN_OK: "확인",
    BTN_RECONNECT: "SuperOffice 사용자 변경",
    BTN_SAVE: "저장",
    BTN_SAVE_AND_ARCHIVE: "보내기 및 보관",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "무료 평가판 등록",
    BTN_UPDATE_CONTACT: "업데이트",
    BUSINESS: "비즈니스",
    BUTTON_LETS_GO: "시작합니다",
    BUTTON_RELOAD: "재로드",
    CAN_NOT_GRANT_PERMISSION: "권한을 부여할 수 없나요?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "첨부 파일이 안전하지 않을 수 있으므로 요청에 메시지를 추가할 수 없음",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "일부 첨부 파일은 안전하지 않을 수 있으므로 보관할 수 없습니다. 첨부 파일이 없는 이메일만 보관할 수 있습니다.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "디지털 서명된 첨부 파일을 저장할 수 없습니다.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "이 이메일은 디지털 방식으로 서명되었습니다. 서명의 첨부 파일은 개별적으로 저장할 수 없습니다.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "첨부 파일이 안전하지 않을 수 있어 보관할 수 없습니다",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "첨부 파일이 안전하지 않을 수 있으므로 요청을 만들 수 없음",
    CANNOT_SAVE_CONTACT: "연락처를 저장할 수 없음",
    CATEGORY: "범주",
    CHANGES_SAVED_AUTOMATICALLY: "변경 사항이 자동으로 저장됩니다.",
    CHOOSE_ONE_OR_CONTINUE: "하나를 선택하거나 계속하십시오.",
    CLICK_HERE_TO_SEE_IT: "보려면 여기를 클릭하십시오.",
    CLICK_HERE_TO_SELECT_CONTACT: "담당자 선택",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "보관할 올바른 담당자를 선택하려면 여기를 클릭하십시오.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} 더 보기. 모두 표시하려면 여기를 클릭하십시오.",
    CLICK_LOGIN_ONSITE: "새 탭에서 SuperOffice 설치를 열려면 여기를 클릭하십시오.",
    COMMENT_PLACEHOLDER: "의견 추가…",
    COMPANY_NAME: "회사 이름",
    CONNECT_ONSITE: "SuperOffice CRM 현장 설치에 ​​연결",
    CONNECT_TO_SUPEROFFICE: "SuperOffice CRM 온라인 계정에 연결",
    CONTACT_ADMINISTRATOR: "CRM 구성을 검토하려면 SuperOffice 관리자에게 문의하십시오.",
    CONTINUE: "계속",
    COULD_IT_BE_ONE_OF_THESE: "이 중 하나가 될 수 있을까요?",
    COUNTRY: "국가",
    CREATE_NEW_COMPANY: "새 회사 만들기",
    CREATE_NEW_CONTACT: "새 담당자 만들기",
    CREATE_REQUEST: "요청 만들기",
    CREATED_REQUEST: "요청이 생성되었습니다",
    DEPARTMENT: "부서",
    DO_NOT_ARCHIVE_ATTACHMENTS: "첨부 파일을 보관하지 마십시오",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "첨부 파일은 기본적으로 보관됩니다",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "SuperOffice에 보관된 전자 메일.",
    EMAIL_ADDRESS: "전자 메일",
    EMAIL_ADDRESS_NOT_REGISTERED: "이 전자 메일 주소는 SuperOffice에 존재하지 않습니다.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span>은(는) SuperOffice의 여러 담당자에 연결됩니다.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "SuperOffice에 등록된 전자 메일입니다.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "이 전자 메일 주소는 SuperOffice의 여러 담당자에 등록되었습니다.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "이러한 설정 편집을 위해 보관 기능을 활성화",
    ERROR: "오류",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "SuperOffice에 전자 메일 주소를 추가할 수 없습니다.",
    ERROR_ARCHIVING_ATTACHMENT: "첨부 파일을 보관할 수 없습니다.",
    ERROR_ARCHIVING_EMAIL: "전자 메일을 보관할 수 없습니다.",
    ERROR_ARCHIVING_REQUEST: "요청을 보관할 수 없습니다.",
    ERROR_ARCHIVING_TASK: "활동을 만들 수 없습니다.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "SuperOffice와 통신할 수 없습니다.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "SuperOffice에서 회사 또는 담당자를 만들 수 있는 권한이 없습니다.",
    FIND_COMPANY_OR_PERSON: "회사 또는 담당자 찾기...",
    FIRST_ATTENDEE_CHANGED: "회의 연락처가 변경되었습니다.",
    FIRST_ATTENDEE_MISMATCH_DESC: "해당 약속을 연결할 연락처를 선택하십시오.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "연락처와 회의 참석자가 일치하지 않음",
    FIRSTNAME: "이름",
    FOLLOWUPS: "후속 조치",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice for Outlook이 Microsoft 서비스에 연결할 수 없습니다. 잠시 후 다시 시도하십시오.",
    GRAPH_API_ERROR_TITLE_SOFO: "Microsoft 서비스를 일시적으로 사용할 수 없음",
    HEADER_ADD_EMAIL: "전자 메일/담당자 추가: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "SuperOffice에 전자 메일 주소 추가",
    HEADER_ADD_RECPIENTS: "SuperOffice에서 받는 사람 추가",
    HEADER_ADD_TO_EXISTING_PERSON: "기존 담당자에 추가",
    HEADER_ARCHIVE_APPOINTMENT: "활동 만들기",
    HEADER_ARCHIVE_ATTACHMENT: "SuperOffice 문서로 첨부 파일 보관",
    HEADER_ARCHIVE_EMAIL: "SuperOffice에서 전자 메일 보관",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "다른 SuperOffice 설치에 연결",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "전자 메일을 기반으로 SuperOffice에서 활동 만들기",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "SuperOffice에서 이 전자 메일의 첨부 파일 저장",
    HEADER_CREATE_EMAIL_AS_EMAIL: "SuperOffice에서 이 전자 메일 보관",
    HEADER_CREATE_EMAIL_AS_REQUEST: "전자 메일을 기반으로 SuperOffice에서 요청 만들기",
    HEADER_CREATE_EMAIL_AS_SALE: "이 전자 메일을 기반으로 SuperOffice에서 판매 만들기",
    HEADER_CREATE_EMAIL_AS_TASK: "전자 메일을 기반으로 검사 목록에서 작업 만들기",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "새 회사 및 담당자 만들기",
    HEADER_CREATE_NEW_PERSON: "새 담당자 만들기",
    HEADER_WELCOME: "환영합니다",
    LABEL_ACHIEVE_MORE: "통합으로 더 많은 성과 달성",
    LABEL_ADD_TO_EXISTING_REQUEST: "SuperOffice에서 기존 요청에 전자 메일을 메시지로 추가",
    LABEL_ARCHIVE_FILE: "파일 보관:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "첨부 파일이 이미 저장되었습니다",
    LABEL_ATTACHMENT_NOT_SAVED: "첨부 파일이 저장되지 않았습니다",
    LABEL_COMMENT: "의견:",
    LABEL_COMPANYPHONE: "회사 전화:",
    LABEL_CONTACT: "회사:",
    LABEL_CONTACT_OR_COMPANY: "담당자 또는 회사:",
    LABEL_CREATE_AND_VISUALIZE: "전문가처럼 만들고 시각화하세요",
    LABEL_CURRENCY: "통화:",
    LABEL_DATE: "날짜:",
    LABEL_DESCRIPTION: "설명:",
    LABEL_DIRECTPHONE: "직통 전화:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "오늘 이 추가 기능으로 무엇을 할 수 있는지 알아보십시오!",
    LABEL_HOME_ADDRESS: "집 주소:",
    LABEL_MOBILEPHONE: "휴대폰:",
    LABEL_NOTES: "노트:",
    LABEL_NUMBER: "번호:",
    LABEL_OPTIONAL_ATTENDEE: "선택 사항",
    LABEL_PERSON: "담당자:",
    LABEL_POSITION: "위치:",
    LABEL_PROJECT: "프로젝트:",
    LABEL_REQUIRED_ATTENDEE: "필수",
    LABEL_SALE: "판매:",
    LABEL_SALE_AMOUNT: "판매 금액:",
    LABEL_SALE_DATE: "판매 날짜:",
    LABEL_SALE_NAME: "판매 이름:",
    LABEL_SALE_TYPE: "판매 유형:",
    LABEL_SAVED_CHANGES: "변경 사항이 저장되었습니다.",
    LABEL_SELECT_CS_QUEUE: "이 대기열에 요청 추가:",
    LABEL_SELECT_CS_QUEUE_SHORT: "대기열 선택",
    LABEL_SERVER_VERSION: "서버 버전:",
    LABEL_SUBJECT: "제목:",
    LABEL_SUPEROFFICE_SITE: "SuperOffice 사이트:",
    LABEL_TELEPHONE: "핸드폰:",
    LABEL_TIME: "시간:",
    LABEL_TYPE: "유형:",
    LABEL_UNLOCK_FEATURES: "기능 잠금 해제",
    LABEL_URL: "URL:",
    LABEL_USER: "사용자:",
    LABEL_VISIBLE_FOR: "공개 대상:",
    LABEL_WEB_PAGE: "웹 페이지:",
    LASTNAME: "성",
    LEARN_MORE: "더 알아보기",
    LOGIN_COMPLETE_SETUP: "SuperOffice Gmail Link 설정을 완료하려면 SuperOffice에 로그인해야 합니다.",
    LOGIN_ONSITE: "SuperOffice CRM Onsite 설치에 로그인하십시오.",
    LOGOUT_FROM_SUPEROFFICE_1: "SuperOffice에서 로그아웃하고 열린 SuperOffice 탭이 있는 경우 닫습니다.",
    LOGOUT_FROM_SUPEROFFICE_2: "다음에 SuperOffice CRM Online에 로그인하면 새 연결이 자동으로 설정됩니다.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "이 주소를 기본 전자 메일 주소로 설정",
    MARK_COMPLETED: "완료됨으로 표시",
    MARK_REMOVE_FROM_INBOX: "받은 편지함에서 제거",
    MENU_ARCHIVE_EMAIL: "전자 메일 보관",
    MENU_CREATE_APPOINTMENT: "활동 만들기",
    MENU_CREATE_NEW_SALE: "새 판매 만들기",
    MENU_SAVE_TO_SUPEROFFICE: "SuperOffice에 저장",
    MESSAGE_NO_EMAIL_ADDRESS: "담당자에 전자 메일 주소가 없습니다",
    MIDDLENAME: "중간 이름",
    MISSING_REQUIRED_VALUES_INTRO: "사용자 계정에는 일부 필수 필드를 사용할 수 없습니다.",
    ML_ADD_COMPANY: "회사 추가",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "담당자에 전자 메일 추가",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "새 회사 및 담당자 추가",
    ML_ADD_NEW_CONTACT_PERSON: "새 담당자 추가",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "이 전자 메일을 캘린더에 약속으로 보관",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "보낸 사람의 회사 카드에 대해 SuperOffice에서 전자 메일 보관",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "클릭하여 SuperOffice에 추가",
    ML_COMPANY_DETAILS: "회사 세부정보",
    ML_CONTACT_DETAILS: "담당자 세부정보",
    ML_CREATE_A_NEW_SALE: "이 고객에 대한 새 판매 만들기",
    ML_DISCONNECT_FROM_SUPEROFFICE: "SuperOffice에서 Outlook 연결 해제",
    ML_INVITATION_OPTIONS: "초대장",
    ML_MOVE_INTO_CS_AS_REQUEST: "이 전자 메일을 고객 서비스에 새 요청으로 추가",
    ML_OR_ADD_CONTACT_TO_COMPANY: "또는 회사에 담당자를 추가하시겠습니까?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "이 메시지에 멘션된 인원",
    ML_PERSON_COULD_BE: "이 담당자의 발신자",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "담당자 또는 회사 검색...",
    ML_SETTINGS_INVITATIONS_HEADER: "SuperOffice 초대장",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Outlook에서 초대에 응할 경우 SuperOffice에서 약속을 추가/업데이트합니다.",
    MOBILE: "휴대폰",
    MORE: "더 보기",
    MRMS: "미스터/미즈",
    MULTIPLE_EMAILADDRESSES_FOUND: "이 전자 메일 주소는 SuperOffice의 여러 담당자에 등록되었습니다. 보관할 올바른 담당자를 선택하려면 여기를 클릭하십시오.",
    MYPROFILE: "내 프로필",
    NO_RESULTS: "결과 없음",
    NOTE_CONTACT_DATA_PREDICTED: "이 이메일의 내용을 의거해서 이 보낸 사람에 대한 세부 정보를 제안했습니다. 이 연락처를 만들기 전에 확인하십시오.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "입력한 사용자 이름과 암호가 올바른지 확인하십시오.",
    ONSITE_CONNECTION_SUCCESSFUL: "축하합니다. SuperOffice Gmail Link가 귀하의 SuperOffice CRM Onsite 설치와 연결되었습니다.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "계속하기 전에 현장 설치에 ​​로그인했는지 확인하십시오.",
    ONSITE_ERROR_LINE_1: "로그인 과정에서 몇 가지 문제가 발생했습니다.",
    ONSITE_ERROR_LINE_2: "올바른 서버 URL을 입력했는지 확인하십시오. 정보 버튼을 클릭하면 획득 방법을 알 수 있습니다.",
    ONSITE_PASSWORD: "암호:",
    ONSITE_SERVER_URL: "서버 URL:",
    ONSITE_SERVER_URL_LINE_1: "SuperOffice CRM의 기본 메뉴에서 바로가기 복사를 선택합니다.",
    ONSITE_SERVER_URL_LINE_2: "그런 다음 여기에 서버 URL을 붙여넣으십시오.",
    ONSITE_URL: "SuperOffice CRM 현장 설치 URL:",
    ONSITE_USER_NAME: "사용자 이름:",
    OPEN_IN_CRM: "CRM에서 열기",
    OR_UPPER: "또는",
    OUR_CONTACT: "우리 담당자",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "나중에 마음이 바뀌면 달력 화면에서 아웃룩용 슈퍼오피스 추가 기능을 다시 열어주세요.",
    PERMISSION_CONTINUE: "새 창을 열고 필요한 권한을 부여하려면 \"계속\"을 클릭하세요.",
    PERMISSION_FOR_CALENDAR: "아웃룩용 슈퍼오피스는 일정 항목에 액세스하려면 권한이 필요합니다.",
    PICKER_BCC: "숨은 참조",
    PICKER_CC: "참조",
    PICKER_CC_COPY: "참조",
    PICKER_TO: "수신자",
    PLACE_REQUEST_IN_QUEUE: "이 대기열에서 요청:",
    POPUP__BOTTOM_TEXT: "이 페이지에서 팝업을 허용하고 다시 시도해 주세요.",
    POPUP__HEADER: "팝업 차단기가 감지되었습니다",
    POPUP__MID_TEXT: "Outlook용 SuperOffice는 인증이 필요하지만, 브라우저의 팝업 차단기가 이를 차단하고 있습니다.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "받은 편지함에서 제거",
    REMOVE_FROM_INBOX_DESC: "보관 후 이메일을 삭제된 항목으로 이동",
    REQUEST: "요청",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "이 이메일은 너무 커서 요청에 추가할 수 없습니다.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "이메일이 너무 큼",
    REQUEST_PRIORITY: "우선 순위",
    REQUEST_QUEUE: "요청 대기열",
    RESET_ALL: "모두 재설정",
    RESET_INFO_SOFO: "Outlook용 SuperOffice에서 정보를 재설정하시겠습니까? 이렇게 하면 현재 데이터가 제거됩니다.",
    REVISION_LABEL: "개정:",
    SEARCH_FAILED: "검색에 실패했습니다. 다시 시도하십시오.",
    SETTINGS: "설정",
    SETTINGS_ApplyArchiveStatus: "아카이브 범주 적용",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "외부 수신자만",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "외부 수신자란 조직 외부의 사람들입니다.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "전달",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "보관 알림",
    SETTINGS_ARCHIVE_REMINDER_INFO: "아카이브 알림을 사용하면 이메일과 회의가 전송되기 전에 SuperOffice에 먼저 저장할 수 있습니다.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "SuperOffice에서 회의를 보관하라는 알림이 전송됩니다.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "모임을 보내기 전에 알림",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "새 이메일",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "회신",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "SuperOffice에서 이메일을 보관하도록 알림을 받게 됩니다.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "이메일을 보내기 전에 미리 알림",
    SETTINGS_CategoryColor: "범주 색상",
    SETTINGS_CategoryName: "범주 이름",
    SETTINGS_CategoryNameFixedInfo: "범주 이름이 수정되어 변경할 수 없습니다.",
    SETTINGS_CategoryTaggingDescription: "Outlook 범주를 사용하여 이미 SuperOffice에 보관된 전자 메일을 식별합니다.",
    SETTINGS_CategoryTaggingInfo: "이메일 보관 상태를 사용하면 Outlook 사서함에서 바로 SuperOffice에 이미 저장된 이메일을 확인할 수 있습니다.",
    SETTINGS_CategoryTaggingSection: "이메일 보관 상태",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "기본 활동 유형",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "기본 이메일 유형",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "수신 이메일",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "발신 이메일",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "기본 수신 전자 메일 템플릿",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "기본 발신 전자 메일 템플릿",
    SETTINGS_EnableCategoryForSharedMailbox: "공유 사서함에서",
    SETTINGS_EnableCategoryOnOpen: "보관된 이메일을 열 때",
    SETTINGS_EnableCategoryOnSendAndArchive: "보내기 및 보관 사용 시",
    SETTINGS_EnableCategoryTagging: "Outlook에서 보관 범주 표시",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "상황별 프로젝트 및 판매 표시",
    SETTINGS_GENERAL_HEADER: "일반",
    SETTINGS_SharedMailboxCategoryInfo: "보관 상태를 표시하려면 공유 사서함에 보관 범주를 생성해야 합니다.",
    SETTINGS_SharedMailboxCategoryInfoBold: "공유 사서함의 경우:",
    SETTINGS_SharedMailboxCategoryLearnMore: "공유 사서함 설정에 대해 자세히 알아보기",
    SETTINGS_YOURCOMPANY: "회사 이름:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "보관 및 전송",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "보관할 연락처 또는 회사를 선택합니다.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "이 이메일은 보낼 준비가 되었지만, SuperOffice에 보관할 수 없습니다.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "아카이브",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "이 이메일은 전송할 준비는 되었지만, SuperOffice에 보관되도록 설정되어 있지는 않습니다. 지금 바로 보관하여 해당 회사 또는 담당자에게 메시지가 저장되도록 하거나, 보관하지 않고 전송할 수도 있습니다.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "설정을 로드하는 중 문제가 발생했습니다.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "설정을 열기 전에 SuperOffice에 로그인하십시오.",
    SR_ADMIN_MYAPPS: "내 앱",
    SR_ALL_ITEM: "모두",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "생체인식 로그인을 끄시겠습니까? 다음에 다시 수동으로 로그인해야 합니다.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "클립보드에 복사하지 못했습니다",
    SR_NO_SELECTION: "(선택 없음)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "몇 번의 클릭으로 시작하기",
    SYNCHRONIZER_REACTIVATE: "몇 번의 클릭으로 재활성화",
    SYNCRONIZER_MSG_CONTENT: "회의, 연락처, 프로젝트 및 영업을 최신 상태로 유지하려면 Outlook 일정 및 작업을 SuperOffice CRM과 동기화하십시오.",
    SYNCRONIZER_NEED_AUTHENTICATION: "SuperOffice 일정과 Outlook의 동기화가 거의 설정되었습니다. 계속 활성화하고 달력을 동기화하십시오.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "SuperOffice 일정과 Outlook의 동기화가 현재 중단되었습니다. 계속해서 다시 활성화하고 달력을 동기화하십시오.",
    TAB_ACTION: "작업",
    TAB_PEOPLE: "인원",
    TASK_ARCHIVED_IN_SUPEROFFICE: "SuperOffice에서 생성된 활동입니다.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "SuperOffice에서 생성된 활동입니다.",
    TIMEOUT_ERROR_MESSAGE: "서버가 응답하는 데 너무 오래 걸렸습니다. 다시 시도하십시오.",
    TIMEOUT_ERROR_TITLE: "요청 시간 초과됨",
    TITLE: "제목",
    UNDO: "실행 취소",
    UNKNOWN_EMAIL_ADDRESS: "알 수 없는 전자 메일 주소입니다.",
    UNKNOWN_EMAILADDRESS: "이 보낸 사람의 전자 메일은 인식되지 않는 주소입니다. 이 전자 메일 주소를 SuperOffice에 추가하려면 여기를 클릭하십시오.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "이 받는 사람의 전자 메일은 인식되지 않는 주소입니다. 이 전자 메일 주소로 SuperOffice를 업데이트하려면 여기를 클릭하십시오.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "알 수 없는 전자 메일 주소입니다. SuperOffice에 {0}을(를) 추가합니다.",
    UNLOCK_THESE_FEATURES: "싱크로나이저로 이러한 기능 잠금 해제",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.com/crm/demo/",
    VERSION_SHORT: "버전",
    VISIT_APP_STORE: "앱 스토어를 방문하세요.",
    WE_RUN_ONLINE_LINE_1: "온라인으로 실행 중인지 확인하려면 다음을 수행하십시오.",
    WE_RUN_ONLINE_LINE_2: "1. SuperOffice CRM에서 도움말 및 정보 선택",
    WE_RUN_ONLINE_LINE_3: "2. NetServer에 대한 항목 살펴보기",
    WE_RUN_ONLINE_LINE_4: "\"SuperOffice CRM Online ...\"이라고 표시되면 온라인을 실행 중인 것입니다.",
    WE_RUN_ONSITE_LINE_1: "Onsite를 실행 중인지 확인하려면 다음을 수행하십시오.",
    WE_RUN_ONSITE_LINE_4: "\"SuperOffice CRM OnSite ...\"라고 표시되면 Onsite를 실행 중인 것입니다.",
    YOU_CAN_STILL_USE: "여전히 전자 메일용으로 Outlook용 SuperOffice를 사용할 수 있습니다!",
  },
  NL: {
    ACTION_ADD: "Toevoegen",
    ACTION_BACK: "Vorige",
    ACTIVITIES: "Activiteiten",
    ADD_ATTENDEES: "Contactpersoon uitnodigen vanuit SuperOffice.",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "E-mailadres aan bestaande persoon toevoegen",
    AI_SUMMARY_AI_NOT_ENABLED: "AI-tekstfuncties zijn niet ingeschakeld voor uw organisatie. Neem contact op met uw SuperOffice-beheerder.",
    AI_SUMMARY_APPEND: "Toevoegen",
    AI_SUMMARY_FEATURE_DISABLED: "Deze functie is uitgeschakeld voor uw organisatie.",
    AI_SUMMARY_GENERATE: "Genereren",
    AI_SUMMARY_GENERATE_ERROR: "Er kan nu geen samenvatting worden gegenereerd. Probeer het opnieuw.",
    AI_SUMMARY_GENERATE_TOOLTIP: "AI-samenvatting genereren",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Deelnemers:",
    AI_SUMMARY_HEADER_SUBJECT: "Onderwerp:",
    AI_SUMMARY_LOADING: "Samenvatting genereren…",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "U hebt geen licentie om AI-functies te gebruiken",
    AI_SUMMARY_NO_PERMISSION: "Je hebt geen toestemming om deze e-mail te lezen.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "Er is niets om samen te vatten in deze e-mail.",
    AI_SUMMARY_REPLACE_CONFIRM: "Vervangen",
    ALREADY_ARCHIVED_ATTACHMENT: "Deze bijlage is al gearchiveerd door <%- archivedBy %> op <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "Deze e-mail is al gearchiveerd door <%- archivedBy %> op <%- archivedAt %>.",
    ALREADY_ARCHIVED_SALE: "Er is al een verkoop gemaakt voor deze e-mail door <%- archivedBy %> op <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "De activiteit is al gemaakt voor deze e-mail door <%- archivedBy %> op <%- archivedAt %>.",
    ALREADY_DONE: "Al gedaan",
    APPOINTMENT_EXISTS_IN_CRM: "Deze afspraak bestaat in CRM en is gemaakt door <%- createdBy %> op <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Activiteit maken",
    ARCHIVE_ALWAYS_SHOW: "Altijd het dialoogvenster voor het archief weergeven",
    ARCHIVE_AS_ACTIVITY: "Afspraak maken in SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Bijlage opslaan in SuperOffice",
    ARCHIVE_AS_REQUEST: "Verzoek maken in SuperOffice",
    ARCHIVE_AS_SALE: "Verkoop maken in SuperOffice",
    ARCHIVE_AS_TASK: "Taak maken in SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "E-mail verwijderen uit Postvak IN na archivering als standaard",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Niet-e-mailsjablonen opnemen in sjablonenlijst",
    ATTACHMENT_SIZE_INFO: "Bijlagen zijn te groot en kunnen niet worden gearchiveerd. Alleen de e-mail zonder bijlagen kan worden gearchiveerd.",
    AUTH__BOTTOM_TEXT_1: "\u2028Meer details?",
    AUTH__BOTTOM_TEXT_2: "Leer hoe u de invoegtoepassing autoriseert",
    AUTH__BUTTON: "Beheerderskoppeling kopiëren",
    AUTH__COPIED: "Gekopieerd naar klembord",
    AUTH__HEADER: "SuperOffice for Outlook-update",
    AUTH__INCREMENTAL_TEXT_1: "Voor het inschakelen van {feature} zijn aanvullende machtigingen vereist.",
    AUTH__MID_TEXT_1: "Om te voldoen aan de nieuwste beveiligingsvereisten van Microsoft, is de Outlook-invoegtoepassing bijgewerkt.",
    AUTH__MID_TEXT_2: "Om deze te kunnen blijven gebruiken, moet <b>een Microsoft 365 Global Administrator namens alle gebruikers machtigingen</b> (toestemming) verlenen.",
    AUTH__MID_TEXT_3: "<b>Deel deze koppeling</b> met uw globale Microsoft 365-beheerder:",
    AUTH__NEW_USER_TEXT_1: "De invoegtoepassing SuperOffice for Outlook heeft aanvullende machtigingen nodig voor toegang tot Microsoft 365-gegevens.",
    AUTH_IN_PROGRESS__HEADER: "Autorisatie in behandeling",
    AUTH_IN_PROGRESS__MID_TEXT: "Ga door met de interactieve autorisatie die momenteel loopt en probeer het opnieuw.",
    AUTOSAVE_FAIL: "Niet opgeslagen.",
    AUTOSAVE_IN_PROGRESS: "Opslaan…",
    AUTOSAVE_RETRY: "Opnieuw proberen",
    AUTOSAVE_SUCCESS: "Opgeslagen",
    BANNER_ADD_MESSAGE: "Bericht gemaakt.",
    BANNER_CREATE_APPOINTMENT: "Afspraak gemaakt",
    BANNER_CREATE_REQUEST: "Verzoek gemaakt",
    BANNER_CREATE_SALE: "Verkoop gemaakt",
    BANNER_CREATE_TASK: "Taak gemaakt",
    BANNER_SAVE_ATTACHMENT: "Bijlage is opgeslagen.",
    BANNER_SAVE_TO_SUPEROFFICE: "E-mail is opgeslagen",
    BANNER_VIEW_IN_CRM: "Weergeven in CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Bericht toevoegen aan verzoek",
    BTN_ADD_TO_SUPEROFFICE: "Toevoegen aan SuperOffice",
    BTN_ARCHIVE: "Archiveren",
    BTN_CANCEL: "Annuleren",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Klik om nieuwe persoon toe te voegen",
    BTN_CONNECT: "Verbinden",
    BTN_CONNECT_TO_SUPEROFFICE: "Wij gebruiken SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Wij gebruiken SuperOffice Onsite",
    BTN_CREATE: "Maken",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Nieuw bedrijf en nieuwe persoon maken",
    BTN_GO_TO_SUPEROFFICE: "Ga naar SuperOffice",
    BTN_KEEP_CONTACT: "Bewaren",
    BTN_LOGIN: "Aanmelden",
    BTN_LOOKUP_SENDER: "Afzender zoeken",
    BTN_OK: "OK",
    BTN_RECONNECT: "SuperOffice-gebruiker wijzigen",
    BTN_SAVE: "Opslaan",
    BTN_SAVE_AND_ARCHIVE: "Verzenden en archiveren",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Meld u aan voor een Free Trial",
    BTN_UPDATE_CONTACT: "Bijwerken",
    BUSINESS: "Branche",
    BUTTON_LETS_GO: "Aan de slag",
    BUTTON_RELOAD: "Opnieuw laden",
    CAN_NOT_GRANT_PERMISSION: "Kunt u geen toestemming verlenen?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Kan geen bericht toevoegen aan verzoek omdat bijlage mogelijk onveilig is",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Bijlagen kunnen niet worden gearchiveerd omdat sommige mogelijk onveilig zijn. Alleen e-mails zonder bijlagen kunnen worden gearchiveerd.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Digitaal ondertekende bijlage kan niet worden opgeslagen",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Deze e-mail is digitaal ondertekend. Bijlagen in de handtekening kunnen niet afzonderlijk worden opgeslagen.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Kan niet archiveren omdat bijlage mogelijk onveilig is",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Kan geen verzoek maken omdat bijlage mogelijk onveilig is",
    CANNOT_SAVE_CONTACT: "Contact kan niet worden opgeslagen",
    CATEGORY: "Categorie",
    CHANGES_SAVED_AUTOMATICALLY: "Uw wijzigingen worden automatisch opgeslagen",
    CHOOSE_ONE_OR_CONTINUE: "Kies er één of ga door",
    CLICK_HERE_TO_SEE_IT: "Klik hier om de tekst weer te geven.",
    CLICK_HERE_TO_SELECT_CONTACT: "Persoon selecteren",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Klik hier om de correcte persoon voor archiveren te selecteren.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} meer. Klik hier om alles weer te geven.",
    CLICK_LOGIN_ONSITE: "Klik hier om uw installatie van SuperOffice te openen in een nieuwe tab.",
    COMMENT_PLACEHOLDER: "Een opmerking toevoegen…",
    COMPANY_NAME: "Bedrijfsnaam",
    CONNECT_ONSITE: "Verbinden met installatie van SuperOffice CRM Onsite",
    CONNECT_TO_SUPEROFFICE: "Verbinden met uw SuperOffice CRM Online-account",
    CONTACT_ADMINISTRATOR: "Neem contact op met uw SuperOffice-beheerder om uw CRM-configuratie te controleren.",
    CONTINUE: "Doorgaan",
    COULD_IT_BE_ONE_OF_THESE: "Kan het een van deze zijn?",
    COUNTRY: "Land",
    CREATE_NEW_COMPANY: "Nieuw bedrijf maken",
    CREATE_NEW_CONTACT: "Nieuwe persoon maken",
    CREATE_REQUEST: "Verzoek maken",
    CREATED_REQUEST: "Verzoek is gemaakt",
    DEPARTMENT: "Afdeling",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Bijlagen niet archiveren",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Bijlagen worden standaard gearchiveerd",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-mail is gearchiveerd in SuperOffice.",
    EMAIL_ADDRESS: "E-mail",
    EMAIL_ADDRESS_NOT_REGISTERED: "Dit e-mailadres bestaat niet in SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> is gekoppeld aan meerdere persoon in SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "Geregistreerde e-mail in SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Dit e-mailadres is geregistreerd voor verschillende personen in SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Schakel archivering in om deze instellingen te bewerken",
    ERROR: "Fout",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Kan geen e-mailadres toevoegen aan SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Kan bijlage niet archiveren.",
    ERROR_ARCHIVING_EMAIL: "Kan e-mail niet archiveren.",
    ERROR_ARCHIVING_REQUEST: "Kan verzoek niet archiveren.",
    ERROR_ARCHIVING_TASK: "Kan activiteit niet maken.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Kan niet met SuperOffice communiceren.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "U hebt geen autorisatie om bedrijven of personen te maken in SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Een bedrijf of persoon zoeken...",
    FIRST_ATTENDEE_CHANGED: "De contactpersoon voor de vergadering is gewijzigd.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Kies aan welke contactpersoon de afspraak moet worden gekoppeld.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "De contactpersoon en de deelnemer aan de vergadering komen niet overeen",
    FIRSTNAME: "Voornaam",
    FOLLOWUPS: "Vervolgactiviteiten",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice voor Outlook kan geen verbinding maken met Microsoft-services. Probeer het later opnieuw.",
    GRAPH_API_ERROR_TITLE_SOFO: "Microsoft-services zijn tijdelijk niet beschikbaar",
    HEADER_ADD_EMAIL: "E-mail/persoon toevoegen: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "E-mailadres aan SuperOffice toevoegen",
    HEADER_ADD_RECPIENTS: "Ontvangers toevoegen uit SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Bestaande persoon toevoegen",
    HEADER_ARCHIVE_APPOINTMENT: "Activiteit maken",
    HEADER_ARCHIVE_ATTACHMENT: "Bijlage archiveren als een SuperOffice-document",
    HEADER_ARCHIVE_EMAIL: "E-mail archiveren in SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Verbinden met een andere SuperOffice-installatie",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Activiteit maken in SuperOffice op basis van e-mail",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Bijlagen van deze e-mail opslaan in SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Archiveer deze e-mail in SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Verzoek maken in SuperOffice op basis van e-mail",
    HEADER_CREATE_EMAIL_AS_SALE: "Verkoop maken in SuperOffice op basis van deze e-mail",
    HEADER_CREATE_EMAIL_AS_TASK: "Maak een taak in uw controlelijst op basis van e-mail",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Nieuw bedrijf en nieuwe persoon maken",
    HEADER_CREATE_NEW_PERSON: "Nieuwe persoon maken",
    HEADER_WELCOME: "Welkom",
    LABEL_ACHIEVE_MORE: "Bereik meer met integratie",
    LABEL_ADD_TO_EXISTING_REQUEST: "E-mail toevoegen als bericht in een bestaand verzoek in SuperOffice",
    LABEL_ARCHIVE_FILE: "Archiveer bestand:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Bijlage is al opgeslagen",
    LABEL_ATTACHMENT_NOT_SAVED: "Bijlage is niet opgeslagen",
    LABEL_COMMENT: "Opmerking:",
    LABEL_COMPANYPHONE: "Telefoon bedrijf:",
    LABEL_CONTACT: "Bedrijf:",
    LABEL_CONTACT_OR_COMPANY: "Persoon of bedrijf:",
    LABEL_CREATE_AND_VISUALIZE: "Creëer en visualiseer als een professional",
    LABEL_CURRENCY: "Valuta:",
    LABEL_DATE: "Datum:",
    LABEL_DESCRIPTION: "Beschrijving:",
    LABEL_DIRECTPHONE: "Rechtstreeks nr.:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Ontdek vandaag nog wat deze add-in voor u kan betekenen!",
    LABEL_HOME_ADDRESS: "Huisadres:",
    LABEL_MOBILEPHONE: "Mobiel nummer:",
    LABEL_NOTES: "Opmerkingen:",
    LABEL_NUMBER: "Nummer:",
    LABEL_OPTIONAL_ATTENDEE: "Optioneel",
    LABEL_PERSON: "Persoon:",
    LABEL_POSITION: "Positie:",
    LABEL_PROJECT: "Project:",
    LABEL_REQUIRED_ATTENDEE: "Vereist",
    LABEL_SALE: "Verkoop:",
    LABEL_SALE_AMOUNT: "Verkoopbedrag:",
    LABEL_SALE_DATE: "Verkoopdatum:",
    LABEL_SALE_NAME: "Verkoopnaam:",
    LABEL_SALE_TYPE: "Verkooptype:",
    LABEL_SAVED_CHANGES: "Uw wijzigingen zijn opgeslagen.",
    LABEL_SELECT_CS_QUEUE: "Verzoek toevoegen aan deze wachtrij:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Wachtrij selecteren",
    LABEL_SERVER_VERSION: "Serverversie:",
    LABEL_SUBJECT: "Onderwerp:",
    LABEL_SUPEROFFICE_SITE: "SuperOffice-site:",
    LABEL_TELEPHONE: "Telefoon:",
    LABEL_TIME: "Tijd:",
    LABEL_TYPE: "Type:",
    LABEL_UNLOCK_FEATURES: "Ontgrendel functies en functionaliteit",
    LABEL_URL: "URL:",
    LABEL_USER: "Gebruiker:",
    LABEL_VISIBLE_FOR: "Zichtbaar voor:",
    LABEL_WEB_PAGE: "Webpagina:",
    LASTNAME: "Achternaam",
    LEARN_MORE: "Meer leren",
    LOGIN_COMPLETE_SETUP: "Ter voltooiing van de instellingen van SuperOffice Gmail Link moet u zich aanmelden bij SuperOffice.",
    LOGIN_ONSITE: "Meld u aan bij uw installatie van SuperOffice CRM Onsite.",
    LOGOUT_FROM_SUPEROFFICE_1: "Meld u af bij SuperOffice en sluit de eventueel geopende SuperOffice-tabbladen.",
    LOGOUT_FROM_SUPEROFFICE_2: "De volgende keer dat u zich aanmeldt bij SuperOffice CRM Online wordt de nieuwe verbinding automatisch ingesteld.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Maak hier het primaire e-mailadres van",
    MARK_COMPLETED: "Markeren als voltooid",
    MARK_REMOVE_FROM_INBOX: "Verwijderen uit Postvak IN",
    MENU_ARCHIVE_EMAIL: "E-mail archiveren",
    MENU_CREATE_APPOINTMENT: "Activiteit maken",
    MENU_CREATE_NEW_SALE: "Nieuwe verkoop maken",
    MENU_SAVE_TO_SUPEROFFICE: "Opslaan in SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Persoon heeft geen e-mailadres",
    MIDDLENAME: "Tussenvoegsel",
    MISSING_REQUIRED_VALUES_INTRO: "Sommige verplichte velden zijn niet beschikbaar voor uw gebruikersaccount:",
    ML_ADD_COMPANY: "Bedrijf toevoegen",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "E-mailadres aan persoon toevoegen",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Nieuw bedrijf en nieuwe persoon toevoegen",
    ML_ADD_NEW_CONTACT_PERSON: "Nieuwe persoon toevoegen",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Dit e-mailbericht als afspraak archiveren in uw agenda",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "E-mail in SuperOffice archiveren op bedrijfskaart van afzender",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Klikken om toe te voegen aan SuperOffice",
    ML_COMPANY_DETAILS: "Bedrijfsgegevens",
    ML_CONTACT_DETAILS: "Persoonsgegevens",
    ML_CREATE_A_NEW_SALE: "Een nieuwe verkoop voor deze klant maken",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Verbinding van Outlook met SuperOffice verbreken",
    ML_INVITATION_OPTIONS: "Uitnodigingen",
    ML_MOVE_INTO_CS_AS_REQUEST: "Dit e-mailbericht als nieuw verzoek aan Customer Service toevoegen",
    ML_OR_ADD_CONTACT_TO_COMPANY: "OF PERSOON TOEVOEGEN AAN BEDRIJF?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Mensen die in dit bericht worden genoemd",
    ML_PERSON_COULD_BE: "Deze persoon kan zijn",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Zoeken naar persoon of bedrijf...",
    ML_SETTINGS_INVITATIONS_HEADER: "Uitnodigingen voor SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Afspraak toevoegen/bijwerken in SuperOffice tijdens beantwoorden van uitnodigingen in Outlook.",
    MOBILE: "Mobiel",
    MORE: "Meer",
    MRMS: "Dhr./Mw.",
    MULTIPLE_EMAILADDRESSES_FOUND: "Dit e-mailadres is geregistreerd voor verschillende personen in SuperOffice. Klik hier om de correcte persoon te selecteren om in te archiveren.",
    MYPROFILE: "Mijn profiel",
    NO_RESULTS: "Geen resultaten",
    NOTE_CONTACT_DATA_PREDICTED: "Op basis van de inhoud van deze e-mail hebben we details voor deze afzender voorgesteld. Controleer dit voordat u deze contactpersoon maakt.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Controleer of de gebruikersnaam en het wachtwoord die u hebt ingevoerd correct zijn.",
    ONSITE_CONNECTION_SUCCESSFUL: "Gefeliciteerd. SuperOffice Gmail Link is verbonden met uw installatie van SuperOffice CRM Onsite.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Controleer of u bent aangemeld bij uw lokale installatie voordat u doorgaat.",
    ONSITE_ERROR_LINE_1: "Er waren enkele problemen tijdens het aanmeldingsproces.",
    ONSITE_ERROR_LINE_2: "Controleer of u een correcte URL voor de server hebt ingevoerd. Klik op de informatieknop voor meer informatie.",
    ONSITE_PASSWORD: "Wachtwoord:",
    ONSITE_SERVER_URL: "Server-URL:",
    ONSITE_SERVER_URL_LINE_1: "Selecteer Snelkoppeling kopiëren in het hoofdmenu van SuperOffice CRM",
    ONSITE_SERVER_URL_LINE_2: "Plak vervolgens hier in de server-URL",
    ONSITE_URL: "URL naar uw installatie van SuperOffice CRM Onsite:",
    ONSITE_USER_NAME: "Gebruikersnaam:",
    OPEN_IN_CRM: "Openen in CRM",
    OR_UPPER: "OF",
    OUR_CONTACT: "Onze contactpersoon",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Als u later van gedachten verandert, opent u de add-in SuperOffice for Outlook opnieuw in het agendascherm",
    PERMISSION_CONTINUE: "Klik op \"Doorgaan\" om een nieuw venster te openen en de vereiste machtigingen te verlenen",
    PERMISSION_FOR_CALENDAR: "SuperOffice for Outlook heeft uw toestemming nodig om toegang te krijgen tot uw agenda-items.",
    PICKER_BCC: "Bcc",
    PICKER_CC: "Cc",
    PICKER_CC_COPY: "Cc",
    PICKER_TO: "Aan",
    PLACE_REQUEST_IN_QUEUE: "Plaats verzoek in deze wachtrij:",
    POPUP__BOTTOM_TEXT: "Sta pop-ups toe voor deze pagina en probeer het opnieuw.",
    POPUP__HEADER: "Pop-upblokkering gedetecteerd",
    POPUP__MID_TEXT: "SuperOffice voor Outlook moet verifiëren, maar de pop-upblokkering van uw browser voorkomt dit.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Verwijder uit Postvak IN",
    REMOVE_FROM_INBOX_DESC: "Verplaatst e-mails na het archiveren naar de verwijderde items",
    REQUEST: "Verzoek",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Deze e-mail is te groot om aan een verzoek toe te voegen.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "E-mail te groot",
    REQUEST_PRIORITY: "Prioriteit",
    REQUEST_QUEUE: "Verzoekwachtrij",
    RESET_ALL: "Alles opnieuw instellen",
    RESET_INFO_SOFO: "Wilt u de informatie in SuperOffice voor Outlook opnieuw instellen? Hiermee worden de huidige gegevens verwijderd.",
    REVISION_LABEL: "Revisie:",
    SEARCH_FAILED: "Zoeken is mislukt. Probeer het opnieuw.",
    SETTINGS: "Instellingen",
    SETTINGS_ApplyArchiveStatus: "Archiefcategorie toepassen",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Alleen externe ontvangers",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Externe ontvangers zijn personen buiten uw organisatie.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Doorgestuurd",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Archiveringsherinnering",
    SETTINGS_ARCHIVE_REMINDER_INFO: "De archiefherinnering zorgt ervoor dat e-mails en vergaderingen in SuperOffice worden opgeslagen voordat ze worden verzonden.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "U krijgt een herinnering om vergaderingen in SuperOffice te archiveren.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Herinner me eraan voordat ik vergaderingen verzend",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Nieuwe e-mails",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Antwoorden",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "U krijgt een herinnering om e-mails in SuperOffice te archiveren.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Herinner me eraan voordat ik e-mails verzend",
    SETTINGS_CategoryColor: "Categoriekleur",
    SETTINGS_CategoryName: "Categorienaam",
    SETTINGS_CategoryNameFixedInfo: "De categorienaam staat vast en kan niet worden gewijzigd.",
    SETTINGS_CategoryTaggingDescription: "Gebruik een Outlook-categorie om e-mails te identificeren die al in SuperOffice zijn gearchiveerd.",
    SETTINGS_CategoryTaggingInfo: "Met de status van het e-mailarchief ziet u direct in uw Outlook-mailbox welke e-mails al in SuperOffice zijn opgeslagen.",
    SETTINGS_CategoryTaggingSection: "Status van het e-mailarchief",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Standaardtype activiteit",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Standaard-e-mailtype",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Binnenkomende e-mail",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Uitgaande e-mail",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Standaardsjabloon binnenkomende e-mail",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Standaardsjabloon uitgaande e-mail",
    SETTINGS_EnableCategoryForSharedMailbox: "In gedeelde mailboxen",
    SETTINGS_EnableCategoryOnOpen: "Bij het openen van gearchiveerde e-mails",
    SETTINGS_EnableCategoryOnSendAndArchive: "Bij gebruik van Verzenden en archiveren",
    SETTINGS_EnableCategoryTagging: "Archiefcategorie weergeven in Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Contextuele projecten en verkopen weergeven",
    SETTINGS_GENERAL_HEADER: "Algemeen",
    SETTINGS_SharedMailboxCategoryInfo: "De archiefstatus kan alleen worden weergegeven als de archiefcategorie is gemaakt in de gedeelde mailbox.",
    SETTINGS_SharedMailboxCategoryInfoBold: "Voor gedeelde mailboxen",
    SETTINGS_SharedMailboxCategoryLearnMore: "Meer informatie over het instellen van een gedeelde mailbox",
    SETTINGS_YOURCOMPANY: "Bedrijfsnaam:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Archiveren en verzenden",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Selecteer een contactpersoon of een bedrijf om te archiveren.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Deze e-mail is klaar om te worden verzonden, maar kan niet in SuperOffice te worden gearchiveerd.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Archiveren",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Deze e-mail is klaar om te worden verzonden, maar is niet ingesteld om in SuperOffice te worden gearchiveerd. Archiveer hem nu, zodat de communicatie bij het juiste bedrijf of de juiste contactpersoon wordt bewaard, of verstuur hem zonder het te archiveren.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Er is een fout opgetreden tijdens het laden van instellingen.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Meld u aan bij SuperOffice voordat u instellingen opent.",
    SR_ADMIN_MYAPPS: "Mijn apps",
    SR_ALL_ITEM: "Iedereen",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Weet u zeker dat u biometrische aanmelding wilt uitschakelen? De volgende keer moet u zich weer handmatig aanmelden.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Kopiëren naar klembord mislukt",
    SR_NO_SELECTION: "(Geen selectie)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Ga met een paar klikken aan de slag",
    SYNCHRONIZER_REACTIVATE: "Met een paar klikken opnieuw activeren",
    SYNCRONIZER_MSG_CONTENT: "Synchroniseer je Outlook-agenda en -taken met SuperOffice CRM om vergaderingen, contactpersonen, projecten en verkopen up-to-date te houden.",
    SYNCRONIZER_NEED_AUTHENTICATION: "Synchronisatie van SuperOffice-agenda met Outlook is bijna ingesteld. Blijf dit activeren om uw agenda's gesynchroniseerd te houden.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "De synchronisatie van uw SuperOffice-agenda met Outlook is momenteel onderbroken. Blijf opnieuw activeren om uw agenda's gesynchroniseerd te houden.",
    TAB_ACTION: "Actie",
    TAB_PEOPLE: "Mensen",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Activiteit is gemaakt in SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Activiteit is gemaakt in SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "De server reageert te traag. Probeer het opnieuw.",
    TIMEOUT_ERROR_TITLE: "De tijdlimiet voor het verzoek is verstreken",
    TITLE: "Functie",
    UNDO: "Ongedaan maken",
    UNKNOWN_EMAIL_ADDRESS: "Het e-mailadres is onbekend.",
    UNKNOWN_EMAILADDRESS: "Het e-mailadres van deze afzender is onbekend. Klik hier om het e-mailadres toe te voegen in SuperOffice.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Dit e-mailadres van de ontvanger wordt niet herkend. Klik hier om SuperOffice bij te werken met dit e-mailadres.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Onbekend e-mailadres. {0} toevoegen aan SuperOffice.",
    UNLOCK_THESE_FEATURES: "Ontgrendel deze functies met de synchronisatietoepassing",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.nl/crm/demo/",
    VERSION_SHORT: "ver.",
    VISIT_APP_STORE: "Ga naar de App Store",
    WE_RUN_ONLINE_LINE_1: "Om te bepalen of u Online werkt, doet u het volgende:",
    WE_RUN_ONLINE_LINE_2: "1. Selecteer Help in SuperOffice CRM en vervolgens Info",
    WE_RUN_ONLINE_LINE_3: "2. Kijk naar de vermelding bij NetServer:",
    WE_RUN_ONLINE_LINE_4: "Als er staat \"SuperOffice CRM Online ...\", werkt u Online",
    WE_RUN_ONSITE_LINE_1: "Om te bepalen of u Onsite werkt, doet u het volgende:",
    WE_RUN_ONSITE_LINE_4: "Als er staat \"SuperOffice CRM Onsite ...\", werkt u Onsite",
    YOU_CAN_STILL_USE: "U kunt SuperOffice for Outlook nog steeds gebruiken voor e-mails!",
  },
  NO: {
    ACTION_ADD: "Legg til",
    ACTION_BACK: "Tilbake",
    ACTIVITIES: "Aktiviteter",
    ADD_ATTENDEES: "Inviter kontakt fra SuperOffice.",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Legg til e-postadresse på eksisterende person",
    AI_SUMMARY_AI_NOT_ENABLED: "AI-tekstfunksjonene er ikke aktivert for organisasjonen din. Ta kontakt med SuperOffice-administratoren.",
    AI_SUMMARY_APPEND: "Tilføy",
    AI_SUMMARY_FEATURE_DISABLED: "Denne funksjonen er deaktivert for organisasjonen din.",
    AI_SUMMARY_GENERATE: "Generer",
    AI_SUMMARY_GENERATE_ERROR: "Kunne ikke generere et sammendrag akkurat nå. Prøv igjen.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Generer KI-sammendrag",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Deltakere:",
    AI_SUMMARY_HEADER_SUBJECT: "Emne:",
    AI_SUMMARY_LOADING: "Genererer sammendrag …",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Du har ikke lisens til å bruke KI-funksjoner",
    AI_SUMMARY_NO_PERMISSION: "Du har ikke tilgang til å lese denne e-posten.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "Det er ingenting å oppsummere i denne e-posten.",
    AI_SUMMARY_REPLACE_CONFIRM: "Erstatt",
    ALREADY_ARCHIVED_ATTACHMENT: "Vedlegget er allerede arkivert av <%- archivedBy %> den <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "E-posten er allerede arkivert av <%- archivedBy %> den <%- archivedAt %>.\n",
    ALREADY_ARCHIVED_SALE: "Et salg har allerede blitt opprettet fra denne e-posten av <%- archivedBy %> på <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "En avtale har allerede blitt laget for denne e-posten av <%- archivedBy %> på <%- archivedAt %>.",
    ALREADY_DONE: "Allerede gjort",
    APPOINTMENT_EXISTS_IN_CRM: "Denne avtalen finnes i CRM og ble opprettet av <%- createdBy %> den <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Opprett aktivitet",
    ARCHIVE_ALWAYS_SHOW: "Vis alltid dialogboks for arkivering",
    ARCHIVE_AS_ACTIVITY: "Opprett avtale i SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Lagre vedlegg i SuperOffice",
    ARCHIVE_AS_REQUEST: "Opprett sak i SuperOffice",
    ARCHIVE_AS_SALE: "Opprett salg i SuperOffice",
    ARCHIVE_AS_TASK: "Opprett oppgave i SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Fjern e-post fra innboks etter arkivering som standard",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Inkluder maltyper som ikke er e-post i mallisten",
    ATTACHMENT_SIZE_INFO: "Vedleggene er for store og kan ikke arkiveres. Bare e-posten uten vedlegg kan arkiveres.",
    AUTH__BOTTOM_TEXT_1: "\u2028Vise flere detaljer?",
    AUTH__BOTTOM_TEXT_2: "Finn ut hvordan du autoriserer tillegget",
    AUTH__BUTTON: "Kopier administratorkobling",
    AUTH__COPIED: "Kopiert til utklippstavlen",
    AUTH__HEADER: "Oppdatering for SuperOffice for Outlook",
    AUTH__INCREMENTAL_TEXT_1: "Ytterligere tillatelser kreves for å aktivere {feature}.",
    AUTH__MID_TEXT_1: "Outlook-tillegget har blitt oppdatert for å oppfylle Microsofts nyeste sikkerhetskrav.",
    AUTH__MID_TEXT_2: "For å fortsette å bruke den må <b>en Microsoft 365 Global Administrator gi tillatelse</b> (samtykke) på vegne av alle brukere.",
    AUTH__MID_TEXT_3: "<b>Del denne koblingen</b> med Microsoft 365-administratoren din:",
    AUTH__NEW_USER_TEXT_1: "Tilleggsfunksjonen SuperOffice for Outlook krever ytterligere tillatelser for å få tilgang til Microsoft 365-data.",
    AUTH_IN_PROGRESS__HEADER: "Autorisasjon pågår",
    AUTH_IN_PROGRESS__MID_TEXT: "Fortsett den interaktive autentiseringen som pågår, og prøv på nytt.",
    AUTOSAVE_FAIL: "Ikke lagret.",
    AUTOSAVE_IN_PROGRESS: "Lagrer …",
    AUTOSAVE_RETRY: "Prøv på nytt",
    AUTOSAVE_SUCCESS: "Lagret",
    BANNER_ADD_MESSAGE: "Melding opprettet.",
    BANNER_CREATE_APPOINTMENT: "Avtale opprettet",
    BANNER_CREATE_REQUEST: "Sak opprettet",
    BANNER_CREATE_SALE: "Salg opprettet",
    BANNER_CREATE_TASK: "Oppgave opprettet",
    BANNER_SAVE_ATTACHMENT: "Vedlegg lagret",
    BANNER_SAVE_TO_SUPEROFFICE: "E-post lagret",
    BANNER_VIEW_IN_CRM: "Vis i CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Legg til melding på sak",
    BTN_ADD_TO_SUPEROFFICE: "Registrer i SuperOffice",
    BTN_ARCHIVE: "Arkiver",
    BTN_CANCEL: "Avbryt",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Klikk for å legge til ny person.",
    BTN_CONNECT: "Koble til",
    BTN_CONNECT_TO_SUPEROFFICE: "Vi benytter SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Vi benytter SuperOffice Onsite",
    BTN_CREATE: "Opprett",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Opprett nytt firma og person",
    BTN_GO_TO_SUPEROFFICE: "Vis i SuperOffice",
    BTN_KEEP_CONTACT: "Behold",
    BTN_LOGIN: "Pålogging",
    BTN_LOOKUP_SENDER: "Søk på avsender",
    BTN_OK: "OK",
    BTN_RECONNECT: "Bytt SuperOffice-bruker",
    BTN_SAVE: "Lagre",
    BTN_SAVE_AND_ARCHIVE: "Send og arkiver",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Prøv SuperOffice gratis her",
    BTN_UPDATE_CONTACT: "Oppdater",
    BUSINESS: "Bransje",
    BUTTON_LETS_GO: "La oss komme i gang",
    BUTTON_RELOAD: "Last inn på nytt",
    CAN_NOT_GRANT_PERMISSION: "Kan du ikke gi tillatelse?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Kan ikke legge til melding i forespørselen fordi vedlegg kan være usikre",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Vedlegg kan ikke arkiveres, da noen av dem kan være usikre. Bare e-poster uten vedlegg kan arkiveres.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Kan ikke lagre vedlegg med digital signatur",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Denne e-posten er signert digitalt. Vedlegg i signaturen kan ikke lagres hver for seg.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Kan ikke arkivere fordi vedlegg kan være usikre",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Kan ikke opprette melding i forespørselen fordi vedlegg kan være usikre",
    CANNOT_SAVE_CONTACT: "Kan ikke lagre person",
    CATEGORY: "Kategori",
    CHANGES_SAVED_AUTOMATICALLY: "Endringene lagres automatisk",
    CHOOSE_ONE_OR_CONTINUE: "Velg én eller fortsett.",
    CLICK_HERE_TO_SEE_IT: "Klikk her for å vise den.",
    CLICK_HERE_TO_SELECT_CONTACT: "Velg person",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Klikk her for å velge riktig person å arkivere på.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} fler. Klikk her for å vise alle.",
    CLICK_LOGIN_ONSITE: "Klikk her for å åpne SuperOffice-installasjonen i en ny fane.",
    COMMENT_PLACEHOLDER: "Legg til en kommentar …",
    COMPANY_NAME: "Firmanavn",
    CONNECT_ONSITE: "Koble til en SuperOffice CRM Onsite-installasjon",
    CONNECT_TO_SUPEROFFICE: "Koble til din SuperOffice CRM Online-konto",
    CONTACT_ADMINISTRATOR: "Ta kontakt med SuperOffice-administratoren din for å gå gjennom CRM-konfigurasjonen din.",
    CONTINUE: "Fortsett",
    COULD_IT_BE_ONE_OF_THESE: "Er det en av disse?",
    COUNTRY: "Land",
    CREATE_NEW_COMPANY: "Opprett nytt firma",
    CREATE_NEW_CONTACT: "Opprett ny person",
    CREATE_REQUEST: "Opprett sak",
    CREATED_REQUEST: "Saken er opprettet",
    DEPARTMENT: "Avdeling",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Ikke arkiver vedlegg",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Vedlegg arkiveres som standard",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-post er arkivert i SuperOffice.",
    EMAIL_ADDRESS: "E-post",
    EMAIL_ADDRESS_NOT_REGISTERED: "Denne e-postadressen finnes ikke i SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> er registrert på flere personer i SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-postmeldingen er registrert i SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Denne e-postadressen er registrert på flere personer i SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Aktiver arkivering for å redigere disse innstillingene",
    ERROR: "Feil",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Kan ikke registrere e-postadresse i SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Kan ikke arkivere vedlegg.",
    ERROR_ARCHIVING_EMAIL: "Kan ikke arkivere e-postmelding.",
    ERROR_ARCHIVING_REQUEST: "Kan ikke arkivere sak.",
    ERROR_ARCHIVING_TASK: "Kan ikke opprette aktivitet.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Kan ikke kommunisere med SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Du har ikke rettigheter til å opprette firmaer og personer i SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Finn firma eller person ...",
    FIRST_ATTENDEE_CHANGED: "Møtekontakten er endret.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Velg hvilken person avtalen skal knyttes til.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Person og møtedeltaker stemmer ikke overens",
    FIRSTNAME: "Fornavn",
    FOLLOWUPS: "Oppfølginger",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice for Outlook klarte ikke å opprette en forbindelse til Microsofts tjenester. Prøv igjen om litt.",
    GRAPH_API_ERROR_TITLE_SOFO: "Microsoft-tjenestene er midlertidig utilgjengelige.",
    HEADER_ADD_EMAIL: "Legg til e-post/person: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Legg til e-postadresse i SuperOffice",
    HEADER_ADD_RECPIENTS: "Legg til mottaker fra SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Legg til på eksisterende person",
    HEADER_ARCHIVE_APPOINTMENT: "Opprett aktivitet ",
    HEADER_ARCHIVE_ATTACHMENT: "Arkiver vedlegg som et SuperOffice-dokument",
    HEADER_ARCHIVE_EMAIL: "Arkiver e-post i SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Koble til en annen SuperOffice-installasjon",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Opprett aktivitet i SuperOffice basert på e-post",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Lagre vedlegg fra denne e-posten i SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Arkiver denne e-posten i SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Opprett sak i SuperOffice basert på e-post",
    HEADER_CREATE_EMAIL_AS_SALE: "Opprett salg i SuperOffice basert på e-post",
    HEADER_CREATE_EMAIL_AS_TASK: "Lag en oppgave i sjekklisten basert på e-post",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Opprett nytt firma og person",
    HEADER_CREATE_NEW_PERSON: "Opprett ny person",
    HEADER_WELCOME: "Velkommen",
    LABEL_ACHIEVE_MORE: "Integrerte verktøy gir deg flere muligheter",
    LABEL_ADD_TO_EXISTING_REQUEST: "Legg til e-post som melding i en eksisterende sak i SuperOffice",
    LABEL_ARCHIVE_FILE: "Arkiver fil:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Vedlegg allerede lagret",
    LABEL_ATTACHMENT_NOT_SAVED: "Vedlegg ikke lagret",
    LABEL_COMMENT: "Kommentar:",
    LABEL_COMPANYPHONE: "Telefon (firma):",
    LABEL_CONTACT: "Firma:",
    LABEL_CONTACT_OR_COMPANY: "Person eller firma:",
    LABEL_CREATE_AND_VISUALIZE: "Produser og visualiser som en proff",
    LABEL_CURRENCY: "Valuta:",
    LABEL_DATE: "Dato:",
    LABEL_DESCRIPTION: "Beskrivelse:",
    LABEL_DIRECTPHONE: "Direktenr:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Oppdag hva dette tillegget kan gjøre for deg idag!",
    LABEL_HOME_ADDRESS: "Hjemmeadresse:",
    LABEL_MOBILEPHONE: "Mobilnr:",
    LABEL_NOTES: "Notat:",
    LABEL_NUMBER: "Nummer:",
    LABEL_OPTIONAL_ATTENDEE: "Valgfritt",
    LABEL_PERSON: "Person:",
    LABEL_POSITION: "Posisjon:",
    LABEL_PROJECT: "Prosjekt:",
    LABEL_REQUIRED_ATTENDEE: "Obligatorisk",
    LABEL_SALE: "Salg:",
    LABEL_SALE_AMOUNT: "Salgssum:",
    LABEL_SALE_DATE: "Salgsdato:",
    LABEL_SALE_NAME: "Salgsnavn:",
    LABEL_SALE_TYPE: "Salgstype:",
    LABEL_SAVED_CHANGES: "Endringene er lagret.",
    LABEL_SELECT_CS_QUEUE: "Legg til saken i denne køen:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Velg kø",
    LABEL_SERVER_VERSION: "Serverversjon:",
    LABEL_SUBJECT: "Overskrift:",
    LABEL_SUPEROFFICE_SITE: "SuperOffice-adresse:",
    LABEL_TELEPHONE: "Telefon:",
    LABEL_TIME: "Klokkeslett:",
    LABEL_TYPE: "Type:",
    LABEL_UNLOCK_FEATURES: "Få tilgang til mer og bedre funksjonalitet",
    LABEL_URL: "URL:",
    LABEL_USER: "Bruker:",
    LABEL_VISIBLE_FOR: "Synlig for:",
    LABEL_WEB_PAGE: "Webside:",
    LASTNAME: "Etternavn",
    LEARN_MORE: "Les mer",
    LOGIN_COMPLETE_SETUP: "Du må logge deg på SuperOffice for å fullføre oppsettet av SuperOffice Gmail Link.",
    LOGIN_ONSITE: "Logg på din SuperOffice CRM Onsite-installasjon.",
    LOGOUT_FROM_SUPEROFFICE_1: "Logg av SuperOffice og lukk eventuelle åpne SuperOffice-faner.",
    LOGOUT_FROM_SUPEROFFICE_2: "Neste gang du logger på SuperOffice CRM Online, vil den nye tilkoblingen bli satt opp automatisk.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Sett som primær e-postadresse.",
    MARK_COMPLETED: "Merk som utført",
    MARK_REMOVE_FROM_INBOX: "Fjern fra innboksen",
    MENU_ARCHIVE_EMAIL: "Arkiver e-post",
    MENU_CREATE_APPOINTMENT: "Opprett aktivitet",
    MENU_CREATE_NEW_SALE: "Opprett nytt salg",
    MENU_SAVE_TO_SUPEROFFICE: "Lagre i SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Personen har ingen e-postadresse registrert",
    MIDDLENAME: "Mellomnavn",
    MISSING_REQUIRED_VALUES_INTRO: "Noen obligatoriske felt er ikke tilgjengelige for din brukerkonto:",
    ML_ADD_COMPANY: "Legg til firma",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Legg til e-post på person",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Legg til nytt firma og ny person",
    ML_ADD_NEW_CONTACT_PERSON: "Legg til ny person",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Arkiver e-postmeldingen som avtale i din kalender",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Arkiver e-postmelding i SuperOffice på avsenderens firmakort",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Klikk for å legge til i SuperOffice",
    ML_COMPANY_DETAILS: "Firmainformasjon",
    ML_CONTACT_DETAILS: "Personinformasjon",
    ML_CREATE_A_NEW_SALE: "Opprett et nytt salg for denne kunden",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Koble Outlook fra SuperOffice",
    ML_INVITATION_OPTIONS: "Invitasjoner",
    ML_MOVE_INTO_CS_AS_REQUEST: "Legg til e-postmeldingen som ny sak i Customer Service",
    ML_OR_ADD_CONTACT_TO_COMPANY: "ELLER LEGG TIL PERSON PÅ FIRMA?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Personer nevnt i denne e-posten",
    ML_PERSON_COULD_BE: "Denne personen kan være",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Søk etter person eller firma ...",
    ML_SETTINGS_INVITATIONS_HEADER: "Invitasjoner for SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Legg til / oppdater avtale i SuperOffice når du svarer på invitasjoner i Outlook.",
    MOBILE: "Mobil",
    MORE: "Mer",
    MRMS: "Hr/Fr",
    MULTIPLE_EMAILADDRESSES_FOUND: "Denne e-postadressen er registrert på flere personer i SuperOffice. Klikk her for å velge riktig person.",
    MYPROFILE: "Min profil",
    NO_RESULTS: "Ingen resultater",
    NOTE_CONTACT_DATA_PREDICTED: "Basert på innholdet i denne e-posten har vi foreslått detaljer for avsenderen. Vennligst verifiser før du oppretter kontakten.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Kontroller at brukernavnet og passordet er riktig.",
    ONSITE_CONNECTION_SUCCESSFUL: "Gratulerer. SuperOffice Gmail Link er nå tilkoblet din SuperOffice CRM Onsite-installasjon.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Du må være logget på din Onsite-installasjon før du fortsetter.",
    ONSITE_ERROR_LINE_1: "Noe gikk galt under påloggingsprosessen.",
    ONSITE_ERROR_LINE_2: "Kontroller at du har riktig URL og at brukernavnet og passordet er riktig.",
    ONSITE_PASSWORD: "Passord:",
    ONSITE_SERVER_URL: "Server-URL:",
    ONSITE_SERVER_URL_LINE_1: "Velg Copy fra hovedmenyen i SuperOffice CRM",
    ONSITE_SERVER_URL_LINE_2: "Og lim in i Server URL-feltet her",
    ONSITE_URL: "URL til SuperOffice CRM Onsite-installasjonen din:",
    ONSITE_USER_NAME: "Brukernavn:",
    OPEN_IN_CRM: "Åpne i CRM",
    OR_UPPER: "ELLER",
    OUR_CONTACT: "Vår kontakt",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Hvis du ombestemmer deg senere, åpner du SuperOffice for Outlook-tillegget i kalendervisningen igjen",
    PERMISSION_CONTINUE: "Klikk på «Fortsett» for å åpne et nytt vindu og gi nødvendige tillatelser",
    PERMISSION_FOR_CALENDAR: "SuperOffice for Outlook trenger din tillatelse til å få tilgang til kalenderelementene dine.",
    PICKER_BCC: "Blindkopi",
    PICKER_CC: "Kopi",
    PICKER_CC_COPY: "Kopi",
    PICKER_TO: "Til",
    PLACE_REQUEST_IN_QUEUE: "Plasser saken i denne køen:",
    POPUP__BOTTOM_TEXT: "Tillat popup-vinduer for denne siden, og prøv på nytt.",
    POPUP__HEADER: "Popup-blokkering oppdaget",
    POPUP__MID_TEXT: "SuperOffice Copilot må autentisere, men nettleserens popup-blokkering forhindrer det.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Fjern fra innboks",
    REMOVE_FROM_INBOX_DESC: "Flytter e-post til Slettede elementer etter arkivering",
    REQUEST: "Sak",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Denne e-posten er for stor til å legges til på en sak.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "E-posten er for stor",
    REQUEST_PRIORITY: "Prioritet",
    REQUEST_QUEUE: "Sakskø:",
    RESET_ALL: "Tilbakestill alle",
    RESET_INFO_SOFO: "Vil du tilbakestille informasjonen i SuperOffice for Outlook? Gjeldende data fjernes.",
    REVISION_LABEL: "Revisjon:",
    SEARCH_FAILED: "Søket mislyktes. Prøv på nytt.",
    SETTINGS: "Innstillinger",
    SETTINGS_ApplyArchiveStatus: "Bruk arkiveringskategori",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Kun eksterne mottakere",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Eksterne mottakere er personer utenfor organisasjonen din.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Videresendinger",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Påminnelse om arkivering",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Arkiveringspåminnelsen bidrar til å sikre at e-poster og møter lagres i SuperOffice før de sendes.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Du vil få en påminnelse om å arkivere møter i SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Minn meg på det før jeg sender møteinnkallelser",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Nye e-poster",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Svar",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Du vil få en påminnelse om å arkivere e-poster i SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Minn meg på det før jeg sender e-post",
    SETTINGS_CategoryColor: "Kategorifarge",
    SETTINGS_CategoryName: "Kategorinavn",
    SETTINGS_CategoryNameFixedInfo: "Kategorinavnet er fast og kan ikke endres.",
    SETTINGS_CategoryTaggingDescription: "Bruk en Outlook-kategori til å identifisere e-poster som allerede er arkivert i SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "Status for e-postarkivering hjelper deg med å se hvilke e-poster som allerede er lagret i SuperOffice, direkte i Outlook-postkassen din.",
    SETTINGS_CategoryTaggingSection: "Status for e-postarkivering",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Standard aktivitetstype",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Standard e-posttype",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Innkommende e-post",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Utgående e-post",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Standardmal for innkommende e-post",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Standardmal utgående e-post",
    SETTINGS_EnableCategoryForSharedMailbox: "I delte postkasser",
    SETTINGS_EnableCategoryOnOpen: "Når du åpner arkiverte e-poster",
    SETTINGS_EnableCategoryOnSendAndArchive: "Når du bruker Send og arkiver",
    SETTINGS_EnableCategoryTagging: "Vis arkiveringskategori i Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Vis kontekstavhengige prosjekter og salg",
    SETTINGS_GENERAL_HEADER: "Generelt",
    SETTINGS_SharedMailboxCategoryInfo: "For å vise arkiveringsstatus må arkiveringskategorien opprettes i den delte postkassen.",
    SETTINGS_SharedMailboxCategoryInfoBold: "For delte postkasser:",
    SETTINGS_SharedMailboxCategoryLearnMore: "Les mer om hvordan du konfigurerer en delt postkasse",
    SETTINGS_YOURCOMPANY: "Firmanavn:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Arkiver og send",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Velg en person eller et firma som skal arkiveres.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Denne e-posten er klar til å sendes, men den kan ikke arkiveres i SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Arkiv",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Denne e-posten er klar til å sendes, men den er ikke angitt til å arkiveres i SuperOffice. Arkiver den nå, slik at kommunikasjonen lagres under riktig firma eller person, eller send den uten å arkivere den.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Noe gikk galt under lasting av innstillinger.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Logg deg på SuperOffice før du åpner innstillinger.",
    SR_ADMIN_MYAPPS: "Mine apper",
    SR_ALL_ITEM: "Alle",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Er du sikker på at du vil slå av biometrisk pålogging? Du må logge deg på manuelt neste gang.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Kunne ikke kopiere til utklippstavlen",
    SR_NO_SELECTION: "(Ingen valgt)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "Mikrofonen er i bruk. Prøv igjen når den er ledig.",
    SYNCHRONIZER_GET_STARTED: "Kom i gang med noen få klikk",
    SYNCHRONIZER_REACTIVATE: "Aktiver på nytt med noen få klikk",
    SYNCRONIZER_MSG_CONTENT: "Synkroniser Outlook-kalenderen og -oppgavene med SuperOffice CRM for å holde møter, kontakter, prosjekter og salg oppdatert.",
    SYNCRONIZER_NEED_AUTHENTICATION: "Synkronisering av SuperOffice-kalenderen med Outlook er nesten konfigurert. Fortsett å aktivere den og hold kalenderne dine synkronisert.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "Synkronisering mellom SuperOffice-kalenderen og Outlook er avbrutt. Fortsett å reaktivere den og hold kalenderne synkronisert.",
    TAB_ACTION: "Handling",
    TAB_PEOPLE: "Kontakter",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Aktiviteten er opprettet i SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Aktiviteten er opprettet i SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "Serveren brukte for lang tid på å svare. Prøv på nytt.",
    TIMEOUT_ERROR_TITLE: "Tidsavbrudd",
    TITLE: "Tittel",
    UNDO: "Angre",
    UNKNOWN_EMAIL_ADDRESS: "Ukjent e-postadresse.",
    UNKNOWN_EMAILADDRESS: "Senderens e-postadresse er ikke registrert. Klikk her for å legge den til i SuperOffice. ",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Mottakerens e-postadresse er ikke registrert. Klikk her for å oppdatere SuperOffice med denne adressen. ",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Ukjent e-postadresse. Legg til {0} i SuperOffice.",
    UNLOCK_THESE_FEATURES: "Lås opp disse funksjonene med synkronisering",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.no/crm/demo/",
    VERSION_SHORT: "ver.",
    VISIT_APP_STORE: "Besøk App Store",
    WE_RUN_ONLINE_LINE_1: "Slik finner du ut om du bruker Online:",
    WE_RUN_ONLINE_LINE_2: "1. I SuperOffice CRM velger du Help og deretter About",
    WE_RUN_ONLINE_LINE_3: "2. Kontroller oppføringen for NetServer:",
    WE_RUN_ONLINE_LINE_4: "Hvis det står «SuperOffice CRM Online ...», bruker du Online",
    WE_RUN_ONSITE_LINE_1: "Slik finner du ut om du bruker Onsite:",
    WE_RUN_ONSITE_LINE_4: "Hvis det står «SuperOffice CRM Onsite...», bruker du OnSite",
    YOU_CAN_STILL_USE: "Du kan fortsatt bruke SuperOffice for Outlook for e-post!",
  },
  PL: {
    ACTION_ADD: "Dodaj",
    ACTION_BACK: "Wstecz",
    ACTIVITIES: "Działalność",
    ADD_ATTENDEES: "Zaproś kontakty z SuperOffice",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Dodaj adres e-mail do istniejącego kontaktu",
    AI_SUMMARY_AI_NOT_ENABLED: "W Twojej organizacji nie włączono funkcji tekstowych opartych na SI. Skontaktuj się z administratorem SuperOffice.",
    AI_SUMMARY_APPEND: "Dołącz",
    AI_SUMMARY_FEATURE_DISABLED: "Ta funkcja została wyłączona w Twojej organizacji.",
    AI_SUMMARY_GENERATE: "Generuj",
    AI_SUMMARY_GENERATE_ERROR: "W tej chwili nie udało się wygenerować podsumowania. Spróbuj ponownie.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Wygeneruj podsumowanie AI",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Uczestnicy:",
    AI_SUMMARY_HEADER_SUBJECT: "Temat:",
    AI_SUMMARY_LOADING: "Tworzenie podsumowania…",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Nie posiadasz licencji na korzystanie z funkcji AI",
    AI_SUMMARY_NO_PERMISSION: "Nie masz uprawnień do odczytania tej wiadomości e-mail.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "W tej wiadomości e-mailu nie ma nic do podsumowania.",
    AI_SUMMARY_REPLACE_CONFIRM: "Zastąp",
    ALREADY_ARCHIVED_ATTACHMENT: "Ten załącznik został już zarchiwizowany przez <%- archivedBy %> dnia <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "Ten e-mail został już zarchiwizowany przez <%- archivedBy %> dnia <%- archivedAt %>.",
    ALREADY_ARCHIVED_SALE: "Sprzedaż została już utworzona dla tego e-mailu przez <%- archivedBy %> , dnia <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "Działanie zostało już utworzone dla tego e-mailu przez <%- archivedBy %> , dnia <%- archivedAt %>.",
    ALREADY_DONE: "Już gotowe",
    APPOINTMENT_EXISTS_IN_CRM: "To spotkanie istnieje w systemie CRM i zostało utworzone przez <%- createdBy %> w dniu <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Utwórz działanie",
    ARCHIVE_ALWAYS_SHOW: "Zawsze pokazuj okno dialogowe archiwum",
    ARCHIVE_AS_ACTIVITY: "Utwórz termin w SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Zapisz załącznik w SuperOffice",
    ARCHIVE_AS_REQUEST: "Utwórz żądanie w SuperOffice",
    ARCHIVE_AS_SALE: "Utwórz sprzedaż w SuperOffice",
    ARCHIVE_AS_TASK: "Utwórz zadanie w SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Domyślnie usuń e-mail ze skrzynki odbiorczej po zarchiwizowaniu",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Dołącz szablony bez e-mailu do listy szablonów",
    ATTACHMENT_SIZE_INFO: "Załączniki są zbyt duże i nie można ich zarchiwizować. Archiwizować można wyłącznie wiadomość e-mail bez załączników.",
    AUTH__BOTTOM_TEXT_1: "\u2028Potrzebujesz więcej szczegółów?",
    AUTH__BOTTOM_TEXT_2: "Dowiedz się, jak autoryzować dodatek",
    AUTH__BUTTON: "Skopiuj link administratora",
    AUTH__COPIED: "Skopiowano do schowka",
    AUTH__HEADER: "Aktualizacja aplikacji SuperOffice for Outlook",
    AUTH__INCREMENTAL_TEXT_1: "Aby włączyć {feature}, wymagane są dodatkowe uprawnienia.",
    AUTH__MID_TEXT_1: "Aby spełnić najnowsze wymagania bezpieczeństwa firmy Microsoft, dodatek Outlook został zaktualizowany.",
    AUTH__MID_TEXT_2: "Aby nadal z niego korzystać, <b>globalny administrator Microsoft 365 musi udzielić uprawnień</b> (zgody) w imieniu wszystkich użytkowników.",
    AUTH__MID_TEXT_3: "<b>Udostępnij ten link</b> administratorowi platformy Microsoft\u00A0365:",
    AUTH__NEW_USER_TEXT_1: "Dodatek SuperOffice dla programu Outlook wymaga dodatkowych uprawnień, aby uzyskać dostęp do danych usługi Microsoft 365.",
    AUTH_IN_PROGRESS__HEADER: "Uwierzytelnianie w toku",
    AUTH_IN_PROGRESS__MID_TEXT: "Kontynuuj aktualnie trwające uwierzytelnianie interaktywne i ponów próbę.",
    AUTOSAVE_FAIL: "Nie zapisano.",
    AUTOSAVE_IN_PROGRESS: "Zapisywanie…",
    AUTOSAVE_RETRY: "Spróbuj ponownie",
    AUTOSAVE_SUCCESS: "Zapisano",
    BANNER_ADD_MESSAGE: "Utworzono wiadomość.",
    BANNER_CREATE_APPOINTMENT: "Utworzono spotkanie.",
    BANNER_CREATE_REQUEST: "Utworzono żądanie.",
    BANNER_CREATE_SALE: "Utworzono sprzedaż.",
    BANNER_CREATE_TASK: "Utworzono zadanie.",
    BANNER_SAVE_ATTACHMENT: "Załącznik został zapisany.",
    BANNER_SAVE_TO_SUPEROFFICE: "Wiadomość e-mail została zapisana.",
    BANNER_VIEW_IN_CRM: "Zobacz w CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Dodaj wiadomość do żądania",
    BTN_ADD_TO_SUPEROFFICE: "Dodaj do programu SuperOffice",
    BTN_ARCHIVE: "Archiwum",
    BTN_CANCEL: "Anuluj",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Kliknij, aby dodać nowy kontakt",
    BTN_CONNECT: "Połącz",
    BTN_CONNECT_TO_SUPEROFFICE: "Uruchamiamy SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Uruchamiamy SuperOffice Onsite",
    BTN_CREATE: "Utwórz",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Utwórz nową firmę i kontakt",
    BTN_GO_TO_SUPEROFFICE: "Idź do programu SuperOffice",
    BTN_KEEP_CONTACT: "Zachowaj",
    BTN_LOGIN: "Logowanie",
    BTN_LOOKUP_SENDER: "Wyszukaj nadawcę",
    BTN_OK: "OK",
    BTN_RECONNECT: "Zmień użytkownika SuperOffice",
    BTN_SAVE: "Zachowaj",
    BTN_SAVE_AND_ARCHIVE: "Wyślij i zarchiwizuj",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Zarejestruj się, aby uzyskać bezpłatną wersję próbną",
    BTN_UPDATE_CONTACT: "Aktualizuj",
    BUSINESS: "Biznes",
    BUTTON_LETS_GO: "Zacznijmy",
    BUTTON_RELOAD: "Odśwież",
    CAN_NOT_GRANT_PERMISSION: "Nie udaje się udzielić zezwolenia?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Nie można dodać wiadomości do żądania",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Załączników nie można zarchiwizować, ponieważ niektóre z nich mogą stanowić zagrożenie. Archiwizować można wyłącznie wiadomości e-mail bez załączników.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Nie można zapisać załącznika z podpisem cyfrowym",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Ten e-mail posiada podpis cyfrowy. Załączników zawartych w podpisie nie można zapisać osobno.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Nie można zarchiwizować, ponieważ załącznik może być niebezpieczny",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Nie można utworzyć żądania",
    CANNOT_SAVE_CONTACT: "Nie można zapisać kontaktu",
    CATEGORY: "Kategoria",
    CHANGES_SAVED_AUTOMATICALLY: "Zmiany są zapisywane automatycznie",
    CHOOSE_ONE_OR_CONTINUE: "Wybierz jeden lub kontynuuj.",
    CLICK_HERE_TO_SEE_IT: "Kliknij tutaj, aby je wyświetlić.",
    CLICK_HERE_TO_SELECT_CONTACT: "Wybierz kontakt",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Kliknij tutaj, aby wybrać odpowiedni kontakt do zarchiwizowania.",
    CLICK_HERE_TO_SHOW_MORE: "+ {0} więcej. Kliknij tutaj, aby wyświetlić wszystkie.",
    CLICK_LOGIN_ONSITE: "Kliknij tutaj, aby otworzyć instalację programu SuperOffice na nowej zakładce.",
    COMMENT_PLACEHOLDER: "Dodaj komentarz…",
    COMPANY_NAME: "Nazwa firmy",
    CONNECT_ONSITE: "Połącz z zainstalowanym lokalnie programie SuperOffice CRM Onsite",
    CONNECT_TO_SUPEROFFICE: "Połącz z kontem SuperOffice CRM Online",
    CONTACT_ADMINISTRATOR: "Skontaktuj się z administratorem SuperOffice, aby sprawdzić konfigurację systemu CRM.",
    CONTINUE: "Kontynuuj",
    COULD_IT_BE_ONE_OF_THESE: "Czy to może jeden z nich?",
    COUNTRY: "Kraj",
    CREATE_NEW_COMPANY: "Utwórz nową firmę",
    CREATE_NEW_CONTACT: "Utwórz nowy kontakt",
    CREATE_REQUEST: "Utwórz żądanie",
    CREATED_REQUEST: "Utworzono żądanie",
    DEPARTMENT: "Oddział",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Nie archiwizuj załączników",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Załączniki są archiwizowane domyślnie",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-mail został zarchiwizowany w programie SuperOffice.",
    EMAIL_ADDRESS: "E-mail",
    EMAIL_ADDRESS_NOT_REGISTERED: "Ten adres e-mail nie istnieje w programie SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> jest połączony z kilkoma kontaktami w programie SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-mail zarejestrowany w programie SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Ten adres e-mail został zarejestrowany w kilku kontaktach w programie SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Włącz archiwizację, aby edytować te ustawienia",
    ERROR: "Błąd",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Nie można dodać adresu e-mail do programu SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Nie można zarchiwizować załącznika.",
    ERROR_ARCHIVING_EMAIL: "Nie można zarchiwizować e-mailu.",
    ERROR_ARCHIVING_REQUEST: "Nie można zarchiwizować żądania.",
    ERROR_ARCHIVING_TASK: "Nie można utworzyć działania.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Brak komunikacji z programem SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Nie masz uprawnień do tworzenia firm lub kontaktów w programie SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Znajdź firmę lub kontakt...",
    FIRST_ATTENDEE_CHANGED: "Kontakt w sprawie spotkania uległ zmianie.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Wybierz, z którym kontaktem ma być powiązane spotkanie.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Kontakt i uczestnik spotkania nie są zgodne",
    FIRSTNAME: "Imię",
    FOLLOWUPS: "Czynności",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice dla programu Outlook nie mógł połączyć się z usługami Microsoft. Spróbuj ponownie za chwilę.",
    GRAPH_API_ERROR_TITLE_SOFO: "Usługi Microsoft są chwilowo niedostępne",
    HEADER_ADD_EMAIL: "Dodaj adres e-mail/kontakt: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Dodaj adres e-mail do programu SuperOffice",
    HEADER_ADD_RECPIENTS: "Dodaj odbiorców z SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Dodaj do istniejącego kontaktu",
    HEADER_ARCHIVE_APPOINTMENT: "Utwórz działanie",
    HEADER_ARCHIVE_ATTACHMENT: "Zarchiwizuj załącznik jako dokument SuperOffice",
    HEADER_ARCHIVE_EMAIL: "Zarchiwizuj e-mail w programie SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Połącz z inną instalacją programu SuperOffice",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Utwórz działanie w SuperOffice na podstawie e-mailu",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Zapisz załączniki z tej wiadomości e-mail w SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Zarchiwizuj ten e-mail w SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Utwórz żądanie w SuperOffice na podstawie e-mailu",
    HEADER_CREATE_EMAIL_AS_SALE: "Utwórz sprzedaż w SuperOffice na podstawie e-mailu",
    HEADER_CREATE_EMAIL_AS_TASK: "Utwórz zadanie na liście kontrolnej na podstawie wiadomości e-mail",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Utwórz nową firmę i kontakt",
    HEADER_CREATE_NEW_PERSON: "Utwórz nowy kontakt",
    HEADER_WELCOME: "Witamy",
    LABEL_ACHIEVE_MORE: "Osiągnij więcej dzięki integracji",
    LABEL_ADD_TO_EXISTING_REQUEST: "Dodaj e-mail jako wiadomość w istniejącym żądaniu w SuperOffice",
    LABEL_ARCHIVE_FILE: "Plik zarchiwizowany:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Załącznik został już zapisany",
    LABEL_ATTACHMENT_NOT_SAVED: "Załącznik nie został zapisany",
    LABEL_COMMENT: "Uwaga:",
    LABEL_COMPANYPHONE: "Numer telefonu firmy:",
    LABEL_CONTACT: "Firma:",
    LABEL_CONTACT_OR_COMPANY: "Kontakt lub Firma:",
    LABEL_CREATE_AND_VISUALIZE: "Twórz i wizualizuj jak profesjonalista",
    LABEL_CURRENCY: "Waluta:",
    LABEL_DATE: "Data:",
    LABEL_DESCRIPTION: "Opis:",
    LABEL_DIRECTPHONE: "Telefon bezpośredni:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Odkryj, co ten dodatek może zrobić dla Ciebie już dziś!",
    LABEL_HOME_ADDRESS: "Adres domowy:",
    LABEL_MOBILEPHONE: "Telefon komórkowy:",
    LABEL_NOTES: "Uwagi:",
    LABEL_NUMBER: "Numer:",
    LABEL_OPTIONAL_ATTENDEE: "Opcjonalne",
    LABEL_PERSON: "Kontakt:",
    LABEL_POSITION: "Stanowisko:",
    LABEL_PROJECT: "Projekt:",
    LABEL_REQUIRED_ATTENDEE: "Wymagane",
    LABEL_SALE: "Sprzedaż:",
    LABEL_SALE_AMOUNT: "Kwota sprzedaży:",
    LABEL_SALE_DATE: "Data sprzedaży:",
    LABEL_SALE_NAME: "Nazwa sprzedaży:",
    LABEL_SALE_TYPE: "Typ sprzedaży:",
    LABEL_SAVED_CHANGES: "Twoje zmiany zostały zapisane.",
    LABEL_SELECT_CS_QUEUE: "Dodaj żądanie do tej kolejki:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Wybierz kolejkę",
    LABEL_SERVER_VERSION: "Wersja serwera:",
    LABEL_SUBJECT: "Przedmiot:",
    LABEL_SUPEROFFICE_SITE: "Strona SuperOffice:",
    LABEL_TELEPHONE: "Telefon:",
    LABEL_TIME: "Czas:",
    LABEL_TYPE: "Rodzaj:",
    LABEL_UNLOCK_FEATURES: "Odblokuj opcje i funkcje",
    LABEL_URL: "Adres URL:",
    LABEL_USER: "Użytkownik:",
    LABEL_VISIBLE_FOR: "Widoczne dla:",
    LABEL_WEB_PAGE: "Strona sieci Web:",
    LASTNAME: "Nazwisko",
    LEARN_MORE: "Dowiedz się więcej",
    LOGIN_COMPLETE_SETUP: "Aby dokończyć ustawienie SuperOffice Gmail Link, musisz zalogować się do programu SuperOffice.",
    LOGIN_ONSITE: "Zaloguj się do zainstalowanego lokalnie programu SuperOffice CRM Onsite.",
    LOGOUT_FROM_SUPEROFFICE_1: "Wyloguj się z programu SuperOffice i zamknij wszystkie otwarte karty SuperOffice.",
    LOGOUT_FROM_SUPEROFFICE_2: "Podczas następnego logowania na konto SuperOffice CRM Online, nowe połączenie zostanie automatycznie ustawione.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Ustaw ten adres e-mail jako główny",
    MARK_COMPLETED: "Oznacz jako zakończone",
    MARK_REMOVE_FROM_INBOX: "Usuń ze skrzynki odbiorczej",
    MENU_ARCHIVE_EMAIL: "Archiwizuj wiadomości e-mail",
    MENU_CREATE_APPOINTMENT: "Utwórz działanie",
    MENU_CREATE_NEW_SALE: "Utwórz nową sprzedaż",
    MENU_SAVE_TO_SUPEROFFICE: "Zapisz w SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Kontakt nie ma adresu e-mail",
    MIDDLENAME: "Drugie imię",
    MISSING_REQUIRED_VALUES_INTRO: "Niektóre pola obowiązkowe są niedostępne dla Twojego konta użytkownika:",
    ML_ADD_COMPANY: "Dodaj firmę",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Dodaj e-mail do kontaktu",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Dodaj nową firmę i kontakt",
    ML_ADD_NEW_CONTACT_PERSON: "Dodaj nowy kontakt",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Zarchiwizuj tę wiadomość e-mail jako spotkanie w swoim kalendarzu",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Zarchiwizuj wiadomość e-mail w programie SuperOffice na karcie firmy nadawcy",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Kliknij, aby dodać do SuperOffice",
    ML_COMPANY_DETAILS: "Informacje o firmie",
    ML_CONTACT_DETAILS: "Dane kontaktowe",
    ML_CREATE_A_NEW_SALE: "Utwórz nową sprzedaż dla tego klienta",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Odłącz Outlook od SuperOffice",
    ML_INVITATION_OPTIONS: "Zaproszenia",
    ML_MOVE_INTO_CS_AS_REQUEST: "Dodaj tę wiadomość e-mail do działu obsługi klienta jako nowe żądanie",
    ML_OR_ADD_CONTACT_TO_COMPANY: "LUB DODAĆ OSOBĘ KONTAKTOWĄ DO FIRMY?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Osoby wymienione w tej wiadomości",
    ML_PERSON_COULD_BE: "Ten kontakt może być",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Wyszukaj dla osoby lub firmy...",
    ML_SETTINGS_INVITATIONS_HEADER: "Zaproszenia z SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Dodaj/zaktualizuj spotkanie w SuperOffice po wysłaniu odpowiedzi na zaproszenie z Outloooka",
    MOBILE: "Tel. kom.",
    MORE: "Więcej",
    MRMS: "Pan/Pani",
    MULTIPLE_EMAILADDRESSES_FOUND: "Ten adres e-mail został zarejestrowany w kilku kontaktach w programie SuperOffice. Kliknij tutaj, aby wybrać odpowiedni kontakt do zarchiwizowania.",
    MYPROFILE: "Mój profil",
    NO_RESULTS: "Brak wyników",
    NOTE_CONTACT_DATA_PREDICTED: "Na podstawie zawartości wiadomości e-mail zasugerowaliśmy szczegóły dotyczące tego nadawcy. Sprawdź przed utworzeniem kontaktu.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Upewnij się, że wprowadzona nazwa użytkownika i hasło są prawidłowe.",
    ONSITE_CONNECTION_SUCCESSFUL: "Gratulacje. SuperOffice Gmail Link został pomyślnie podłączony do zainstalowanego lokalnie programu SuperOffice CRM Onsite.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Przed kontynuowaniem, sprawdź, czy jesteś zalogowany do lokalnej instalacji programu.",
    ONSITE_ERROR_LINE_1: "Podczas procesu logowania wystąpiły problemy.",
    ONSITE_ERROR_LINE_2: "Upewnij się, że wprowadzony adres URL serwera jest prawidłowy. Kliknij na przycisk informacji, aby dowiedzieć się, jak go uzyskać.",
    ONSITE_PASSWORD: "Hasło:",
    ONSITE_SERVER_URL: "Adres URL serwera:",
    ONSITE_SERVER_URL_LINE_1: "W programie SuperOffice CRM wybierz w menu głównym opcję Kopiuj skrót",
    ONSITE_SERVER_URL_LINE_2: "Następnie wklej skopiowaną zawartość w tym miejscu adresu URL serwera",
    ONSITE_URL: "Adres URL do lokalnej instalacji SuperOffice CRM Onsite:",
    ONSITE_USER_NAME: "Nazwa użytkownika:",
    OPEN_IN_CRM: "Otwórz w CRM",
    OR_UPPER: "LUB",
    OUR_CONTACT: "Nasz kontakt",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Jeśli później zmienisz zdanie, otwórz ponownie dodatek SuperOffice for Outlook na ekranie kalendarza",
    PERMISSION_CONTINUE: "Kliknij „Kontynuuj”, aby otworzyć nowe okno i nadać wymagane uprawnienia",
    PERMISSION_FOR_CALENDAR: "SuperOffice for Outlook wymaga Twojej zgody na dostęp do elementów kalendarza.",
    PICKER_BCC: "UDW",
    PICKER_CC: "DW",
    PICKER_CC_COPY: "DW",
    PICKER_TO: "Do",
    PLACE_REQUEST_IN_QUEUE: "Umieść żądanie w tej kolejce:",
    POPUP__BOTTOM_TEXT: "Zezwól na wyskakujące okienka dla tej stronie i spróbuj ponownie.",
    POPUP__HEADER: "Wykryto blokadę wyskakujących okienek",
    POPUP__MID_TEXT: "Aplikacja SuperOffice dla programu Outlook wymaga uwierzytelnienia, ale uniemożliwia to blokada wyskakujących okienek przeglądarki.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Usuń ze skrzynki odbiorczej",
    REMOVE_FROM_INBOX_DESC: "Przenosi wiadomości e-mail do folderu „Usunięte” po zarchiwizowaniu",
    REQUEST: "Żądanie",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Ta wiadomość e-mail jest za duża, aby dodać ją do żądania.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "Wiadomość e-mail jest za duża",
    REQUEST_PRIORITY: "Priorytet",
    REQUEST_QUEUE: "Kolejka żądań",
    RESET_ALL: "Resetuj wszystko",
    RESET_INFO_SOFO: "Czy chcesz zresetować informacje w aplikacji SuperOffice for Outlook? Spowoduje to usunięcie bieżących danych.",
    REVISION_LABEL: "Wersja:",
    SEARCH_FAILED: "Wyszukiwanie nie powiodło się. Spróbuj ponownie.",
    SETTINGS: "Ustawienia",
    SETTINGS_ApplyArchiveStatus: "Zastosuj kategorię archiwum",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Wyłącznie odbiorcy zewnętrzni",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Odbiorcy zewnętrzni to osoby spoza Twojej organizacji.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Przekierowania",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Przypomnienie dotyczące archiwum",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Przypomnienie o archiwizacji pomaga upewnić się, że wiadomości e-mail i spotkania zostaną zapisane w programie SuperOffice przed ich wysłaniem.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Otrzymasz przypomnienie o archiwizacji spotkań w SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Przypominaj mi przed wysłaniem spotkań",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Nowe wiadomości e-mail",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Odpowiedzi",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Otrzymasz przypomnienie o archiwizacji wiadomości e-mail w SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Przypominaj mi przed wysłaniem e-maili",
    SETTINGS_CategoryColor: "Kolor kategorii",
    SETTINGS_CategoryName: "Nazwa kategorii",
    SETTINGS_CategoryNameFixedInfo: "Nazwa kategorii jest stała i nie można jej zmienić.",
    SETTINGS_CategoryTaggingDescription: "Użyj kategorii programu Outlook, aby zidentyfikować wiadomości e-mail, które zostały już zarchiwizowane w SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "Status archiwum wiadomości e-mail pomaga sprawdzić bezpośrednio w skrzynce pocztowej programu Outlook, które wiadomości e-mail zostały już zapisane w programie SuperOffice.",
    SETTINGS_CategoryTaggingSection: "Status archiwum wiadomości e-mail",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Domyślny typ czynności",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Domyślny typ wiadomości e-mail",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Poczta przychodząca",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Poczta wychodząca",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Domyślny szablon przychodzących wiadomości e-mail",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Domyślny szablon wychodzących wiadomości e-mail",
    SETTINGS_EnableCategoryForSharedMailbox: "We wspólnych skrzynkach pocztowych",
    SETTINGS_EnableCategoryOnOpen: "Podczas otwierania zarchiwizowanych wiadomości e-mail",
    SETTINGS_EnableCategoryOnSendAndArchive: "Podczas korzystania z funkcji „Wyślij i zarchiwizuj”",
    SETTINGS_EnableCategoryTagging: "Wyświetl kategorię archiwum w programie Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Pokaż projekty i sprzedaże kontekstowe",
    SETTINGS_GENERAL_HEADER: "Ogólne",
    SETTINGS_SharedMailboxCategoryInfo: "Aby wyświetlić status archiwum, należy utworzyć kategorię archiwum we wspólnej skrzynce pocztowej.",
    SETTINGS_SharedMailboxCategoryInfoBold: "W przypadku wspólnych skrzynek pocztowych:",
    SETTINGS_SharedMailboxCategoryLearnMore: "Dowiedz się więcej o konfiguracji wspólnej skrzynki pocztowej",
    SETTINGS_YOURCOMPANY: "Nazwa firmy:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Archiwizuj i wyślij",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Wybierz kontakt lub firmę, którą chcesz zarchiwizować.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Ten e-mail jest gotowy do wysłania, ale nie może zostać zarchiwizowany w SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Archiwum",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Ten e-mail jest gotowy do wysłania, ale nie jest skonfigurowany do zarchiwizowania w SuperOffice. Zarchiwizuj teraz, aby powiązać historię komunikacji z właściwą firmą lub kontaktem, bądź wyślij wiadomość bez archiwizowania.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Podczas ładowania ustawień wystąpił problem.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Przed otwarciem ustawień zaloguj się do programu SuperOffice",
    SR_ADMIN_MYAPPS: "Moje aplikacje",
    SR_ALL_ITEM: "Wszystkie",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Czy na pewno chcesz wyłączyć logowanie biometryczne? Następnym razem wymagane będzie ponowne, ręczne zalogowanie.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Kopiowanie do schowka nie powiodło się",
    SR_NO_SELECTION: "(Brak wyboru)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Zacznij za pomocą kilku kliknięć",
    SYNCHRONIZER_REACTIVATE: "Aktywuj ponownie za pomocą kilku kliknięć",
    SYNCRONIZER_MSG_CONTENT: "Zsynchronizuj swój kalendarz Outlook i zadania z SuperOffice CRM, aby aktualizować spotkania, kontakty, projekty i sprzedaż.",
    SYNCRONIZER_NEED_AUTHENTICATION: "Synchronizacja kalendarza SuperOffice z programem Outlook jest prawie skonfigurowana. Kontynuuj aktywację i synchronizuj kalendarze.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "Synchronizacja kalendarza SuperOffice z programem Outlook jest obecnie przerwana. Kontynuuj ponowną aktywację i synchronizuj kalendarze.",
    TAB_ACTION: "Akcja",
    TAB_PEOPLE: "Osoby",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Działanie zostało utworzone w programie SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Działanie zostało utworzone w programie SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "Serwer zbyt długo nie odpowiadał. Spróbuj ponownie.",
    TIMEOUT_ERROR_TITLE: "Przekroczono limit czasu żądania",
    TITLE: "Tytuł",
    UNDO: "Cofnij",
    UNKNOWN_EMAIL_ADDRESS: "Nieznany adres e-mail.",
    UNKNOWN_EMAILADDRESS: "Nie rozpoznano adresu e-mail nadawcy. Kliknij tutaj, aby dodać ten adres e-mail do programu SuperOffice.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Nie rozpoznano adresu e-mail odbiorcy. Kliknij tutaj, aby zaktualizować program SuperOffice tym adresem e-mail.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Nieznany adres e-mail. Dodaj {0} do programu SuperOffice.",
    UNLOCK_THESE_FEATURES: "Odblokuj te funkcje za pomocą synchronizatora",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.com/crm/demo/",
    VERSION_SHORT: "wer.",
    VISIT_APP_STORE: "Odwiedź App Store",
    WE_RUN_ONLINE_LINE_1: "Aby ustalić, czy uruchamiasz wersję Online, wykonaj następujące czynności:",
    WE_RUN_ONLINE_LINE_2: "1. W programie SuperOffice CRM wybierz menu „Pomoc”, a następnie „Informacje”",
    WE_RUN_ONLINE_LINE_3: "2. Spójrz na wpis dla NetServer:",
    WE_RUN_ONLINE_LINE_4: "Jeśli jest tam wyświetlana informacja „SuperOffice CRM Online ...”, uruchamiasz wersję Online",
    WE_RUN_ONSITE_LINE_1: "Aby ustalić, czy uruchamiasz wersję Onsite, wykonaj następujące czynności:",
    WE_RUN_ONSITE_LINE_4: "Jeśli jest tam wyświetlana informacja „SuperOffice CRM OnSite ...”, uruchamiasz wersję Onsite",
    YOU_CAN_STILL_USE: "Nadal możesz używać aplikacji SuperOffice for Outlook do wysyłania wiadomości e-mail!",
  },
  SV: {
    ACTION_ADD: "Lägg till",
    ACTION_BACK: "Tillbaka",
    ACTIVITIES: "Aktiviteter",
    ADD_ATTENDEES: "Bjud in kontakt från SuperOffice.",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Lägg till e-postadress för befintlig kontakt",
    AI_SUMMARY_AI_NOT_ENABLED: "AI-textfunktionerna är inte aktiverade för din organisation. Kontakta din SuperOffice-administratör.",
    AI_SUMMARY_APPEND: "Lägg till",
    AI_SUMMARY_FEATURE_DISABLED: "Den här funktionen har inaktiverats för din organisation.",
    AI_SUMMARY_GENERATE: "Generera",
    AI_SUMMARY_GENERATE_ERROR: "Det gick inte att skapa en sammanfattning just nu. Försök igen.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Skapa en AI-sammanfattning",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Deltagare:",
    AI_SUMMARY_HEADER_SUBJECT: "Ämne:",
    AI_SUMMARY_LOADING: "Sammanfattning skapas…",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Du har inte behörighet att använda AI-funktionerna",
    AI_SUMMARY_NO_PERMISSION: "Du har inte behörighet att läsa det här e-postmeddelandet.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "Det finns inget att sammanfatta i det här e-postmeddelandet.",
    AI_SUMMARY_REPLACE_CONFIRM: "Ersätt",
    ALREADY_ARCHIVED_ATTACHMENT: "Bilagan har redan arkiverats av <%- archivedBy %> den <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "E-posten har redan arkiverats av <%- archivedBy %> den <%- archivedAt %>.\n",
    ALREADY_ARCHIVED_SALE: "En försäljning har redan skapats för den här e-postadressen av <%- archivedBy %> den <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "Aktiviteten har redan skapats för den här e-postadressen av <%- archivedBy %> den <%- archivedAt %>.",
    ALREADY_DONE: "Redan gjort",
    APPOINTMENT_EXISTS_IN_CRM: "Denna bokning finns i CRM och skapades av <%- createdBy %> den <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Skapa aktivitet",
    ARCHIVE_ALWAYS_SHOW: "Visa alltid dialogruta för arkivering",
    ARCHIVE_AS_ACTIVITY: "Skapa bokning i SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Spara bilaga i SuperOffice",
    ARCHIVE_AS_REQUEST: "Skapa ärende i SuperOffice",
    ARCHIVE_AS_SALE: "Skapa försäljning i SuperOffice",
    ARCHIVE_AS_TASK: "Skapa en uppgift i SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Ta bort e-post från inkorg som standard efter aktivering",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Inkludera malltyper som inte är e-post i mallistan",
    ATTACHMENT_SIZE_INFO: "Bilagorna är för stora och kan inte arkiveras. Endast e-postmeddelanden utan bilagor kan arkiveras.",
    AUTH__BOTTOM_TEXT_1: "\u2028Behöver du mer information?",
    AUTH__BOTTOM_TEXT_2: "Lär dig hur du godkänner tillägget",
    AUTH__BUTTON: "Kopiera administratörslänk",
    AUTH__COPIED: "Kopierat till Urklipp",
    AUTH__HEADER: "SuperOffice för Outlook-uppdatering",
    AUTH__INCREMENTAL_TEXT_1: "För att aktivera {feature} krävs ytterligare behörigheter.",
    AUTH__MID_TEXT_1: "För att uppfylla Microsofts senaste säkerhetskrav har Outlook-tillägget uppdaterats.",
    AUTH__MID_TEXT_2: "För att fortsätta använda den måste <b>en Microsoft 365 Global Administrator ge behörighet</b> (samtycke) för alla användares räkning.",
    AUTH__MID_TEXT_3: "<b>Dela den här länken med din Microsoft 365-administratör:",
    AUTH__NEW_USER_TEXT_1: "Tillägget SuperOffice för Outlook kräver ytterligare behörigheter för att komma åt data i Microsoft 365.",
    AUTH_IN_PROGRESS__HEADER: "Auktorisation pågår",
    AUTH_IN_PROGRESS__MID_TEXT: "Fortsätt med den interaktiva autentisering som pågår och försök igen.",
    AUTOSAVE_FAIL: "Informationen har inte sparats.",
    AUTOSAVE_IN_PROGRESS: "Sparar…",
    AUTOSAVE_RETRY: "Försök igen",
    AUTOSAVE_SUCCESS: "Sparat",
    BANNER_ADD_MESSAGE: "Meddelande skapat.",
    BANNER_CREATE_APPOINTMENT: "Bokning skapad.",
    BANNER_CREATE_REQUEST: "Ärende skapat.",
    BANNER_CREATE_SALE: "Försäljning skapad.",
    BANNER_CREATE_TASK: "Uppgift skapad.",
    BANNER_SAVE_ATTACHMENT: "Bilagan sparades.",
    BANNER_SAVE_TO_SUPEROFFICE: "E-postmeddelandet sparades.",
    BANNER_VIEW_IN_CRM: "Visa i CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Lägg till meddelande till ärende",
    BTN_ADD_TO_SUPEROFFICE: "Registrera i SuperOffice",
    BTN_ARCHIVE: "Arkivera",
    BTN_CANCEL: "Avbryt",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Klicka här om du vill lägga till ny kontakt",
    BTN_CONNECT: "Anslut",
    BTN_CONNECT_TO_SUPEROFFICE: "Vi kör SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Vi kör SuperOffice Onsite",
    BTN_CREATE: "Skapa",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Skapa nytt företag och ny kontakt",
    BTN_GO_TO_SUPEROFFICE: "Visa i SuperOffice",
    BTN_KEEP_CONTACT: "Behåll",
    BTN_LOGIN: "Inloggning",
    BTN_LOOKUP_SENDER: "Sök på avsändare",
    BTN_OK: "OK",
    BTN_RECONNECT: "Byt SuperOffice-användare",
    BTN_SAVE: "Spara",
    BTN_SAVE_AND_ARCHIVE: "Skicka och arkivera",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Registrera dig för en gratis provperiod",
    BTN_UPDATE_CONTACT: "Uppdatera",
    BUSINESS: "Bransch",
    BUTTON_LETS_GO: "Låt oss komma igång",
    BUTTON_RELOAD: "Läs in igen",
    CAN_NOT_GRANT_PERMISSION: "Kan du inte ge tillstånd?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Det går inte att lägga till ett meddelande i ärendet eftersom den bifogade filen kan vara osäker",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Bilagor kan inte arkiveras eftersom vissa av dem kan innehålla skadlig kod. Endast e-postmeddelanden utan bilagor kan arkiveras.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Kan inte spara en digitalt signerad bilaga",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Det här e-postmeddelandet har signerats digitalt. Bilagor i signaturen kan inte sparas separat.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Det går inte att aktivera eftersom bifogade filer kan vara osäkra",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Det går inte att skapa begäran eftersom den bifogade filen kan vara osäker",
    CANNOT_SAVE_CONTACT: "Det går inte att spara kontakten",
    CATEGORY: "Kategori  ",
    CHANGES_SAVED_AUTOMATICALLY: "Dina ändringar sparas automatiskt",
    CHOOSE_ONE_OR_CONTINUE: "Välj en för att fortsätta.",
    CLICK_HERE_TO_SEE_IT: "Klicka här för att visa den.",
    CLICK_HERE_TO_SELECT_CONTACT: "Välj kontakt",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Klicka här för att välja rätt kontakt för arkivering.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} till. Klicka här för att visa alla.",
    CLICK_LOGIN_ONSITE: "Klicka här för att öppna SuperOffice-installationen i en ny flik.",
    COMMENT_PLACEHOLDER: "Lägg till en kommentar…",
    COMPANY_NAME: "Företagsnamn",
    CONNECT_ONSITE: "Anslut till SuperOffice CRM Onsite-installationen",
    CONNECT_TO_SUPEROFFICE: "Koppla till ditt SuperOffice CRM Online-konto",
    CONTACT_ADMINISTRATOR: "Kontakta din SuperOffice-administratör för att granska din CRM-konfiguration.",
    CONTINUE: "Fortsätt",
    COULD_IT_BE_ONE_OF_THESE: "Är det en av dessa?",
    COUNTRY: "Land",
    CREATE_NEW_COMPANY: "Skapa nytt företag",
    CREATE_NEW_CONTACT: "Skapa ny kontakt",
    CREATE_REQUEST: "Skapa ärende",
    CREATED_REQUEST: "Ärendet har skapats",
    DEPARTMENT: "Avdelning",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Arkivera inte bifogade filer",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Bilagor arkiveras som standard",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-post har arkiverats i SuperOffice.",
    EMAIL_ADDRESS: "E-post",
    EMAIL_ADDRESS_NOT_REGISTERED: "Den här e-postadressen finns inte i SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> har registrerats för flera kontakter i SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-post registrerad i SuperOffice",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "E-postadressen har registrerats för flera kontakter i SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Aktivera arkivering för att redigera dessa inställningar",
    ERROR: "Fel",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Kan inte lägga till e-postadress i SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Kan inte arkivera bilaga.",
    ERROR_ARCHIVING_EMAIL: "Kan inte arkivera e-post.",
    ERROR_ARCHIVING_REQUEST: "Kan inte arkivera ärende.",
    ERROR_ARCHIVING_TASK: "Kan inte skapa aktivitet.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Kan inte kommunicera med SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Du har inte behörighet att skapa företag eller kontakter i SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Hitta företag eller kontakt ...",
    FIRST_ATTENDEE_CHANGED: "Möteskontakten har ändrats.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Välj vilken kontakt som mötet ska kopplas till.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Kontaktuppgifterna och mötesdeltagaren överensstämmer inte",
    FIRSTNAME: "Förnamn",
    FOLLOWUPS: "Händelser",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice för Outlook kunde inte ansluta till Microsofts tjänster. Vänligen försök igen om en liten stund.",
    GRAPH_API_ERROR_TITLE_SOFO: "Microsofts tjänster är inte tillgängliga just nu",
    HEADER_ADD_EMAIL: "Lägg till e-post/kontakt: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Lägg till e-postadress i SuperOffice",
    HEADER_ADD_RECPIENTS: "Lägg till mottagare från SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Lägg till för befintlig kontakt",
    HEADER_ARCHIVE_APPOINTMENT: "Skapa aktivitet",
    HEADER_ARCHIVE_ATTACHMENT: "Arkivera bilaga som ett SuperOffice-dokument",
    HEADER_ARCHIVE_EMAIL: "Arkivera e-post i SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Koppla till en annan SuperOffice-installation",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Skapa aktivitet i SuperOffice utifrån e-post",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Spara bilagor från det här e-postmeddelandet i SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Arkivera det här meddelandet i SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Skapa ärende i SuperOffice utifrån e-post",
    HEADER_CREATE_EMAIL_AS_SALE: "Skapa försäljning i SuperOffice utifrån det här e-postmeddelandet",
    HEADER_CREATE_EMAIL_AS_TASK: "Skapa en uppgift i din checklista baserat på e-postmeddelande",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Skapa ny företag och kontakt",
    HEADER_CREATE_NEW_PERSON: "Skapa ny kontakt",
    HEADER_WELCOME: "Välkommen",
    LABEL_ACHIEVE_MORE: "Uppnå mer med integrering",
    LABEL_ADD_TO_EXISTING_REQUEST: "Lägg till e-postmeddelandet som meddelande i ett befintligt ärende i SuperOffice",
    LABEL_ARCHIVE_FILE: "Arkivera fil:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Bilagan har redan sparats",
    LABEL_ATTACHMENT_NOT_SAVED: "Bilagan har inte sparats",
    LABEL_COMMENT: "Kommentar:",
    LABEL_COMPANYPHONE: "Telefon (företag):",
    LABEL_CONTACT: "Företag",
    LABEL_CONTACT_OR_COMPANY: "Kontakt eller Företag:",
    LABEL_CREATE_AND_VISUALIZE: "Skapa och visualisera som ett proffs",
    LABEL_CURRENCY: "Valuta",
    LABEL_DATE: "Datum:",
    LABEL_DESCRIPTION: "Beskrivning:",
    LABEL_DIRECTPHONE: "Direktnr:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Se vad detta tillägg kan göra för dig idag!",
    LABEL_HOME_ADDRESS: "Privat:",
    LABEL_MOBILEPHONE: "Mobiltelefon:",
    LABEL_NOTES: "Anteckningar:",
    LABEL_NUMBER: "Nummer:",
    LABEL_OPTIONAL_ATTENDEE: "Valfritt",
    LABEL_PERSON: "Kontakt:",
    LABEL_POSITION: "Befattning:",
    LABEL_PROJECT: "Projekt:",
    LABEL_REQUIRED_ATTENDEE: "Krävs",
    LABEL_SALE: "Försäljning:",
    LABEL_SALE_AMOUNT: "Försäljningsbelopp:",
    LABEL_SALE_DATE: "Försäljningsdatum:",
    LABEL_SALE_NAME: "Försäljningsnamn:",
    LABEL_SALE_TYPE: "Försäljningstyp:",
    LABEL_SAVED_CHANGES: "Dina ändringar har sparats.",
    LABEL_SELECT_CS_QUEUE: "Placera ärendet i den här kön:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Välj kö",
    LABEL_SERVER_VERSION: "Serverversion:",
    LABEL_SUBJECT: "Rubrik:",
    LABEL_SUPEROFFICE_SITE: "SuperOffice-adress:",
    LABEL_TELEPHONE: "Telefon:",
    LABEL_TIME: "Kl:",
    LABEL_TYPE: "Typ:",
    LABEL_UNLOCK_FEATURES: "Lås upp funktioner och funktionalitet",
    LABEL_URL: "Webbadress",
    LABEL_USER: "Användare:",
    LABEL_VISIBLE_FOR: "Synlig för:",
    LABEL_WEB_PAGE: "Webbadress:",
    LASTNAME: "Efternamn",
    LEARN_MORE: "Läs mer",
    LOGIN_COMPLETE_SETUP: "Du måste logga in på SuperOffice för att slutföra konfigurationen av SuperOffice Gmail Link.",
    LOGIN_ONSITE: "Logga in på SuperOffice CRM Onsite-installationen.",
    LOGOUT_FROM_SUPEROFFICE_1: "Logga ut från SuperOffice och stäng eventuella öppna SuperOffice-flikar.",
    LOGOUT_FROM_SUPEROFFICE_2: "Nästa gång du loggar in på SuperOffice CRM Online ställs den nya anslutningen in automatiskt.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Ange som primär e-postadress.",
    MARK_COMPLETED: "Markera som utförd",
    MARK_REMOVE_FROM_INBOX: "Ta bort från Inkorgen",
    MENU_ARCHIVE_EMAIL: "Arkivera e-post",
    MENU_CREATE_APPOINTMENT: "Skapa aktivitet",
    MENU_CREATE_NEW_SALE: "Skapa ny försäljning",
    MENU_SAVE_TO_SUPEROFFICE: "Spara i SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Kontakten har ingen e-postadress",
    MIDDLENAME: "Mellannamn",
    MISSING_REQUIRED_VALUES_INTRO: "Vissa obligatoriska fält är inte tillgängliga för ditt användarkonto:",
    ML_ADD_COMPANY: "Lägg till företag",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Lägg till e-postadress för kontakt",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Lägg till nytt företag och ny kontakt",
    ML_ADD_NEW_CONTACT_PERSON: "Lägg till ny kontakt",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Arkivera e-postmeddelandet som en bokning i din kalender",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Arkivera e-postmeddelande i SuperOffice på avsändarens företagskort",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Klicka för att lägga till i SuperOffice",
    ML_COMPANY_DETAILS: "Företagsinformation",
    ML_CONTACT_DETAILS: "Kontaktinformation",
    ML_CREATE_A_NEW_SALE: "Skapa en ny försäljning för den här kunden",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Koppla från Outlook från SuperOffice",
    ML_INVITATION_OPTIONS: "Förfrågningar",
    ML_MOVE_INTO_CS_AS_REQUEST: "Lägg till e-postmeddelandet som nytt ärende i Customer Service",
    ML_OR_ADD_CONTACT_TO_COMPANY: "ELLER LÄGG TILL KONTAKT TILL FÖRETAG?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Personer som nämns i detta meddelande",
    ML_PERSON_COULD_BE: "Den här kontakten kan vara",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Sök efter kontakt eller företag…",
    ML_SETTINGS_INVITATIONS_HEADER: "Förfrågningar för SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Lägg till/uppdatera bokning i SuperOffice när du svarar på förfrågningar i Outlook.",
    MOBILE: "Mobil",
    MORE: "Mer",
    MRMS: "Hr/Fr",
    MULTIPLE_EMAILADDRESSES_FOUND: "E-postadressen har registrerats för flera kontakter i SuperOffice. Klicka här för att välja rätt kontakt för arkivering.",
    MYPROFILE: "Min profil",
    NO_RESULTS: "Inga träffar",
    NOTE_CONTACT_DATA_PREDICTED: "Baserat på innehållet i detta e-postmeddelande har vi föreslagit detaljer för denna avsändare. Kontrollera innan du skapar den här kontakten.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Kontrollera att användarnamnet och lösenordet som du har angett är korrekta.",
    ONSITE_CONNECTION_SUCCESSFUL: "Gratulerar. SuperOffice Gmail Link har anslutit till SuperOffice CRM Onsite-installationen.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Kontrollera att du är inloggad i Onsite-installationen innan du fortsätter.",
    ONSITE_ERROR_LINE_1: "Det uppstod några problem under inloggningsprocessen.",
    ONSITE_ERROR_LINE_2: "Kontrollera att du har angett rätt server-URL. Klicka på informationsknappen för att läsa mer om hur du får den.",
    ONSITE_PASSWORD: "Lösenord:",
    ONSITE_SERVER_URL: "Server-URL:",
    ONSITE_SERVER_URL_LINE_1: "I SuperOffice CRM väljer du Kopiera genväg i huvudmenyn",
    ONSITE_SERVER_URL_LINE_2: "Klistra sedan in genvägen i serverns URL här",
    ONSITE_URL: "URL till SuperOffice CRM Onsite-installationen:",
    ONSITE_USER_NAME: "Användarnamn:",
    OPEN_IN_CRM: "Öppna i CRM",
    OR_UPPER: "ELLER",
    OUR_CONTACT: "Vår kontakt",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Om du ändrar dig senare, öppna SuperOffice for Outlook-tillägget i kalenderskärmen igen",
    PERMISSION_CONTINUE: "Klicka på ”Fortsätt” för att öppna ett nytt fönster och bevilja nödvändiga behörigheter",
    PERMISSION_FOR_CALENDAR: "SuperOffice for Outlook behöver din behörighet för att komma åt dina kalenderobjekt.",
    PICKER_BCC: "Hemlig kopia",
    PICKER_CC: "FF",
    PICKER_CC_COPY: "FF",
    PICKER_TO: "Till",
    PLACE_REQUEST_IN_QUEUE: "Placera ärendet i den här kön.",
    POPUP__BOTTOM_TEXT: "Tillåt popup-fönster för den här sidan och försök igen.",
    POPUP__HEADER: "Popup-blockerare upptäckt",
    POPUP__MID_TEXT: "SuperOffice för Outlook behöver autentisera, men din webbläsares popup-blockerare förhindrar detta.",
    PRODUCT_NAME: "SuperOffice Gmail Link",
    REMOVE_FROM_INBOX: "Ta bort från inkorgen",
    REMOVE_FROM_INBOX_DESC: "Flyttar e-postmeddelanden till mappen ”Borttagna objekt” efter arkivering",
    REQUEST: "Ärende",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Det här e-postmeddelandet är för stort för att läggas till i ett ärende.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "E-postmeddelandet är för stort",
    REQUEST_PRIORITY: "Prioritet",
    REQUEST_QUEUE: "Ärendekö:",
    RESET_ALL: "Återställ alla",
    RESET_INFO_SOFO: "Vill du återställa informationen i SuperOffice för Outlook? Detta kommer att ta bort aktuella data.",
    REVISION_LABEL: "Revision:",
    SEARCH_FAILED: "Sökningen misslyckades. Försök igen.",
    SETTINGS: "Inställningar",
    SETTINGS_ApplyArchiveStatus: "Tillämpa arkivkategori",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Endast externa mottagare",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Externa mottagare är personer utanför din organisation.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Vidarebefordrat",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Påminnelse om arkivet",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Arkiveringspåminnelsen bidrar till att e-postmeddelanden och möten sparas i SuperOffice innan de skickas.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Du kommer att få en påminnelse om att arkivera möten i SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Påminn mig innan jag skickar möten",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Nya e-postmeddelanden",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Svar",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Du kommer att få en påminnelse om att arkivera e-postmeddelanden i SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Påminn mig innan jag skickar e-postmeddelanden",
    SETTINGS_CategoryColor: "Kategorifärg",
    SETTINGS_CategoryName: "Kategorinamn",
    SETTINGS_CategoryNameFixedInfo: "Kategorinamnet är fast och kan inte ändras.",
    SETTINGS_CategoryTaggingDescription: "Använd en Outlook-kategori för att identifiera e-postmeddelanden som redan har arkiverats i SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "Status för e-postarkivet hjälper dig att se vilka e-postmeddelanden som redan har sparats i SuperOffice, direkt i din Outlook-postlåda.",
    SETTINGS_CategoryTaggingSection: "Status för e-postarkivet",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Standardaktivitetstyp",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Standardtyp för e-post",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Inkommande e-post",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Utgående e-post",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Standardmall för inkommande e-post",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Standardmall för utgående e-post",
    SETTINGS_EnableCategoryForSharedMailbox: "I delade brevlådor",
    SETTINGS_EnableCategoryOnOpen: "När du öppnar arkiverade e-postmeddelanden",
    SETTINGS_EnableCategoryOnSendAndArchive: "När du använder funktionen ”Skicka och arkivera”",
    SETTINGS_EnableCategoryTagging: "Visa arkivkategorin i Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Visa kontextbaserade projekt och försäljning",
    SETTINGS_GENERAL_HEADER: "Allmänt",
    SETTINGS_SharedMailboxCategoryInfo: "För att arkivstatusen ska visas måste arkivkategorin ha skapats i den delade postlådan.",
    SETTINGS_SharedMailboxCategoryInfoBold: "För delade brevlådor",
    SETTINGS_SharedMailboxCategoryLearnMore: "Läs mer om hur man konfigurerar en delad postlåda",
    SETTINGS_YOURCOMPANY: "Företagsnamn:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Arkivera och skicka",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Välj en kontakt eller ett företag som du vill arkivera.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "Det här e-postmeddelandet är klart att skicka, men det kan inte arkiveras i SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Arkiv",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Det här e-postmeddelandet är klart att skicka, men det är inte inställt på att arkiveras i SuperOffice. Arkivera det nu så att meddelandet sparas under rätt företag eller kontakt, eller skicka det utan att arkivera.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Något gick fel vid laddning av inställningar.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Logga in på SuperOffice innan du öppnar inställningar.",
    SR_ADMIN_MYAPPS: "Mina appar",
    SR_ALL_ITEM: "Alla",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Är du säker på att du vill inaktivera biometrisk inloggning? Nästa gång kommer du att behöva logga in manuellt igen.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Det gick inte att kopiera till Urklipp",
    SR_NO_SELECTION: "(Välj ingen)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Kom igång med några klick",
    SYNCHRONIZER_REACTIVATE: "Återaktivera med några klick",
    SYNCRONIZER_MSG_CONTENT: "Synkronisera din Outlook-kalender och dina uppgifter med SuperOffice CRM för att hålla möten, kontakter, projekt och försäljning uppdaterade.",
    SYNCRONIZER_NEED_AUTHENTICATION: "SuperOffice Kalendersynkronisering med Outlook är nästan klar. Fortsätt att aktivera den och håll dina kalendrar synkroniserade.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "Din SuperOffice-kalendersynkronisering med Outlook har avbrutits. Fortsätt att återaktivera och hålla dina kalendrar synkroniserade.",
    TAB_ACTION: "Åtgärd",
    TAB_PEOPLE: "Människor",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Aktiviteten har skapats i SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Aktiviteten har skapats i SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "Servern dröjde för länge med att svara. Försök igen.",
    TIMEOUT_ERROR_TITLE: "Tidsgränsen för begäran har överskridits",
    TITLE: "Titel",
    UNDO: "Ångra",
    UNKNOWN_EMAIL_ADDRESS: "Okänd e-postadress.",
    UNKNOWN_EMAILADDRESS: "Avsändarens e-postadress är inte registrerad. Klicka här för att lägga till den i SuperOffice. ",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Mottagarens e-postadress är inte registrerad. Klicka här för att uppdatera SuperOffice med denna adress. ",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Okänd e-postadress. Lägg till {0} i SuperOffice.",
    UNLOCK_THESE_FEATURES: "Lås upp dessa funktioner med synkroniseraren",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.se/crm/demo/",
    VERSION_SHORT: "ver.",
    VISIT_APP_STORE: "Besök App Store",
    WE_RUN_ONLINE_LINE_1: "Så tar du reda på om du kör Online:",
    WE_RUN_ONLINE_LINE_2: "1. Välj Hjälp och sedan Om i SuperOffice CRM",
    WE_RUN_ONLINE_LINE_3: "2. Kontrollera vad det står under NetServer:",
    WE_RUN_ONLINE_LINE_4: "Om det står ”SuperOffice CRM Online ...” kör du Online",
    WE_RUN_ONSITE_LINE_1: "Så tar du reda på om du kör Onsite:",
    WE_RUN_ONSITE_LINE_4: "Om det står ”SuperOffice CRM OnSite ...” kör du Onsite",
    YOU_CAN_STILL_USE: "Du kan fortfarande använda SuperOffice för Outlook för e-post!",
  },
  VI: {
    ACTION_ADD: "Thêm",
    ACTION_BACK: "Trở lại",
    ACTIVITIES: "Các hoạt động",
    ADD_ATTENDEES: "Mời liên hệ từ SuperOffice",
    ADD_EMAIL_ADDRESS_TO_EXISTING: "Thêm địa chỉ e-mail vào người liên hệ hiện có",
    AI_SUMMARY_AI_NOT_ENABLED: "Tính năng văn bản AI không được bật cho tổ chức của bạn. Liên hệ với quản trị viên SuperOffice của bạn.",
    AI_SUMMARY_APPEND: "Thêm vào",
    AI_SUMMARY_FEATURE_DISABLED: "Tính năng này đã bị tắt đối với tổ chức của bạn.",
    AI_SUMMARY_GENERATE: "Tạo",
    AI_SUMMARY_GENERATE_ERROR: "Không thể tạo bản tóm tắt ngay bây giờ. Vui lòng thử lại.",
    AI_SUMMARY_GENERATE_TOOLTIP: "Tạo tóm tắt AI",
    AI_SUMMARY_HEADER_PARTICIPANTS: "Người tham gia:",
    AI_SUMMARY_HEADER_SUBJECT: "Chủ đề:",
    AI_SUMMARY_LOADING: "Đang tạo bản tóm tắt...",
    AI_SUMMARY_NO_LICENSE_TOOLTIP: "Bạn không có giấy phép sử dụng các tính năng AI",
    AI_SUMMARY_NO_PERMISSION: "Bạn không có quyền đọc email này.",
    AI_SUMMARY_NOTHING_TO_SUMMARIZE: "Không có gì để tóm tắt trong email này.",
    AI_SUMMARY_REPLACE_CONFIRM: "Thay thế",
    ALREADY_ARCHIVED_ATTACHMENT: "Tệp đính kèm đã được lưu trữ bởi <%- archivedBy %> trên <%- archivedAt %>.",
    ALREADY_ARCHIVED_EMAIL: "E-mail này đã được lưu trữ bởi <%- archivedBy %> trên <%- archivedAt %>.",
    ALREADY_ARCHIVED_SALE: "Một mục bán hàng đã được tạo cho e-mail này bởi <%- archivedBy %> trên <%- archivedAt %>.",
    ALREADY_ARCHIVED_TASK: "Hoạt động đã được tạo cho e-mail này bởi <%- archivedBy %> trên <%- archivedAt %>.",
    ALREADY_DONE: "Đã hoàn thành",
    APPOINTMENT_EXISTS_IN_CRM: "Cuộc hẹn này đã có trong CRM và được tạo bởi <%- createdBy %> vào ngày <%- creationDate %>.",
    ARCHIVE_ACTIVITY: "Tạo hoạt động",
    ARCHIVE_ALWAYS_SHOW: "Luôn hiển thị hộp thoại lưu trữ",
    ARCHIVE_AS_ACTIVITY: "Tạo cuộc hẹn trong SuperOffice",
    ARCHIVE_AS_ATTACHMENT: "Lưu tệp đính kèm trong SuperOffice",
    ARCHIVE_AS_REQUEST: "Tạo yêu cầu trong SuperOffice",
    ARCHIVE_AS_SALE: "Tạo mục bán hàng trong SuperOffice",
    ARCHIVE_AS_TASK: "Tạo nhiệm vụ trong SuperOffice",
    ARCHIVE_REMOVE_FROM_INBOX: "Xóa e-mail khỏi hộp thư đến sau khi lưu trữ làm mặc định",
    ARCHIVE_SHOW_ALL_TEMPLATES: "Bao gồm các mẫu không phải e-mail trong danh sách mẫu",
    ATTACHMENT_SIZE_INFO: "Tệp đính kèm quá lớn và không thể lưu trữ. Chỉ có thể lưu trữ email không có tệp đính kèm.",
    AUTH__BOTTOM_TEXT_1: "\u2028Cần thêm chi tiết không?",
    AUTH__BOTTOM_TEXT_2: "Tìm hiểu cách ủy quyền phần bổ trợ",
    AUTH__BUTTON: "Sao chép liên kết quản trị viên",
    AUTH__COPIED: "Đã sao chép vào bộ nhớ đệm tạm thời",
    AUTH__HEADER: "Cập nhật SuperOffice cho Outlook",
    AUTH__INCREMENTAL_TEXT_1: "Để bật {feature}, cần có thêm quyền.",
    AUTH__MID_TEXT_1: "Để đáp ứng yêu cầu bảo mật mới nhất của Microsoft, phần bổ trợ Outlook đã được cập nhật.",
    AUTH__MID_TEXT_2: "Để tiếp tục sử dụng, <b>Quản trị viên Toàn cầu Microsoft 365 phải cấp quyền</b> (cho phép) thay mặt cho tất cả người dùng.",
    AUTH__MID_TEXT_3: "<b>Chia sẻ liên kết</b> này với quản trị viên Microsoft 365 của bạn:",
    AUTH__NEW_USER_TEXT_1: "Phần bổ trợ SuperOffice cho Outlook yêu cầu quyền bổ sung để truy nhập dữ liệu Microsoft 365.",
    AUTH_IN_PROGRESS__HEADER: "Đang cấp quyền",
    AUTH_IN_PROGRESS__MID_TEXT: "Vui lòng tiếp tục quá trình xác thực tương tác đang diễn ra và thử lại.",
    AUTOSAVE_FAIL: "Chưa lưu.",
    AUTOSAVE_IN_PROGRESS: "Đang lưu...",
    AUTOSAVE_RETRY: "Thử lại",
    AUTOSAVE_SUCCESS: "Đã lưu",
    BANNER_ADD_MESSAGE: "Đã tạo thư.",
    BANNER_CREATE_APPOINTMENT: "Đã tạo cuộc hẹn.",
    BANNER_CREATE_REQUEST: "Đã tạo yêu cầu.",
    BANNER_CREATE_SALE: "Đã tạo giao dịch bán hàng.",
    BANNER_CREATE_TASK: "Đã tạo nhiệm vụ.",
    BANNER_SAVE_ATTACHMENT: "Đã lưu tệp đính kèm.",
    BANNER_SAVE_TO_SUPEROFFICE: "Đã lưu email.",
    BANNER_VIEW_IN_CRM: "Xem trong CRM",
    BTN_ADD_TO_EXISTING_REQUEST: "Thêm tin nhắn vào yêu cầu",
    BTN_ADD_TO_SUPEROFFICE: "Thêm vào SuperOffice",
    BTN_ARCHIVE: "Lưu trữ",
    BTN_CANCEL: "Hủy",
    BTN_CLICK_TO_ADD_NEW_CONTACT: "Nhấp để thêm người liên hệ mới",
    BTN_CONNECT: "Kết nối",
    BTN_CONNECT_TO_SUPEROFFICE: "Chúng tôi vận hành SuperOffice Online",
    BTN_CONNECT_TO_SUPEROFFICE_ONSITE: "Chúng tôi vận hành SuperOffice Onsite",
    BTN_CREATE: "Tạo",
    BTN_CREATE_NEW_COMPANY_AND_PERSON: "Tạo công ty và người liên hệ mới",
    BTN_GO_TO_SUPEROFFICE: "Đi tới SuperOffice",
    BTN_KEEP_CONTACT: "Giữ",
    BTN_LOGIN: "Đăng nhập",
    BTN_LOOKUP_SENDER: "Tìm kiếm người gửi",
    BTN_OK: "OK",
    BTN_RECONNECT: "Thay đổi người dùng SuperOffice",
    BTN_SAVE: "Lưu",
    BTN_SAVE_AND_ARCHIVE: "Gửi và lưu trữ",
    BTN_SIGN_UP_FOR_FREE_TRIAL: "Đăng ký dùng thử miễn phí",
    BTN_UPDATE_CONTACT: "Cập nhật",
    BUSINESS: "Hoạt động kinh doanh",
    BUTTON_LETS_GO: "Bắt đầu thôi",
    BUTTON_RELOAD: "Tải lại",
    CAN_NOT_GRANT_PERMISSION: "Không thể cấp quyền?",
    CANNOT_ADD_MESSAGE_TO_REQUEST_UNSAFE_ATTACHMENT: "Không thể thêm thư vào yêu cầu vì tệp đính kèm có thể không an toàn",
    CANNOT_ARCHIVE_EMAIL_UNSAFE_ATTACHMENT: "Không thể lưu trữ tệp đính kèm vì một số tệp có thể không an toàn. Chỉ có thể lưu trữ các email không có tệp đính kèm.",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT: "Không thể lưu tệp đính kèm có chữ ký điện tử",
    CANNOT_ARCHIVE_SIGNED_ATTACHMENT_DETAIL: "Email này được ký điện tử. Không thể lưu riêng các tệp đính kèm trong chữ ký.",
    CANNOT_ARCHIVE_UNSAFE_ATTACHMENT: "Không thể lưu trữ vì tệp đính kèm có thể không an toàn",
    CANNOT_CREATE_REQUEST_UNSAFE_ATTACHMENT: "Không thể tạo yêu cầu vì tệp đính kèm có thể không an toàn",
    CANNOT_SAVE_CONTACT: "Không thể lưu liên hệ",
    CATEGORY: "Danh mục",
    CHANGES_SAVED_AUTOMATICALLY: "Các thay đổi của bạn đang được lưu tự động",
    CHOOSE_ONE_OR_CONTINUE: "Vui lòng chọn một hoặc tiếp tục.",
    CLICK_HERE_TO_SEE_IT: "Nhấp vào đây để xem.",
    CLICK_HERE_TO_SELECT_CONTACT: "Chọn người liên hệ",
    CLICK_HERE_TO_SELECT_CONTACT_TO_ARCHIVE_ON: "Nhấp vào đây để chọn người liên hệ phù hợp để lưu trữ.",
    CLICK_HERE_TO_SHOW_MORE: "+{0} khác. Nhấp vào đây để hiển thị tất cả.",
    CLICK_LOGIN_ONSITE: "Nhấp vào đây để mở cài đặt SuperOffice của bạn trong một tab mới.",
    COMMENT_PLACEHOLDER: "Thêm nhận xét...",
    COMPANY_NAME: "Tên công ty",
    CONNECT_ONSITE: "Kết nối với cài đặt SuperOffice CRM Onsite",
    CONNECT_TO_SUPEROFFICE: "Kết nối với tài khoản SuperOffice CRM Online của bạn",
    CONTACT_ADMINISTRATOR: "Liên hệ với quản trị viên SuperOffice để xem lại cấu hình CRM của bạn.",
    CONTINUE: "Tiếp tục",
    COULD_IT_BE_ONE_OF_THESE: "Có thể là một trong số này?",
    COUNTRY: "Quốc gia",
    CREATE_NEW_COMPANY: "Tạo công ty mới",
    CREATE_NEW_CONTACT: "Tạo người liên hệ mới",
    CREATE_REQUEST: "Tạo yêu cầu",
    CREATED_REQUEST: "Yêu cầu đã được tạo",
    DEPARTMENT: "Bộ phận",
    DO_NOT_ARCHIVE_ATTACHMENTS: "Không lưu trữ tệp đính kèm",
    DO_NOT_ARCHIVE_ATTACHMENTS_SUB_TEXT: "Tệp đính kèm được lưu trữ theo mặc định",
    DOCUMENT_ARCHIVED_IN_SUPEROFFICE: "E-mail được lưu trữ trong SuperOffice.",
    EMAIL_ADDRESS: "E-mail",
    EMAIL_ADDRESS_NOT_REGISTERED: "Địa chỉ e-mail này không tồn tại trong SuperOffice.",
    EMAIL_ATTACHED_TO_SEVERAL_CONTACTS: "<span class='so-email'>{0}</span> được đính kèm với một số người liên hệ trong SuperOffice.",
    EMAIL_REGISTERED_IN_SUPEROFFICE: "E-mail đã đăng ký trong SuperOffice.",
    EMAIL_REGISTERED_ON_MULTIPLE_CONTACTS: "Địa chỉ e-mail này được đăng ký trên một số người liên hệ trong SuperOffice.",
    ENABLE_ARCHIVING_TO_EDIT_THESE_SETTINGS: "Cho phép lưu trữ để chỉnh sửa các cài đặt này",
    ERROR: "Lỗi",
    ERROR_ADDING_EMAIL_TO_SUPEROFFICE: "Không thể thêm địa chỉ e-mail vào SuperOffice.",
    ERROR_ARCHIVING_ATTACHMENT: "Không thể lưu trữ tệp đính kèm.",
    ERROR_ARCHIVING_EMAIL: "Không thể lưu trữ e-mail.",
    ERROR_ARCHIVING_REQUEST: "Không thể lưu trữ yêu cầu.",
    ERROR_ARCHIVING_TASK: "Không thể tạo hoạt động.",
    ERROR_COMMUNICATING_WITH_SUPEROFFICE: "Không thể kết nối với SuperOffice.",
    ERROR_PERMISSIONS_CREATE_CONTACTS: "Bạn không có quyền tạo công ty hoặc người liên hệ trong SuperOffice.",
    FIND_COMPANY_OR_PERSON: "Tìm một công ty hoặc người liên hệ...",
    FIRST_ATTENDEE_CHANGED: "Người liên hệ cuộc họp đã thay đổi.",
    FIRST_ATTENDEE_MISMATCH_DESC: "Chọn người liên hệ mà cuộc hẹn sẽ được liên kết.",
    FIRST_ATTENDEE_MISMATCH_LABEL: "Người liên hệ và người tham dự cuộc họp không khớp",
    FIRSTNAME: "Tên",
    FOLLOWUPS: "Theo dõi",
    GRAPH_API_ERROR_MESSAGE_SOFO: "SuperOffice for Outlook không thể truy cập các dịch vụ của Microsoft. Vui lòng thử lại trong giây lát.",
    GRAPH_API_ERROR_TITLE_SOFO: "Dịch vụ Microsoft tạm thời không khả dụng",
    HEADER_ADD_EMAIL: "Thêm e-mail/người liên hệ: {0}",
    HEADER_ADD_EMAIL_ADDRESS_TO_SUPEROFFICE: "Thêm địa chỉ e-mail vào SuperOffice",
    HEADER_ADD_RECPIENTS: "Thêm người nhận từ SuperOffice",
    HEADER_ADD_TO_EXISTING_PERSON: "Thêm vào người liên hệ hiện có",
    HEADER_ARCHIVE_APPOINTMENT: "Tạo hoạt động",
    HEADER_ARCHIVE_ATTACHMENT: "Lưu trữ tệp đính kèm dưới dạng tài liệu SuperOffice",
    HEADER_ARCHIVE_EMAIL: "Lưu trữ e-mail trong SuperOffice",
    HEADER_CONNECT_TO_NEW_INSTALLATION: "Kết nối với một cài đặt SuperOffice khác",
    HEADER_CREATE_EMAIL_AS_ACTIVITY: "Tạo hoạt động trong SuperOffice dựa trên e-mail",
    HEADER_CREATE_EMAIL_AS_ATTACHMENT: "Lưu tệp đính kèm từ e-mail này trong SuperOffice",
    HEADER_CREATE_EMAIL_AS_EMAIL: "Lưu trữ e-mail này trong SuperOffice",
    HEADER_CREATE_EMAIL_AS_REQUEST: "Tạo yêu cầu trong SuperOffice dựa trên e-mail",
    HEADER_CREATE_EMAIL_AS_SALE: "Tạo mục bán hàng trong SuperOffice dựa trên e-mail này",
    HEADER_CREATE_EMAIL_AS_TASK: "Tạo một nhiệm vụ trong danh sách kiểm tra của bạn dựa trên e-mail",
    HEADER_CREATE_NEW_COMPANY_AND_PERSON: "Tạo công ty và người liên hệ mới",
    HEADER_CREATE_NEW_PERSON: "Tạo người liên hệ mới",
    HEADER_WELCOME: "Chào mừng",
    LABEL_ACHIEVE_MORE: "Đạt được nhiều hơn với tích hợp",
    LABEL_ADD_TO_EXISTING_REQUEST: "Thêm e-mail dưới dạng tin nhắn trong một yêu cầu hiện có trong SuperOffice",
    LABEL_ARCHIVE_FILE: "Lưu trữ tệp:",
    LABEL_ATTACHMENT_ALREADY_SAVED: "Tệp đính kèm đã được lưu",
    LABEL_ATTACHMENT_NOT_SAVED: "Tệp đính kèm chưa được lưu",
    LABEL_COMMENT: "Nhận xét:",
    LABEL_COMPANYPHONE: "Điện thoại của công ty:",
    LABEL_CONTACT: "Công ty:",
    LABEL_CONTACT_OR_COMPANY: "Liên hệ hoặc Công ty:",
    LABEL_CREATE_AND_VISUALIZE: "Tạo và trực quan hóa như một người chuyên nghiệp",
    LABEL_CURRENCY: "Đơn vị tiền tệ:",
    LABEL_DATE: "Ngày:",
    LABEL_DESCRIPTION: "Mô tả:",
    LABEL_DIRECTPHONE: "Điện thoại trực tiếp:",
    LABEL_DISCOVER_WHAT_ADDIN_CAN_DO: "Khám phá những gì mà sự bổ trợ này có thể làm cho bạn ngay hôm nay!",
    LABEL_HOME_ADDRESS: "Địa chỉ nhà:",
    LABEL_MOBILEPHONE: "Điện thoại di động:",
    LABEL_NOTES: "Ghi chú:",
    LABEL_NUMBER: "Số:",
    LABEL_OPTIONAL_ATTENDEE: "Tùy chọn",
    LABEL_PERSON: "Người liên hệ:",
    LABEL_POSITION: "Vị trí:",
    LABEL_PROJECT: "Dự án:",
    LABEL_REQUIRED_ATTENDEE: "Bắt buộc",
    LABEL_SALE: "Bán hàng:",
    LABEL_SALE_AMOUNT: "Lượng bán hàng:",
    LABEL_SALE_DATE: "Ngày bán hàng:",
    LABEL_SALE_NAME: "Tên bán hàng:",
    LABEL_SALE_TYPE: "Loại bán hàng:",
    LABEL_SAVED_CHANGES: "Đã lưu các thay đổi của bạn.",
    LABEL_SELECT_CS_QUEUE: "Thêm yêu cầu vào hàng đợi này:",
    LABEL_SELECT_CS_QUEUE_SHORT: "Chọn hàng đợi",
    LABEL_SERVER_VERSION: "Phiên bản máy chủ:",
    LABEL_SUBJECT: "Tiêu đề:",
    LABEL_SUPEROFFICE_SITE: "Trang web SuperOffice:",
    LABEL_TELEPHONE: "Điện thoại:",
    LABEL_TIME: "Thời gian:",
    LABEL_TYPE: "Loại:",
    LABEL_UNLOCK_FEATURES: "Mở khóa các tính năng và chức năng",
    LABEL_URL: "URL:",
    LABEL_USER: "Người dùng:",
    LABEL_VISIBLE_FOR: "Hiển thị cho:",
    LABEL_WEB_PAGE: "Trang web:",
    LASTNAME: "Họ",
    LEARN_MORE: "Tìm hiểu thêm",
    LOGIN_COMPLETE_SETUP: "Để hoàn tất thiết lập Liên Kết Gmail SuperOffice, bạn cần đăng nhập vào SuperOffice.",
    LOGIN_ONSITE: "Vui lòng đăng nhập vào cài đặt SuperOffice CRM Onsite của bạn.",
    LOGOUT_FROM_SUPEROFFICE_1: "Đăng xuất khỏi SuperOffice và đóng (các) tab SuperOffice đang mở nếu có.",
    LOGOUT_FROM_SUPEROFFICE_2: "Lần tiếp theo bạn đăng nhập vào SuperOffice CRM Online, kết nối mới sẽ được thiết lập tự động.",
    MAKE_PRIMARY_EMAIL_ADDRESS: "Đặt đây là địa chỉ e-mail chính",
    MARK_COMPLETED: "Đánh dấu là đã hoàn thành",
    MARK_REMOVE_FROM_INBOX: "Xóa khỏi Hộp thư đến",
    MENU_ARCHIVE_EMAIL: "Lưu Trữ E-mail",
    MENU_CREATE_APPOINTMENT: "Tạo hoạt động",
    MENU_CREATE_NEW_SALE: "Tạo mục bán hàng mới",
    MENU_SAVE_TO_SUPEROFFICE: "Lưu vào SuperOffice",
    MESSAGE_NO_EMAIL_ADDRESS: "Người liên hệ không có địa chỉ e-mail",
    MIDDLENAME: "Tên đệm",
    MISSING_REQUIRED_VALUES_INTRO: "Một số trường bắt buộc không khả dụng cho tài khoản người dùng của bạn:",
    ML_ADD_COMPANY: "Thêm công ty",
    ML_ADD_EMAIL_TO_CONTACT_PERSON: "Thêm e-mail để liên hệ",
    ML_ADD_NEW_COMPANY_AND_CONTACT_PERSON: "Thêm người liên hệ và công ty mới",
    ML_ADD_NEW_CONTACT_PERSON: "Thêm người liên hệ mới",
    ML_ARCHIVE_APPOINTMENT_IN_SUPEROFFICE: "Lưu trữ e-mail này dưới dạng một cuộc hẹn trong lịch của bạn",
    ML_ARCHIVE_EMAIL_IN_SUPEROFFICE_ON_SENDERS_CONTACT: "Lưu trữ e-mail trong SuperOffice trên danh thiếp công ty của người gửi",
    ML_CLICK_TO_ADD_TO_SUPEROFFICE: "Nhấp để thêm vào SuperOffice",
    ML_COMPANY_DETAILS: "Thông tin chi tiết công ty",
    ML_CONTACT_DETAILS: "Thông tin chi tiết người liên hệ",
    ML_CREATE_A_NEW_SALE: "Tạo mục bán hàng mới cho khách hàng này",
    ML_DISCONNECT_FROM_SUPEROFFICE: "Ngắt kết nối Outlook khỏi SuperOffice",
    ML_INVITATION_OPTIONS: "Lời mời",
    ML_MOVE_INTO_CS_AS_REQUEST: "Thêm e-mail này vào Dịch Vụ Khách Hàng như một yêu cầu mới",
    ML_OR_ADD_CONTACT_TO_COMPANY: "HOẶC THÊM NGƯỜI LIÊN HỆ VỚI CÔNG TY?",
    ML_PEOPLE_METIONED_IN_MESSAGE: "Những người được đề cập trong tin nhắn này",
    ML_PERSON_COULD_BE: "Người liên hệ này có thể là",
    ML_SEARCH_FOR_PERSON_OR_COMPANY: "Tìm kiếm người liên hệ hoặc công ty...",
    ML_SETTINGS_INVITATIONS_HEADER: "Lời mời cho SuperOffice",
    ML_SETTINGS_INVITATIONS_UPDATESUPEROFFICE: "Thêm / cập nhật cuộc hẹn trong SuperOffice khi trả lời lời mời trong Outlook.",
    MOBILE: "Di động",
    MORE: "Khác nữa",
    MRMS: "Ông/Bà",
    MULTIPLE_EMAILADDRESSES_FOUND: "Địa chỉ e-mail này được đăng ký trên một số người liên hệ trong SuperOffice. Nhấp vào đây để chọn người liên hệ phù hợp để lưu trữ.",
    MYPROFILE: "Hồ Sơ Của Tôi",
    NO_RESULTS: "Không có kết quả",
    NOTE_CONTACT_DATA_PREDICTED: "Dựa trên nội dung có trong email này, chúng tôi đã gợi ý các chi tiết cho người gửi trên đây. Vui lòng xác minh trước khi tạo liên hệ này.",
    ONSITE_AUTHENTICATION_ERROR_LINE_2: "Kiểm tra xem tên người dùng và mật khẩu bạn đã nhập có chính xác không.",
    ONSITE_CONNECTION_SUCCESSFUL: "Xin chúc mừng. Liên Kết Gmail SuperOffice đã kết nối thành công với cài đặt SuperOffice CRM Onsite của bạn.",
    ONSITE_CONTINUE_WHEN_LOGGED_IN: "Vui lòng kiểm tra xem bạn đã đăng nhập vào cài đặt tại chỗ của mình chưa trước khi tiếp tục hay chưa.",
    ONSITE_ERROR_LINE_1: "Có một số vấn đề trong quá trình đăng nhập.",
    ONSITE_ERROR_LINE_2: "Hãy đảm bảo bạn đã nhập đúng URL Máy Chủ. Nhấp vào nút thông tin để tìm hiểu cách lấy.",
    ONSITE_PASSWORD: "Mật khẩu:",
    ONSITE_SERVER_URL: "URL Máy Chủ:",
    ONSITE_SERVER_URL_LINE_1: "Trong SuperOffice CRM, chọn phím tắt Sao Chép từ menu chính",
    ONSITE_SERVER_URL_LINE_2: "Sau đó dán vào URL Máy Chủ tại đây",
    ONSITE_URL: "URL đến cài đặt SuperOffice CRM Onsite của bạn:",
    ONSITE_USER_NAME: "Tên người dùng:",
    OPEN_IN_CRM: "Mở trong CRM",
    OR_UPPER: "HOẶC",
    OUR_CONTACT: "Người liên hệ của chúng tôi",
    OUTLOOK_AND_SUPEROFFICE: "Outlook + SuperOffice CRM",
    PERMISSION_CHANGE_OF_MIND: "Nếu sau này bạn đổi ý, vui lòng mở lại phần bổ sung SuperOffice for Outlook trên màn hình lịch",
    PERMISSION_CONTINUE: "Nhấp vào \"Tiếp tục\" để mở cửa sổ mới và cấp các quyền cần thiết",
    PERMISSION_FOR_CALENDAR: "SuperOffice for Outlook cần sự cho phép của bạn để truy cập vào các mục lịch.",
    PICKER_BCC: "Đồng gửi ẩn danh",
    PICKER_CC: "Đồng gửi",
    PICKER_CC_COPY: "Đồng gửi",
    PICKER_TO: "Đến",
    PLACE_REQUEST_IN_QUEUE: "Đặt yêu cầu trong hàng đợi này:",
    POPUP__BOTTOM_TEXT: "Vui lòng bật tính năng cửa sổ bật lên cho trang này và thử lại.",
    POPUP__HEADER: "Đã phát hiện trình chặn cửa sổ bật lên",
    POPUP__MID_TEXT: "SuperOffice cho Outlook cần xác thực, nhưng trình chặn cửa sổ bật lên của trình duyệt đang ngăn nó.",
    PRODUCT_NAME: "Liên Kết Gmail SuperOffice",
    REMOVE_FROM_INBOX: "Xóa khỏi hộp thư đến",
    REMOVE_FROM_INBOX_DESC: "Di chuyển email đến các mục đã xóa sau khi lưu trữ",
    REQUEST: "Yêu cầu",
    REQUEST_EMAIL_TOO_LARGE_MESSAGE: "Email này quá lớn để thêm vào yêu cầu.",
    REQUEST_EMAIL_TOO_LARGE_TITLE: "Email quá lớn",
    REQUEST_PRIORITY: "Ưu tiên",
    REQUEST_QUEUE: "Hàng đợi yêu cầu",
    RESET_ALL: "Đặt lại tất cả",
    RESET_INFO_SOFO: "Bạn có muốn đặt lại thông tin trong SuperOffice for Outlook không? Thao tác này sẽ xóa dữ liệu hiện tại.",
    REVISION_LABEL: "Bản sửa đổi:",
    SEARCH_FAILED: "Tìm kiếm không thành công. Vui lòng thử lại.",
    SETTINGS: "Cài đặt",
    SETTINGS_ApplyArchiveStatus: "Áp dụng danh mục lưu trữ",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY: "Chỉ người nhận bên ngoài",
    SETTINGS_ARCHIVE_REMINDER_EXTERNAL_ONLY_TOOLTIP: "Người nhận bên ngoài là những người bên ngoài tổ chức của bạn.",
    SETTINGS_ARCHIVE_REMINDER_FORWARDS: "Chuyển tiếp",
    SETTINGS_ARCHIVE_REMINDER_HEADER: "Lời nhắc lưu trữ",
    SETTINGS_ARCHIVE_REMINDER_INFO: "Lời nhắc lưu trữ giúp đảm bảo email và cuộc họp được lưu vào SuperOffice trước khi chúng được gửi.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_DESC: "Bạn sẽ được nhắc lưu trữ các cuộc họp trong SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_MEETINGS_TOGGLE_LABEL: "Nhắc nhở tôi trước khi gửi cuộc họp",
    SETTINGS_ARCHIVE_REMINDER_NEW_EMAILS: "Email mới",
    SETTINGS_ARCHIVE_REMINDER_REPLIES: "Trả lời",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_DESC: "Bạn sẽ được nhắc lưu trữ email trong SuperOffice.",
    SETTINGS_ARCHIVE_REMINDER_TOGGLE_LABEL: "Nhắc nhở tôi trước khi gửi email",
    SETTINGS_CategoryColor: "Màu danh mục",
    SETTINGS_CategoryName: "Tên danh mục",
    SETTINGS_CategoryNameFixedInfo: "Tên danh mục là cố định và không thể thay đổi.",
    SETTINGS_CategoryTaggingDescription: "Sử dụng danh mục Outlook để xác định các email đã được lưu trữ trong SuperOffice.",
    SETTINGS_CategoryTaggingInfo: "Trạng thái lưu trữ email giúp bạn biết những email nào đã được lưu vào SuperOffice, ngay trong hộp thư Outlook của bạn.",
    SETTINGS_CategoryTaggingSection: "Trạng thái lưu trữ email",
    SETTINGS_DEFAULT_APPOINTMENT_TYPE: "Loại hoạt động mặc định",
    SETTINGS_DEFAULT_EMAIL_TYPE_HEADER: "Loại email mặc định",
    SETTINGS_DEFAULT_EMAIL_TYPE_INCOMING: "Email đến",
    SETTINGS_DEFAULT_EMAIL_TYPE_OUTGOING: "Email gửi đi",
    SETTINGS_DEFAULT_INCOMING_TEMPLATE: "Mẫu e-mail gửi đến mặc định",
    SETTINGS_DEFAULT_OUTGOING_TEMPLATE: "Mẫu e-mail gửi đi mặc định",
    SETTINGS_EnableCategoryForSharedMailbox: "Trong hộp thư chung",
    SETTINGS_EnableCategoryOnOpen: "Khi mở email đã lưu trữ",
    SETTINGS_EnableCategoryOnSendAndArchive: "Khi sử dụng Gửi & Lưu trữ",
    SETTINGS_EnableCategoryTagging: "Hiển thị danh mục lưu trữ trong Outlook",
    SETTINGS_EnableContextualProjectsAndSalesForContact: "Hiển thị các dự án và mục bán hàng theo ngữ cảnh",
    SETTINGS_GENERAL_HEADER: "Chung",
    SETTINGS_SharedMailboxCategoryInfo: "Để hiển thị trạng thái lưu trữ, phải tạo danh mục lưu trữ trong hộp thư chung.",
    SETTINGS_SharedMailboxCategoryInfoBold: "Đối với hộp thư chung:",
    SETTINGS_SharedMailboxCategoryLearnMore: "Tìm hiểu thêm về thiết lập hộp thư chung",
    SETTINGS_YOURCOMPANY: "Tên công ty:",
    SMART_ALERT_ARCHIVE_AND_SEND_LABEL: "Lưu trữ và gửi",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_ACTION: "Chọn một liên hệ hoặc công ty để lưu trữ.",
    SMART_ALERT_ARCHIVE_CONTACT_REQUIRED_MESSAGE: "E-mail này đã sẵn sàng để gửi, nhưng không thể lưu trữ nó trong SuperOffice.",
    SMART_ALERT_BUTTON_ARCHIVE_LABEL: "Lưu trữ",
    SMART_ALERT_SEND_WITHOUT_ARCHIVING_MESSAGE: "Email này đã sẵn sàng để gửi, nhưng chưa được cài đặt để lưu trữ trong SuperOffice. Hãy lưu trữ ngay để thông tin liên lạc được lưu lại với đúng công ty hoặc người liên hệ, hoặc gửi đi mà không cần lưu trữ.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_1: "Đã xảy ra sự cố khi tải cài đặt.",
    SOMETHING_WENT_WRONG_PLEASE_LOG_IN_2: "Vui lòng đăng nhập vào SuperOffice trước khi mở cài đặt.",
    SR_ADMIN_MYAPPS: "Ứng dụng của tôi",
    SR_ALL_ITEM: "Tất cả",
    SR_DISABLE_BIOMETRIC_LOGIN_CONFIRM: "Bạn có chắc chắn muốn tắt đăng nhập sinh trắc học không? Bạn sẽ cần phải đăng nhập lại theo cách thủ công vào lần tới.",
    SR_FAILED_TO_COPY_TO_CLIPBOARD: "Không thể sao chép vào bộ nhớ tạm",
    SR_NO_SELECTION: "(Không Có Lựa Chọn Nào)",
    SR_VOICEMEMO_MICROPHONE_BUSY: "The microphone is in use. Try again when it is free.",
    SYNCHRONIZER_GET_STARTED: "Bắt đầu chỉ với vài cú nhấp chuột",
    SYNCHRONIZER_REACTIVATE: "Kích hoạt lại chỉ với vài cú nhấp chuột",
    SYNCRONIZER_MSG_CONTENT: "Đồng bộ hóa lịch và các nhiệm vụ trên Outlook với SuperOffice CRM để luôn cập nhật thông tin về các cuộc họp, liên hệ, dự án và doanh số bán hàng.",
    SYNCRONIZER_NEED_AUTHENTICATION: "Việc đồng bộ hóa Lịch SuperOffice với Outlook sắp hoàn tất. Tiếp tục kích hoạt và giữ cho các lịch của bạn được đồng bộ.",
    SYNCRONIZER_NEED_REAUTHENTICATION: "Việc đồng bộ hóa Lịch SuperOffice với Outlook của bạn hiện đang bị gián đoạn. Tiếp tục kích hoạt lại và giữ cho các lịch của bạn được đồng bộ.",
    TAB_ACTION: "Hoạt động",
    TAB_PEOPLE: "Mọi người",
    TASK_ARCHIVED_IN_SUPEROFFICE: "Hoạt động được tạo trong SuperOffice.",
    TASK_ARCHIVED_IN_SUPEROFFICE_COPY: "Hoạt động được tạo trong SuperOffice.",
    TIMEOUT_ERROR_MESSAGE: "Máy chủ mất quá nhiều thời gian để phản hồi. Vui lòng thử lại.",
    TIMEOUT_ERROR_TITLE: "Đã hết thời gian yêu cầu",
    TITLE: "Chức vụ",
    UNDO: "Hoàn tác",
    UNKNOWN_EMAIL_ADDRESS: "Địa chỉ email không xác định.",
    UNKNOWN_EMAILADDRESS: "Địa chỉ e-mail của người gửi này không được xác nhận. Nhấp vào đây để thêm địa chỉ e-mail này vào SuperOffice.",
    UNKNOWN_EMAILADDRESS_OUTGOING: "Địa chỉ e-mail của người nhận này không được xác nhận. Nhấp vào đây để cập nhật SuperOffice với địa chỉ e-mail này.",
    UNKONWN_EMAIL_ADDRESS_WITH_PLACEHOLDER: "Địa chỉ email không xác định. Thêm {0} vào SuperOffice.",
    UNLOCK_THESE_FEATURES: "Khám phá các tính năng này bằng synchronizer",
    URL_SIGN_UP_FREE_TRIAL: "https://www.superoffice.com/crm/demo/",
    VERSION_SHORT: "phiên bản",
    VISIT_APP_STORE: "Truy cập App Store",
    WE_RUN_ONLINE_LINE_1: "Để xác định xem bạn có đang chạy Online hay không, hãy làm như sau:",
    WE_RUN_ONLINE_LINE_2: "1. Trong SuperOffice CRM, chọn Trợ Giúp rồi chọn Giới Thiệu",
    WE_RUN_ONLINE_LINE_3: "2. Nhìn vào mục nhập cho NetServer:",
    WE_RUN_ONLINE_LINE_4: "Nếu mục đó hiện \"SuperOffice CRM Online ... \", thì tức là bạn đang chạy Online",
    WE_RUN_ONSITE_LINE_1: "Để xác định xem bạn có đang chạy Onsite hay không, hãy làm như sau:",
    WE_RUN_ONSITE_LINE_4: "Nếu mục đó hiện \"SuperOffice CRM OnSite ... \", thì tức là bạn đang chạy OnSite",
    YOU_CAN_STILL_USE: "Bạn vẫn có thể sử dụng SuperOffice cho Outlook để làm việc với email!",
  }
};


/* utility classes for easy access to resources */

export class ResourceManager {

  /**
     The language set for this ResourceManager-instance.
  */
  readonly language: ResourceLanguageName;

  /**
     Class used to provide resources in local language, with
     fallback to default-language.
  */
  constructor(language?: string) {
    this.language = getResourceLanguage(language);
  }

  get(this: ResourceManager, item: keyof SingleLanguageResources): string {
    const langResources = resources[this.language];
    const result = langResources[item];
    return result;
  }
}

export function localizeResources(language?: string): SingleLanguageResources {
  const resourceLanguage = getResourceLanguage(language);
  return resources[resourceLanguage];
}

export function getResourceLanguage(language?: string): ResourceLanguageName {
  const lang = language?.toUpperCase();
  for (const resourceLanguage of resourceLanguages) {
    if (lang === resourceLanguage) {
      return resourceLanguage;
    }
  }

  return defaultLanguage;
}